import * as D from "react";
import b1, { createContext as H0, useState as A1, useCallback as e0, useRef as y1, useEffect as w1, useMemo as m0, createElement as t1, useContext as C0, useLayoutEffect as u5, forwardRef as C1, Children as a0, isValidElement as _0, cloneElement as f5, Fragment as ke, lazy as o2, Suspense as s2, useReducer as De } from "react";
import { flushSync as Re } from "react-dom";
var u1 = "colors", D1 = "sizes", B = "space", Ae = { gap: B, gridGap: B, columnGap: B, gridColumnGap: B, rowGap: B, gridRowGap: B, inset: B, insetBlock: B, insetBlockEnd: B, insetBlockStart: B, insetInline: B, insetInlineEnd: B, insetInlineStart: B, margin: B, marginTop: B, marginRight: B, marginBottom: B, marginLeft: B, marginBlock: B, marginBlockEnd: B, marginBlockStart: B, marginInline: B, marginInlineEnd: B, marginInlineStart: B, padding: B, paddingTop: B, paddingRight: B, paddingBottom: B, paddingLeft: B, paddingBlock: B, paddingBlockEnd: B, paddingBlockStart: B, paddingInline: B, paddingInlineEnd: B, paddingInlineStart: B, top: B, right: B, bottom: B, left: B, scrollMargin: B, scrollMarginTop: B, scrollMarginRight: B, scrollMarginBottom: B, scrollMarginLeft: B, scrollMarginX: B, scrollMarginY: B, scrollMarginBlock: B, scrollMarginBlockEnd: B, scrollMarginBlockStart: B, scrollMarginInline: B, scrollMarginInlineEnd: B, scrollMarginInlineStart: B, scrollPadding: B, scrollPaddingTop: B, scrollPaddingRight: B, scrollPaddingBottom: B, scrollPaddingLeft: B, scrollPaddingX: B, scrollPaddingY: B, scrollPaddingBlock: B, scrollPaddingBlockEnd: B, scrollPaddingBlockStart: B, scrollPaddingInline: B, scrollPaddingInlineEnd: B, scrollPaddingInlineStart: B, fontSize: "fontSizes", background: u1, backgroundColor: u1, backgroundImage: u1, borderImage: u1, border: u1, borderBlock: u1, borderBlockEnd: u1, borderBlockStart: u1, borderBottom: u1, borderBottomColor: u1, borderColor: u1, borderInline: u1, borderInlineEnd: u1, borderInlineStart: u1, borderLeft: u1, borderLeftColor: u1, borderRight: u1, borderRightColor: u1, borderTop: u1, borderTopColor: u1, caretColor: u1, color: u1, columnRuleColor: u1, fill: u1, outline: u1, outlineColor: u1, stroke: u1, textDecorationColor: u1, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: D1, minBlockSize: D1, maxBlockSize: D1, inlineSize: D1, minInlineSize: D1, maxInlineSize: D1, width: D1, minWidth: D1, maxWidth: D1, height: D1, minHeight: D1, maxHeight: D1, flexBasis: D1, gridTemplateColumns: D1, gridTemplateRows: D1, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, _e = (e, a) => typeof a == "function" ? { "()": Function.prototype.toString.call(a) } : a, v0 = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (a, i, ...r) => {
    const n = ((c) => JSON.stringify(c, _e))(a);
    return n in e ? e[n] : e[n] = i(a, ...r);
  };
}, r0 = Symbol.for("sxs.internal"), h5 = (e, a) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)), I5 = (e) => {
  for (const a in e)
    return !0;
  return !1;
}, { hasOwnProperty: Pe } = Object.prototype, n5 = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, (a) => "-" + a.toLowerCase()), ze = /\s+(?![^()]*\))/, u0 = (e) => (a) => e(...typeof a == "string" ? String(a).split(ze) : [a]), L5 = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), tabSize: (e) => ({ MozTabSize: e, tabSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: u0((e, a) => ({ marginBlockStart: e, marginBlockEnd: a || e })), marginInline: u0((e, a) => ({ marginInlineStart: e, marginInlineEnd: a || e })), maxSize: u0((e, a) => ({ maxBlockSize: e, maxInlineSize: a || e })), minSize: u0((e, a) => ({ minBlockSize: e, minInlineSize: a || e })), paddingBlock: u0((e, a) => ({ paddingBlockStart: e, paddingBlockEnd: a || e })), paddingInline: u0((e, a) => ({ paddingInlineStart: e, paddingInlineEnd: a || e })) }, a5 = /([\d.]+)([^]*)/, Ie = (e, a) => e.length ? e.reduce((i, r) => (i.push(...a.map((n) => n.includes("&") ? n.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(n) ? `:is(${r})` : r) : r + " " + n)), i), []) : a, Le = (e, a) => e in Te && typeof a == "string" ? a.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (i, r, n, c) => r + (n === "stretch" ? `-moz-available${c};${n5(e)}:${r}-webkit-fill-available` : `-moz-fit-content${c};${n5(e)}:${r}fit-content`) + c) : String(a), Te = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, q1 = (e) => e ? e + "-" : "", d2 = (e, a, i) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (r, n, c, s, o) => s == "$" == !!c ? r : (n || s == "--" ? "calc(" : "") + "var(--" + (s === "$" ? q1(a) + (o.includes("$") ? "" : q1(i)) + o.replace(/\$/g, "-") : o) + ")" + (n || s == "--" ? "*" + (n || "") + (c || "1") + ")" : "")), Ee = /\s*,\s*(?![^()]*\))/, Fe = Object.prototype.toString, f0 = (e, a, i, r, n) => {
  let c, s, o;
  const l = (d, v, u) => {
    let f, h;
    const $ = (b) => {
      for (f in b) {
        const S = f.charCodeAt(0) === 64, P = S && Array.isArray(b[f]) ? b[f] : [b[f]];
        for (h of P) {
          const z = /[A-Z]/.test(Z = f) ? Z : Z.replace(/-[^]/g, (F) => F[1].toUpperCase()), L = typeof h == "object" && h && h.toString === Fe && (!r.utils[z] || !v.length);
          if (z in r.utils && !L) {
            const F = r.utils[z];
            if (F !== s) {
              s = F, $(F(h)), s = null;
              continue;
            }
          } else if (z in L5) {
            const F = L5[z];
            if (F !== o) {
              o = F, $(F(h)), o = null;
              continue;
            }
          }
          if (S && (x = f.slice(1) in r.media ? "@media " + r.media[f.slice(1)] : f, f = x.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (F, I, U, T, M, Y) => {
            const Q = a5.test(I), H = 0.0625 * (Q ? -1 : 1), [y, p] = Q ? [T, I] : [I, T];
            return "(" + (U[0] === "=" ? "" : U[0] === ">" === Q ? "max-" : "min-") + y + ":" + (U[0] !== "=" && U.length === 1 ? p.replace(a5, (C, g, k) => Number(g) + H * (U === ">" ? 1 : -1) + k) : p) + (M ? ") and (" + (M[0] === ">" ? "min-" : "max-") + y + ":" + (M.length === 1 ? Y.replace(a5, (C, g, k) => Number(g) + H * (M === ">" ? -1 : 1) + k) : Y) : "") + ")";
          })), L) {
            const F = S ? u.concat(f) : [...u], I = S ? [...v] : Ie(v, f.split(Ee));
            c !== void 0 && n(T5(...c)), c = void 0, l(h, I, F);
          } else
            c === void 0 && (c = [[], v, u]), f = S || f.charCodeAt(0) !== 36 ? f : `--${q1(r.prefix)}${f.slice(1).replace(/\$/g, "-")}`, h = L ? h : typeof h == "number" ? h && z in Ne ? String(h) + "px" : String(h) : d2(Le(z, h == null ? "" : h), r.prefix, r.themeMap[z]), c[0].push(`${S ? `${f} ` : `${n5(f)}:`}${h}`);
        }
      }
      var x, Z;
    };
    $(d), c !== void 0 && n(T5(...c)), c = void 0;
  };
  l(e, a, i);
}, T5 = (e, a, i) => `${i.map((r) => `${r}{`).join("")}${a.length ? `${a.join(",")}{` : ""}${e.join(";")}${a.length ? "}" : ""}${Array(i.length ? i.length + 1 : 0).join("}")}`, Ne = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, E5 = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), i0 = (e) => ((a) => {
  let i, r = "";
  for (i = Math.abs(a); i > 52; i = i / 52 | 0)
    r = E5(i % 52) + r;
  return E5(i % 52) + r;
})(((a, i) => {
  let r = i.length;
  for (; r; )
    a = 33 * a ^ i.charCodeAt(--r);
  return a;
})(5381, JSON.stringify(e)) >>> 0), x0 = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], Oe = (e) => {
  if (e.href && !e.href.startsWith(location.origin))
    return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, We = (e) => {
  let a;
  const i = () => {
    const { cssRules: n } = a.sheet;
    return [].map.call(n, (c, s) => {
      const { cssText: o } = c;
      let l = "";
      if (o.startsWith("--sxs"))
        return "";
      if (n[s - 1] && (l = n[s - 1].cssText).startsWith("--sxs")) {
        if (!c.cssRules.length)
          return "";
        for (const d in a.rules)
          if (a.rules[d].group === c)
            return `--sxs{--sxs:${[...a.rules[d].cache].join(" ")}}${o}`;
        return c.cssRules.length ? `${l}${o}` : "";
      }
      return o;
    }).join("");
  }, r = () => {
    if (a) {
      const { rules: o, sheet: l } = a;
      if (!l.deleteRule) {
        for (; Object(Object(l.cssRules)[0]).type === 3; )
          l.cssRules.splice(0, 1);
        l.cssRules = [];
      }
      for (const d in o)
        delete o[d];
    }
    const n = Object(e).styleSheets || [];
    for (const o of n)
      if (Oe(o)) {
        for (let l = 0, d = o.cssRules; d[l]; ++l) {
          const v = Object(d[l]);
          if (v.type !== 1)
            continue;
          const u = Object(d[l + 1]);
          if (u.type !== 4)
            continue;
          ++l;
          const { cssText: f } = v;
          if (!f.startsWith("--sxs"))
            continue;
          const h = f.slice(14, -3).trim().split(/\s+/), $ = x0[h[0]];
          $ && (a || (a = { sheet: o, reset: r, rules: {}, toString: i }), a.rules[$] = { group: u, index: l, cache: new Set(h) });
        }
        if (a)
          break;
      }
    if (!a) {
      const o = (l, d) => ({ type: d, cssRules: [], insertRule(v, u) {
        this.cssRules.splice(u, 0, o(v, { import: 3, undefined: 1 }[(v.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return l === "@media{}" ? `@media{${[].map.call(this.cssRules, (v) => v.cssText).join("")}}` : l;
      } });
      a = { sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : o("", "text/css"), rules: {}, reset: r, toString: i };
    }
    const { sheet: c, rules: s } = a;
    for (let o = x0.length - 1; o >= 0; --o) {
      const l = x0[o];
      if (!s[l]) {
        const d = x0[o + 1], v = s[d] ? s[d].index : c.cssRules.length;
        c.insertRule("@media{}", v), c.insertRule(`--sxs{--sxs:${o}}`, v), s[l] = { group: c.cssRules[v + 1], index: v, cache: /* @__PURE__ */ new Set([o]) };
      }
      je(s[l]);
    }
  };
  return r(), a;
}, je = (e) => {
  const a = e.group;
  let i = a.cssRules.length;
  e.apply = (r) => {
    try {
      a.insertRule(r, i), ++i;
    } catch {
    }
  };
}, b0 = Symbol(), Be = v0(), F5 = (e, a) => Be(e, () => (...i) => {
  let r = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const n of i)
    if (n != null)
      if (n[r0]) {
        r.type == null && (r.type = n[r0].type);
        for (const c of n[r0].composers)
          r.composers.add(c);
      } else
        n.constructor !== Object || n.$$typeof ? r.type == null && (r.type = n) : r.composers.add(Ye(n, e));
  return r.type == null && (r.type = "span"), r.composers.size || r.composers.add(["PJLV", {}, [], [], {}, []]), Ge(e, r, a);
}), Ye = ({ variants: e, compoundVariants: a, defaultVariants: i, ...r }, n) => {
  const c = `${q1(n.prefix)}c-${i0(r)}`, s = [], o = [], l = /* @__PURE__ */ Object.create(null), d = [];
  for (const f in i)
    l[f] = String(i[f]);
  if (typeof e == "object" && e)
    for (const f in e) {
      v = l, u = f, Pe.call(v, u) || (l[f] = "undefined");
      const h = e[f];
      for (const $ in h) {
        const b = { [f]: String($) };
        String($) === "undefined" && d.push(f);
        const x = h[$], Z = [b, x, !I5(x)];
        s.push(Z);
      }
    }
  var v, u;
  if (typeof a == "object" && a)
    for (const f of a) {
      let { css: h, ...$ } = f;
      h = typeof h == "object" && h || {};
      for (const x in $)
        $[x] = String($[x]);
      const b = [$, h, !I5(h)];
      o.push(b);
    }
  return [c, r, s, o, l, d];
}, Ge = (e, a, i) => {
  const [r, n, c, s] = Ue(a.composers), o = typeof a.type == "function" || a.type.$$typeof ? ((u) => {
    function f() {
      for (let h = 0; h < f[b0].length; h++) {
        const [$, b] = f[b0][h];
        u.rules[$].apply(b);
      }
      return f[b0] = [], null;
    }
    return f[b0] = [], f.rules = {}, x0.forEach((h) => f.rules[h] = { apply: ($) => f[b0].push([h, $]) }), f;
  })(i) : null, l = (o || i).rules, d = `.${r}${n.length > 1 ? `:where(.${n.slice(1).join(".")})` : ""}`, v = (u) => {
    u = typeof u == "object" && u || qe;
    const { css: f, ...h } = u, $ = {};
    for (const Z in c)
      if (delete h[Z], Z in u) {
        let S = u[Z];
        typeof S == "object" && S ? $[Z] = { "@initial": c[Z], ...S } : (S = String(S), $[Z] = S !== "undefined" || s.has(Z) ? S : c[Z]);
      } else
        $[Z] = c[Z];
    const b = /* @__PURE__ */ new Set([...n]);
    for (const [Z, S, P, z] of a.composers) {
      i.rules.styled.cache.has(Z) || (i.rules.styled.cache.add(Z), f0(S, [`.${Z}`], [], e, (I) => {
        l.styled.apply(I);
      }));
      const L = N5(P, $, e.media), F = N5(z, $, e.media, !0);
      for (const I of L)
        if (I !== void 0)
          for (const [U, T, M] of I) {
            const Y = `${Z}-${i0(T)}-${U}`;
            b.add(Y);
            const Q = (M ? i.rules.resonevar : i.rules.onevar).cache, H = M ? l.resonevar : l.onevar;
            Q.has(Y) || (Q.add(Y), f0(T, [`.${Y}`], [], e, (y) => {
              H.apply(y);
            }));
          }
      for (const I of F)
        if (I !== void 0)
          for (const [U, T] of I) {
            const M = `${Z}-${i0(T)}-${U}`;
            b.add(M), i.rules.allvar.cache.has(M) || (i.rules.allvar.cache.add(M), f0(T, [`.${M}`], [], e, (Y) => {
              l.allvar.apply(Y);
            }));
          }
    }
    if (typeof f == "object" && f) {
      const Z = `${r}-i${i0(f)}-css`;
      b.add(Z), i.rules.inline.cache.has(Z) || (i.rules.inline.cache.add(Z), f0(f, [`.${Z}`], [], e, (S) => {
        l.inline.apply(S);
      }));
    }
    for (const Z of String(u.className || "").trim().split(/\s+/))
      Z && b.add(Z);
    const x = h.className = [...b].join(" ");
    return { type: a.type, className: x, selector: d, props: h, toString: () => x, deferredInjector: o };
  };
  return h5(v, { className: r, selector: d, [r0]: a, toString: () => (i.rules.styled.cache.has(r) || v(), r) });
}, Ue = (e) => {
  let a = "";
  const i = [], r = {}, n = [];
  for (const [c, , , , s, o] of e) {
    a === "" && (a = c), i.push(c), n.push(...o);
    for (const l in s) {
      const d = s[l];
      (r[l] === void 0 || d !== "undefined" || o.includes(d)) && (r[l] = d);
    }
  }
  return [a, i, r, new Set(n)];
}, N5 = (e, a, i, r) => {
  const n = [];
  e:
    for (let [c, s, o] of e) {
      if (o)
        continue;
      let l, d = 0, v = !1;
      for (l in c) {
        const u = c[l];
        let f = a[l];
        if (f !== u) {
          if (typeof f != "object" || !f)
            continue e;
          {
            let h, $, b = 0;
            for (const x in f) {
              if (u === String(f[x])) {
                if (x !== "@initial") {
                  const Z = x.slice(1);
                  ($ = $ || []).push(Z in i ? i[Z] : x.replace(/^@media ?/, "")), v = !0;
                }
                d += b, h = !0;
              }
              ++b;
            }
            if ($ && $.length && (s = { ["@media " + $.join(", ")]: s }), !h)
              continue e;
          }
        }
      }
      (n[d] = n[d] || []).push([r ? "cv" : `${l}-${c[l]}`, s, v]);
    }
  return n;
}, qe = {}, Ke = v0(), Je = (e, a) => Ke(e, () => (...i) => {
  const r = () => {
    for (let n of i) {
      n = typeof n == "object" && n || {};
      let c = i0(n);
      if (!a.rules.global.cache.has(c)) {
        if (a.rules.global.cache.add(c), "@import" in n) {
          let s = [].indexOf.call(a.sheet.cssRules, a.rules.themed.group) - 1;
          for (let o of [].concat(n["@import"]))
            o = o.includes('"') || o.includes("'") ? o : `"${o}"`, a.sheet.insertRule(`@import ${o};`, s++);
          delete n["@import"];
        }
        f0(n, [], [], e, (s) => {
          a.rules.global.apply(s);
        });
      }
    }
    return "";
  };
  return h5(r, { toString: r });
}), Xe = v0(), Qe = (e, a) => Xe(e, () => (i) => {
  const r = `${q1(e.prefix)}k-${i0(i)}`, n = () => {
    if (!a.rules.global.cache.has(r)) {
      a.rules.global.cache.add(r);
      const c = [];
      f0(i, [], [], e, (o) => c.push(o));
      const s = `@keyframes ${r}{${c.join("")}}`;
      a.rules.global.apply(s);
    }
    return r;
  };
  return h5(n, { get name() {
    return n();
  }, toString: n });
}), et = class {
  constructor(e, a, i, r) {
    this.token = e == null ? "" : String(e), this.value = a == null ? "" : String(a), this.scale = i == null ? "" : String(i), this.prefix = r == null ? "" : String(r);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + q1(this.prefix) + q1(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, tt = v0(), at = (e, a) => tt(e, () => (i, r) => {
  r = typeof i == "object" && i || Object(r);
  const n = `.${i = (i = typeof i == "string" ? i : "") || `${q1(e.prefix)}t-${i0(r)}`}`, c = {}, s = [];
  for (const l in r) {
    c[l] = {};
    for (const d in r[l]) {
      const v = `--${q1(e.prefix)}${l}-${d}`, u = d2(String(r[l][d]), e.prefix, l);
      c[l][d] = new et(d, u, l, e.prefix), s.push(`${v}:${u}`);
    }
  }
  const o = () => {
    if (s.length && !a.rules.themed.cache.has(i)) {
      a.rules.themed.cache.add(i);
      const l = `${r === e.theme ? ":root," : ""}.${i}{${s.join(";")}}`;
      a.rules.themed.apply(l);
    }
    return i;
  };
  return { ...c, get className() {
    return o();
  }, selector: n, toString: o };
}), rt = v0(), O5, it = v0(), u2 = (e) => {
  const a = ((i) => {
    let r = !1;
    const n = rt(i, (c) => {
      r = !0;
      const s = "prefix" in (c = typeof c == "object" && c || {}) ? String(c.prefix) : "", o = typeof c.media == "object" && c.media || {}, l = typeof c.root == "object" ? c.root || null : globalThis.document || null, d = typeof c.theme == "object" && c.theme || {}, v = { prefix: s, media: o, theme: d, themeMap: typeof c.themeMap == "object" && c.themeMap || { ...Ae }, utils: typeof c.utils == "object" && c.utils || {} }, u = We(l), f = { css: F5(v, u), globalCss: Je(v, u), keyframes: Qe(v, u), createTheme: at(v, u), reset() {
        u.reset(), f.theme.toString();
      }, theme: {}, sheet: u, config: v, prefix: s, getCssText: u.toString, toString: u.toString };
      return String(f.theme = f.createTheme(d)), f;
    });
    return r || n.reset(), n;
  })(e);
  return a.styled = (({ config: i, sheet: r }) => it(i, () => {
    const n = F5(i, r);
    return (...c) => {
      const s = n(...c), o = s[r0].type, l = b1.forwardRef((d, v) => {
        const u = d && d.as || o, { props: f, deferredInjector: h } = s(d);
        return delete f.as, f.ref = v, h ? b1.createElement(b1.Fragment, null, b1.createElement(u, f), b1.createElement(h, null)) : b1.createElement(u, f);
      });
      return l.className = s.className, l.displayName = `Styled.${o.displayName || o.name || o}`, l.selector = s.selector, l.toString = () => s.selector, l[r0] = s[r0], l;
    };
  }))(a), a;
}, nt = () => O5 || (O5 = u2()), f2 = (...e) => nt().css(...e);
const ct = {
  "primary-light": "#002066",
  "primary-default": "#022a9a",
  "primary-middle": "#022a9a",
  "primary-dark": "#b0d1ff",
  "primary-darker": "#e0edff",
  "primary-lighter": "#001645",
  "bg-light": "#21283e",
  "bg-default": "#171f2a",
  "bg-hover": "#606882",
  "bg-press": "#313643",
  "bg-primary-default": "#0054ea",
  "bg-primary-hover": "#0047c7",
  "bg-primary-press": "#022a9a",
  "neutral-white": "#ffffff",
  "neutral-lighter": "#606882",
  "neutral-light": "#313643",
  "neutral-middle": "#606882",
  "neutral-dark": "#dee2ec",
  "neutral-darker": "#ffffff",
  "accent-light": "#991438",
  "accent-middle": "#ff7391",
  "accent-dark": "#ffdde4",
  "error-light": "#bc1d19",
  "error-middle": "#f64e45",
  "error-dark": "#ffe9e4",
  "success-light": "#196b4d",
  "success-middle": "#2ab281",
  "success-dark": "#d9f4eb",
  "warning-light": "#836d10",
  "warning-middle": "#f9d205",
  "warning-dark": "#fcf8d8",
  "information-light": "#022a9a",
  "information-middle": "#4591ff",
  "information-dark": "#e0edff",
  brand: {
    "brand-coral": "#FF5874",
    "brand-blue": "#022a9a"
  },
  "text-warning": "#fcf8d8",
  "text-error": "#f64e45",
  "text-success": "#2ab281",
  "text-information": "#4591ff",
  "text-default": "#dee2ec",
  "text-dark": "#ffffff",
  "text-accent": "#ffdde4",
  "text-inverted": "#ffffff",
  "text-link-default": "#4591ff",
  "text-link-hover": "#b0d1ff",
  "text-link-press": "#e0edff",
  "element-primary-default": "#4591ff",
  "element-primary-hover": "#b0d1ff",
  "element-primary-press": "#e0edff",
  "element-active-default": "#ff7391",
  focus: "#b0d1ff",
  "active-light": "#da2b55",
  "active-middle": "#ff7391",
  "active-dark": "#ffdde4"
}, W5 = {
  color: ct
}, lt = {
  category: {
    "category-loyalty-light": "#fff4e9",
    "category-loyalty-default": "#fd9426",
    "category-entertainment-light": "#e8e3ff",
    "category-entertainment-default": "#8e73fd",
    "category-restaurant-default": "#ff5267",
    "category-restaurant-light": "#ffdce1",
    "category-supermarket-light": "#ffded7",
    "category-supermarket-default": "#ff5935",
    "category-sport-light": "#d7f4ef",
    "category-sport-default": "#36c5ac",
    "category-shopping-light": "#fbe7fa",
    "category-shopping-default": "#f281eb",
    "category-transportation-light": "#e0f2fa",
    "category-transportation-default": "#55b3e0",
    "category-travel-light": "#dae8fb",
    "category-travel-default": "#448aec",
    "category-payment-light": "#dbf4df",
    "category-payment-default": "#85cc47",
    "category-gaming-light": "#ccf4e5",
    "category-gaming-default": "#00c17a",
    "category-mobile-light": "#dbf4fb",
    "category-mobile-default": "#4cc7e9",
    "category-tv-light": "#e3e5ff",
    "category-tv-default": "#717fff",
    "category-finance-light": "#dbf4df",
    "category-finance-default": "#53c866",
    "category-government-light": "#f2efe8",
    "category-government-default": "#c1b298",
    "category-electricity-light": "#fff4cc",
    "category-electricity-default": "#ffa800",
    "category-gas-light": "#ffe7d6",
    "category-gas-default": "#ff8933",
    "category-water-light": "#d5f7f7",
    "category-water-default": "#34dcda",
    "category-education-light": "#d3f4ff",
    "category-education-default": "#02bdfa",
    "category-pet-light": "#fdeae4",
    "category-pet-default": "#f59776",
    "category-baby-light": "#f4e8f7",
    "category-baby-default": "#c68ed7",
    "category-living-light": "#ddf6eb",
    "category-living-default": "#68dcaa",
    "category-beauty-light": "#ffe2de",
    "category-beauty-default": "#ff68d1",
    "category-health-light": "#ffe2de",
    "category-health-default": "#ff6e5b",
    "category-internet-light": "#d8eefd",
    "category-internet-default": "#20a2f8",
    "category-security-light": "#dfeaff",
    "category-security-default": "#1f8bef",
    "category-car-light": "#ffe7e5",
    "category-car-default": "#ff756c",
    "category-no-category-light": "#e9e9e9",
    "category-no-category-default": "#929191"
  },
  palette: {
    "palette-blue-10": "#b0d1ff",
    "palette-blue-20": "#72abff",
    "palette-blue-30": "#4591ff",
    "palette-blue-40": "#217cff",
    "palette-blue-50": "#0054ea",
    "palette-blue-60": "#0047c7",
    "palette-blue-70": "#022a9a",
    "palette-blue-80": "#002066",
    "palette-blue-90": "#001645",
    "palette-blue-05": "#e0edff",
    "palette-grey-10": "#eff1f5",
    "palette-grey-20": "#dee2ec",
    "palette-grey-30": "#cfd5e4",
    "palette-grey-40": "#b7bfd3",
    "palette-grey-50": "#929dba",
    "palette-grey-60": "#606882",
    "palette-grey-70": "#454b5e",
    "palette-grey-80": "#313643",
    "palette-grey-90": "#21283e",
    "palette-grey-95": "#171f2a",
    "palette-grey-00": "#ffffff",
    "palette-grey-05": "#fafafa",
    "palette-magenta-10": "#ffbdcc",
    "palette-magenta-20": "#ffa9bc",
    "palette-magenta-30": "#ffa1b5",
    "palette-magenta-40": "#ff7391",
    "palette-magenta-50": "#ff5874",
    "palette-magenta-60": "#da2b55",
    "palette-magenta-70": "#cc1b4a",
    "palette-magenta-80": "#991438",
    "palette-magenta-90": "#660e25",
    "palette-magenta-05": "#ffdde4",
    "palette-yellow-10": "#f9f4cc",
    "palette-yellow-20": "#f4edb4",
    "palette-yellow-30": "#f8e46b",
    "palette-yellow-40": "#f8da32",
    "palette-yellow-50": "#f9d205",
    "palette-yellow-60": "#b49200",
    "palette-yellow-70": "#836d10",
    "palette-yellow-80": "#5b4f17",
    "palette-yellow-90": "#3a330f",
    "palette-yellow-05": "#fcf8d8",
    "palette-red-10": "#ffd2ca",
    "palette-red-20": "#ffa598",
    "palette-red-30": "#ff7868",
    "palette-red-40": "#f64e45",
    "palette-red-50": "#e3131a",
    "palette-red-60": "#bc1d19",
    "palette-red-70": "#93130d",
    "palette-red-80": "#660b04",
    "palette-red-90": "#330500",
    "palette-red-05": "#ffe9e4",
    "palette-green-10": "#d9f4eb",
    "palette-green-20": "#beeedc",
    "palette-green-30": "#7fd1b3",
    "palette-green-40": "#55c19a",
    "palette-green-50": "#2ab281",
    "palette-green-60": "#1c8367",
    "palette-green-70": "#196b4d",
    "palette-green-80": "#115139",
    "palette-green-90": "#08241a",
    "palette-green-05": "#d9f4eb"
  }
}, ot = {
  sm: "0rem 0.125rem 0.5rem 0rem #3a3a3a33",
  md: "0rem 0.25rem 1rem 0rem #3a3a3a33",
  lg: "0rem 0.5rem 2rem 0rem #3a3a3a33"
}, st = {
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  72: "4.5rem",
  80: "5rem",
  96: "6rem",
  104: "6.5rem",
  base: "16px",
  none: 0
}, dt = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  full: "100%",
  none: 0
}, ut = {
  thin: "0.0625rem",
  medium: "0.125rem",
  strong: "0.25rem"
}, ft = {
  primary: "Public Sans,-apple-system,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
  secondary: "Sofia Pro,-apple-system,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif"
}, ht = {
  light: "200",
  regular: "400",
  bold: "600"
}, mt = {
  tight: "-0.0125rem",
  normal: 0
}, pt = {
  none: 0,
  normal: "1",
  base: "1.2",
  tall: "1.4"
}, vt = {
  1: "0.625rem",
  2: "0.75rem",
  3: "0.875rem",
  4: "1rem",
  5: "1.125rem",
  6: "1.375rem",
  7: "2.125rem",
  base: "16px"
}, gt = {
  upper: "uppercase",
  lower: "lowercase",
  capitalize: "capitalize",
  none: "none"
}, bt = {
  body: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$4",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$4",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$4",
        textDecoration: "$undefined",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm",
        textDecoration: "$undefined"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm",
        textDecoration: "$undefined"
      }
    }
  },
  label: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$5"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$5"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$3"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$3"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$2"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$2"
      }
    }
  },
  button: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$4"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$4",
        letterSpacing: "$normal"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$3"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$3"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$1"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$1"
      }
    }
  },
  number: {
    lg: {
      light: {
        fontFamily: "$primary",
        fontWeight: "$light",
        lineHeight: "$normal",
        fontSize: "$7"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$7"
      }
    },
    md: {
      light: {
        fontFamily: "$primary",
        fontWeight: "$light",
        lineHeight: "$normal",
        fontSize: "$6"
      },
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$6"
      }
    },
    sm: {
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$4"
      },
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$4"
      }
    }
  },
  title: {
    lg: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$6",
      letterSpacing: "$normal"
    },
    md: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$5",
      letterSpacing: "$normal"
    },
    sm: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$4",
      letterSpacing: "$normal"
    },
    xs: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$3",
      letterSpacing: "$normal"
    }
  },
  heading: {
    sm: {
      fontFamily: "$primary",
      fontWeight: "$regular",
      lineHeight: "$normal",
      fontSize: "$4",
      letterSpacing: "$normal"
    }
  }
}, $t = {
  base: "16px",
  sm: "0.5rem"
}, yt = {
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem",
  96: "6rem",
  128: "8rem",
  base: "16px",
  none: 0
}, Zt = {
  breakpoints: {
    sm: "(min-width: 0)",
    md: "(min-width: 46.25rem)",
    lg: "(min-width: 61.25rem)",
    xl: "(min-width: 87.5rem)",
    "2xl": "(min-width: 100rem)"
  }
}, xt = {
  none: "none",
  underline: "underline"
}, R1 = {
  color: lt,
  boxShadow: ot,
  spacing: st,
  borderRadius: dt,
  borderWidth: ut,
  fontFamilies: ft,
  fontWeights: ht,
  letterSpacing: mt,
  lineHeights: pt,
  fontSizes: vt,
  textCase: gt,
  typography: bt,
  paragraphSpacing: $t,
  sizing: yt,
  other: Zt,
  textDecoration: xt
}, St = {
  "primary-light": "#b0d1ff",
  "primary-default": "#022a9a",
  "primary-middle": "#022a9a",
  "primary-dark": "#002066",
  "primary-darker": "#001645",
  "primary-lighter": "#e0edff",
  "bg-light": "#ffffff",
  "bg-default": "#fafafa",
  "bg-hover": "#eff1f5",
  "bg-press": "#dee2ec",
  "bg-primary-default": "#022a9a",
  "bg-primary-hover": "#0047c7",
  "bg-primary-press": "#0054ea",
  "neutral-white": "#ffffff",
  "neutral-lighter": "#eff1f5",
  "neutral-light": "#dee2ec",
  "neutral-middle": "#b7bfd3",
  "neutral-dark": "#606882",
  "neutral-darker": "#313643",
  "accent-light": "#ffdde4",
  "accent-middle": "#ff7391",
  "accent-dark": "#991438",
  "error-light": "#ffe9e4",
  "error-middle": "#e3131a",
  "error-dark": "#bc1d19",
  "success-light": "#d9f4eb",
  "success-middle": "#1c8367",
  "success-dark": "#196b4d",
  "warning-light": "#fcf8d8",
  "warning-middle": "#f9d205",
  "warning-dark": "#836d10",
  "information-light": "#e0edff",
  "information-middle": "#0054ea",
  "information-dark": "#022a9a",
  brand: {
    "brand-coral": "#FF5874",
    "brand-blue": "#022a9a"
  },
  "text-warning": "#836d10",
  "text-error": "#e3131a",
  "text-success": "#1c8367",
  "text-information": "#022a9a",
  "text-default": "#606882",
  "text-dark": "#313643",
  "text-accent": "#991438",
  "text-inverted": "#ffffff",
  "text-link-default": "#0054ea",
  "text-link-hover": "#0047c7",
  "text-link-press": "#022a9a",
  "element-primary-default": "#022a9a",
  "element-primary-hover": "#0047c7",
  "element-primary-press": "#0054ea",
  "element-active-default": "#ff7391",
  focus: "#b0d1ff",
  "active-light": "#ffdde4",
  "active-middle": "#ff7391",
  "active-dark": "#da2b55"
}, Mt = {
  color: St
}, {
  styled: O,
  css: Mi,
  globalCss: h2,
  keyframes: Ht,
  getCssText: Hi,
  theme: Ci,
  createTheme: Ct,
  config: Vi
} = u2({
  theme: {
    colors: {
      ...R1.color.category,
      ...R1.color.palette,
      ...Mt.color
    },
    space: {
      ...R1.spacing
    },
    fontSizes: {
      ...R1.fontSizes
    },
    fonts: {
      ...R1.fontFamilies
    },
    fontWeights: {
      ...R1.fontWeights
    },
    lineHeights: {
      ...R1.lineHeights
    },
    letterSpacings: {
      ...R1.letterSpacing
    },
    sizes: {
      ...R1.sizing
    },
    borderWidths: {
      ...R1.borderWidth
    },
    borderStyles: {},
    radii: { ...R1.borderRadius },
    shadows: { ...R1.boxShadow },
    transitions: {
      default: "all 0.3s ease-in-out"
    }
  },
  media: {
    ...R1.other.breakpoints
  },
  utils: {
    m: (e) => ({ margin: e }),
    my: (e) => ({ marginTop: e, marginBottom: e }),
    mx: (e) => ({ marginLeft: e, marginRight: e }),
    p: (e) => ({ padding: e }),
    px: (e) => ({ paddingLeft: e, paddingRight: e }),
    py: (e) => ({ paddingTop: e, paddingBottom: e }),
    pt: (e) => ({ paddingTop: e }),
    pl: (e) => ({ paddingLeft: e }),
    pr: (e) => ({ paddingRight: e }),
    pb: (e) => ({ paddingBottom: e }),
    mr: (e) => ({ marginRight: e }),
    ml: (e) => ({ marginLeft: e }),
    mt: (e) => ({ marginTop: e }),
    mb: (e) => ({ marginBottom: e }),
    w: (e) => ({ width: e + "%" }),
    h: (e) => ({ height: e + "%" }),
    bg: (e) => ({ backgroundColor: e })
  }
}), m2 = Ct({
  colors: {
    ...W5.color,
    ...W5.color.brand
  }
}), q = {
  ...R1.typography
}, wi = {
  ...R1.other.breakpoints
}, Vt = {
  dark: {
    color: "$text-dark"
  },
  default: {
    color: "$text-default"
  },
  disabled: {
    color: "$neutral-middle"
  },
  light: {
    color: "$neutral-light"
  },
  white: {
    color: "$neutral-white"
  },
  error: {
    color: "$error-dark"
  },
  warning: {
    color: "$warning-dark"
  },
  information: {
    color: "$information-dark"
  },
  primary: {
    color: "$primary-default"
  },
  success: {
    color: "$success-dark"
  },
  accent: {
    color: "$accent-dark"
  }
}, wt = h2({
  "html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, main, menu, nav, output, ruby, section, summary, time, mark, audio, video": {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline",
    boxSizing: "border-box",
    "font-smooth": "always",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale"
  },
  "*, ::after, ::before": {
    boxSizing: "inherit"
  },
  "article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section": {
    display: "block"
  },
  "*[hidden]": {
    display: "none"
  },
  html: {
    fontSize: "var(--fontSizes-base)"
  },
  body: {
    lineHeight: "1",
    fontFamily: "var(--fonts-primary)",
    fontSize: "var(--fontSizes-base)",
    color: "var(--colors-text-default)",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale"
  },
  "ol, ul": {
    listStyle: "none"
  },
  "blockquote, q": {
    quotes: "none"
  },
  "blockquote:before, blockquote:after, q:before, q:after": {
    content: ""
  },
  table: {
    borderSpacing: "0"
  },
  a: {
    textDecoration: "none",
    "&:focus": {
      outline: "none"
    }
  },
  hr: {
    margin: "0px"
  },
  "[type=button], [type=reset], [type=submit], button": {
    "-webkit-appearance": "button"
  },
  svg: {
    path: {
      width: "100%",
      height: "100%"
    }
  },
  "* &:focus": {
    outline: "none"
  },
  "* &:focus-visible": {
    outline: "0.25rem var(--colors-primary-light) solid"
  }
}), kt = h2({
  "@import": 'url("https://fonts.googleapis.com/css2?family=Public+Sans:wght@100;200;400;600&display=swap")',
  ".abra": {
    width: "100%",
    height: "100%",
    "font-smooth": "always",
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "grayscale",
    fontFamily: "var(--fonts-primary)",
    color: "var(--colors-text-default)"
  }
}), p2 = H0({
  mode: "light",
  brand: "uala"
});
var Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, T0 = { exports: {} }, $0 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j5;
function Rt() {
  if (j5)
    return $0;
  j5 = 1;
  var e = b1, a = Symbol.for("react.element"), i = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, l, d) {
    var v, u = {}, f = null, h = null;
    d !== void 0 && (f = "" + d), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (v in l)
      r.call(l, v) && !c.hasOwnProperty(v) && (u[v] = l[v]);
    if (o && o.defaultProps)
      for (v in l = o.defaultProps, l)
        u[v] === void 0 && (u[v] = l[v]);
    return { $$typeof: a, type: o, key: f, ref: h, props: u, _owner: n.current };
  }
  return $0.Fragment = i, $0.jsx = s, $0.jsxs = s, $0;
}
var y0 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B5;
function At() {
  return B5 || (B5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = b1, a = Symbol.for("react.element"), i = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), $ = Symbol.iterator, b = "@@iterator";
    function x(m) {
      if (m === null || typeof m != "object")
        return null;
      var R = $ && m[$] || m[b];
      return typeof R == "function" ? R : null;
    }
    var Z = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(m) {
      {
        for (var R = arguments.length, E = new Array(R > 1 ? R - 1 : 0), X = 1; X < R; X++)
          E[X - 1] = arguments[X];
        P("error", m, E);
      }
    }
    function P(m, R, E) {
      {
        var X = Z.ReactDebugCurrentFrame, o1 = X.getStackAddendum();
        o1 !== "" && (R += "%s", E = E.concat([o1]));
        var p1 = E.map(function(c1) {
          return String(c1);
        });
        p1.unshift("Warning: " + R), Function.prototype.apply.call(console[m], console, p1);
      }
    }
    var z = !1, L = !1, F = !1, I = !1, U = !1, T;
    T = Symbol.for("react.module.reference");
    function M(m) {
      return !!(typeof m == "string" || typeof m == "function" || m === r || m === c || U || m === n || m === d || m === v || I || m === h || z || L || F || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === u || m.$$typeof === s || m.$$typeof === o || m.$$typeof === l || m.$$typeof === T || m.getModuleId !== void 0));
    }
    function Y(m, R, E) {
      var X = m.displayName;
      if (X)
        return X;
      var o1 = R.displayName || R.name || "";
      return o1 !== "" ? E + "(" + o1 + ")" : E;
    }
    function Q(m) {
      return m.displayName || "Context";
    }
    function H(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case r:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case n:
          return "StrictMode";
        case d:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case o:
            var R = m;
            return Q(R) + ".Consumer";
          case s:
            var E = m;
            return Q(E._context) + ".Provider";
          case l:
            return Y(m, m.render, "ForwardRef");
          case u:
            var X = m.displayName || null;
            return X !== null ? X : H(m.type) || "Memo";
          case f: {
            var o1 = m, p1 = o1._payload, c1 = o1._init;
            try {
              return H(c1(p1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var y = Object.assign, p = 0, C, g, k, w, _, j, G;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function l1() {
      {
        if (p === 0) {
          C = console.log, g = console.info, k = console.warn, w = console.error, _ = console.group, j = console.groupCollapsed, G = console.groupEnd;
          var m = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: m,
            log: m,
            warn: m,
            error: m,
            group: m,
            groupCollapsed: m,
            groupEnd: m
          });
        }
        p++;
      }
    }
    function n1() {
      {
        if (p--, p === 0) {
          var m = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: y({}, m, {
              value: C
            }),
            info: y({}, m, {
              value: g
            }),
            warn: y({}, m, {
              value: k
            }),
            error: y({}, m, {
              value: w
            }),
            group: y({}, m, {
              value: _
            }),
            groupCollapsed: y({}, m, {
              value: j
            }),
            groupEnd: y({}, m, {
              value: G
            })
          });
        }
        p < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var d1 = Z.ReactCurrentDispatcher, Z1;
    function g1(m, R, E) {
      {
        if (Z1 === void 0)
          try {
            throw Error();
          } catch (o1) {
            var X = o1.stack.trim().match(/\n( *(at )?)/);
            Z1 = X && X[1] || "";
          }
        return `
` + Z1 + m;
      }
    }
    var e1 = !1, r1;
    {
      var V1 = typeof WeakMap == "function" ? WeakMap : Map;
      r1 = new V1();
    }
    function N(m, R) {
      if (!m || e1)
        return "";
      {
        var E = r1.get(m);
        if (E !== void 0)
          return E;
      }
      var X;
      e1 = !0;
      var o1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var p1;
      p1 = d1.current, d1.current = null, l1();
      try {
        if (R) {
          var c1 = function() {
            throw Error();
          };
          if (Object.defineProperty(c1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(c1, []);
            } catch (G1) {
              X = G1;
            }
            Reflect.construct(m, [], c1);
          } else {
            try {
              c1.call();
            } catch (G1) {
              X = G1;
            }
            m.call(c1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (G1) {
            X = G1;
          }
          m();
        }
      } catch (G1) {
        if (G1 && X && typeof G1.stack == "string") {
          for (var i1 = G1.stack.split(`
`), k1 = X.stack.split(`
`), M1 = i1.length - 1, H1 = k1.length - 1; M1 >= 1 && H1 >= 0 && i1[M1] !== k1[H1]; )
            H1--;
          for (; M1 >= 1 && H1 >= 0; M1--, H1--)
            if (i1[M1] !== k1[H1]) {
              if (M1 !== 1 || H1 !== 1)
                do
                  if (M1--, H1--, H1 < 0 || i1[M1] !== k1[H1]) {
                    var I1 = `
` + i1[M1].replace(" at new ", " at ");
                    return m.displayName && I1.includes("<anonymous>") && (I1 = I1.replace("<anonymous>", m.displayName)), typeof m == "function" && r1.set(m, I1), I1;
                  }
                while (M1 >= 1 && H1 >= 0);
              break;
            }
        }
      } finally {
        e1 = !1, d1.current = p1, n1(), Error.prepareStackTrace = o1;
      }
      var d0 = m ? m.displayName || m.name : "", z5 = d0 ? g1(d0) : "";
      return typeof m == "function" && r1.set(m, z5), z5;
    }
    function W(m, R, E) {
      return N(m, !1);
    }
    function J(m) {
      var R = m.prototype;
      return !!(R && R.isReactComponent);
    }
    function a1(m, R, E) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return N(m, J(m));
      if (typeof m == "string")
        return g1(m);
      switch (m) {
        case d:
          return g1("Suspense");
        case v:
          return g1("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case l:
            return W(m.render);
          case u:
            return a1(m.type, R, E);
          case f: {
            var X = m, o1 = X._payload, p1 = X._init;
            try {
              return a1(p1(o1), R, E);
            } catch {
            }
          }
        }
      return "";
    }
    var h1 = Object.prototype.hasOwnProperty, m1 = {}, x1 = Z.ReactDebugCurrentFrame;
    function S1(m) {
      if (m) {
        var R = m._owner, E = a1(m.type, m._source, R ? R.type : null);
        x1.setExtraStackFrame(E);
      } else
        x1.setExtraStackFrame(null);
    }
    function O1(m, R, E, X, o1) {
      {
        var p1 = Function.call.bind(h1);
        for (var c1 in m)
          if (p1(m, c1)) {
            var i1 = void 0;
            try {
              if (typeof m[c1] != "function") {
                var k1 = Error((X || "React class") + ": " + E + " type `" + c1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[c1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw k1.name = "Invariant Violation", k1;
              }
              i1 = m[c1](R, c1, X, E, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M1) {
              i1 = M1;
            }
            i1 && !(i1 instanceof Error) && (S1(o1), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", E, c1, typeof i1), S1(null)), i1 instanceof Error && !(i1.message in m1) && (m1[i1.message] = !0, S1(o1), S("Failed %s type: %s", E, i1.message), S1(null));
          }
      }
    }
    var K1 = Array.isArray;
    function J0(m) {
      return K1(m);
    }
    function ue(m) {
      {
        var R = typeof Symbol == "function" && Symbol.toStringTag, E = R && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return E;
      }
    }
    function fe(m) {
      try {
        return H5(m), !1;
      } catch {
        return !0;
      }
    }
    function H5(m) {
      return "" + m;
    }
    function C5(m) {
      if (fe(m))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(m)), H5(m);
    }
    var g0 = Z.ReactCurrentOwner, he = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, V5, w5, X0;
    X0 = {};
    function me(m) {
      if (h1.call(m, "ref")) {
        var R = Object.getOwnPropertyDescriptor(m, "ref").get;
        if (R && R.isReactWarning)
          return !1;
      }
      return m.ref !== void 0;
    }
    function pe(m) {
      if (h1.call(m, "key")) {
        var R = Object.getOwnPropertyDescriptor(m, "key").get;
        if (R && R.isReactWarning)
          return !1;
      }
      return m.key !== void 0;
    }
    function ve(m, R) {
      if (typeof m.ref == "string" && g0.current && R && g0.current.stateNode !== R) {
        var E = H(g0.current.type);
        X0[E] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(g0.current.type), m.ref), X0[E] = !0);
      }
    }
    function ge(m, R) {
      {
        var E = function() {
          V5 || (V5 = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", R));
        };
        E.isReactWarning = !0, Object.defineProperty(m, "key", {
          get: E,
          configurable: !0
        });
      }
    }
    function be(m, R) {
      {
        var E = function() {
          w5 || (w5 = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", R));
        };
        E.isReactWarning = !0, Object.defineProperty(m, "ref", {
          get: E,
          configurable: !0
        });
      }
    }
    var $e = function(m, R, E, X, o1, p1, c1) {
      var i1 = {
        $$typeof: a,
        type: m,
        key: R,
        ref: E,
        props: c1,
        _owner: p1
      };
      return i1._store = {}, Object.defineProperty(i1._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i1, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(i1, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o1
      }), Object.freeze && (Object.freeze(i1.props), Object.freeze(i1)), i1;
    };
    function ye(m, R, E, X, o1) {
      {
        var p1, c1 = {}, i1 = null, k1 = null;
        E !== void 0 && (C5(E), i1 = "" + E), pe(R) && (C5(R.key), i1 = "" + R.key), me(R) && (k1 = R.ref, ve(R, o1));
        for (p1 in R)
          h1.call(R, p1) && !he.hasOwnProperty(p1) && (c1[p1] = R[p1]);
        if (m && m.defaultProps) {
          var M1 = m.defaultProps;
          for (p1 in M1)
            c1[p1] === void 0 && (c1[p1] = M1[p1]);
        }
        if (i1 || k1) {
          var H1 = typeof m == "function" ? m.displayName || m.name || "Unknown" : m;
          i1 && ge(c1, H1), k1 && be(c1, H1);
        }
        return $e(m, i1, k1, o1, X, g0.current, c1);
      }
    }
    var Q0 = Z.ReactCurrentOwner, k5 = Z.ReactDebugCurrentFrame;
    function s0(m) {
      if (m) {
        var R = m._owner, E = a1(m.type, m._source, R ? R.type : null);
        k5.setExtraStackFrame(E);
      } else
        k5.setExtraStackFrame(null);
    }
    var e5;
    e5 = !1;
    function t5(m) {
      return typeof m == "object" && m !== null && m.$$typeof === a;
    }
    function D5() {
      {
        if (Q0.current) {
          var m = H(Q0.current.type);
          if (m)
            return `

Check the render method of \`` + m + "`.";
        }
        return "";
      }
    }
    function Ze(m) {
      {
        if (m !== void 0) {
          var R = m.fileName.replace(/^.*[\\\/]/, ""), E = m.lineNumber;
          return `

Check your code at ` + R + ":" + E + ".";
        }
        return "";
      }
    }
    var R5 = {};
    function xe(m) {
      {
        var R = D5();
        if (!R) {
          var E = typeof m == "string" ? m : m.displayName || m.name;
          E && (R = `

Check the top-level render call using <` + E + ">.");
        }
        return R;
      }
    }
    function A5(m, R) {
      {
        if (!m._store || m._store.validated || m.key != null)
          return;
        m._store.validated = !0;
        var E = xe(R);
        if (R5[E])
          return;
        R5[E] = !0;
        var X = "";
        m && m._owner && m._owner !== Q0.current && (X = " It was passed a child from " + H(m._owner.type) + "."), s0(m), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', E, X), s0(null);
      }
    }
    function _5(m, R) {
      {
        if (typeof m != "object")
          return;
        if (J0(m))
          for (var E = 0; E < m.length; E++) {
            var X = m[E];
            t5(X) && A5(X, R);
          }
        else if (t5(m))
          m._store && (m._store.validated = !0);
        else if (m) {
          var o1 = x(m);
          if (typeof o1 == "function" && o1 !== m.entries)
            for (var p1 = o1.call(m), c1; !(c1 = p1.next()).done; )
              t5(c1.value) && A5(c1.value, R);
        }
      }
    }
    function Se(m) {
      {
        var R = m.type;
        if (R == null || typeof R == "string")
          return;
        var E;
        if (typeof R == "function")
          E = R.propTypes;
        else if (typeof R == "object" && (R.$$typeof === l || R.$$typeof === u))
          E = R.propTypes;
        else
          return;
        if (E) {
          var X = H(R);
          O1(E, m.props, "prop", X, m);
        } else if (R.PropTypes !== void 0 && !e5) {
          e5 = !0;
          var o1 = H(R);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o1 || "Unknown");
        }
        typeof R.getDefaultProps == "function" && !R.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Me(m) {
      {
        for (var R = Object.keys(m.props), E = 0; E < R.length; E++) {
          var X = R[E];
          if (X !== "children" && X !== "key") {
            s0(m), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), s0(null);
            break;
          }
        }
        m.ref !== null && (s0(m), S("Invalid attribute `ref` supplied to `React.Fragment`."), s0(null));
      }
    }
    function P5(m, R, E, X, o1, p1) {
      {
        var c1 = M(m);
        if (!c1) {
          var i1 = "";
          (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (i1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var k1 = Ze(o1);
          k1 ? i1 += k1 : i1 += D5();
          var M1;
          m === null ? M1 = "null" : J0(m) ? M1 = "array" : m !== void 0 && m.$$typeof === a ? (M1 = "<" + (H(m.type) || "Unknown") + " />", i1 = " Did you accidentally export a JSX literal instead of a component?") : M1 = typeof m, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M1, i1);
        }
        var H1 = ye(m, R, E, o1, p1);
        if (H1 == null)
          return H1;
        if (c1) {
          var I1 = R.children;
          if (I1 !== void 0)
            if (X)
              if (J0(I1)) {
                for (var d0 = 0; d0 < I1.length; d0++)
                  _5(I1[d0], m);
                Object.freeze && Object.freeze(I1);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _5(I1, m);
        }
        return m === r ? Me(H1) : Se(H1), H1;
      }
    }
    function He(m, R, E) {
      return P5(m, R, E, !0);
    }
    function Ce(m, R, E) {
      return P5(m, R, E, !1);
    }
    var Ve = Ce, we = He;
    y0.Fragment = r, y0.jsx = Ve, y0.jsxs = we;
  }()), y0;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Rt() : e.exports = At();
})(T0);
const A = T0.exports.Fragment, t = T0.exports.jsx, V = T0.exports.jsxs, _t = ({
  children: e,
  resetCSS: a,
  mode: i = "light"
}) => (a && wt(), kt(), /* @__PURE__ */ t("div", {
  className: i === "dark" ? m2 : "uala-abra-light abra",
  children: /* @__PURE__ */ t(p2.Provider, {
    value: {
      mode: i,
      brand: "uala"
    },
    children: e
  })
})), T1 = O("svg", {
  fill: "currentColor",
  color: "currentColor",
  "&:not(.loyalty-color)": {
    "& path": {
      fill: "currentColor",
      color: "currentColor"
    }
  },
  variants: {
    size: {
      sm: {
        width: "$16",
        height: "$16"
      },
      md: {
        width: "$24",
        height: "$24"
      },
      lg: {
        width: "$32",
        height: "$32"
      }
    },
    color: {
      default: {
        color: "$neutral-dark"
      },
      light: {
        color: "$neutral-white"
      },
      dark: {
        color: "$neutral-darker"
      },
      primary: {
        color: "$element-primary-default"
      },
      error: {
        color: "$error-middle"
      },
      warning: {
        color: "$warning-middle"
      },
      success: {
        color: "$success-middle"
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Pt = O("svg", {
  width: "$32",
  height: "$32"
}), P1 = O("span", {
  all: "unset",
  variants: {
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {}
    },
    isInverted: {
      true: {
        color: "$neutral-white"
      },
      false: {
        color: "$neutral-darker"
      }
    }
  },
  defaultVariants: {
    size: "md",
    isInverted: !1
  }
}), Y5 = O("span", {
  variants: {
    size: {
      xs: {
        ...q.label.md.bold,
        marginRight: 0
      },
      sm: {
        ...q.number.sm.regular,
        marginRight: "$4",
        fontWeight: 500
      },
      md: {
        ...q.number.md.regular,
        marginRight: "$4",
        fontWeight: 500
      },
      lg: {
        ...q.number.lg.light,
        marginRight: "$8",
        fontWeight: 500
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), G5 = O("span", {
  variants: {
    size: {
      xs: {
        ...q.label.md.bold
      },
      sm: {
        ...q.number.sm.regular,
        fontWeight: 500
      },
      md: {
        ...q.number.md.regular,
        fontWeight: 500
      },
      lg: {
        ...q.number.lg.light,
        fontWeight: 500
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), zt = O("span", {
  variants: {
    size: {
      xs: {
        ...q.label.md.bold
      },
      sm: {
        ...q.number.sm.regular,
        fontWeight: 500
      },
      md: {
        ...q.number.sm.regular,
        fontWeight: 500
      },
      lg: {
        ...q.number.md.regular,
        fontWeight: 500
      }
    },
    isCrypto: {
      true: {},
      false: {}
    }
  },
  defaultVariants: {
    size: "md"
  },
  compoundVariants: [
    {
      size: "md",
      isCrypto: !0,
      css: {
        ...q.number.md.regular
      }
    },
    {
      size: "lg",
      isCrypto: !0,
      css: {
        ...q.number.lg.light
      }
    }
  ]
}), L1 = O("a", {
  all: "unset",
  backgroundColor: "transparent",
  border: "none",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  textDecoration: "underline",
  color: "$text-link-default",
  borderRadius: "$xs",
  cursor: "pointer",
  "&:hover": {
    color: "$$text-link-hover"
  },
  "&:active": {
    color: "$text-link-press"
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    outline: "0.25rem solid $focus"
  },
  "&:disabled": {
    color: "$primary-darker"
  },
  variants: {
    isInline: {
      true: {
        wordBreak: "break-word",
        marginRight: "$4"
      },
      false: {
        minHeight: "$48",
        padding: "0 $4",
        borderRadius: "$sm",
        ...q.body.md.link,
        textDecoration: "underline"
      }
    },
    size: {
      sm: {
        ...q.body.sm.link,
        textDecoration: "underline",
        [`& ${T1}`]: {
          width: 12,
          height: 12,
          marginLeft: -4
        }
      },
      md: {
        ...q.body.md.link,
        textDecoration: "underline"
      },
      lg: {
        ...q.body.lg.link,
        "& svg": {
          marginTop: 1
        },
        textDecoration: "underline"
      }
    },
    isExternal: {
      true: {
        paddingRight: "$4",
        "& svg": {
          marginLeft: "-1px"
        }
      },
      false: {}
    },
    isDisabled: {
      true: {
        pointerEvents: "none",
        color: "$neutral-middle"
      }
    }
  },
  defaultVariants: {
    isInline: !1,
    isExternal: !1,
    isDisabled: !1
  }
}), J1 = O("p", {
  all: "unset",
  color: "$neutral-darker",
  [`& ${L1} ${T1}`]: {
    marginRight: 4
  },
  [`& ${P1}`]: {
    all: "unset"
  },
  [`& ${P1} span, & ${L1}`]: {
    display: "inline",
    padding: 0,
    "& span": {
      display: "inline-flex"
    }
  },
  variants: {
    size: {
      sm: {
        ...q.body.sm.regular,
        [`& ${P1} span, & ${L1}`]: {
          ...q.body.sm.regular
        },
        [`& ${L1} ${T1}`]: {
          with: 12,
          height: 12,
          marginLeft: -4
        }
      },
      md: {
        ...q.body.md.regular,
        [`& ${P1} span, & ${L1}`]: {
          ...q.body.md.regular
        }
      },
      lg: {
        [`& ${P1} span, & ${L1}`]: {
          ...q.body.lg.regular
        },
        ...q.body.lg.regular
      }
    },
    align: {
      center: {
        textAlign: "center",
        [`& ${P1}, & ${L1}`]: {
          textAlign: "center"
        }
      },
      right: {
        textAlign: "right",
        [`& ${P1}, & ${L1}`]: {
          textAlign: "right"
        }
      },
      left: {
        textAlign: "left",
        [`& ${P1}, & ${L1}`]: {
          textAlign: "left"
        }
      }
    },
    weight: {
      regular: {
        fontWeight: "$regular",
        [`& ${P1}, & ${L1}`]: {
          fontWeight: "$regular"
        }
      },
      bold: {
        fontWeight: "$bold",
        [`& ${P1}, & ${L1}`]: {
          fontWeight: "$bold"
        }
      }
    },
    color: Vt
  },
  defaultVariants: {
    color: "default",
    size: "lg",
    weight: "regular"
  }
}), X1 = O("h2", {
  all: "unset",
  fontFamily: "$primary",
  lineHeight: "$base",
  letterSpacing: "$normal",
  color: "$neutral-darker",
  fontWeight: "$bold",
  variants: {
    size: {
      xs: {
        ...q.title.xs
      },
      sm: {
        ...q.title.sm
      },
      md: {
        ...q.title.md
      },
      lg: {
        ...q.title.lg
      }
    },
    align: {
      center: {
        textAlign: "center"
      },
      right: {
        textAlign: "right"
      },
      left: {
        textAlign: "left"
      }
    },
    color: {
      default: {
        color: "$text-dark"
      },
      disabled: {
        color: "$neutral-middle"
      },
      light: {
        color: "$neutral-dark"
      },
      white: {
        color: "$neutral-white"
      },
      error: {
        color: "$error-middle"
      },
      warning: {
        color: "$warning-dark"
      },
      information: {
        color: "$information-default"
      },
      primary: {
        color: "$primary-default"
      },
      success: {
        color: "$success-middle"
      }
    }
  },
  defaultVariants: {
    color: "default",
    size: "lg"
  }
}), It = O("div", {
  all: "unset",
  backgroundColor: "transparent",
  padding: "$12",
  display: "flex",
  flexDirection: "row",
  gap: "$8",
  borderRadius: "$md",
  [`& ${T1}`]: {
    mt: -4
  },
  variants: {
    variant: {
      error: {
        [`& ${T1}`]: {
          color: "$error-middle"
        },
        border: "1px solid $error-middle",
        [`& ${X1}`]: {
          color: "$text-error"
        },
        [`& ${J1}`]: {
          color: "$text-error"
        }
      },
      information: {
        [`& ${T1}`]: {
          color: "$information-dark"
        },
        border: "1px solid $information-middle",
        [`& ${X1}`]: {
          color: "$text-information"
        },
        [`& ${J1}`]: {
          color: "$text-information"
        }
      },
      security: {
        bg: "$bg-light",
        border: "1px solid transparent",
        [`& ${T1}`]: {
          color: "$element-primary-default"
        },
        [`& ${X1}`]: {
          color: "$neutral-dark"
        },
        [`& ${J1}`]: {
          color: "$text-default"
        }
      },
      default: {
        border: "1px solid $neutral-light",
        [`& ${X1}`]: {
          color: "$neutral-dark"
        },
        [`& ${J1}`]: {
          color: "$text-default"
        }
      },
      success: {
        [`& ${T1}`]: {
          color: "$success-middle"
        },
        border: "1px solid $success-middle",
        [`& ${X1}`]: {
          color: "$text-success"
        },
        [`& ${J1}`]: {
          color: "$text-success"
        }
      },
      warning: {
        [`& ${T1}`]: {
          color: "$warning-middle"
        },
        border: "1px solid $warning-middle",
        [`& ${X1}`]: {
          color: "$text-warning"
        },
        [`& ${J1}`]: {
          color: "$text-warning"
        }
      }
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Lt = D.forwardRef((e, a) => {
  const {
    children: i,
    title: r,
    description: n,
    variant: c,
    ...s
  } = e, [o, l] = D.useState("status"), [d, v] = D.useState("");
  return D.useLayoutEffect(() => {
    e.role && l(e.role), c === "error" ? (v("denied-circle"), l("alert")) : (l("status"), c === "success" && v("check-circle"), c === "warning" && v("warning-circle"), c === "information" && v("info-circle-feedback"), c === "security" && v("security"), c === "default" && v(""));
  }, [c, e.role]), /* @__PURE__ */ V(It, {
    ref: a,
    ...s,
    variant: c,
    role: o,
    tabIndex: 0,
    "aria-live": e["aria-live"] || o === "alert" ? "assertive" : "polite",
    children: [d ? /* @__PURE__ */ t(B1, {
      children: /* @__PURE__ */ t(_1, {
        name: d
      })
    }) : null, /* @__PURE__ */ V(f1, {
      direction: "column",
      spacing: "4",
      children: [r ? /* @__PURE__ */ t(B0, {
        size: "xs",
        as: "h2",
        children: r
      }) : null, n ? /* @__PURE__ */ t(j0, {
        size: "sm",
        children: n
      }) : null]
    })]
  });
});
Lt.displayName = "Alert";
const P0 = {
  ARS: {
    singular: "peso",
    plural: "pesos",
    cent: "centavo",
    cents: "centavos",
    symbol: "$"
  },
  USD: {
    singular: "d\xF3lar",
    plural: "d\xF3lares",
    cent: "centavo",
    cents: "centavos",
    symbol: "$"
  },
  MXN: {
    singular: "peso",
    plural: "pesos",
    cent: "centavo",
    cents: "centavos",
    symbol: "$"
  },
  PEN: {
    singular: "sol",
    plural: "soles",
    cent: "centavo",
    cents: "centavos",
    symbol: "$"
  },
  COP: {
    singular: "peso",
    plural: "pesos",
    cent: "centavo",
    cents: "centavos",
    symbol: "$"
  }
};
var m5 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, p5 = { exports: {} };
(function(e, a) {
  (function(i, r) {
    e.exports = r();
  })(m5, function() {
    var i = 1e3, r = 6e4, n = 36e5, c = "millisecond", s = "second", o = "minute", l = "hour", d = "day", v = "week", u = "month", f = "quarter", h = "year", $ = "date", b = "Invalid Date", x = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Z = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(H) {
      var y = ["th", "st", "nd", "rd"], p = H % 100;
      return "[" + H + (y[(p - 20) % 10] || y[p] || y[0]) + "]";
    } }, P = function(H, y, p) {
      var C = String(H);
      return !C || C.length >= y ? H : "" + Array(y + 1 - C.length).join(p) + H;
    }, z = { s: P, z: function(H) {
      var y = -H.utcOffset(), p = Math.abs(y), C = Math.floor(p / 60), g = p % 60;
      return (y <= 0 ? "+" : "-") + P(C, 2, "0") + ":" + P(g, 2, "0");
    }, m: function H(y, p) {
      if (y.date() < p.date())
        return -H(p, y);
      var C = 12 * (p.year() - y.year()) + (p.month() - y.month()), g = y.clone().add(C, u), k = p - g < 0, w = y.clone().add(C + (k ? -1 : 1), u);
      return +(-(C + (p - g) / (k ? g - w : w - g)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: u, y: h, w: v, d, D: $, h: l, m: o, s, ms: c, Q: f }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, L = "en", F = {};
    F[L] = S;
    var I = function(H) {
      return H instanceof Y;
    }, U = function H(y, p, C) {
      var g;
      if (!y)
        return L;
      if (typeof y == "string") {
        var k = y.toLowerCase();
        F[k] && (g = k), p && (F[k] = p, g = k);
        var w = y.split("-");
        if (!g && w.length > 1)
          return H(w[0]);
      } else {
        var _ = y.name;
        F[_] = y, g = _;
      }
      return !C && g && (L = g), g || !C && L;
    }, T = function(H, y) {
      if (I(H))
        return H.clone();
      var p = typeof y == "object" ? y : {};
      return p.date = H, p.args = arguments, new Y(p);
    }, M = z;
    M.l = U, M.i = I, M.w = function(H, y) {
      return T(H, { locale: y.$L, utc: y.$u, x: y.$x, $offset: y.$offset });
    };
    var Y = function() {
      function H(p) {
        this.$L = U(p.locale, null, !0), this.parse(p);
      }
      var y = H.prototype;
      return y.parse = function(p) {
        this.$d = function(C) {
          var g = C.date, k = C.utc;
          if (g === null)
            return new Date(NaN);
          if (M.u(g))
            return new Date();
          if (g instanceof Date)
            return new Date(g);
          if (typeof g == "string" && !/Z$/i.test(g)) {
            var w = g.match(x);
            if (w) {
              var _ = w[2] - 1 || 0, j = (w[7] || "0").substring(0, 3);
              return k ? new Date(Date.UTC(w[1], _, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, j)) : new Date(w[1], _, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, j);
            }
          }
          return new Date(g);
        }(p), this.$x = p.x || {}, this.init();
      }, y.init = function() {
        var p = this.$d;
        this.$y = p.getFullYear(), this.$M = p.getMonth(), this.$D = p.getDate(), this.$W = p.getDay(), this.$H = p.getHours(), this.$m = p.getMinutes(), this.$s = p.getSeconds(), this.$ms = p.getMilliseconds();
      }, y.$utils = function() {
        return M;
      }, y.isValid = function() {
        return this.$d.toString() !== b;
      }, y.isSame = function(p, C) {
        var g = T(p);
        return this.startOf(C) <= g && g <= this.endOf(C);
      }, y.isAfter = function(p, C) {
        return T(p) < this.startOf(C);
      }, y.isBefore = function(p, C) {
        return this.endOf(C) < T(p);
      }, y.$g = function(p, C, g) {
        return M.u(p) ? this[C] : this.set(g, p);
      }, y.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, y.valueOf = function() {
        return this.$d.getTime();
      }, y.startOf = function(p, C) {
        var g = this, k = !!M.u(C) || C, w = M.p(p), _ = function(g1, e1) {
          var r1 = M.w(g.$u ? Date.UTC(g.$y, e1, g1) : new Date(g.$y, e1, g1), g);
          return k ? r1 : r1.endOf(d);
        }, j = function(g1, e1) {
          return M.w(g.toDate()[g1].apply(g.toDate("s"), (k ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e1)), g);
        }, G = this.$W, K = this.$M, l1 = this.$D, n1 = "set" + (this.$u ? "UTC" : "");
        switch (w) {
          case h:
            return k ? _(1, 0) : _(31, 11);
          case u:
            return k ? _(1, K) : _(0, K + 1);
          case v:
            var d1 = this.$locale().weekStart || 0, Z1 = (G < d1 ? G + 7 : G) - d1;
            return _(k ? l1 - Z1 : l1 + (6 - Z1), K);
          case d:
          case $:
            return j(n1 + "Hours", 0);
          case l:
            return j(n1 + "Minutes", 1);
          case o:
            return j(n1 + "Seconds", 2);
          case s:
            return j(n1 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, y.endOf = function(p) {
        return this.startOf(p, !1);
      }, y.$set = function(p, C) {
        var g, k = M.p(p), w = "set" + (this.$u ? "UTC" : ""), _ = (g = {}, g[d] = w + "Date", g[$] = w + "Date", g[u] = w + "Month", g[h] = w + "FullYear", g[l] = w + "Hours", g[o] = w + "Minutes", g[s] = w + "Seconds", g[c] = w + "Milliseconds", g)[k], j = k === d ? this.$D + (C - this.$W) : C;
        if (k === u || k === h) {
          var G = this.clone().set($, 1);
          G.$d[_](j), G.init(), this.$d = G.set($, Math.min(this.$D, G.daysInMonth())).$d;
        } else
          _ && this.$d[_](j);
        return this.init(), this;
      }, y.set = function(p, C) {
        return this.clone().$set(p, C);
      }, y.get = function(p) {
        return this[M.p(p)]();
      }, y.add = function(p, C) {
        var g, k = this;
        p = Number(p);
        var w = M.p(C), _ = function(K) {
          var l1 = T(k);
          return M.w(l1.date(l1.date() + Math.round(K * p)), k);
        };
        if (w === u)
          return this.set(u, this.$M + p);
        if (w === h)
          return this.set(h, this.$y + p);
        if (w === d)
          return _(1);
        if (w === v)
          return _(7);
        var j = (g = {}, g[o] = r, g[l] = n, g[s] = i, g)[w] || 1, G = this.$d.getTime() + p * j;
        return M.w(G, this);
      }, y.subtract = function(p, C) {
        return this.add(-1 * p, C);
      }, y.format = function(p) {
        var C = this, g = this.$locale();
        if (!this.isValid())
          return g.invalidDate || b;
        var k = p || "YYYY-MM-DDTHH:mm:ssZ", w = M.z(this), _ = this.$H, j = this.$m, G = this.$M, K = g.weekdays, l1 = g.months, n1 = function(e1, r1, V1, N) {
          return e1 && (e1[r1] || e1(C, k)) || V1[r1].slice(0, N);
        }, d1 = function(e1) {
          return M.s(_ % 12 || 12, e1, "0");
        }, Z1 = g.meridiem || function(e1, r1, V1) {
          var N = e1 < 12 ? "AM" : "PM";
          return V1 ? N.toLowerCase() : N;
        }, g1 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: G + 1, MM: M.s(G + 1, 2, "0"), MMM: n1(g.monthsShort, G, l1, 3), MMMM: n1(l1, G), D: this.$D, DD: M.s(this.$D, 2, "0"), d: String(this.$W), dd: n1(g.weekdaysMin, this.$W, K, 2), ddd: n1(g.weekdaysShort, this.$W, K, 3), dddd: K[this.$W], H: String(_), HH: M.s(_, 2, "0"), h: d1(1), hh: d1(2), a: Z1(_, j, !0), A: Z1(_, j, !1), m: String(j), mm: M.s(j, 2, "0"), s: String(this.$s), ss: M.s(this.$s, 2, "0"), SSS: M.s(this.$ms, 3, "0"), Z: w };
        return k.replace(Z, function(e1, r1) {
          return r1 || g1[e1] || w.replace(":", "");
        });
      }, y.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, y.diff = function(p, C, g) {
        var k, w = M.p(C), _ = T(p), j = (_.utcOffset() - this.utcOffset()) * r, G = this - _, K = M.m(this, _);
        return K = (k = {}, k[h] = K / 12, k[u] = K, k[f] = K / 3, k[v] = (G - j) / 6048e5, k[d] = (G - j) / 864e5, k[l] = G / n, k[o] = G / r, k[s] = G / i, k)[w] || G, g ? K : M.a(K);
      }, y.daysInMonth = function() {
        return this.endOf(u).$D;
      }, y.$locale = function() {
        return F[this.$L];
      }, y.locale = function(p, C) {
        if (!p)
          return this.$L;
        var g = this.clone(), k = U(p, C, !0);
        return k && (g.$L = k), g;
      }, y.clone = function() {
        return M.w(this.$d, this);
      }, y.toDate = function() {
        return new Date(this.valueOf());
      }, y.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, y.toISOString = function() {
        return this.$d.toISOString();
      }, y.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), Q = Y.prototype;
    return T.prototype = Q, [["$ms", c], ["$s", s], ["$m", o], ["$H", l], ["$W", d], ["$M", u], ["$y", h], ["$D", $]].forEach(function(H) {
      Q[H[1]] = function(y) {
        return this.$g(y, H[0], H[1]);
      };
    }), T.extend = function(H, y) {
      return H.$i || (H(y, Y, T), H.$i = !0), T;
    }, T.locale = U, T.isDayjs = I, T.unix = function(H) {
      return T(1e3 * H);
    }, T.en = F[L], T.Ls = F, T.p = {}, T;
  });
})(p5);
const S0 = p5.exports;
var v2 = { exports: {} };
(function(e, a) {
  (function(i, r) {
    e.exports = r(p5.exports);
  })(m5, function(i) {
    function r(s) {
      return s && typeof s == "object" && "default" in s ? s : { default: s };
    }
    var n = r(i), c = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_mi\xE9rcoles_jueves_viernes_s\xE1bado".split("_"), weekdaysShort: "dom._lun._mar._mi\xE9._jue._vie._s\xE1b.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_s\xE1".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un d\xEDa", dd: "%d d\xEDas", M: "un mes", MM: "%d meses", y: "un a\xF1o", yy: "%d a\xF1os" }, ordinal: function(s) {
      return s + "\xBA";
    } };
    return n.default.locale(c, null, !0), c;
  });
})(v2);
const Tt = v2.exports;
var g2 = { exports: {} };
(function(e, a) {
  (function(i, r) {
    e.exports = r();
  })(m5, function() {
    var i = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, c = /\d\d?/, s = /\d*[^-_:/,()\s\d]+/, o = {}, l = function(b) {
      return (b = +b) + (b > 68 ? 1900 : 2e3);
    }, d = function(b) {
      return function(x) {
        this[b] = +x;
      };
    }, v = [/[+-]\d\d:?(\d\d)?|Z/, function(b) {
      (this.zone || (this.zone = {})).offset = function(x) {
        if (!x || x === "Z")
          return 0;
        var Z = x.match(/([+-]|\d\d)/g), S = 60 * Z[1] + (+Z[2] || 0);
        return S === 0 ? 0 : Z[0] === "+" ? -S : S;
      }(b);
    }], u = function(b) {
      var x = o[b];
      return x && (x.indexOf ? x : x.s.concat(x.f));
    }, f = function(b, x) {
      var Z, S = o.meridiem;
      if (S) {
        for (var P = 1; P <= 24; P += 1)
          if (b.indexOf(S(P, 0, x)) > -1) {
            Z = P > 12;
            break;
          }
      } else
        Z = b === (x ? "pm" : "PM");
      return Z;
    }, h = { A: [s, function(b) {
      this.afternoon = f(b, !1);
    }], a: [s, function(b) {
      this.afternoon = f(b, !0);
    }], S: [/\d/, function(b) {
      this.milliseconds = 100 * +b;
    }], SS: [n, function(b) {
      this.milliseconds = 10 * +b;
    }], SSS: [/\d{3}/, function(b) {
      this.milliseconds = +b;
    }], s: [c, d("seconds")], ss: [c, d("seconds")], m: [c, d("minutes")], mm: [c, d("minutes")], H: [c, d("hours")], h: [c, d("hours")], HH: [c, d("hours")], hh: [c, d("hours")], D: [c, d("day")], DD: [n, d("day")], Do: [s, function(b) {
      var x = o.ordinal, Z = b.match(/\d+/);
      if (this.day = Z[0], x)
        for (var S = 1; S <= 31; S += 1)
          x(S).replace(/\[|\]/g, "") === b && (this.day = S);
    }], M: [c, d("month")], MM: [n, d("month")], MMM: [s, function(b) {
      var x = u("months"), Z = (u("monthsShort") || x.map(function(S) {
        return S.slice(0, 3);
      })).indexOf(b) + 1;
      if (Z < 1)
        throw new Error();
      this.month = Z % 12 || Z;
    }], MMMM: [s, function(b) {
      var x = u("months").indexOf(b) + 1;
      if (x < 1)
        throw new Error();
      this.month = x % 12 || x;
    }], Y: [/[+-]?\d+/, d("year")], YY: [n, function(b) {
      this.year = l(b);
    }], YYYY: [/\d{4}/, d("year")], Z: v, ZZ: v };
    function $(b) {
      var x, Z;
      x = b, Z = o && o.formats;
      for (var S = (b = x.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(T, M, Y) {
        var Q = Y && Y.toUpperCase();
        return M || Z[Y] || i[Y] || Z[Q].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(H, y, p) {
          return y || p.slice(1);
        });
      })).match(r), P = S.length, z = 0; z < P; z += 1) {
        var L = S[z], F = h[L], I = F && F[0], U = F && F[1];
        S[z] = U ? { regex: I, parser: U } : L.replace(/^\[|\]$/g, "");
      }
      return function(T) {
        for (var M = {}, Y = 0, Q = 0; Y < P; Y += 1) {
          var H = S[Y];
          if (typeof H == "string")
            Q += H.length;
          else {
            var y = H.regex, p = H.parser, C = T.slice(Q), g = y.exec(C)[0];
            p.call(M, g), T = T.replace(g, "");
          }
        }
        return function(k) {
          var w = k.afternoon;
          if (w !== void 0) {
            var _ = k.hours;
            w ? _ < 12 && (k.hours += 12) : _ === 12 && (k.hours = 0), delete k.afternoon;
          }
        }(M), M;
      };
    }
    return function(b, x, Z) {
      Z.p.customParseFormat = !0, b && b.parseTwoDigitYear && (l = b.parseTwoDigitYear);
      var S = x.prototype, P = S.parse;
      S.parse = function(z) {
        var L = z.date, F = z.utc, I = z.args;
        this.$u = F;
        var U = I[1];
        if (typeof U == "string") {
          var T = I[2] === !0, M = I[3] === !0, Y = T || M, Q = I[2];
          M && (Q = I[2]), o = this.$locale(), !T && Q && (o = Z.Ls[Q]), this.$d = function(C, g, k) {
            try {
              if (["x", "X"].indexOf(g) > -1)
                return new Date((g === "X" ? 1e3 : 1) * C);
              var w = $(g)(C), _ = w.year, j = w.month, G = w.day, K = w.hours, l1 = w.minutes, n1 = w.seconds, d1 = w.milliseconds, Z1 = w.zone, g1 = new Date(), e1 = G || (_ || j ? 1 : g1.getDate()), r1 = _ || g1.getFullYear(), V1 = 0;
              _ && !j || (V1 = j > 0 ? j - 1 : g1.getMonth());
              var N = K || 0, W = l1 || 0, J = n1 || 0, a1 = d1 || 0;
              return Z1 ? new Date(Date.UTC(r1, V1, e1, N, W, J, a1 + 60 * Z1.offset * 1e3)) : k ? new Date(Date.UTC(r1, V1, e1, N, W, J, a1)) : new Date(r1, V1, e1, N, W, J, a1);
            } catch {
              return new Date("");
            }
          }(L, U, F), this.init(), Q && Q !== !0 && (this.$L = this.locale(Q).$L), Y && L != this.format(U) && (this.$d = new Date("")), o = {};
        } else if (U instanceof Array)
          for (var H = U.length, y = 1; y <= H; y += 1) {
            I[1] = U[y - 1];
            var p = Z.apply(this, I);
            if (p.isValid()) {
              this.$d = p.$d, this.$L = p.$L, this.init();
              break;
            }
            y === H && (this.$d = new Date(""));
          }
        else
          P.call(this, z);
      };
    };
  });
})(g2);
const b2 = g2.exports;
S0.extend(b2);
const Et = (e, a) => e && a ? {
  gridArea: `span ${e} / span ${a} / span ${e} / span ${a}`
} : e && !a ? { gridColumn: `span ${e} / span ${e}` } : a && !e ? { gridRow: `span ${a} / span ${a}` } : {}, Ft = {
  category: {
    "category-loyalty-light": "#fff4e9",
    "category-loyalty-default": "#fd9426",
    "category-entertainment-light": "#e8e3ff",
    "category-entertainment-default": "#8e73fd",
    "category-restaurant-default": "#ff5267",
    "category-restaurant-light": "#ffdce1",
    "category-supermarket-light": "#ffded7",
    "category-supermarket-default": "#ff5935",
    "category-sport-light": "#d7f4ef",
    "category-sport-default": "#36c5ac",
    "category-shopping-light": "#fbe7fa",
    "category-shopping-default": "#f281eb",
    "category-transportation-light": "#e0f2fa",
    "category-transportation-default": "#55b3e0",
    "category-travel-light": "#dae8fb",
    "category-travel-default": "#448aec",
    "category-payment-light": "#dbf4df",
    "category-payment-default": "#85cc47",
    "category-gaming-light": "#ccf4e5",
    "category-gaming-default": "#00c17a",
    "category-mobile-light": "#dbf4fb",
    "category-mobile-default": "#4cc7e9",
    "category-tv-light": "#e3e5ff",
    "category-tv-default": "#717fff",
    "category-finance-light": "#dbf4df",
    "category-finance-default": "#53c866",
    "category-government-light": "#f2efe8",
    "category-government-default": "#c1b298",
    "category-electricity-light": "#fff4cc",
    "category-electricity-default": "#ffa800",
    "category-gas-light": "#ffe7d6",
    "category-gas-default": "#ff8933",
    "category-water-light": "#d5f7f7",
    "category-water-default": "#34dcda",
    "category-education-light": "#d3f4ff",
    "category-education-default": "#02bdfa",
    "category-pet-light": "#fdeae4",
    "category-pet-default": "#f59776",
    "category-baby-light": "#f4e8f7",
    "category-baby-default": "#c68ed7",
    "category-living-light": "#ddf6eb",
    "category-living-default": "#68dcaa",
    "category-beauty-light": "#ffe2de",
    "category-beauty-default": "#ff68d1",
    "category-health-light": "#ffe2de",
    "category-health-default": "#ff6e5b",
    "category-internet-light": "#d8eefd",
    "category-internet-default": "#20a2f8",
    "category-security-light": "#dfeaff",
    "category-security-default": "#1f8bef",
    "category-car-light": "#ffe7e5",
    "category-car-default": "#ff756c",
    "category-no-category-light": "#e9e9e9",
    "category-no-category-default": "#929191"
  },
  palette: {
    "palette-blue-10": "#b0d1ff",
    "palette-blue-20": "#72abff",
    "palette-blue-30": "#4591ff",
    "palette-blue-40": "#217cff",
    "palette-blue-50": "#0054ea",
    "palette-blue-60": "#0047c7",
    "palette-blue-70": "#022a9a",
    "palette-blue-80": "#002066",
    "palette-blue-90": "#001645",
    "palette-blue-05": "#e0edff",
    "palette-grey-10": "#eff1f5",
    "palette-grey-20": "#dee2ec",
    "palette-grey-30": "#cfd5e4",
    "palette-grey-40": "#b7bfd3",
    "palette-grey-50": "#929dba",
    "palette-grey-60": "#606882",
    "palette-grey-70": "#454b5e",
    "palette-grey-80": "#313643",
    "palette-grey-90": "#21283e",
    "palette-grey-95": "#171f2a",
    "palette-grey-00": "#ffffff",
    "palette-grey-05": "#fafafa",
    "palette-magenta-10": "#ffbdcc",
    "palette-magenta-20": "#ffa9bc",
    "palette-magenta-30": "#ffa1b5",
    "palette-magenta-40": "#ff7391",
    "palette-magenta-50": "#ff5874",
    "palette-magenta-60": "#da2b55",
    "palette-magenta-70": "#cc1b4a",
    "palette-magenta-80": "#991438",
    "palette-magenta-90": "#660e25",
    "palette-magenta-05": "#ffdde4",
    "palette-yellow-10": "#f9f4cc",
    "palette-yellow-20": "#f4edb4",
    "palette-yellow-30": "#f8e46b",
    "palette-yellow-40": "#f8da32",
    "palette-yellow-50": "#f9d205",
    "palette-yellow-60": "#b49200",
    "palette-yellow-70": "#836d10",
    "palette-yellow-80": "#5b4f17",
    "palette-yellow-90": "#3a330f",
    "palette-yellow-05": "#fcf8d8",
    "palette-red-10": "#ffd2ca",
    "palette-red-20": "#ffa598",
    "palette-red-30": "#ff7868",
    "palette-red-40": "#f64e45",
    "palette-red-50": "#e3131a",
    "palette-red-60": "#bc1d19",
    "palette-red-70": "#93130d",
    "palette-red-80": "#660b04",
    "palette-red-90": "#330500",
    "palette-red-05": "#ffe9e4",
    "palette-green-10": "#d9f4eb",
    "palette-green-20": "#beeedc",
    "palette-green-30": "#7fd1b3",
    "palette-green-40": "#55c19a",
    "palette-green-50": "#2ab281",
    "palette-green-60": "#1c8367",
    "palette-green-70": "#196b4d",
    "palette-green-80": "#115139",
    "palette-green-90": "#08241a",
    "palette-green-05": "#d9f4eb"
  }
}, Nt = {
  sm: "0rem 0.125rem 0.5rem 0rem #3a3a3a33",
  md: "0rem 0.25rem 1rem 0rem #3a3a3a33",
  lg: "0rem 0.5rem 2rem 0rem #3a3a3a33"
}, Ot = {
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  72: "4.5rem",
  80: "5rem",
  96: "6rem",
  104: "6.5rem",
  base: "16px",
  none: 0
}, Wt = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  full: "100%",
  none: 0
}, jt = {
  thin: "0.0625rem",
  medium: "0.125rem",
  strong: "0.25rem"
}, Bt = {
  primary: "Public Sans,-apple-system,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
  secondary: "Sofia Pro,-apple-system,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif"
}, Yt = {
  light: "200",
  regular: "400",
  bold: "600"
}, Gt = {
  tight: "-0.0125rem",
  normal: 0
}, Ut = {
  none: 0,
  normal: "1",
  base: "1.2",
  tall: "1.4"
}, qt = {
  1: "0.625rem",
  2: "0.75rem",
  3: "0.875rem",
  4: "1rem",
  5: "1.125rem",
  6: "1.375rem",
  7: "2.125rem",
  base: "16px"
}, Kt = {
  upper: "uppercase",
  lower: "lowercase",
  capitalize: "capitalize",
  none: "none"
}, Jt = {
  body: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$4",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$4",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$4",
        textDecoration: "$undefined",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$3",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm",
        textDecoration: "$undefined"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm"
      },
      link: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$tall",
        fontSize: "$2",
        letterSpacing: "$normal",
        paragraphSpacing: "$sm",
        textDecoration: "$undefined"
      }
    }
  },
  label: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$5"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$5"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$3"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$3"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$2"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$2"
      }
    }
  },
  button: {
    lg: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$4"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$4",
        letterSpacing: "$normal"
      }
    },
    md: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$3"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$3"
      }
    },
    sm: {
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$1"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$1"
      }
    }
  },
  number: {
    lg: {
      light: {
        fontFamily: "$primary",
        fontWeight: "$light",
        lineHeight: "$normal",
        fontSize: "$7"
      },
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$7"
      }
    },
    md: {
      light: {
        fontFamily: "$primary",
        fontWeight: "$light",
        lineHeight: "$normal",
        fontSize: "$6"
      },
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$6"
      }
    },
    sm: {
      bold: {
        fontFamily: "$primary",
        fontWeight: "$bold",
        lineHeight: "$normal",
        fontSize: "$4"
      },
      regular: {
        fontFamily: "$primary",
        fontWeight: "$regular",
        lineHeight: "$normal",
        fontSize: "$4"
      }
    }
  },
  title: {
    lg: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$6",
      letterSpacing: "$normal"
    },
    md: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$5",
      letterSpacing: "$normal"
    },
    sm: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$4",
      letterSpacing: "$normal"
    },
    xs: {
      fontFamily: "$primary",
      fontWeight: "$bold",
      lineHeight: "$base",
      fontSize: "$3",
      letterSpacing: "$normal"
    }
  },
  heading: {
    sm: {
      fontFamily: "$primary",
      fontWeight: "$regular",
      lineHeight: "$normal",
      fontSize: "$4",
      letterSpacing: "$normal"
    }
  }
}, Xt = {
  base: "16px",
  sm: "0.5rem"
}, Qt = {
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem",
  96: "6rem",
  128: "8rem",
  base: "16px",
  none: 0
}, ea = {
  breakpoints: {
    sm: "(min-width: 0)",
    md: "(min-width: 46.25rem)",
    lg: "(min-width: 61.25rem)",
    xl: "(min-width: 87.5rem)",
    "2xl": "(min-width: 100rem)"
  }
}, ta = {
  none: "none",
  underline: "underline"
}, U5 = {
  color: Ft,
  boxShadow: Nt,
  spacing: Ot,
  borderRadius: Wt,
  borderWidth: jt,
  fontFamilies: Bt,
  fontWeights: Yt,
  letterSpacing: Gt,
  lineHeights: Ut,
  fontSizes: qt,
  textCase: Kt,
  typography: Jt,
  paragraphSpacing: Xt,
  sizing: Qt,
  other: ea,
  textDecoration: ta
}, s1 = (e) => {
  const a = parseFloat(U5.fontSizes.base), i = U5.sizing[String(e)] || void 0, r = e / a;
  return i ? `var(--sizes-${e})` : r + "rem";
}, $2 = (e) => {
  switch (e) {
    case "USD":
      return "en-US";
    case "MXN":
      return "es-MX";
    case "COP":
      return "es-CO";
    case "PEN":
      return "es-PE";
    default:
      return "es-AR";
  }
}, aa = (e, a = {}) => {
  const i = new Intl.NumberFormat($2(e), {
    ...a,
    style: "currency"
  }).formatToParts(1.1), r = i.find((o) => o.type === "currency"), n = i.find((o) => o.type === "integer"), c = i.find((o) => o.type === "fraction"), s = i.find((o) => o.type === "decimal");
  return {
    currency: r == null ? void 0 : r.value,
    integer: n == null ? void 0 : n.value,
    fraction: c == null ? void 0 : c.value,
    decimal: (s == null ? void 0 : s.value) || "."
  };
}, q5 = (e, a, i) => {
  const r = $2(a.currency);
  return i ? `${e.toLocaleString(r, {
    ...a,
    style: "decimal"
  })}` : `${e.toLocaleString(r, a)}`;
}, y2 = (e, a, i) => {
  const {
    code: r,
    symbol: n,
    decimals: c = 2,
    style: s = "currency"
  } = a;
  return b1.useMemo(() => {
    const o = {
      style: s,
      currency: r,
      minimumIntegerDigits: 1,
      minimumFractionDigits: c,
      maximumFractionDigits: c
    };
    if (i) {
      const { currency: l, decimal: d } = aa(r, {
        ...o,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }), v = q5(e, o, n).split(d || "."), u = v[0].replace(/^(-)|[^0-9.,]+/g, "");
      return {
        currency: n || l,
        integer: u,
        fraction: v[1],
        decimal: d
      };
    } else
      return Object.keys(P0).indexOf(r) > 0 ? `${e.toFixed(c)} ${r}` : q5(e, o, n);
  }, [e, i, s, r, n, c]);
}, ra = (e) => e.replace(/[.,]+/g, ""), ia = (e, a, i) => {
  const r = P0[a.code] || void 0, n = y2(e, {
    ...a,
    code: a.code || "ARS"
  }, !0), c = n.integer && ra(n.integer);
  return !r || i ? `${c}.${n.fraction} ${a.symbol}` : `${c} 
  ${Number(c) > 1 ? r == null ? void 0 : r.plural : r == null ? void 0 : r.singular}
  ${Number(n.fraction) > 0 ? ` con ${n.fraction} ${r == null ? void 0 : r.cents}` : ""} `;
};
S0.extend(b2);
const K5 = (e) => {
  let a = e;
  if (e && e.includes("hs") && (a = e.replace("hs", " horas")), S0(a, "DD/MM").isValid() || S0(a, "DD/MM/YYYY", !0).isValid()) {
    const i = a.split("/"), r = i[0], n = parseInt(i[1]), c = i[2] ? `de ${i[2]}` : "";
    return `${r} de ${S0().locale(Tt).month(n - 1).format("MMMM")} ${c}`;
  }
  return a;
}, Z2 = typeof window < "u" ? D.useLayoutEffect : () => {
};
function na(e, a, i, r) {
  const n = y1(a);
  Z2(() => {
    n.current = a;
  }, [a]), w1(() => {
    const c = (i == null ? void 0 : i.current) || window;
    if (!(c && c.addEventListener))
      return;
    const s = (o) => n.current(o);
    return c.addEventListener(e, s, r), () => {
      c.removeEventListener(e, s);
    };
  }, [e, i, r]);
}
function c5() {
  const [e, a] = A1(null), [i, r] = A1({
    width: 0,
    height: 0
  }), n = e0(() => {
    r({
      width: (e == null ? void 0 : e.offsetWidth) || 0,
      height: (e == null ? void 0 : e.offsetHeight) || 0
    });
  }, [e == null ? void 0 : e.offsetHeight, e == null ? void 0 : e.offsetWidth]);
  return na("resize", n), Z2(() => {
    n();
  }, [e == null ? void 0 : e.offsetHeight, e == null ? void 0 : e.offsetWidth]), [a, i];
}
const ca = "id-";
let J5 = 0;
const la = (e) => (J5++, `${e || ca}${J5}`), oa = (e, a) => {
  const i = [];
  for (let r = 0; r < e; r++)
    i.push(la(a));
  return i;
}, X5 = (e) => {
  const a = b1.useRef();
  return b1.useEffect(() => {
    a.current = e;
  }), a.current;
}, Y1 = (e = 1, a) => {
  const i = b1.useRef([]), r = X5(e), n = X5(a);
  return (e !== r || n !== a) && (i.current = oa(e, a)), i.current;
}, sa = O("div", {
  all: "unset",
  display: "block",
  variants: {
    isVisuallyHidden: {
      true: {
        clip: "rect(0 0 0 0)",
        border: 0,
        clipPath: "inset(50%)",
        height: 1,
        margin: "0 -1px -1px 0",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: 1
      }
    }
  }
}), x2 = D.forwardRef((e, a) => {
  const {
    as: i = "div",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(sa, {
    as: i,
    ...n,
    ref: a,
    children: r
  });
}), B1 = x2;
x2.displayName = "Box";
const E0 = H0({}), F0 = D.forwardRef((e, a) => {
  const {
    value: i,
    isCrypto: r,
    size: n,
    prefix: c,
    code: s,
    symbol: o,
    decimals: l,
    label: d,
    isHidden: v,
    ...u
  } = e, f = D.useContext(E0), h = D.useMemo(() => ({
    value: i,
    options: {
      code: s || f.code || "ARS",
      symbol: o || "$",
      decimals: r ? 8 : (s === "COP" || f.code === "COP") && !l ? 0 : l || 2
    },
    isCrypto: r
  }), [i, s, o, r, l]), $ = y2(h.value, h.options, !0), b = ia(h.value, h.options, h.isCrypto);
  return /* @__PURE__ */ V(A, {
    children: [/* @__PURE__ */ t(B1, {
      isVisuallyHidden: !0,
      as: "span",
      children: d || b
    }), $ ? /* @__PURE__ */ t(A, {
      children: /* @__PURE__ */ V(P1, {
        ...u,
        ref: a,
        "aria-hidden": !0,
        children: [c || i < 0 ? /* @__PURE__ */ t(Y5, {
          size: n,
          children: i < 0 ? "-" : c
        }) : null, /* @__PURE__ */ t(Y5, {
          size: n,
          css: {
            marginRight: r && n === "sm" ? "$4" : ""
          },
          children: $.currency
        }), /* @__PURE__ */ t(A, {
          children: v ? /* @__PURE__ */ t(G5, {
            size: n,
            children: h.isCrypto ? "*********" : "****"
          }) : /* @__PURE__ */ V(A, {
            children: [/* @__PURE__ */ V(G5, {
              size: n,
              children: [$.integer && $.integer.replace("-", "").replace("+", ""), h.options.decimals ? $.decimal : null]
            }), h.options.decimals ? /* @__PURE__ */ t(zt, {
              size: n,
              isCrypto: r,
              children: $.fraction
            }) : null]
          })
        })]
      })
    }) : null]
  });
});
F0.displayName = "Amount";
function $1() {
  return $1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
    }
    return e;
  }, $1.apply(this, arguments);
}
function o0(e, a = []) {
  let i = [];
  function r(c, s) {
    const o = /* @__PURE__ */ H0(s), l = i.length;
    i = [
      ...i,
      s
    ];
    function d(u) {
      const { scope: f, children: h, ...$ } = u, b = (f == null ? void 0 : f[e][l]) || o, x = m0(
        () => $,
        Object.values($)
      );
      return /* @__PURE__ */ t1(b.Provider, {
        value: x
      }, h);
    }
    function v(u, f) {
      const h = (f == null ? void 0 : f[e][l]) || o, $ = C0(h);
      if ($)
        return $;
      if (s !== void 0)
        return s;
      throw new Error(`\`${u}\` must be used within \`${c}\``);
    }
    return d.displayName = c + "Provider", [
      d,
      v
    ];
  }
  const n = () => {
    const c = i.map((s) => /* @__PURE__ */ H0(s));
    return function(o) {
      const l = (o == null ? void 0 : o[e]) || c;
      return m0(
        () => ({
          [`__scope${e}`]: {
            ...o,
            [e]: l
          }
        }),
        [
          o,
          l
        ]
      );
    };
  };
  return n.scopeName = e, [
    r,
    da(n, ...a)
  ];
}
function da(...e) {
  const a = e[0];
  if (e.length === 1)
    return a;
  const i = () => {
    const r = e.map(
      (n) => ({
        useScope: n(),
        scopeName: n.scopeName
      })
    );
    return function(c) {
      const s = r.reduce((o, { useScope: l, scopeName: d }) => {
        const u = l(c)[`__scope${d}`];
        return {
          ...o,
          ...u
        };
      }, {});
      return m0(
        () => ({
          [`__scope${a.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return i.scopeName = a.scopeName, i;
}
function N0(e) {
  const a = y1(e);
  return w1(() => {
    a.current = e;
  }), m0(
    () => (...i) => {
      var r;
      return (r = a.current) === null || r === void 0 ? void 0 : r.call(a, ...i);
    },
    []
  );
}
const V0 = Boolean(globalThis == null ? void 0 : globalThis.document) ? u5 : () => {
};
function ua(e, a) {
  typeof e == "function" ? e(a) : e != null && (e.current = a);
}
function S2(...e) {
  return (a) => e.forEach(
    (i) => ua(i, a)
  );
}
function t0(...e) {
  return e0(S2(...e), e);
}
const z0 = /* @__PURE__ */ C1((e, a) => {
  const { children: i, ...r } = e, n = a0.toArray(i), c = n.find(ha);
  if (c) {
    const s = c.props.children, o = n.map((l) => l === c ? a0.count(s) > 1 ? a0.only(null) : /* @__PURE__ */ _0(s) ? s.props.children : null : l);
    return /* @__PURE__ */ t1(l5, $1({}, r, {
      ref: a
    }), /* @__PURE__ */ _0(s) ? /* @__PURE__ */ f5(s, void 0, o) : null);
  }
  return /* @__PURE__ */ t1(l5, $1({}, r, {
    ref: a
  }), i);
});
z0.displayName = "Slot";
const l5 = /* @__PURE__ */ C1((e, a) => {
  const { children: i, ...r } = e;
  return /* @__PURE__ */ _0(i) ? /* @__PURE__ */ f5(i, {
    ...ma(r, i.props),
    ref: S2(a, i.ref)
  }) : a0.count(i) > 1 ? a0.only(null) : null;
});
l5.displayName = "SlotClone";
const fa = ({ children: e }) => /* @__PURE__ */ t1(ke, null, e);
function ha(e) {
  return /* @__PURE__ */ _0(e) && e.type === fa;
}
function ma(e, a) {
  const i = {
    ...a
  };
  for (const r in a) {
    const n = e[r], c = a[r];
    /^on[A-Z]/.test(r) ? n && c ? i[r] = (...o) => {
      c(...o), n(...o);
    } : n && (i[r] = n) : r === "style" ? i[r] = {
      ...n,
      ...c
    } : r === "className" && (i[r] = [
      n,
      c
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...i
  };
}
const pa = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], z1 = pa.reduce((e, a) => {
  const i = /* @__PURE__ */ C1((r, n) => {
    const { asChild: c, ...s } = r, o = c ? z0 : a;
    return w1(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ t1(o, $1({}, s, {
      ref: n
    }));
  });
  return i.displayName = `Primitive.${a}`, {
    ...e,
    [a]: i
  };
}, {}), M2 = "Avatar", [va, ki] = o0(M2), [ga, H2] = va(M2), ba = /* @__PURE__ */ C1((e, a) => {
  const { __scopeAvatar: i, ...r } = e, [n, c] = A1("idle");
  return /* @__PURE__ */ t1(ga, {
    scope: i,
    imageLoadingStatus: n,
    onImageLoadingStatusChange: c
  }, /* @__PURE__ */ t1(z1.span, $1({}, r, {
    ref: a
  })));
}), $a = "AvatarImage", ya = /* @__PURE__ */ C1((e, a) => {
  const { __scopeAvatar: i, src: r, onLoadingStatusChange: n = () => {
  }, ...c } = e, s = H2($a, i), o = Sa(r), l = N0((d) => {
    n(d), s.onImageLoadingStatusChange(d);
  });
  return V0(() => {
    o !== "idle" && l(o);
  }, [
    o,
    l
  ]), o === "loaded" ? /* @__PURE__ */ t1(z1.img, $1({}, c, {
    ref: a,
    src: r
  })) : null;
}), Za = "AvatarFallback", xa = /* @__PURE__ */ C1((e, a) => {
  const { __scopeAvatar: i, delayMs: r, ...n } = e, c = H2(Za, i), [s, o] = A1(r === void 0);
  return w1(() => {
    if (r !== void 0) {
      const l = window.setTimeout(
        () => o(!0),
        r
      );
      return () => window.clearTimeout(l);
    }
  }, [
    r
  ]), s && c.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ t1(z1.span, $1({}, n, {
    ref: a
  })) : null;
});
function Sa(e) {
  const [a, i] = A1("idle");
  return w1(() => {
    if (!e) {
      i("error");
      return;
    }
    let r = !0;
    const n = new window.Image(), c = (s) => () => {
      !r || i(s);
    };
    return i("loading"), n.onload = c("loaded"), n.onerror = c("error"), n.src = e, () => {
      r = !1;
    };
  }, [
    e
  ]), a;
}
const Ma = ba, Ha = ya, Ca = xa, Va = O(Ma, {
  ...q.label.md.regular,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  overflow: "hidden",
  userSelect: "none",
  borderRadius: "100%",
  backgroundColor: "$neutral-white",
  variants: {
    size: {
      sm: {
        width: "$40",
        height: "$40"
      },
      md: {
        width: "$64",
        height: "$64",
        fontSize: "calc($base * 1.625)"
      },
      lg: {
        width: s1(80),
        height: s1(80),
        fontSize: "calc($base * 2)"
      },
      xl: {
        width: s1(128),
        height: s1(128),
        fontSize: "calc($base * 3)"
      }
    },
    isDisabled: {
      true: {
        opacity: 0.5
      }
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), wa = O(Ha, {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "inherit"
}), ka = O(Ca, {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "uppercase",
  backgroundColor: "$primary-lighter",
  color: "$primary-default",
  fontFamily: "$primary",
  lineHeight: "$normal",
  fontWeight: "$regular"
}), Da = D.forwardRef((e, a) => {
  const {
    image: i,
    title: r,
    name: n,
    initials: c,
    ...s
  } = e;
  return /* @__PURE__ */ V(Va, {
    ...s,
    ref: a,
    children: [/* @__PURE__ */ t(wa, {
      src: i,
      alt: r || n
    }), /* @__PURE__ */ t(ka, {
      children: c || (() => {
        if (!n)
          return " ";
        const l = n.split(" ");
        return l.length > 1 ? `${l[0].charAt(0)}${l[1].charAt(0)}` : l[0].charAt(0);
      })()
    })]
  });
});
Da.displayName = "Avatar";
const C2 = (e, a) => {
  const i = e[a];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((r, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(n.bind(null, new Error("Unknown variable dynamic import: " + a)));
  });
}, Q5 = [
  "uala-abc-default-lg",
  "uala-abc-default-md",
  "uala-abc-default-sm",
  "uala-abc-mas-default-lg",
  "uala-abc-mas-default-md",
  "uala-abc-mas-default-sm",
  "uala-abc-mas-inverted-lg",
  "uala-abc-mas-inverted-md",
  "uala-abc-mas-inverted-sm",
  "uala-abc-mas-monocromo-lg",
  "uala-abc-mas-monocromo-md",
  "uala-abc-mas-monocromo-sm",
  "uala-abc-monocromo-lg",
  "uala-abc-monocromo-md",
  "uala-abc-monocromo-sm",
  "uala-bis-default-lg",
  "uala-bis-default-md",
  "uala-bis-default-sm",
  "uala-bis-inverted-lg",
  "uala-bis-inverted-md",
  "uala-bis-inverted-sm",
  "uala-bis-monocromo-lg",
  "uala-bis-monocromo-md",
  "uala-bis-monocromo-sm",
  "uala-iso-default-lg",
  "uala-iso-default-md",
  "uala-iso-default-sm",
  "uala-iso-inverted-lg",
  "uala-iso-inverted-md",
  "uala-iso-inverted-sm",
  "uala-iso-monocromo-lg",
  "uala-iso-monocromo-md",
  "uala-iso-monocromo-sm",
  "uala-isotipo-horizontal-default-lg",
  "uala-isotipo-horizontal-default-md",
  "uala-isotipo-horizontal-default-sm",
  "uala-isotipo-horizontal-inverted-lg",
  "uala-isotipo-horizontal-inverted-md",
  "uala-isotipo-horizontal-inverted-sm",
  "uala-isotipo-horizontal-monocromo-lg",
  "uala-isotipo-horizontal-monocromo-md",
  "uala-isotipo-horizontal-monocromo-sm",
  "uala-isotipo-vertical-default-lg",
  "uala-isotipo-vertical-default-md",
  "uala-isotipo-vertical-default-sm",
  "uala-isotipo-vertical-inverted-lg",
  "uala-isotipo-vertical-inverted-md",
  "uala-isotipo-vertical-inverted-sm",
  "uala-isotipo-vertical-monocromo-lg",
  "uala-isotipo-vertical-monocromo-md",
  "uala-isotipo-vertical-monocromo-sm",
  "uala-mas-default-lg",
  "uala-mas-default-md",
  "uala-mas-default-sm",
  "uala-mas-inverted-lg",
  "uala-mas-inverted-md",
  "uala-mas-inverted-sm",
  "uala-mas-monocromo-lg",
  "uala-mas-monocromo-md",
  "uala-mas-monocromo-sm",
  "uala-tipo-default-lg",
  "uala-tipo-default-md",
  "uala-tipo-default-sm",
  "uala-tipo-monocromo-lg",
  "uala-tipo-monocromo-md",
  "uala-tipo-monocromo-sm",
  "ualatienda-default-lg",
  "ualatienda-default-md",
  "ualatienda-default-sm",
  "ualatienda-inverted-lg",
  "ualatienda-inverted-md",
  "ualatienda-inverted-sm",
  "ualatienda-monocromo-lg",
  "ualatienda-monocromo-md",
  "ualatienda-monocromo-sm",
  "ualintec-default-lg",
  "ualintec-default-md",
  "ualintec-default-sm",
  "ualintec-monocromo-lg",
  "ualintec-monocromo-md",
  "ualintec-monocromo-sm",
  "uanex-default-lg",
  "uanex-default-md",
  "uanex-default-sm",
  "uanex-monocromo-lg",
  "uanex-monocromo-md",
  "uanex-monocromo-sm",
  "uilo-default-lg",
  "uilo-default-md",
  "uilo-default-sm",
  "uilo-monocromo-lg",
  "uilo-monocromo-md",
  "uilo-monocromo-sm"
], v5 = {
  align: {
    start: {
      alignItems: "start"
    },
    end: {
      alignItems: "end"
    },
    center: {
      alignItems: "center"
    },
    baseline: {
      alignItems: "baseline"
    },
    stretch: {
      alignItems: "stretch"
    }
  },
  direction: {
    column: {
      flexDirection: "column"
    },
    "column-reverse": {
      flexDirection: "column-reverse"
    },
    row: {
      flexDirection: "row"
    },
    "row-reverse": {
      flexDirection: "row-reverse"
    }
  },
  justify: {
    start: {
      justifyContent: "flex-start"
    },
    end: {
      justifyContent: "flex-end"
    },
    center: {
      justifyContent: "center"
    },
    "space-between": {
      justifyContent: "space-between"
    },
    "space-around": {
      justifyContent: "space-around"
    },
    "space-evenly": {
      justifyContent: "space-evenly"
    }
  },
  spacing: {
    0: {
      gap: 0
    },
    4: {
      gap: "$4"
    },
    8: {
      gap: "$8"
    },
    12: {
      gap: "$12"
    },
    16: {
      gap: "$16"
    },
    20: {
      gap: "$20"
    },
    24: {
      gap: "$24"
    },
    32: {
      gap: "$32"
    },
    40: {
      gap: "$40"
    },
    48: {
      gap: "$48"
    }
  }
}, N1 = O("div", {
  all: "unset",
  display: "flex",
  variants: v5,
  defaultVariants: {
    direction: "row",
    spacing: "12"
  }
}), Ra = Ht({
  "100%": { transform: "translateX(100%)" }
}), Aa = O("span", {
  width: "100%",
  position: "relative",
  backgroundColor: "$neutral-light",
  minHeight: 24,
  overflow: "hidden",
  display: "inline-flex",
  "&:after": {
    content: '""',
    zIndex: 2,
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundImage: "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent, transparent )",
    [`.${m2} &`]: {
      backgroundImage: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent, transparent )"
    },
    transform: "translateX(-100%)",
    animation: `${Ra} 2.5s`,
    animationDirection: "normal",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite"
  },
  variants: {
    isCircle: {
      true: {
        borderRadius: "$full"
      },
      false: {
        borderRadius: "$xs"
      }
    }
  },
  defaultVariants: {
    isCircle: !1
  }
}), _a = O(N1, {
  overflow: "hidden",
  defaultVariants: {
    direction: "column"
  }
}), v1 = D.forwardRef((e, a) => {
  const {
    as: i = "span",
    width: r,
    height: n,
    css: c,
    ...s
  } = e;
  return /* @__PURE__ */ t(Aa, {
    as: i,
    css: {
      ...c,
      width: r,
      height: n
    },
    ref: a,
    ...s
  });
});
v1.displayName = "SkeletonItem";
const Pa = (e) => Array(e).fill(1).map((a, i) => i + 1), j1 = D.forwardRef((e, a) => {
  const {
    count: i = 1,
    width: r,
    height: n,
    as: c,
    css: s,
    children: o
  } = e, l = Pa(i);
  return /* @__PURE__ */ t(_a, {
    as: c,
    css: {
      ...s,
      width: r,
      height: n
    },
    ref: a,
    ...e,
    children: o || l.map((d) => /* @__PURE__ */ t(v1, {}, d))
  });
});
j1.displayName = "Skeleton";
const za = O("div", {}), e2 = (e, a) => {
  const i = [];
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (a[0] === "uala-abc" && a[1].includes("monocromo")) {
      const c = a[1].split("-")[2];
      i.push(`uala-abc-monocromo-${c}`);
      break;
    } else if (n.startsWith(a[0]) && n.includes(a[1])) {
      i.push(n);
      break;
    }
  }
  return i;
}, Ia = D.forwardRef((e, a) => {
  const {
    children: i,
    label: r,
    name: n = "uala-iso",
    className: c,
    variant: s,
    size: o = "md",
    ...l
  } = e, [d, v] = D.useState(""), {
    mode: u
  } = C0(p2), f = () => s === void 0 && u === "dark" ? "inverted" : s || "default";
  D.useMemo(() => {
    let $ = e2(Q5, [`${n}`, `-${f()}-${o}`])[0];
    n === "uala-abc" && f() === "inverted" && ($ = `uala-abc-monocromo-${o}`), $ || ($ = e2(Q5, [`${n}`, `-monocromo-${o}`])[0]), v($);
  }, [n, s, o, u]);
  const h = o2(() => C2(/* @__PURE__ */ Object.assign({ "../brands/uala-abc-default-lg.tsx": () => import("./uala-abc-default-lg.6bb8c4de.mjs"), "../brands/uala-abc-default-md.tsx": () => import("./uala-abc-default-md.c84332c9.mjs"), "../brands/uala-abc-default-sm.tsx": () => import("./uala-abc-default-sm.bf3b7295.mjs"), "../brands/uala-abc-mas-default-lg.tsx": () => import("./uala-abc-mas-default-lg.d08b79b0.mjs"), "../brands/uala-abc-mas-default-md.tsx": () => import("./uala-abc-mas-default-md.66810d2a.mjs"), "../brands/uala-abc-mas-default-sm.tsx": () => import("./uala-abc-mas-default-sm.eb07e1d7.mjs"), "../brands/uala-abc-mas-inverted-lg.tsx": () => import("./uala-abc-mas-inverted-lg.7fcfe2a4.mjs"), "../brands/uala-abc-mas-inverted-md.tsx": () => import("./uala-abc-mas-inverted-md.07e3c35f.mjs"), "../brands/uala-abc-mas-inverted-sm.tsx": () => import("./uala-abc-mas-inverted-sm.a6e84d4a.mjs"), "../brands/uala-abc-mas-monocromo-lg.tsx": () => import("./uala-abc-mas-monocromo-lg.6809cfe3.mjs"), "../brands/uala-abc-mas-monocromo-md.tsx": () => import("./uala-abc-mas-monocromo-md.ea972405.mjs"), "../brands/uala-abc-mas-monocromo-sm.tsx": () => import("./uala-abc-mas-monocromo-sm.9ebde3bd.mjs"), "../brands/uala-abc-monocromo-lg.tsx": () => import("./uala-abc-monocromo-lg.375b4777.mjs"), "../brands/uala-abc-monocromo-md.tsx": () => import("./uala-abc-monocromo-md.addbb81f.mjs"), "../brands/uala-abc-monocromo-sm.tsx": () => import("./uala-abc-monocromo-sm.7b74d39d.mjs"), "../brands/uala-bis-default-lg.tsx": () => import("./uala-bis-default-lg.2df96dec.mjs"), "../brands/uala-bis-default-md.tsx": () => import("./uala-bis-default-md.5faa96dc.mjs"), "../brands/uala-bis-default-sm.tsx": () => import("./uala-bis-default-sm.bee41962.mjs"), "../brands/uala-bis-inverted-lg.tsx": () => import("./uala-bis-inverted-lg.c601a131.mjs"), "../brands/uala-bis-inverted-md.tsx": () => import("./uala-bis-inverted-md.a7c50678.mjs"), "../brands/uala-bis-inverted-sm.tsx": () => import("./uala-bis-inverted-sm.7efe2a42.mjs"), "../brands/uala-bis-monocromo-lg.tsx": () => import("./uala-bis-monocromo-lg.bce4e52c.mjs"), "../brands/uala-bis-monocromo-md.tsx": () => import("./uala-bis-monocromo-md.eb27dcc7.mjs"), "../brands/uala-bis-monocromo-sm.tsx": () => import("./uala-bis-monocromo-sm.e82ccd49.mjs"), "../brands/uala-iso-default-lg.tsx": () => import("./uala-iso-default-lg.845fbca1.mjs"), "../brands/uala-iso-default-md.tsx": () => import("./uala-iso-default-md.fffb3490.mjs"), "../brands/uala-iso-default-sm.tsx": () => import("./uala-iso-default-sm.0090277f.mjs"), "../brands/uala-iso-inverted-lg.tsx": () => import("./uala-iso-inverted-lg.a4a3f363.mjs"), "../brands/uala-iso-inverted-md.tsx": () => import("./uala-iso-inverted-md.ff0af97e.mjs"), "../brands/uala-iso-inverted-sm.tsx": () => import("./uala-iso-inverted-sm.c7d6dfa0.mjs"), "../brands/uala-iso-monocromo-lg.tsx": () => import("./uala-iso-monocromo-lg.1d40c36a.mjs"), "../brands/uala-iso-monocromo-md.tsx": () => import("./uala-iso-monocromo-md.5c32707d.mjs"), "../brands/uala-iso-monocromo-sm.tsx": () => import("./uala-iso-monocromo-sm.baa60dd3.mjs"), "../brands/uala-isotipo-horizontal-default-lg.tsx": () => import("./uala-isotipo-horizontal-default-lg.96aa80eb.mjs"), "../brands/uala-isotipo-horizontal-default-md.tsx": () => import("./uala-isotipo-horizontal-default-md.72010f61.mjs"), "../brands/uala-isotipo-horizontal-default-sm.tsx": () => import("./uala-isotipo-horizontal-default-sm.a9434acb.mjs"), "../brands/uala-isotipo-horizontal-inverted-lg.tsx": () => import("./uala-isotipo-horizontal-inverted-lg.a52736ea.mjs"), "../brands/uala-isotipo-horizontal-inverted-md.tsx": () => import("./uala-isotipo-horizontal-inverted-md.7f85c356.mjs"), "../brands/uala-isotipo-horizontal-inverted-sm.tsx": () => import("./uala-isotipo-horizontal-inverted-sm.59eab598.mjs"), "../brands/uala-isotipo-horizontal-monocromo-lg.tsx": () => import("./uala-isotipo-horizontal-monocromo-lg.24b29313.mjs"), "../brands/uala-isotipo-horizontal-monocromo-md.tsx": () => import("./uala-isotipo-horizontal-monocromo-md.077cec37.mjs"), "../brands/uala-isotipo-horizontal-monocromo-sm.tsx": () => import("./uala-isotipo-horizontal-monocromo-sm.3b69a76f.mjs"), "../brands/uala-isotipo-vertical-default-lg.tsx": () => import("./uala-isotipo-vertical-default-lg.8a684355.mjs"), "../brands/uala-isotipo-vertical-default-md.tsx": () => import("./uala-isotipo-vertical-default-md.4c6d0af5.mjs"), "../brands/uala-isotipo-vertical-default-sm.tsx": () => import("./uala-isotipo-vertical-default-sm.ea867610.mjs"), "../brands/uala-isotipo-vertical-inverted-lg.tsx": () => import("./uala-isotipo-vertical-inverted-lg.c5a2a338.mjs"), "../brands/uala-isotipo-vertical-inverted-md.tsx": () => import("./uala-isotipo-vertical-inverted-md.e02eab05.mjs"), "../brands/uala-isotipo-vertical-inverted-sm.tsx": () => import("./uala-isotipo-vertical-inverted-sm.7c482cb1.mjs"), "../brands/uala-isotipo-vertical-monocromo-lg.tsx": () => import("./uala-isotipo-vertical-monocromo-lg.70fab541.mjs"), "../brands/uala-isotipo-vertical-monocromo-md.tsx": () => import("./uala-isotipo-vertical-monocromo-md.98fdef77.mjs"), "../brands/uala-isotipo-vertical-monocromo-sm.tsx": () => import("./uala-isotipo-vertical-monocromo-sm.51405bc7.mjs"), "../brands/uala-mas-default-lg.tsx": () => import("./uala-mas-default-lg.23a31efe.mjs"), "../brands/uala-mas-default-md.tsx": () => import("./uala-mas-default-md.c61b0539.mjs"), "../brands/uala-mas-default-sm.tsx": () => import("./uala-mas-default-sm.6eaf474e.mjs"), "../brands/uala-mas-inverted-lg.tsx": () => import("./uala-mas-inverted-lg.b4869a04.mjs"), "../brands/uala-mas-inverted-md.tsx": () => import("./uala-mas-inverted-md.b367c1e6.mjs"), "../brands/uala-mas-inverted-sm.tsx": () => import("./uala-mas-inverted-sm.f5b66f43.mjs"), "../brands/uala-mas-monocromo-lg.tsx": () => import("./uala-mas-monocromo-lg.b40f7898.mjs"), "../brands/uala-mas-monocromo-md.tsx": () => import("./uala-mas-monocromo-md.47385276.mjs"), "../brands/uala-mas-monocromo-sm.tsx": () => import("./uala-mas-monocromo-sm.9792b11c.mjs"), "../brands/uala-tipo-default-lg.tsx": () => import("./uala-tipo-default-lg.dee28a5b.mjs"), "../brands/uala-tipo-default-md.tsx": () => import("./uala-tipo-default-md.c8803bde.mjs"), "../brands/uala-tipo-default-sm.tsx": () => import("./uala-tipo-default-sm.27398bf3.mjs"), "../brands/uala-tipo-monocromo-lg.tsx": () => import("./uala-tipo-monocromo-lg.f99f8825.mjs"), "../brands/uala-tipo-monocromo-md.tsx": () => import("./uala-tipo-monocromo-md.cea504e7.mjs"), "../brands/uala-tipo-monocromo-sm.tsx": () => import("./uala-tipo-monocromo-sm.c04d7fee.mjs"), "../brands/ualabis-default-lg.tsx": () => import("./ualabis-default-lg.374c251a.mjs"), "../brands/ualabis-default-md.tsx": () => import("./ualabis-default-md.f4b7e472.mjs"), "../brands/ualabis-default-sm.tsx": () => import("./ualabis-default-sm.c6c9c77e.mjs"), "../brands/ualabis-inverted-lg.tsx": () => import("./ualabis-inverted-lg.5ab73383.mjs"), "../brands/ualabis-inverted-md.tsx": () => import("./ualabis-inverted-md.e5e3bd97.mjs"), "../brands/ualabis-inverted-sm.tsx": () => import("./ualabis-inverted-sm.fa075c99.mjs"), "../brands/ualabis-monocromo-lg.tsx": () => import("./ualabis-monocromo-lg.0490866c.mjs"), "../brands/ualabis-monocromo-md.tsx": () => import("./ualabis-monocromo-md.187a9ca7.mjs"), "../brands/ualabis-monocromo-sm.tsx": () => import("./ualabis-monocromo-sm.9a7b4972.mjs"), "../brands/ualatienda-default-lg.tsx": () => import("./ualatienda-default-lg.d9888c05.mjs"), "../brands/ualatienda-default-md.tsx": () => import("./ualatienda-default-md.d2ca487a.mjs"), "../brands/ualatienda-default-sm.tsx": () => import("./ualatienda-default-sm.2ec23de3.mjs"), "../brands/ualatienda-inverted-lg.tsx": () => import("./ualatienda-inverted-lg.b375e6ce.mjs"), "../brands/ualatienda-inverted-md.tsx": () => import("./ualatienda-inverted-md.c1f2b70b.mjs"), "../brands/ualatienda-inverted-sm.tsx": () => import("./ualatienda-inverted-sm.a83e571f.mjs"), "../brands/ualatienda-monocromo-lg.tsx": () => import("./ualatienda-monocromo-lg.37de283f.mjs"), "../brands/ualatienda-monocromo-md.tsx": () => import("./ualatienda-monocromo-md.43556eb0.mjs"), "../brands/ualatienda-monocromo-sm.tsx": () => import("./ualatienda-monocromo-sm.075e063e.mjs"), "../brands/ualintec-default-lg.tsx": () => import("./ualintec-default-lg.8c861165.mjs"), "../brands/ualintec-default-md.tsx": () => import("./ualintec-default-md.af60372c.mjs"), "../brands/ualintec-default-sm.tsx": () => import("./ualintec-default-sm.da7d0c1c.mjs"), "../brands/ualintec-monocromo-lg.tsx": () => import("./ualintec-monocromo-lg.c0b42d1c.mjs"), "../brands/ualintec-monocromo-md.tsx": () => import("./ualintec-monocromo-md.d205b1ff.mjs"), "../brands/ualintec-monocromo-sm.tsx": () => import("./ualintec-monocromo-sm.428a437f.mjs"), "../brands/uanex-default-lg.tsx": () => import("./uanex-default-lg.b876892f.mjs"), "../brands/uanex-default-md.tsx": () => import("./uanex-default-md.f3310d65.mjs"), "../brands/uanex-default-sm.tsx": () => import("./uanex-default-sm.9214bbd7.mjs"), "../brands/uanex-monocromo-lg.tsx": () => import("./uanex-monocromo-lg.81e2bcd3.mjs"), "../brands/uanex-monocromo-md.tsx": () => import("./uanex-monocromo-md.2d69ac17.mjs"), "../brands/uanex-monocromo-sm.tsx": () => import("./uanex-monocromo-sm.c7471b21.mjs"), "../brands/uilo-default-lg.tsx": () => import("./uilo-default-lg.34897770.mjs"), "../brands/uilo-default-md.tsx": () => import("./uilo-default-md.c95a864f.mjs"), "../brands/uilo-default-sm.tsx": () => import("./uilo-default-sm.6cf682fe.mjs"), "../brands/uilo-monocromo-lg.tsx": () => import("./uilo-monocromo-lg.98507b2f.mjs"), "../brands/uilo-monocromo-md.tsx": () => import("./uilo-monocromo-md.2f080750.mjs"), "../brands/uilo-monocromo-sm.tsx": () => import("./uilo-monocromo-sm.2a2cdd10.mjs") }), `../brands/${d || "uala-iso-default-md"}.tsx`));
  return /* @__PURE__ */ t(za, {
    ref: a,
    ...l,
    className: `${c || ""} ${d || ""}`,
    children: /* @__PURE__ */ t(s2, {
      fallback: /* @__PURE__ */ t(j1, {
        children: /* @__PURE__ */ t(v1, {
          width: 60,
          height: 20,
          css: {
            mt: "$4"
          }
        })
      }),
      children: /* @__PURE__ */ t(h, {
        "aria-label": r
      })
    })
  });
});
Ia.displayName = "Brand";
const Z0 = {
  "add-circle": {
    pathDefinition: "M2 11.75C2 6.37 6.37 2 11.75 2s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2 17.13 2 11.75Zm1.5 0C3.5 16.3 7.2 20 11.75 20S20 16.3 20 11.75 16.3 3.5 11.75 3.5 3.5 7.2 3.5 11.75ZM11.75 7c.41 0 .75.34.75.75V11h3.25c.41 0 .75.34.75.75s-.34.75-.75.75H12.5v3.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V12.5H7.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H11V7.75c0-.41.34-.75.75-.75Z",
    paths: null
  },
  "add-contact": {
    pathDefinition: "M10.997 13.25c2.888 0 5.246-2.36 5.246-5.25s-2.358-5.25-5.246-5.25C8.11 2.75 5.751 5.11 5.751 8s2.359 5.25 5.246 5.25Zm0-9a3.75 3.75 0 0 1 0 7.5 3.75 3.75 0 0 1 0-7.5Zm0 12c.41 0 .75-.34.75-.75s-.34-.75-.75-.75c-6.535 0-7.714 5.55-7.734 5.6-.04.22.01.45.16.62.15.17.36.27.58.27h6.994c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.052c.58-1.29 2.128-3.5 5.945-3.5v.01Zm9.003.5h-2.248V14.5c0-.41-.34-.75-.75-.75a.755.755 0 0 0-.749.75v2.25h-2.258c-.41 0-.75.34-.75.75s.34.75.75.75h2.258v2.25c0 .41.34.75.75.75s.75-.34.75-.75v-2.25H20c.41 0 .749-.34.749-.75s-.34-.75-.75-.75Z",
    paths: null
  },
  "all-categories": {
    pathDefinition: "M9.129 21.244a1.766 1.766 0 0 1-1.246-.52l-.91-.93a.244.244 0 0 0-.29-.05l-1.902.95c-.55.27-1.18.24-1.7-.08a1.74 1.74 0 0 1-.831-1.49V3.5c0-.41.34-.75.75-.75h18c.41 0 .75.34.75.75v15.625c0 .61-.31 1.17-.83 1.49-.52.32-1.161.35-1.701.08l-1.901-.95a.244.244 0 0 0-.29.05l-.91.93c-.591.6-1.522.7-2.222.23l-1.76-1.17a.24.24 0 0 0-.281 0l-1.761 1.17a1.72 1.72 0 0 1-.965.29Zm0 0h.005-.01.005Zm-2.337-3.029c.46 0 .91.18 1.251.53l.91.93c.08.08.22.1.32.03l1.761-1.17c.59-.39 1.351-.39 1.941 0l1.761 1.17c.1.07.23.05.32-.03l.911-.93c.53-.55 1.35-.68 2.031-.34l1.901.95c.11.05.2.02.24-.01.04-.03.12-.09.12-.21V4.25H3.741v14.875c0 .12.07.19.12.21.05.03.14.07.24.01l1.9-.95c.251-.12.521-.19.781-.19l.01.01Zm10.206-8.967H6.992c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10.006c.41 0 .75.34.75.75s-.34.75-.75.75ZM6.992 14.246h7.004c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H6.992c-.41 0-.75.34-.75.75s.34.75.75.75Z",
    paths: null
  },
  analyze: {
    pathDefinition: "M13.255 3c0-.41.34-.75.75-.75 4.267 0 7.745 3.482 7.745 7.754 0 .41-.34.75-.75.75h-6.996c-.41 0-.75-.34-.75-.75V3Zm1.499.79v5.464h5.457c-.35-2.852-2.609-5.123-5.457-5.463Zm2.478 9.636c.03-.41.39-.73.8-.7l-.01-.01c.41.03.73.39.7.8-.26 4.052-3.459 7.234-7.726 7.234-4.268 0-7.746-3.482-7.746-7.754 0-4.072 3.168-7.464 7.226-7.734a.751.751 0 1 1 .1 1.5c-3.268.22-5.827 2.792-5.827 6.244a6.252 6.252 0 0 0 6.247 6.253 6.267 6.267 0 0 0 6.236-5.833Z",
    paths: null
  },
  "apple-pay": {
    pathDefinition: "M16 2.1H8c-1.52 0-2.75 1.23-2.75 2.75v14c0 1.52 1.23 2.75 2.75 2.75h8c1.52 0 2.75-1.23 2.75-2.75v-14c0-1.52-1.23-2.75-2.75-2.75Zm1.25 16.75c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25v-14c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v14Zm-6.46-8.47c.33-.33.6-.49 1.21-.49.5 0 .79.17 1.18.52.14.13.32.19.5.19.21 0 .41-.08.56-.25.28-.31.25-.78-.06-1.06-.52-.47-1.15-.9-2.18-.9-1.17 0-1.8.47-2.26.93-.29.29-.3.77 0 1.06.29.29.77.3 1.06 0h-.01ZM8.47 6.61C9.53 5.55 10.58 5.1 12 5.1c1.41 0 2.47.45 3.53 1.51.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22C13.58 6.78 12.84 6.6 12 6.6c-.84 0-1.58.18-2.47 1.07-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06ZM15 14.1H9c-.41 0-.75.34-.75.75s.34.75.75.75h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm-2.25 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    paths: null
  },
  "atm-pin": {
    pathDefinition: "M5.75 6.85a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM5.75 13.1a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-12.5 6.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm6.25 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    paths: null
  },
  "atm-section": {
    pathDefinition: "M20.99 4H3c-.41 0-.75.34-.75.75v7.995c0 .41.34.75.75.75h2.998c.09 0 .17-.02.25-.05v5.296c0 .24.11.46.3.6 1 .75 1.909 1.009 2.748 1.009 1.15 0 2.16-.5 3.039-.94 1.45-.719 2.579-1.289 4.208-.07.23.17.53.2.79.07a.77.77 0 0 0 .42-.669v-5.297c.079.03.159.05.249.05H21c.41 0 .75-.34.75-.75V4.75c0-.41-.34-.75-.75-.75h-.01Zm-4.747 13.442c-1.82-.76-3.328 0-4.578.63-1.36.679-2.439 1.219-3.918.28V9.496h1.81c-.19.38-.31.8-.31 1.249a2.747 2.747 0 0 0 2.748 2.748c1.52 0 2.749-1.23 2.749-2.748 0-.45-.12-.87-.31-1.25h1.809v7.946Zm-2.999-6.696a1.25 1.25 0 1 1-2.5-.001 1.25 1.25 0 0 1 2.5 0Zm6.997 1.25h-2.25a.695.695 0 0 0-.249.05v-3.3c0-.41-.34-.75-.75-.75H6.998c-.41 0-.75.34-.75.75v3.298a.696.696 0 0 0-.25-.05H3.75V5.5h16.492v6.496Z",
    paths: null
  },
  atm: {
    pathDefinition: "M21 4.25H3c-.41 0-.75.34-.75.75v8c0 .41.34.75.75.75h3c.09 0 .17-.02.25-.05V20c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-6.3c.08.03.16.05.25.05h3c.41 0 .75-.34.75-.75V5c0-.41-.34-.75-.75-.75Zm-13.25 15v-9.5h1.81c-.19.38-.31.8-.31 1.25 0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75c0-.45-.12-.87-.31-1.25h1.81v9.5h-8.5Zm5.5-8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm7 1.25H18c-.09 0-.17.02-.25.05V8.25H6.25v4.05a.696.696 0 0 0-.25-.05H3.75v-6.5h16.5v6.5Z",
    paths: null
  },
  attach: {
    pathDefinition: "M17 7c-.41 0-.75.34-.75.75v8.5A4.26 4.26 0 0 1 12 20.5a4.26 4.26 0 0 1-4.25-4.25v-10c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75v9.5a1.25 1.25 0 0 1-2.5 0v-8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v8c0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75v-9.5A4.26 4.26 0 0 0 10.5 2a4.26 4.26 0 0 0-4.25 4.25v10C6.25 19.42 8.83 22 12 22s5.75-2.58 5.75-5.75v-8.5c0-.41-.34-.75-.75-.75Z",
    paths: null
  },
  attention: {
    pathDefinition: "M12 3.25c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5Zm0 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    paths: null
  },
  battery: {
    pathDefinition: "M17 5.25H5C3.48 5.25 2.25 6.48 2.25 8v8c0 1.52 1.23 2.75 2.75 2.75h12c1.52 0 2.75-1.23 2.75-2.75V8c0-1.52-1.23-2.75-2.75-2.75ZM18.25 16c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25V8c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v8Zm-4.49-4.71-2.01.67V11c0-.24-.12-.47-.31-.61a.75.75 0 0 0-.68-.1l-3 1c-.39.13-.61.56-.47.95.13.39.55.6.95.47l2.01-.67V13c0 .24.12.47.31.61a.767.767 0 0 0 .68.1l3-1c.39-.13.61-.56.47-.95a.749.749 0 0 0-.95-.47ZM20.25 10c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4Z",
    paths: null
  },
  bitcoin: {
    pathDefinition: "M17.75 15.35c0-1.98-.89-3.3-2.09-4.04.78-.79 1.09-2.02 1.09-2.96 0-.99-.46-2.65-2-3.38V3.35c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.26c-.08 0-.16-.01-.25-.01h-2.25V3.35c0-.41-.34-.75-.75-.75s-.75.34-.75.75V4.6H7c-.41 0-.75.34-.75.75s.34.75.75.75h1.25v11.5H7c-.41 0-.75.34-.75.75s.34.75.75.75h2.25v1.25c0 .41.34.75.75.75s.75-.34.75-.75V19.1h2.5v1.25c0 .41.34.75.75.75s.75-.34.75-.75v-1.44c1.64-.43 3-1.63 3-3.56ZM13 6.1c2.12 0 2.25 1.88 2.25 2.25 0 .02-.02 2.25-1.52 2.25-.06 0-.12.02-.18.04-.14-.01-.29-.04-.43-.04H9.75V6.1H13Zm.36 11.5H9.75v-5.5h3.37c.32 0 3.13.09 3.13 3.25 0 1.55-1.5 2.25-2.89 2.25Z",
    paths: null
  },
  calculator: {
    pathDefinition: "M9.15 2.25h6c2.62 0 4.75 2.13 4.75 4.75v10c0 2.62-2.13 4.75-4.75 4.75h-6c-2.62 0-4.75-2.13-4.75-4.75V7c0-2.62 2.13-4.75 4.75-4.75Zm6 18c1.79 0 3.25-1.46 3.25-3.25V7c0-1.79-1.46-3.25-3.25-3.25h-6C7.36 3.75 5.9 5.21 5.9 7v10c0 1.79 1.46 3.25 3.25 3.25h6ZM16.9 7v3c0 .41-.34.75-.75.75h-8c-.41 0-.75-.34-.75-.75V7c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75Zm-8 2.25h6.5v-1.5H8.9v1.5ZM8.15 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    paths: null
  },
  calendar: {
    pathDefinition: "M17.75 3.25H18c2.07 0 3.75 1.68 3.75 3.75v11c0 2.07-1.68 3.75-3.75 3.75H6c-2.07 0-3.75-1.68-3.75-3.75V7c0-2.07 1.68-3.75 3.75-3.75h.25V3c0-.41.34-.75.75-.75s.75.34.75.75v.25h3.5V3c0-.41.34-.75.75-.75s.75.34.75.75v.25h3.5V3c0-.41.34-.75.75-.75s.75.34.75.75v.25Zm-11.5 1.5H6C4.76 4.75 3.75 5.76 3.75 7v1.25h16.5V7c0-1.24-1.01-2.25-2.25-2.25h-.25V6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.75h-3.5V6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.75h-3.5V6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.75ZM3.75 18c0 1.24 1.01 2.25 2.25 2.25h12c1.24 0 2.25-1.01 2.25-2.25V9.75H3.75V18ZM7 13.74a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 17.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm5.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-10 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    paths: null
  },
  "camera-sm": {
    pathDefinition: "M11 3.5h2.25c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5H2.75c-.83 0-1.5-.67-1.5-1.5V5c0-.83.67-1.5 1.5-1.5H5L6.5 2h3L11 3.5ZM2.75 5v7.5h10.5V5H11c-.4 0-.78-.16-1.06-.44L8.88 3.5H7.12L6.06 4.56C5.78 4.84 5.4 5 5 5H2.75Zm2 3.43c0-1.79 1.46-3.25 3.25-3.25s3.25 1.46 3.25 3.25S9.79 11.68 8 11.68s-3.25-1.46-3.25-3.25Zm1.5 0c0 .96.79 1.75 1.75 1.75s1.75-.79 1.75-1.75S8.96 6.68 8 6.68s-1.75.79-1.75 1.75Z",
    paths: null
  },
  camera: {
    pathDefinition: "M16.31 5.25H19c1.52 0 2.75 1.23 2.75 2.75v10c0 1.52-1.23 2.75-2.75 2.75H5c-1.52 0-2.75-1.23-2.75-2.75V8c0-1.52 1.23-2.75 2.75-2.75h2.69l1.78-1.78a.75.75 0 0 1 .53-.22h4c.2 0 .39.08.53.22l1.78 1.78Zm2.69 14c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25h-3a.75.75 0 0 1-.53-.22l-1.78-1.78h-3.38L8.53 6.53a.75.75 0 0 1-.53.22H5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14ZM7.25 13c0-2.62 2.13-4.75 4.75-4.75s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75S7.25 15.62 7.25 13Zm1.5 0c0 1.79 1.46 3.25 3.25 3.25s3.25-1.46 3.25-3.25S13.79 9.75 12 9.75 8.75 11.21 8.75 13Z",
    paths: null
  },
  "card-alt": {
    pathDefinition: "M17.75 5h-12C3.68 5 2 6.68 2 8.75v7c0 2.07 1.68 3.75 3.75 3.75h12c2.07 0 3.75-1.68 3.75-3.75v-7C21.5 6.68 19.82 5 17.75 5Zm-12 1.5h12c1.07 0 1.96.75 2.19 1.75H3.56c.23-1 1.12-1.75 2.19-1.75Zm12 11.5h-12c-1.24 0-2.25-1.01-2.25-2.25v-4.5H20v4.5c0 1.24-1.01 2.25-2.25 2.25Z",
    paths: null
  },
  "card-fill": {
    pathDefinition: "M18 5.5H6a3.51 3.51 0 0 0-3.5 3.512v9.031c0 .16.08.311.21.412C4.3 19.589 5.74 20 7.09 20c1.83 0 3.49-.753 5.12-1.505 2.69-1.224 5.24-2.388 8.5-.05.15.11.35.12.52.04a.5.5 0 0 0 .27-.442v-9.03A3.51 3.51 0 0 0 18 5.5Zm2.5 5.368c0 .221-.18.402-.4.402H3.9c-.22 0-.4-.18-.4-.402V9.163c0-.221.18-.402.4-.402h16.2c.22 0 .4.18.4.402v1.705Z",
    paths: null
  },
  card: {
    pathDefinition: "M18 5.25H6a3.759 3.759 0 0 0-3.75 3.765v9.036c0 .241.12.472.31.613 1.63 1.164 3.12 1.586 4.52 1.586 1.91 0 3.63-.783 5.23-1.516 2.74-1.245 5.11-2.33 8.25-.07.23.16.53.19.78.06s.41-.392.41-.673V9.015A3.759 3.759 0 0 0 18 5.25ZM6 6.756h12c1.07 0 1.96.753 2.19 1.757H3.81A2.253 2.253 0 0 1 6 6.756Zm5.69 10.613c-2.65 1.204-4.94 2.259-7.94.29v-6.124h16.5v5.18c-3.32-1.736-6.09-.461-8.56.663v-.01Z",
    paths: null
  },
  "cash-out-section": {
    pathDefinition: "M21.43 3.63c.19.14.31.37.31.61h.01v11.957c0 .28-.16.54-.41.67-.25.13-.55.1-.78-.06-.999-.72-1.928-1.1-2.808-1.24v3.631a2.75 2.75 0 0 1-2.748 2.752H9.007a2.749 2.749 0 0 1-2.749-2.752v-.95c-.08.02-.16.04-.25.04-.025 0-.047-.003-.07-.005a.512.512 0 0 0-.07-.005c-1.12-.2-2.199-.68-3.298-1.47a.75.75 0 0 1-.32-.611V4.24c0-.28.16-.54.41-.67.25-.13.55-.1.78.06 3.138 2.251 5.507 1.18 8.245-.07 2.769-1.26 5.897-2.682 9.745.07ZM8.997 20.45h5.996l-.01.01c.69 0 1.25-.561 1.25-1.252v-3.661c-1.32.15-2.579.72-3.938 1.34-.33.15-.67.3-1.01.45a.75.75 0 0 1-.99-.39.749.749 0 0 1-.02-.53c-.02-.07-.04-.14-.04-.22v-4.893c0-.67-.439-1.24-1.029-1.34-.38-.06-.74.04-1.019.28-.28.24-.44.58-.44.95v8.004c0 .69.56 1.251 1.25 1.251Zm2.748-9.146v4.182c2.459-1.11 5.208-2.34 8.496-.63V4.63c-2.981-1.956-5.276-.915-7.916.281l-.02.01c-2.479 1.13-5.237 2.381-8.556.66v10.226c.8.53 1.58.85 2.379 1 .05.01.12.05.12.05v-5.653a2.757 2.757 0 0 1 3.208-2.721c1.3.21 2.29 1.43 2.29 2.821Zm.6-3.222a.76.76 0 0 1 1.03-.27l-.01-.02a2.77 2.77 0 0 1 1.369 2.382c0 .49-.13.96-.37 1.38-.14.25-.39.38-.65.38a.747.747 0 0 1-.64-1.12c.11-.18.17-.4.17-.62 0-.44-.24-.86-.63-1.081a.761.761 0 0 1-.27-1.03Z",
    paths: null
  },
  "cash-out": {
    pathDefinition: "M3 3.25h18c.41 0 .75.34.75.75v10c0 .41-.34.75-.75.75h-3.3c.03.08.05.16.05.25v4c0 1.52-1.23 2.75-2.75 2.75H9c-1.52 0-2.75-1.23-2.75-2.75v-4.25H3c-.41 0-.75-.34-.75-.75V4c0-.41.34-.75.75-.75ZM16.25 19v-4h-.01c0-.09.02-.17.05-.25h-4.55V16c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4.89c0-.67-.44-1.24-1.03-1.34-.38-.06-.74.04-1.02.28-.28.24-.44.58-.44.95v8c0 .69.56 1.25 1.25 1.25h6c.69 0 1.25-.56 1.25-1.25Zm-4.5-5.75h8.5v-8.5H3.75v8.51h2.5v-2.25c0-.81.35-1.58.97-2.1a2.76 2.76 0 0 1 2.24-.62c1.3.21 2.29 1.43 2.29 2.82v2.14Zm1.5-3.89c0-.44-.24-.86-.63-1.08l-.01-.02a.76.76 0 0 1-.27-1.03.76.76 0 0 1 1.03-.27c.84.49 1.37 1.4 1.37 2.38 0 .49-.13.96-.37 1.38-.14.25-.39.38-.65.38a.746.746 0 0 1-.64-1.12c.11-.18.17-.4.17-.62Z",
    paths: null
  },
  cash: {
    pathDefinition: "M2.56 18.61c1.63 1.16 3.12 1.58 4.52 1.58 1.91 0 3.63-.78 5.23-1.51l.027-.012c2.728-1.235 5.083-2.3 8.223-.058.23.17.53.19.78.06a.76.76 0 0 0 .41-.67V6a.74.74 0 0 0-.31-.61c-3.85-2.75-6.99-1.33-9.75-.07l-.027.012c-2.728 1.235-5.083 2.3-8.223.058a.735.735 0 0 0-.78-.06.76.76 0 0 0-.41.67v12c0 .24.11.47.31.61Zm9.13-1.29c-2.65 1.21-4.94 2.25-7.94.29V7.35c3.306 1.723 6.066.47 8.528-.646l.032-.014c2.65-1.21 4.95-2.25 7.94-.29v10.26c-3.316-1.718-6.083-.463-8.55.656l-.01.004ZM9.25 12c0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75S13.52 9.25 12 9.25 9.25 10.48 9.25 12Zm1.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    paths: null
  },
  categories: {
    pathDefinition: "M2.25 7c0 .41.34.75.75.75v-.01c.41 0 .75-.34.75-.75 0-.14.11-.25.25-.25h8.01c.25 0 .48-.12.62-.33l1.7-2.55a.26.26 0 0 1 .21-.11h5.71V4c0 .41.34.75.75.75s.75-.34.75-.75V3c0-.41-.34-.75-.75-.75h-6.46c-.59 0-1.13.29-1.46.78L11.6 5.25H4c-.96 0-1.75.79-1.75 1.75ZM20 21.75H4c-.96 0-1.75-.79-1.75-1.75v-9c0-.96.79-1.75 1.75-1.75h9.6l1.48-2.22c.33-.49.87-.78 1.46-.78H20c.96 0 1.75.79 1.75 1.75v12c0 .96-.79 1.75-1.75 1.75Zm-16-11c-.14 0-.25.11-.25.25v9c0 .14.11.25.25.25h16c.14 0 .25-.11.25-.25V8c0-.14-.11-.25-.25-.25h-3.46a.26.26 0 0 0-.21.11l-1.7 2.55c-.14.21-.37.33-.62.33H4v.01Zm6 7H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    paths: null
  },
  cbu: {
    pathDefinition: "M4 9.75h16c.32 0 .61-.21.71-.51.1-.31 0-.64-.26-.84l-8-6a.75.75 0 0 0-.9 0l-8 6A.75.75 0 0 0 4 9.75Zm8-5.81 5.75 4.31H6.25L12 3.94ZM7.75 15v-3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .41.34.75.75.75s.75-.34.75-.75Zm10 0v-3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .41.34.75.75.75s.75-.34.75-.75Zm-13.5 3c0 .41.34.75.75.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5c-.41 0-.75.34-.75.75ZM21 20.25H3c-.41 0-.75.34-.75.75s.34.75.75.75h18c.41 0 .75-.34.75-.75s-.34-.75-.75-.75ZM12.75 15v-3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .41.34.75.75.75s.75-.34.75-.75Z",
    paths: null
  },
  cedears: {
    pathDefinition: "M13.616 21.49c.38.17.8.26 1.21.26a2.925 2.925 0 0 0 2.741-1.89l.4-1.062c.14-.38.45-.69.831-.83l1.06-.4a2.982 2.982 0 0 0 1.671-1.621c.31-.75.29-1.6-.04-2.331l-.47-1.03c-.17-.37-.17-.801 0-1.171l.47-1.03c.33-.741.35-1.591.04-2.332-.31-.75-.92-1.34-1.67-1.62l-1.06-.4a1.415 1.415 0 0 1-.831-.831l-.4-1.06a2.982 2.982 0 0 0-1.621-1.671 2.95 2.95 0 0 0-2.331.04l-1.03.47c-.37.17-.801.17-1.171 0l-1.03-.47a2.95 2.95 0 0 0-2.332-.04c-.75.31-1.34.92-1.62 1.67l-.4 1.06c-.14.381-.45.691-.831.831l-1.06.4c-.751.29-1.361.88-1.671 1.621-.31.75-.29 1.6.04 2.331l.47 1.03c.17.37.17.801 0 1.171l-.47 1.03a2.95 2.95 0 0 0-.04 2.332c.31.75.92 1.34 1.67 1.62l1.06.4c.381.14.691.45.831.831l.4 1.06c.29.751.88 1.361 1.621 1.671.75.31 1.59.29 2.331-.04l1.03-.47c.37-.17.801-.17 1.171 0l1.03.47Zm-.41-1.841a3.03 3.03 0 0 0-1.206-.26h.005-.01H12c-.409 0-.827.09-1.206.26l-1.03.47c-.36.16-.76.17-1.13.02a1.4 1.4 0 0 1-.79-.81l-.401-1.061c-.3-.79-.92-1.41-1.71-1.71l-1.061-.401a1.4 1.4 0 0 1-.81-.79c-.15-.37-.14-.77.02-1.131l.47-1.03c.35-.77.35-1.651 0-2.422l-.47-1.03a1.39 1.39 0 0 1-.02-1.13c.15-.37.44-.65.81-.79l1.06-.401c.79-.3 1.41-.92 1.71-1.71l.401-1.061c.14-.37.42-.66.79-.81.37-.15.77-.14 1.131.02l1.03.47c.76.35 1.641.35 2.412 0l1.03-.47c.36-.16.76-.17 1.13-.02.37.15.65.44.79.81l.401 1.06c.3.79.92 1.41 1.71 1.71l1.061.401c.37.14.66.42.81.79.15.37.14.77-.02 1.131l-.47 1.03c-.35.77-.35 1.651 0 2.422l.47 1.03c.17.36.17.76.02 1.13a1.4 1.4 0 0 1-.81.79l-1.06.401c-.79.3-1.41.92-1.71 1.71l-.401 1.061a1.4 1.4 0 0 1-.79.81c-.37.15-.77.14-1.131-.02l-1.03-.47Zm-1.841-3.212c.02.29.35.42.64.42l-.02-.02c.29 0 .61-.13.63-.41v-.47l.08-.02c.53-.09 1-.31 1.41-.64.401-.32.601-.84.601-1.551 0-.49-.14-.94-.41-1.35-.27-.411-.83-.761-1.66-1.051-.671-.23-1.141-.43-1.391-.61-.27-.19-.4-.44-.4-.73 0-.261.1-.471.31-.621.2-.14.46-.21.78-.21.36 0 .67.1.91.29.24.19.41.44.51.77.05.29.36.31.45.31.25 0 .501-.11.631-.29.11-.15.13-.32.07-.52-.14-.48-.37-.86-.67-1.15-.3-.28-.66-.46-1.07-.52h-.09v-.571c-.04-.29-.37-.42-.661-.42-.29 0-.61.13-.62.41v.58l-.08.02c-.59.14-1.03.4-1.31.78-.281.38-.421.8-.421 1.241 0 .55.17 1.01.5 1.35.34.35.92.671 1.72.951.571.2.991.39 1.241.58.27.2.4.46.4.78 0 .361-.12.641-.36.811-.22.17-.55.25-.97.25-.4 0-.74-.13-1.03-.37-.29-.24-.5-.64-.62-1.15a.54.54 0 0 0-.521-.33.68.68 0 0 0-.54.25c-.11.15-.16.35-.11.57.13.61.39 1.1.75 1.45.36.35.78.58 1.24.68l.08.02v.491Z",
    paths: null
  },
  challenge: {
    pathDefinition: "M18.979 18.7H5.026a.755.755 0 0 1-.728-.57L2.056 9.106c-.19-.75.11-1.499.767-1.908a1.705 1.705 0 0 1 2.044.14l2.78 2.328c.07.06.16.06.19.05.04 0 .12-.03.169-.11l2.541-3.827a1.744 1.744 0 0 1 2.91 0L16 9.606c.05.08.13.1.17.11.04 0 .119 0 .189-.05l2.78-2.329c.588-.5 1.395-.55 2.043-.14.648.41.947 1.16.768 1.91l-2.253 9.023a.748.748 0 0 1-.727.57h.01ZM5.614 17.2h12.787l2.113-8.454a.22.22 0 0 0-.11-.27c-.07-.04-.18-.08-.29.02l-2.78 2.329c-.378.32-.877.46-1.365.39a1.771 1.771 0 0 1-1.206-.76l-2.541-3.827c-.13-.19-.29-.19-.419 0l-2.541 3.827a1.75 1.75 0 0 1-1.206.76 1.7 1.7 0 0 1-1.366-.39L3.91 8.497c-.12-.1-.22-.06-.29-.02a.227.227 0 0 0-.109.27L5.624 17.2h-.01Z",
    paths: null
  },
  chat: {
    pathDefinition: "M6 2.1h12c2.07 0 3.75 1.68 3.75 3.75v8c0 2.07-1.68 3.75-3.75 3.75h-4.74l-4.79 3.84c-.14.1-.3.16-.47.16-.12 0-.23-.02-.33-.07a.773.773 0 0 1-.42-.68V17.6H6c-2.07 0-3.75-1.68-3.75-3.75v-8C2.25 3.78 3.93 2.1 6 2.1Zm12 14c1.24 0 2.25-1.01 2.25-2.25v-8c0-1.24-1.01-2.25-2.25-2.25H6c-1.24 0-2.25 1.01-2.25 2.25v8c0 1.24 1.01 2.25 2.25 2.25h2c.41 0 .75.34.75.75v2.44l3.78-3.03c.13-.1.3-.16.47-.16h5Zm-5.45-2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.5 6.88c.4-1.06 1.34-1.73 2.53-1.78h-.01c1.05-.05 2.03.62 2.39 1.66.32.93.14 2.3-1.33 3.34-.38.27-.55.58-.55.96 0 .41-.33.76-.74.76h-.01c-.41 0-.75-.33-.75-.74-.02-.88.4-1.66 1.18-2.21.68-.47.97-1.08.78-1.63a.93.93 0 0 0-.9-.65c-.79.04-1.08.52-1.19.81-.14.39-.57.59-.96.44a.736.736 0 0 1-.44-.96Z",
    paths: null
  },
  "check-circle-empty-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm0 12.5A5.51 5.51 0 0 1 2.5 8c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5Z",
    paths: null
  },
  "check-circle-empty": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm0 18c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25Z",
    paths: null
  },
  "check-circle-fill-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm3.64 5.97-3.89 3.89c-.15.15-.34.22-.53.22s-.38-.07-.53-.22L5.13 9.3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.03 1.03 3.36-3.36c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06Z",
    paths: null
  },
  "check-circle-fill": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm4.53 8.28-5 5c-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L11 13.94l4.47-4.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06Z",
    paths: null
  },
  "check-circle-sm": {
    pathDefinition: "M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm1.5 0c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5S11.03 2.5 8 2.5A5.51 5.51 0 0 0 2.5 8Zm4.72 1.27 3.36-3.36c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.89 3.89c-.15.15-.34.22-.53.22s-.38-.07-.53-.22L5.13 9.3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.03 1.03Z",
    paths: null
  },
  "check-circle": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12ZM11 13.94l4.47-4.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-5 5c-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L11 13.94Z",
    paths: null
  },
  "check-fill": {
    pathDefinition: "M9.502 18.001c-.38 0-.77-.15-1.06-.44l-4-4a1.49 1.49 0 0 1 0-2.12c.59-.58 1.54-.59 2.12 0l2.94 2.94 7.94-7.94a1.49 1.49 0 0 1 2.12 0c.58.59.59 1.54 0 2.12l-9 9c-.29.29-.68.44-1.06.44Z",
    paths: null
  },
  check: {
    pathDefinition: "M9.5 17.249c-.19 0-.38-.07-.53-.22l-4-4a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.47 3.47 8.47-8.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-9 9c-.15.15-.34.22-.53.22Z",
    paths: null
  },
  clients: {
    pathDefinition: "M15 12.75a5.271 5.271 0 0 1-3.001-.946A5.215 5.215 0 0 1 9 12.75c-2.89 0-5.25-2.36-5.25-5.25S6.11 2.25 9 2.25c1.112 0 2.145.35 2.996.944a5.254 5.254 0 0 1 3.014-.954c2.89 0 5.25 2.36 5.25 5.25s-2.36 5.25-5.25 5.25l-.01.01Zm-.75-5.25a5.22 5.22 0 0 1-1.123 3.238c.567.328 1.21.502 1.883.502 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75-.667 0-1.319.179-1.89.514A5.221 5.221 0 0 1 14.25 7.5Zm-9 0c0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75-2.07 0-3.75-1.68-3.75-3.75ZM1.42 20.48c.14.17.36.27.58.27h20l.01-.02c.22 0 .43-.1.58-.27.15-.17.2-.4.16-.62l-.006-.022c-.096-.383-1.407-5.578-7.734-5.578-1.104 0-2.123.16-3.035.475-.84-.283-1.825-.455-2.975-.455-6.54 0-7.73 5.54-7.74 5.6-.04.22.02.45.16.62Zm10.302-4.276.038.014c1.877.72 2.786 2.11 3.2 3.032H3.06c.57-1.29 2.13-3.5 5.95-3.5 1.074 0 1.968.175 2.712.454Zm2.32-.406c.309-.032.628-.048.958-.048 3.82 0 5.37 2.21 5.95 3.5h-4.398c-.297-.822-1.005-2.313-2.51-3.452Z",
    paths: null
  },
  clock: {
    pathDefinition: "M2.25 11.85C2.25 6.47 6.62 2.1 12 2.1s9.75 4.37 9.75 9.75S17.38 21.6 12 21.6s-9.75-4.37-9.75-9.75Zm10.5 7v1.21a8.26 8.26 0 0 0 7.46-7.46H19c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.21a8.26 8.26 0 0 0-7.46-7.46v1.21c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.64a8.26 8.26 0 0 0-7.46 7.46H5c.41 0 .75.34.75.75s-.34.75-.75.75H3.79a8.26 8.26 0 0 0 7.46 7.46v-1.21c0-.41.34-.75.75-.75s.75.34.75.75Zm0-7.65c.13.16.21.35.23.57v-.01l2.55 2.55c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.55-2.55a.984.984 0 0 1-.92-.98c0-.24.1-.46.25-.64V8.84c0-.41.34-.75.75-.75s.75.34.75.75v2.36Z",
    paths: null
  },
  "close-sm": {
    pathDefinition: "m9.063 8 2.972-2.97c.29-.29.29-.77 0-1.06a.755.755 0 0 0-1.06 0L8.001 6.94l-2.97-2.97a.755.755 0 0 0-1.06 0 .753.753 0 0 0 0 1.06L6.94 8l-2.97 2.97a.753.753 0 0 0 0 1.06c.15.15.34.22.53.22s.38-.07.53-.22l2.971-2.97 2.972 2.97c.15.15.34.22.53.22s.38-.07.53-.22a.753.753 0 0 0 0-1.06L9.065 8Z",
    paths: null
  },
  close: {
    pathDefinition: "m13.07 11.999 4.46-4.46a.761.761 0 0 0 0-1.07.762.762 0 0 0-1.07 0L12 10.93 7.54 6.47a.762.762 0 0 0-1.07 0 .761.761 0 0 0 0 1.07L10.93 12l-4.46 4.46a.761.761 0 0 0 0 1.069.748.748 0 0 0 .534.222c.192 0 .384-.07.535-.222L12 13.068l4.46 4.46a.749.749 0 0 0 .536.222c.191 0 .383-.07.535-.222a.761.761 0 0 0 0-1.07l-4.461-4.46Z",
    paths: null
  },
  comment: {
    pathDefinition: "M8 21.6c-.11 0-.22-.02-.33-.07a.744.744 0 0 1-.42-.68V17.6H6c-2.07 0-3.75-1.68-3.75-3.75v-8C2.25 3.78 3.93 2.1 6 2.1h12c2.07 0 3.75 1.68 3.75 3.75v8c0 2.07-1.68 3.75-3.75 3.75h-4.74l-4.79 3.84c-.14.11-.3.16-.47.16Zm-2-18c-1.24 0-2.25 1.01-2.25 2.25v8c0 1.24 1.01 2.25 2.25 2.25h2c.41 0 .75.34.75.75v2.44l3.78-3.03c.13-.11.3-.16.47-.16h5c1.24 0 2.25-1.01 2.25-2.25v-8c0-1.24-1.01-2.25-2.25-2.25H6Z",
    paths: null
  },
  commission: {
    pathDefinition: "M12.01 20.6c-.36 0-.902-.15-.942-.56v-1.049l-.31-.07c-.792-.17-1.504-.57-2.135-1.18-.631-.609-1.062-1.448-1.293-2.498-.07-.33-.02-.62.16-.84.181-.23.492-.37.802-.37.351 0 .612.17.742.47.23.95.621 1.68 1.172 2.15.562.469 1.233.709 2.005.709.771 0 1.443-.17 1.894-.49.49-.36.741-.91.741-1.639 0-.64-.27-1.18-.812-1.579-.47-.36-1.222-.71-2.304-1.08-1.413-.489-2.435-1.049-3.027-1.658-.56-.58-.841-1.35-.841-2.279 0-.75.24-1.46.721-2.109.471-.64 1.233-1.09 2.245-1.329l.31-.07v-1.21c.01-.38.542-.519.892-.519.451 0 .922.2.962.57v1.199l.351.05c.691.09 1.303.38 1.814.87.52.49.912 1.149 1.162 1.968.09.29.06.54-.09.74-.19.26-.581.44-.952.44-.16 0-.541-.04-.591-.38-.2-.66-.531-1.16-.992-1.53-.471-.379-1.073-.569-1.784-.569-.621 0-1.132.14-1.533.43-.431.31-.662.76-.662 1.3 0 .609.271 1.108.822 1.498.471.34 1.313.71 2.575 1.13 1.454.5 2.426 1.109 2.887 1.799.47.7.701 1.479.701 2.318 0 1.2-.33 2.079-.992 2.619-.712.57-1.533.95-2.445 1.119l-.33.06v1.03c-.02.38-.562.519-.913.519l-.01.02Z",
    paths: null
  },
  copy: {
    pathDefinition: "M18 2.25c.41 0 .75.34.75.75s-.34.75-.75.75H5c-.69 0-1.25.56-1.25 1.25v13c0 .41-.34.75-.75.75s-.75-.34-.75-.75V5c0-1.52 1.23-2.75 2.75-2.75h13Zm-9 4h10c1.52 0 2.75 1.23 2.75 2.75v10c0 1.52-1.23 2.75-2.75 2.75H9c-1.52 0-2.75-1.23-2.75-2.75V9c0-1.52 1.23-2.75 2.75-2.75Zm10 14c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25H9c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10Z",
    paths: null
  },
  crypto: {
    pathDefinition: "M11.665 21.671c.1.05.21.08.33.08h.01a.8.8 0 0 0 .33-.08l7.995-4c.26-.13.42-.39.42-.67v-10a.77.77 0 0 0-.42-.67l-7.995-4a.72.72 0 0 0-.67 0l-7.995 4c-.26.13-.42.39-.42.67v10c0 .28.17.54.42.67l7.995 4Zm.33-1.51-7.246-3.62v-9.08l7.246-3.62 7.246 3.62v9.08l-7.246 3.62Zm-.35-3.5c.11.06.23.09.35.09v-.01c.12 0 .24-.03.35-.09l2.998-1.58c.36-.19.5-.64.31-1.01a.742.742 0 0 0-1.01-.31l-2.648 1.4-2.798-1.48v-3.35l2.798-1.48 2.649 1.4c.37.2.82.06 1.009-.31.2-.36.06-.82-.31-1.01l-2.998-1.58a.725.725 0 0 0-.7 0l-3.548 1.87c-.25.13-.4.38-.4.66v4.26c0 .28.15.53.4.66l3.548 1.87Z",
    paths: null
  },
  cvu: {
    pathDefinition: "M7 3.25h10c2.62 0 4.75 2.13 4.75 4.75v8c0 2.62-2.13 4.75-4.75 4.75H7c-2.62 0-4.75-2.13-4.75-4.75V8c0-2.62 2.13-4.75 4.75-4.75Zm13.22 4.47A3.235 3.235 0 0 0 17 4.75H6.99C5.2 4.75 3.74 6.21 3.74 8v.57c3.43 1.99 5.52.96 7.92-.24 2.29-1.14 4.85-2.41 8.56-.61ZM17 19.25c1.79 0 3.25-1.46 3.25-3.25V9.42c-3.44-1.99-5.52-.95-7.92.25l-.008.004c-2.288 1.15-4.846 2.434-8.572.606V16c0 1.79 1.46 3.25 3.25 3.25h10Zm0-2.5c-1.52 0-2.75-1.23-2.75-2.75s1.23-2.75 2.75-2.75c.41 0 .75.34.75.75s-.34.75-.75.75a1.25 1.25 0 0 0 0 2.5c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    paths: null
  },
  "dark-mode": {
    pathDefinition: "M9.417 2.91a.755.755 0 0 0-.764-.063 9.754 9.754 0 0 0-3.54 2.266c-3.804 3.804-3.804 10.001 0 13.806a9.715 9.715 0 0 0 6.897 2.853l.02-.01a9.732 9.732 0 0 0 6.898-2.854 9.759 9.759 0 0 0 2.292-3.614.764.764 0 0 0-.46-.96.767.767 0 0 0-.331-.035.753.753 0 0 0-.36.134c-2.983 2.113-7.038 1.762-9.64-.83a7.471 7.471 0 0 1-.831-9.642c.24-.34.16-.81-.18-1.05Zm6.317 14.407a9 9 0 0 1-6.377-2.653 8.99 8.99 0 0 1-2.13-9.384 8.367 8.367 0 0 0-1.053.894c-3.223 3.224-3.223 8.46 0 11.683 3.223 3.224 8.46 3.224 11.683 0 .331-.331.63-.682.896-1.054a8.937 8.937 0 0 1-3.009.524l-.01-.01Zm2.002-11.033 1.522.51c.3.1.51.391.51.711 0 .32-.2.611-.51.711l-1.522.51-.51 1.523c-.1.3-.39.51-.71.51a.743.743 0 0 1-.712-.51l-.51-1.522-1.522-.51a.756.756 0 0 1-.51-.712c0-.32.2-.61.51-.71l1.522-.51.51-1.523c.1-.3.39-.51.711-.51.32 0 .61.2.71.51l.511 1.522Z",
    paths: null
  },
  decrease: {
    pathDefinition: "M11.47 12.53c.15.15.34.22.53.22s.38-.07.53-.22l6.5-6.5c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L12 10.94 6.03 4.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l6.5 6.5Zm0 7.01c.15.15.34.22.53.22s.38-.07.53-.22l6.5-6.5c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L12 17.95l-5.97-5.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l6.5 6.5Z",
    paths: null
  },
  "denied-circle-fill-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm2.53 8.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L8 9.06l-1.47 1.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L6.94 8 5.47 6.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L8 6.94l1.47-1.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L9.06 8l1.47 1.47Z",
    paths: null
  },
  "denied-circle-fill": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm3.53 12.22c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L12 13.06l-2.47 2.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L10.94 12 8.47 9.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 10.94l2.47-2.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L13.06 12l2.47 2.47Z",
    paths: null
  },
  "denied-circle-sm": {
    pathDefinition: "M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm1.5 0c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5S11.03 2.5 8 2.5A5.51 5.51 0 0 0 2.5 8Zm6.97-2.53c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L9.06 8l1.47 1.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L8 9.06l-1.47 1.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L6.94 8 5.47 6.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L8 6.94l1.47-1.47Z",
    paths: null
  },
  "denied-circle": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12Zm10.72-3.53c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L13.06 12l2.47 2.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L12 13.06l-2.47 2.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L10.94 12 8.47 9.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 10.94l2.47-2.47Z",
    paths: null
  },
  design: {
    pathDefinition: "m6.47 11.53-2-2-2-2a.754.754 0 0 1 0-1.06l4-4c.29-.29.77-.29 1.06 0L12 6.94l1.44-1.44a.73.73 0 0 1 .06-.06l1.97-1.97c1.04-1.04 2.85-1.04 3.89 0l1.17 1.17c.52.52.81 1.21.81 1.94s-.29 1.42-.81 1.94l-1.933 1.933a.723.723 0 0 1-.146.146l-1.396 1.396 4.475 4.475c.29.29.29.77 0 1.06l-4 4c-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2-2-2-2-.475-.475L8.12 20.93a2.74 2.74 0 0 1-1.574.785c-.123.02-.248.032-.376.035H2.25v-3.76a.735.735 0 0 1-.01-.12c0-.185.02-.366.056-.54.101-.541.365-1.04.764-1.44l3.883-3.887-.473-.473ZM16.06 19l.47-.47c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.47.47-.94-.94.47-.47c.29-.29.29-.77 0-1.06a.755.755 0 0 0-.772-.178l2.237-2.237L19.94 17 17 19.94l-.94-.94Zm-7.35-8.765a.755.755 0 0 0-.18-.765.754.754 0 0 0-1.06 0L7 9.94 6.06 9l.47-.47c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L5 7.94 4.06 7 7 4.06l3.942 3.942-2.232 2.233ZM6.132 20.25H3.74v-2.38c0-.62.5-1.12 1.12-1.12.5 0 .93.32 1.07.8l.12.39.39.12a1.118 1.118 0 0 1-.308 2.19Zm2.48-1.933 8.323-8.322L14 7.06l-8.32 8.32c.677.222 1.24.714 1.55 1.38a2.605 2.605 0 0 1 1.383 1.557Zm9.383-9.382L15.06 6l1.46-1.46c.48-.47 1.3-.47 1.77 0l1.17 1.17a1.234 1.234 0 0 1 0 1.76l-1.465 1.465Z",
    paths: null
  },
  "dollar-mep": {
    pathDefinition: "M2.56 18.708C4.19 19.877 5.68 20.3 7.08 20.3c1.91 0 3.63-.786 5.23-1.521l.027-.012c2.728-1.244 5.083-2.318 8.223-.059a.73.73 0 0 0 .78.06.767.767 0 0 0 .41-.674V6.005a.747.747 0 0 0-.31-.614c-3.85-2.77-6.99-1.34-9.75-.07l-.008.003C8.955 6.57 6.587 7.655 3.44 5.39a.73.73 0 0 0-.78-.06.766.766 0 0 0-.41.674v12.089c0 .242.11.473.31.614Zm9.13-1.3c-2.65 1.22-4.94 2.267-7.94.293V7.365c3.306 1.736 6.066.474 8.528-.65l.032-.015.02-.009c2.642-1.205 4.938-2.252 7.92-.283v10.336c-3.316-1.73-6.083-.467-8.55.66l-.01.005Zm.75-1.732c-.03.554-1.13.554-1.18 0l.01-.01v-.343c-.39-.08-.73-.271-1.04-.574-.31-.292-.52-.705-.63-1.209-.17-.745.84-1.037 1.1-.443.11.413.26.716.48.897.22.191.48.282.78.282.32 0 .57-.07.74-.191.17-.132.25-.323.25-.595 0-.232-.1-.413-.29-.564-.2-.141-.52-.292-.98-.453-.66-.222-1.13-.494-1.42-.786-.29-.292-.43-.675-.43-1.148 0-.383.12-.736.36-1.058.24-.323.6-.544 1.1-.665v-.403c.02-.554 1.12-.554 1.18 0v.403c.35.04.65.191.91.433.25.252.44.574.56.967.24.766-.98 1.038-1.07.443a1.1 1.1 0 0 0-.38-.574c-.18-.14-.4-.211-.68-.211-.24 0-.43.05-.58.16a.496.496 0 0 0-.22.434c0 .212.1.383.29.524.19.14.56.302 1.1.483.69.232 1.15.534 1.38.877.23.352.34.735.34 1.148 0 .605-.17 1.038-.51 1.32a2.51 2.51 0 0 1-1.17.544v.312Z",
    paths: null
  },
  dollar: {
    pathDefinition: "M7.28 8.66c-.23 0-.39.06-.51.17-.12.11-.17.299-.17.538v3.14c0 .559-.13.987-.39 1.267-.26.298-.64.448-1.11.448-.47 0-.86-.15-1.12-.449-.25-.289-.38-.717-.38-1.266v-3.14c0-.239-.06-.428-.18-.538a.734.734 0 0 0-.51-.18c-.24 0-.42.06-.53.18-.12.12-.18.299-.18.538v3.12c0 .489.06.918.19 1.277.12.348.31.637.54.867.24.23.54.409.9.528.36.12.79.19 1.27.19.64 0 1.17-.11 1.6-.32.42-.209.72-.508.94-.927.22-.428.33-.967.33-1.605v-3.12c0-.249-.06-.428-.17-.538-.12-.12-.28-.17-.51-.17l-.01-.01Zm13.6.947c-.61-.558-1.5-.847-2.65-.847h-1.91c-.25 0-.44.06-.56.18-.12.12-.18.299-.18.558v5.004c0 .25.06.439.18.558.12.12.3.18.56.18h1.91c.58 0 1.1-.07 1.55-.22.44-.139.81-.358 1.1-.627.3-.28.52-.609.68-1.007.16-.4.24-.868.24-1.386 0-1.027-.31-1.834-.92-2.383v-.01Zm-.67 3.33a1.7 1.7 0 0 1-.42.698c-.19.18-.42.319-.7.419-.27.09-.59.14-.96.14h-1.14V9.826h1.14c.73 0 1.29.18 1.66.548.37.359.56.907.56 1.635 0 .359-.04.668-.13.937l-.01-.01Zm-7.98-1.495c-.54-.18-.91-.34-1.1-.479-.19-.14-.29-.309-.29-.518 0-.18.07-.33.22-.429.15-.11.34-.16.58-.16.28 0 .5.07.68.21.18.14.31.329.38.568.09.588 1.31.32 1.07-.438a2.275 2.275 0 0 0-.56-.957c-.26-.24-.56-.39-.91-.429v-.399c-.06-.548-1.16-.548-1.18 0v.399c-.5.12-.86.339-1.1.658-.24.319-.36.668-.36 1.047 0 .468.14.847.43 1.136.28.29.76.558 1.42.778.46.16.78.309.98.448.19.15.29.33.29.558 0 .27-.08.46-.25.589-.17.12-.42.19-.74.19-.3 0-.56-.09-.78-.28-.22-.18-.37-.478-.48-.887-.26-.588-1.27-.3-1.1.438.11.499.32.908.63 1.197.31.299.65.488 1.04.568v.339c.05.548 1.15.548 1.18 0v-.31c.44-.079.83-.258 1.17-.538.34-.279.51-.707.51-1.306 0-.408-.11-.787-.34-1.136-.23-.339-.69-.638-1.38-.867l-.01.01Z",
    paths: null
  },
  down: {
    pathDefinition: "M12 16c-.19 0-.38-.07-.53-.22l-6.5-6.5a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 14.19l5.97-5.97c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6.5 6.5c-.15.15-.34.22-.53.22Z",
    paths: null
  },
  download: {
    pathDefinition: "M11.71 15.69a.776.776 0 0 1-.24-.16l-4-4a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.72 2.72V4c0-.41.34-.75.75-.75s.75.34.75.75v9.19l2.72-2.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-4 4a.776.776 0 0 1-.53.22c-.1 0-.2-.02-.29-.06ZM20.25 13c0-.41.34-.75.75-.75s.75.34.75.75v3c0 2.62-2.13 4.75-4.75 4.75H7c-2.62 0-4.75-2.13-4.75-4.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 1.79 1.46 3.25 3.25 3.25h10c1.79 0 3.25-1.46 3.25-3.25v-3Z",
    paths: null
  },
  due: {
    pathDefinition: "M17.75 3.3H18c2.07 0 3.75 1.681 3.75 3.752V20.06c0 .28-.16.54-.41.67-.25.13-.55.1-.78-.06-3.134-2.246-5.5-1.175-8.233.063l-.017.007c-1.6.73-3.32 1.511-5.23 1.511-1.4 0-2.89-.42-4.52-1.58a.768.768 0 0 1-.31-.611V7.052A3.752 3.752 0 0 1 6 3.301h.25v-.25c0-.41.34-.751.75-.751s.75.34.75.75v.25h3.5v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25h3.5v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25ZM6.25 4.801H6c-1.24 0-2.25 1.01-2.25 2.251v1.251h16.5v-1.25A2.255 2.255 0 0 0 18 4.8h-.25v.69c0 .41-.34.751-.75.751s-.75-.34-.75-.75v-.69h-3.5v.69c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.69h-3.5v.69c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.69Zm5.41 14.592.03-.014.032-.015c2.462-1.117 5.222-2.37 8.528-.646V9.804H3.75v9.865c2.988 1.953 5.272.918 7.91-.276Zm-4.42-5.397c.2.14.56.3 1.1.48l.01.01c.68.24 1.14.53 1.37.87.23.34.34.72.34 1.131 0 .59-.17 1.03-.51 1.3-.34.27-.73.451-1.17.531v.31c-.04.55-1.13.55-1.18 0v-.34a2.08 2.08 0 0 1-1.03-.57c-.3-.3-.51-.7-.62-1.2-.16-.741.84-1.031 1.1-.441.1.41.26.71.47.89.21.18.47.27.77.27.32 0 .56-.06.73-.18.17-.12.25-.31.25-.58 0-.23-.1-.42-.29-.56-.19-.14-.51-.29-.97-.45-.66-.23-1.13-.49-1.41-.78-.28-.29-.42-.671-.42-1.141 0-.37.12-.72.36-1.04.24-.321.61-.541 1.1-.661v-.4c.02-.55 1.12-.55 1.18 0v.4c.34.04.64.19.9.43.25.24.44.56.56.95.24.76-.98 1.031-1.07.44-.08-.24-.2-.43-.38-.57a1.08 1.08 0 0 0-.68-.21c-.24 0-.43.06-.58.16a.49.49 0 0 0-.22.43c0 .21.1.38.29.52Z",
    paths: null
  },
  edit: {
    pathDefinition: "m20.017 5.126-1.16-1.15a2.755 2.755 0 0 0-3.887 0L3.978 14.966c-.52.52-.81 1.21-.81 1.94v3.92h3.918c.73 0 1.419-.29 1.939-.81l10.992-11a2.76 2.76 0 0 0 0-3.89ZM7.975 18.976c-.23.23-.55.37-.879.37H4.678v-2.42c0-.33.13-.65.37-.88l8.863-8.9 2.938 2.94-8.874 8.88v.01Zm10.993-11.01-1.06 1.06-2.938-2.94 1.06-1.06c.49-.49 1.279-.49 1.768 0l1.17 1.17c.49.49.49 1.28 0 1.77Z",
    paths: null
  },
  education: {
    pathDefinition: "M21.64 8.883s-.04-.05-.05-.079a.686.686 0 0 0-.19-.189c-.02-.01-.03-.03-.04-.04l-9.01-4.978a.734.734 0 0 0-.73 0L2.64 8.565a.74.74 0 0 0-.39.656c0 .279.15.517.39.656l2.607 1.441v4.333c0 .586.29 1.123.78 1.45l4.445 2.942c.46.308.989.457 1.528.457.54 0 1.059-.15 1.528-.457l4.446-2.941c.49-.328.78-.865.78-1.451v-4.333l1.497-.825V14.2c0 .407.34.745.75.745s.749-.338.749-.745V9.23a.74.74 0 0 0-.09-.338l-.02-.01Zm-4.405 6.768c0 .08-.04.159-.11.208l-4.446 2.942a1.26 1.26 0 0 1-1.388 0l-4.446-2.942a.245.245 0 0 1-.11-.208v-3.498l4.885 2.693a.77.77 0 0 0 .72 0l4.885-2.693v3.498h.01Zm-5.245-2.306L4.538 9.231l7.452-4.114 7.452 4.114-7.452 4.114Z",
    paths: null
  },
  electricity: {
    pathDefinition: "M18.653 9.637a.745.745 0 0 0-.66-.39h-4.25V2.995c0-.33-.21-.62-.52-.71a.75.75 0 0 0-.84.29l-7 9.993a.75.75 0 0 0 .62 1.18h4.25V21a.75.75 0 0 0 .75.75c.25 0 .49-.13.63-.35l7-11.003c.15-.23.16-.52.02-.76Zm-6.91 8.792v-5.421c0-.41-.34-.75-.75-.75h-3.56l4.81-6.872v4.621c0 .41.34.75.75.75h3.63l-4.88 7.672Z",
    paths: null
  },
  erase: {
    pathDefinition: "M15.7 5.25H19c.41 0 .75.34.75.75s-.34.75-.75.75h-.25V19c0 1.52-1.23 2.75-2.75 2.75H8c-1.52 0-2.75-1.23-2.75-2.75V6.75H5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.3A.696.696 0 0 1 8.25 5V3c0-.41.34-.75.75-.75h6c.41 0 .75.34.75.75v2c0 .09-.02.17-.05.25Zm-5.95-1.5V5c0 .09-.02.17-.05.25h4.6a.696.696 0 0 1-.05-.25V3.75h-4.5ZM16 20.25c.69 0 1.25-.56 1.25-1.25V6.75H6.75V19c0 .69.56 1.25 1.25 1.25h8ZM10.75 18c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-.41.34-.75.75-.75s.75.34.75.75v9Zm4 0c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-.41.34-.75.75-.75s.75.34.75.75v9Z",
    paths: null
  },
  "errase-keyboard": {
    pathDefinition: "M8.965 5H20c1.1 0 2 .896 2 2v10c0 1.105-.89 2-2 2H8.964c-.63 0-1.22-.299-1.6-.796l-5.162-5.602a.98.98 0 0 1 0-1.194l5.162-5.612c.37-.497.97-.796 1.6-.796ZM20 17.517c.27 0 .5-.228.5-.507v-10a.502.502 0 0 0-.5-.508H8.965c-.15 0-.31.07-.4.2-.03.04-.09.109-.09.109l-4.792 5.194 4.792 5.204c.03.03.06.07.09.11.09.119.24.198.4.198H20ZM16.91 8.97a.758.758 0 0 1 1.06 0c.29.289.29.766 0 1.055l-2.001 1.99 2 1.99a.748.748 0 0 1-1.06 1.055l-2-1.99-2.011 2a.744.744 0 0 1-.53.219.748.748 0 0 1-.53-1.274l2.01-2-2-1.99a.748.748 0 0 1 0-1.055.758.758 0 0 1 1.06 0l2 1.99 2.001-1.99Z",
    paths: null
  },
  "external-link-sm": {
    pathDefinition: "M13.29 2.31a.717.717 0 0 0-.29-.06H6.33c-.41 0-.75.34-.75.75s.34.75.75.75h4.86l-8.72 8.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l8.72-8.72v4.86c0 .41.34.75.75.75s.75-.34.75-.75V3c0-.1-.02-.19-.06-.29a.782.782 0 0 0-.41-.41l.01.01Z",
    paths: null
  },
  "external-link": {
    pathDefinition: "M18.689 5.72a.782.782 0 0 0-.41-.41.718.718 0 0 0-.29-.06h-7.99c-.41 0-.75.34-.75.75s.34.749.75.749h6.19L5.469 17.47c-.29.29-.29.77 0 1.06.15.15.34.219.53.219s.38-.07.53-.22l10.72-10.712v6.186c0 .41.34.749.75.749s.75-.34.75-.75V6.01c0-.1-.02-.19-.06-.29Z",
    paths: null
  },
  "face-id": {
    pathDefinition: "M4 8.6c.41 0 .75-.34.75-.75v-3c0-.14.11-.25.25-.25h3c.41 0 .75-.34.75-.75S8.41 3.1 8 3.1H5c-.96 0-1.75.79-1.75 1.75v3c0 .41.34.75.75.75Zm4 10.5H5c-.14 0-.25-.11-.25-.25v-3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .96.79 1.75 1.75 1.75h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm12-4c-.41 0-.75.34-.75.75v3c0 .14-.11.25-.25.25h-3c-.41 0-.75.34-.75.75s.34.75.75.75h3c.96 0 1.75-.79 1.75-1.75v-3c0-.41-.34-.75-.75-.75Zm-1-12h-3c-.41 0-.75.34-.75.75s.34.75.75.75h3c.14 0 .25.11.25.25v3c0 .41.34.75.75.75s.75-.34.75-.75v-3c0-.96-.79-1.75-1.75-1.75Zm-2.47 10.22a.754.754 0 0 0-1.06 0c-1.72 1.72-5.22 1.72-6.94 0a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06 1.14 1.14 2.84 1.71 4.53 1.71 1.69 0 3.39-.57 4.53-1.71.29-.29.29-.77 0-1.06ZM10 11.6c.41 0 .75-.34.75-.75v-1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1c0 .41.34.75.75.75Zm4 0c.41 0 .75-.34.75-.75v-1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1c0 .41.34.75.75.75Z",
    paths: null
  },
  fci: {
    pathDefinition: "m18.712 11.113 1.17 4.044h.02c.51 2.42-.21 3.934-.91 4.791-1.08 1.325-2.85 2.052-4.99 2.052h-4c-2.11 0-3.92-.747-4.99-2.052-.69-.857-1.42-2.37-.92-4.741l1.19-4.104c.36-1.425 1.44-3.636 4.62-4.323l-1.57-3.118a.743.743 0 0 1 .17-.896c.25-.22.63-.25.91-.06 1.082.712 1.464.462 2.155.01l.015-.01c.81-.538 1.92-1.275 3.83 0 .31.21.42.618.25.956l-1.57 3.118c3.19.687 4.26 2.908 4.62 4.333Zm-6.32-7.162c-.49.329-1.11.707-1.91.707h-.01l.97 1.933.046-.003c.162-.009.31-.017.484-.017.097 0 .19.005.28.01.084.005.167.01.25.01l1.48-2.959c-.668-.288-1.028-.05-1.585.316l-.005.003Zm1.58 16.565c1.66 0 3.05-.548 3.83-1.504.72-.867.92-2.042.62-3.487l-1.17-4.014c-.58-2.3-2.35-3.446-5.28-3.446s-4.7 1.145-5.28 3.416v.03l-1.18 4.064c-.29 1.385-.08 2.56.63 3.437.78.956 2.18 1.504 3.83 1.504h4Zm-2.54-7.281c.19.139.56.298 1.1.478l.02-.01c.69.229 1.15.528 1.38.866.23.349.34.727.34 1.136 0 .597-.17 1.026-.51 1.305-.34.278-.73.458-1.17.537v.31c-.03.547-1.13.547-1.18 0v-.34a2.07 2.07 0 0 1-1.04-.567c-.31-.289-.52-.697-.63-1.195-.17-.738.84-1.026 1.1-.439.1.409.25.707.47.887.22.19.48.279.78.279.32 0 .57-.07.74-.19.17-.129.25-.318.25-.587 0-.23-.09-.419-.29-.558-.2-.14-.52-.289-.98-.448-.66-.22-1.13-.488-1.42-.777-.29-.29-.43-.668-.43-1.136 0-.378.12-.727.36-1.046.24-.318.6-.537 1.1-.657v-.399c.02-.547 1.12-.547 1.18 0v.399c.35.04.65.19.91.428.25.25.44.568.56.957.24.757-.98 1.025-1.07.438-.07-.24-.2-.429-.38-.568-.18-.14-.4-.21-.68-.21-.24 0-.43.05-.58.16-.15.1-.22.25-.22.428 0 .21.1.379.29.519Z",
    paths: null
  },
  filter: {
    pathDefinition: "M4 6.75h2l.14-.03a1.992 1.992 0 0 0 3.72 0c.05 0 .09.03.14.03h10c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H10l-.14.03a1.992 1.992 0 0 0-3.72 0c-.05 0-.09-.03-.14-.03H4c-.41 0-.75.34-.75.75s.34.75.75.75ZM8 5.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5Zm12 5.75h-2l-.14.03a1.992 1.992 0 0 0-3.72 0c-.05 0-.09-.03-.14-.03H4c-.41 0-.75.34-.75.75s.34.75.75.75h10l.14-.03a1.992 1.992 0 0 0 3.72 0c.05 0 .09.03.14.03h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm-4 1.25c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5Zm4 4.75H10l-.14.03a1.992 1.992 0 0 0-3.72 0c-.05 0-.09-.03-.14-.03H4c-.41 0-.75.34-.75.75s.34.75.75.75h2l.14-.03a1.992 1.992 0 0 0 3.72 0c.05 0 .09.03.14.03h10c.41 0 .75-.34.75-.75s-.34-.75-.75-.75ZM8 18.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5Z",
    paths: null
  },
  "finger-print": {
    pathDefinition: "M18.061 3.334c1.6.79 2.711 2.071 3.212 3.692h-.01a.738.738 0 0 1-.71.97.76.76 0 0 1-.721-.53c-.38-1.24-1.2-2.18-2.441-2.79-1.76-.871-3.812-.801-4.712-.471a.75.75 0 1 1-.51-1.411c1.37-.5 3.841-.48 5.892.54Zm-.75 10.376c-.69 0-1.25-.56-1.25-1.25 0-.41-.34-.751-.75-.751a.756.756 0 0 0-.751.75 2.75 2.75 0 0 0 2.75 2.752c1.522 0 2.752-1.23 2.752-2.822 0-.1-.11-.98-.66-1.93a.75.75 0 0 0-1.03-.27c-.36.21-.48.67-.27 1.03.306.53.414 1.04.447 1.2.007.032.01.05.012.05 0 .69-.56 1.251-1.25 1.251v-.01Zm2.1 3.782c-1.72.81-3.22.96-4.451.44-1.82-.77-2.531-2.781-2.541-2.811-.68-1.921.41-2.872.48-2.922.32-.25.38-.72.13-1.05a.739.739 0 0 0-1.05-.13c-.08.06-2.031 1.61-.97 4.592l.002.007c.065.18.955 2.66 3.359 3.685.67.29 1.39.43 2.15.43 1.101 0 2.282-.3 3.542-.89.38-.18.54-.62.36-1a.753.753 0 0 0-1-.36l-.01.01ZM8.909 5.135c.37-.18.53-.63.35-1a.752.752 0 0 0-1-.35c-1.912.92-3.352 2.21-4.182 3.732-3.472 6.413.7 13.077.88 13.357.14.22.38.35.63.35a.757.757 0 0 0 .63-1.16c-.04-.06-3.871-6.214-.83-11.837.85-1.57 2.381-2.541 3.512-3.092h.01Zm7.153 3.542c-1.461-.88-3.972-1.06-5.743.36v-.01c-4.842 3.893.28 10.676.5 10.967.25.33.19.8-.14 1.05-.14.11-.3.16-.46.16-.22 0-.44-.1-.59-.29-2.181-2.832-5.042-9.205-.25-13.047 2.32-1.861 5.512-1.651 7.463-.47.35.21.46.68.25 1.03-.21.35-.68.46-1.03.25Z",
    paths: null
  },
  "fixed-term-deposit": {
    pathDefinition: "M7 6.75c-.41 0-.75-.34-.75-.75V4.75H6C4.76 4.75 3.75 5.76 3.75 7v1.25H9c.41 0 .75.34.75.75s-.34.75-.75.75H3.75V18c0 1.24 1.01 2.25 2.25 2.25h3c.41 0 .75.34.75.75s-.34.75-.75.75H6c-2.07 0-3.75-1.68-3.75-3.75V7c0-2.07 1.68-3.75 3.75-3.75h.25V3c0-.42.33-.75.75-.75.41 0 .75.34.75.75v.25h3.5V3a.749.749 0 1 1 1.5 0v.25h3.5V3a.749.749 0 1 1 1.5 0v.25H18c2.07 0 3.75 1.68 3.75 3.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7c0-1.24-1.01-2.25-2.25-2.25h-.25V6a.749.749 0 1 1-1.5 0V4.75h-3.5V6a.749.749 0 1 1-1.5 0V4.75h-3.5V6c0 .42-.33.75-.75.75Zm2.24 8.77c0 3.45 2.8 6.25 6.25 6.25s6.25-2.8 6.25-6.25-2.8-6.25-6.25-6.25-6.25 2.8-6.25 6.25Zm1.5 0c0-2.62 2.13-4.75 4.75-4.75s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75-4.75-2.13-4.75-4.75Zm4.2-1.04c.2.14.56.3 1.1.48l.01.01c.68.24 1.14.53 1.37.87.23.34.34.72.34 1.13 0 .59-.17 1.03-.51 1.3-.34.27-.73.45-1.17.53v.31c-.04.55-1.13.55-1.18 0v-.34c-.38-.08-.72-.27-1.03-.57-.3-.3-.51-.7-.62-1.2-.16-.74.84-1.03 1.1-.44.1.41.26.71.47.89.21.18.47.27.77.27.32 0 .56-.06.73-.18.17-.12.25-.31.25-.58 0-.23-.1-.42-.29-.56-.19-.14-.51-.29-.97-.45-.66-.23-1.13-.49-1.41-.78-.28-.29-.42-.67-.42-1.14 0-.37.12-.72.36-1.04.24-.32.61-.54 1.1-.66v-.4c.02-.55 1.12-.55 1.18 0v.4c.34.04.64.19.9.43.25.24.44.56.56.95.24.76-.98 1.03-1.07.44-.08-.24-.2-.43-.38-.57a1.08 1.08 0 0 0-.68-.21c-.24 0-.43.06-.58.16a.49.49 0 0 0-.22.43c0 .21.1.38.29.52Z",
    paths: null
  },
  freeze: {
    pathDefinition: "m21.305 16.341-1.988-.998 1.069-.738a.75.75 0 0 0 .2-1.038.752.752 0 0 0-1.039-.2L17.8 14.565l-2.067-1.038v-3.064l2.057-1.018 1.777 1.178c.13.08.27.13.41.13a.744.744 0 0 0 .41-1.367l-1.06-.7 2.008-.997a.756.756 0 0 0 .34-1.008.756.756 0 0 0-1.01-.34l-1.947.969V6.012c0-.409-.34-.748-.749-.748s-.748.34-.748.748v2.036l-2.197 1.088-2.297-1.537V6.401l2.666-1.776c.34-.23.44-.698.21-1.038a.753.753 0 0 0-1.039-.21l-1.827 1.218V2.998a.754.754 0 0 0-.749-.748c-.41 0-.749.34-.749.748v1.597L9.412 3.378a.746.746 0 0 0-1.039.21.743.743 0 0 0 .21 1.037l2.666 1.776V7.6L8.953 9.136 6.756 8.038V6.002a.754.754 0 0 0-.75-.748.754.754 0 0 0-.748.748V7.29L3.34 6.332a.753.753 0 0 0-1.009.339c-.19.37-.04.818.34 1.008l1.997.998-1.069.698a.743.743 0 0 0-.21 1.038c.14.22.38.34.63.34.14 0 .28-.04.41-.12l1.796-1.178 2.038 1.018v3.064l-2.068 1.038-1.747-1.198a.743.743 0 0 0-1.038.2c-.23.34-.15.808.2 1.038l1.068.738-1.987.998a.748.748 0 0 0 .34 1.417c.109 0 .229-.03.339-.08l1.907-.958v1.268c0 .409.34.748.749.748.41 0 .749-.34.749-.748v-2.016l2.196-1.108 2.297 1.527v1.198l-2.666 1.776a.753.753 0 0 0-.21 1.038c.23.339.7.439 1.039.21l1.827-1.218V21c0 .41.34.749.75.749.409 0 .748-.34.748-.748v-1.597l1.827 1.217c.13.08.27.13.42.13a.744.744 0 0 0 .41-1.367l-2.667-1.777V16.41l2.297-1.527 2.197 1.108v2.016c0 .409.339.748.748.748.41 0 .75-.34.75-.748V16.74l1.907.958a.751.751 0 0 0 1.008-.33.748.748 0 0 0-.33-1.007l-.02-.02Zm-7.08-2.754-2.247 1.497-2.247-1.497v-3.194l2.247-1.497 2.247 1.497v3.194Z",
    paths: null
  },
  gallery: {
    pathDefinition: "M5 2.25h14c1.52 0 2.75 1.23 2.75 2.75v14c0 1.52-1.23 2.75-2.75 2.75H5c-1.52 0-2.75-1.23-2.75-2.75V5c0-1.52 1.23-2.75 2.75-2.75Zm14 1.5H5c-.69 0-1.25.56-1.25 1.25v8.97l4.68-5.46a.73.73 0 0 1 .6-.26c.23.01.45.12.58.31l4.49 6.28 2.37-2.37c.29-.29.77-.29 1.06 0l2.72 2.72V5c0-.69-.56-1.25-1.25-1.25ZM5 20.25h14c.69 0 1.25-.56 1.25-1.25v-1.69L17 14.06l-2.47 2.47a.72.72 0 0 1-.59.22.758.758 0 0 1-.55-.31l-4.44-6.22-5.2 6.06V19c0 .69.56 1.25 1.25 1.25ZM17.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    paths: null
  },
  gift: {
    pathDefinition: "M18 7.25h-.54c.2-.42.29-.87.29-1.25 0-2.02-1.64-2.75-2.75-2.75-1.5 0-2.43.62-3 1.41-.57-.78-1.5-1.41-3-1.41-1.11 0-2.75.73-2.75 2.75 0 .38.09.83.29 1.25H6c-2.07 0-3.75 1.68-3.75 3.75v7c0 2.07 1.68 3.75 3.75 3.75h12c2.07 0 3.75-1.68 3.75-3.75v-7c0-2.07-1.68-3.75-3.75-3.75ZM20.25 11v1.67c-2.85-1.48-5.3-.77-7.5.18V8.76H18c1.24 0 2.25 1.01 2.25 2.25V11Zm-5.26-6.25c.29 0 1.26.11 1.26 1.24 0 .29-.11 1.26-1.25 1.26h-2.25V7c0-.38.13-2.25 2.24-2.25ZM9 4.75c2.12 0 2.25 1.88 2.25 2.25v.25H9c-1.14 0-1.25-.96-1.25-1.25 0-1.14.96-1.25 1.25-1.25Zm-3 4h5.25v4.77c-2.46 1.11-4.67 1.93-7.5.08V11c0-1.24 1.01-2.25 2.25-2.25ZM3.75 18v-2.66c1.18.61 2.28.85 3.33.85 1.49 0 2.87-.48 4.17-1.04v5.1H6c-1.24 0-2.25-1.01-2.25-2.25ZM18 20.25h-5.25v-5.77c2.47-1.11 4.68-1.93 7.5-.08V18c0 1.24-1.01 2.25-2.25 2.25Z",
    paths: null
  },
  "help-circle-fill": {
    pathDefinition: "M12 2.5c-5.24 0-9.5 4.26-9.5 9.5s4.26 9.5 9.5 9.5 9.5-4.26 9.5-9.5-4.26-9.5-9.5-9.5Zm-.2 14c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75Zm1.28-4.24c-.38.26-.55.58-.55.96 0 .41-.32.76-.74.76h-.01c-.41 0-.74-.33-.75-.74-.02-.88.4-1.66 1.18-2.21.67-.48.96-1.08.78-1.63-.14-.41-.51-.63-.9-.65-.79.04-1.08.52-1.19.81-.14.39-.57.59-.96.44a.748.748 0 0 1-.44-.96c.4-1.06 1.34-1.73 2.53-1.78 1.06-.06 2.03.62 2.39 1.66.32.94.14 2.31-1.33 3.34h-.01Z",
    paths: null
  },
  "help-circle": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm0 18c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25Zm.03-13c-1.19.05-2.13.72-2.53 1.78-.15.39.05.82.44.96.39.15.82-.05.96-.44.11-.29.4-.77 1.19-.81.4.01.76.24.9.65.19.55-.1 1.16-.78 1.63-.78.55-1.2 1.33-1.18 2.21 0 .41.34.74.75.74h.01c.41 0 .74-.35.74-.76 0-.38.17-.69.55-.96 1.47-1.04 1.65-2.41 1.33-3.34-.36-1.04-1.31-1.73-2.39-1.66h.01Zm.52 8.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    paths: null
  },
  "hide-password": {
    pathDefinition: "M20.397 11.668c.44-.37.85-.77 1.19-1.199.26-.32.21-.8-.12-1.05a.74.74 0 0 0-1.05.12c-1.741 2.17-4.882 3.468-8.414 3.468-3.53 0-6.682-1.299-8.413-3.467a.758.758 0 0 0-1.05-.12c-.32.26-.38.73-.12 1.05.35.439.76.829 1.19 1.198l-1.24 1.929a.757.757 0 0 0 .63 1.16c.25 0 .49-.12.63-.34l1.19-1.85c.671.42 1.401.77 2.182 1.06-.03.05-.07.1-.09.16l-.62 1.998c-.12.4.1.82.49.94a.76.76 0 0 0 .94-.5l.62-1.998c.02-.06.02-.12.02-.18.92.23 1.89.38 2.891.42v2.538c0 .41.34.75.75.75s.75-.34.75-.75v-2.539c1.001-.05 1.972-.19 2.892-.42 0 .06 0 .12.02.18l.62 2a.76.76 0 0 0 .94.499c.4-.12.62-.54.49-.94l-.62-1.998c-.02-.06-.06-.11-.09-.16.78-.29 1.51-.64 2.181-1.06l1.19 1.85a.741.741 0 0 0 1.031.22c.35-.22.45-.69.23-1.04l-1.24-1.929Z",
    paths: null
  },
  "home-fill": {
    pathDefinition: "m19.241 7.152-7.216-4.82a.5.5 0 0 0-.55 0L4.25 7.152a4.507 4.507 0 0 0-1.999 3.74v7.858c0 .17.09.33.24.42 1.789 1.12 3.298 1.53 4.647 1.53 1.83 0 3.349-.76 4.838-1.5 2.439-1.22 4.747-2.37 8.505-.02a.509.509 0 0 0 .77-.43v-7.859c0-1.51-.75-2.91-1.999-3.74h-.01Z",
    paths: null
  },
  home: {
    pathDefinition: "M7.38 21.188c-1.39 0-2.95-.41-4.78-1.55a.755.755 0 0 1-.35-.64v-7.86c0-1.59.79-3.07 2.12-3.95l7.21-4.81a.74.74 0 0 1 .83 0l7.22 4.81a4.75 4.75 0 0 1 2.12 3.95v7.86c0 .27-.15.52-.39.66-.24.13-.53.12-.76-.02-3.65-2.28-5.79-1.21-8.27.04-1.46.73-3.04 1.52-4.96 1.52l.01-.01Zm-3.63-2.61c3.43 2 5.52.95 7.92-.25 2.29-1.15 4.86-2.43 8.58-.61v-6.58c0-1.09-.54-2.1-1.45-2.7L12 3.897l-6.8 4.54c-.91.6-1.45 1.62-1.45 2.7v7.44Z",
    paths: null
  },
  income: {
    pathDefinition: "M18.531 5.467a.755.755 0 0 0-1.06 0L6.751 16.181V9.995c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7.995c0 .1.02.19.06.29.08.18.22.33.41.41.09.04.19.06.29.06h7.99c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6.19l10.72-10.723c.29-.29.29-.77 0-1.06Z",
    paths: null
  },
  increase: {
    pathDefinition: "M17.97 12.02c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-6.5-6.5a.754.754 0 0 0-1.06 0l-6.5 6.5c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0L12 6.05l5.97 5.97Zm0 7.01c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-6.5-6.5a.754.754 0 0 0-1.06 0l-6.5 6.5c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0L12 13.06l5.97 5.97Z",
    paths: null
  },
  "info-circle-feedback-fill-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm.75 10.11c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7c0-.41.34-.75.75-.75s.75.34.75.75v4.11ZM8 5.5c-.41 0-.75-.34-.75-.75S7.59 4 8 4s.75.34.75.75-.34.75-.75.75Z",
    paths: null
  },
  "info-circle-feedback-fill": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25ZM12.75 16c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5c0-.41.34-.75.75-.75s.75.34.75.75v5ZM12 8.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75Z",
    paths: null
  },
  "info-circle-feedback-sm": {
    pathDefinition: "M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm1.5 0c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5S11.03 2.5 8 2.5A5.51 5.51 0 0 0 2.5 8Zm6.25-3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.25 7c0-.41.34-.75.75-.75s.75.34.75.75v4.11c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7Z",
    paths: null
  },
  "info-circle-feedback": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12Zm9-4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-1.5 3c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5Z",
    paths: null
  },
  "info-circle": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12Zm9-4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-1.5 3c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5Z",
    paths: null
  },
  insurance: {
    pathDefinition: "M21.44 3.68c.2.14.3.36.3.59 0 .02.01.06.01.06v5.073c0 1.33-.21 2.652-.63 3.912a12.373 12.373 0 0 1-5.6 6.834l-3.15 1.801c-.11.07-.24.1-.37.1a.71.71 0 0 1-.37-.1l-3.15-1.801a12.333 12.333 0 0 1-5.6-6.834c-.42-1.26-.63-2.581-.63-3.912V4.33c0-.01.002-.022.005-.035a.196.196 0 0 0 .005-.035c.01-.14.04-.29.13-.41a.76.76 0 0 1 1.05-.17c3.14 2.251 5.51 1.18 8.25-.07 2.77-1.26 5.9-2.682 9.75.07Zm-6.67 15.168a10.861 10.861 0 0 0 4.92-6.003c.37-1.11.56-2.271.56-3.442V4.69c-2.99-1.96-5.29-.92-7.94.28-1.6.731-3.32 1.511-5.23 1.511-1.05 0-2.15-.24-3.33-.85v3.772c0 1.17.19 2.331.56 3.442a10.861 10.861 0 0 0 4.92 6.003L12 20.43l2.77-1.58ZM11 13.235l4.47-4.472c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-5 5.003c-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2-2.001a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.47 1.47Z",
    paths: null
  },
  "international-money": {
    pathDefinition: "m15.122 9.337 1.4 2.27h.02c.21.35.1.81-.25 1.03a.803.803 0 0 1-.39.109c-.25 0-.5-.13-.64-.36l-1.451-2.349c-.024-.04-.04-.084-.057-.126a2.76 2.76 0 0 1 1.368-3.362l1.9-.95c-1.43-1.13-3.221-1.81-5.122-1.81a8.23 8.23 0 0 0-4.232 1.18l1.37 4.888c.21.37.27.79.19 1.2-.1.46-.36.85-.75 1.11l-1.32.749c-.06.04-.06.14-.06.19.01.06.03.15.14.21l4.212 1.61c.8.399 1.18 1.219.98 2.018l-.81 3.22a.329.329 0 0 1-.024.062.23.23 0 0 0-.016.037c.1.01.2.02.31.02.62 0 1.23-.07 1.83-.21.401-.08.811.16.901.57.09.41-.17.81-.57.9a9.9 9.9 0 0 1-2.171.24c-5.383 0-9.755-4.379-9.755-9.747S6.497 2.29 11.87 2.3a9.785 9.785 0 0 1 9.185 6.448.749.749 0 1 1-1.411.51c-.34-.96-.86-1.81-1.5-2.55l-2.372 1.19c-.53.27-.8.87-.65 1.44Zm-7.424 1.24a.51.51 0 0 1-.1-.21l-1.24-4.438c-1.672 1.509-2.732 3.678-2.732 6.107 0 3.949 2.791 7.258 6.513 8.057a.71.71 0 0 1 .01-.29l.81-3.218a.248.248 0 0 0-.13-.28l-4.222-1.61c-.63-.32-1-.86-1.03-1.49-.03-.629.26-1.209.78-1.559l1.32-.75c.03-.02.06-.09.06-.13l.001-.017c.001-.04.003-.103-.04-.172Zm12.046 5.718c.85.3 1.42.66 1.71 1.09h-.01c.29.42.431.899.431 1.409 0 .74-.2 1.29-.63 1.63-.43.339-.91.569-1.461.669v.39c-.04.69-1.41.69-1.47 0v-.42a2.59 2.59 0 0 1-1.291-.71c-.38-.37-.64-.87-.78-1.5-.211-.929 1.05-1.289 1.37-.55.12.51.32.88.59 1.11.27.23.59.34.97.34.4 0 .71-.08.921-.23.21-.16.32-.4.32-.73 0-.28-.12-.52-.36-.699-.24-.19-.65-.38-1.22-.57-.821-.29-1.411-.61-1.761-.98-.35-.36-.53-.84-.53-1.419 0-.47.15-.9.45-1.3.3-.4.75-.67 1.37-.82v-.499c.02-.69 1.39-.69 1.47 0v.5c.431.06.811.24 1.132.54.32.3.55.7.7 1.19.3.939-1.23 1.279-1.34.55-.09-.3-.251-.53-.471-.71-.22-.18-.51-.27-.85-.27-.3 0-.54.07-.72.2a.628.628 0 0 0-.271.54c0 .26.12.479.36.649.24.17.7.37 1.37.6Z",
    paths: null
  },
  "investment-fill": {
    pathDefinition: "M4 15.5c-.24 0-.44.17-.49.4-.02.09-.43 2.23.91 3.87C5.36 20.92 6.9 21.5 9 21.5c.24 0 .44-.17.49-.4.02-.09.43-2.23-.91-3.87C7.64 16.08 6.1 15.5 4 15.5Zm16.55.4a.503.503 0 0 0-.49-.4c-2.1 0-3.64.58-4.58 1.73-1.34 1.63-.93 3.78-.91 3.87.05.23.25.4.49.4 2.1 0 3.64-.58 4.58-1.73 1.34-1.63.93-3.78.91-3.87ZM12 2.5C8.42 2.5 5.5 5.42 5.5 9c0 3.33 2.52 6.08 5.75 6.45V21c0 .41.34.75.75.75s.75-.34.75-.75v-5.55c3.23-.37 5.75-3.12 5.75-6.45 0-3.58-2.92-6.5-6.5-6.5Zm1.75 9.25c-.34.27-.73.45-1.16.53h-.02v.33c-.02.27-.3.39-.55.4-.28 0-.55-.12-.58-.38v-.36h-.02a2.25 2.25 0 0 1-1.03-.57c-.3-.29-.51-.69-.62-1.19-.08-.37.14-.61.39-.7.24-.08.54-.01.66.25.11.43.27.74.49.92.22.19.49.28.79.28.32 0 .58-.06.75-.19.18-.13.26-.33.26-.6 0-.24-.1-.43-.3-.58-.2-.15-.52-.3-.98-.46-.65-.23-1.13-.49-1.41-.78-.28-.29-.42-.66-.42-1.12 0-.37.12-.72.35-1.03.23-.31.6-.53 1.09-.65h.02v-.42c0-.26.27-.38.52-.39h.03c.26 0 .55.12.58.38v.43h.02c.35.05.64.19.89.43s.44.56.56.95c.06.2.02.39-.12.53-.17.17-.46.24-.67.17-.14-.04-.22-.14-.24-.29-.07-.23-.2-.43-.38-.57-.18-.14-.42-.22-.7-.22-.24 0-.44.05-.59.16a.51.51 0 0 0-.23.45c0 .22.1.4.3.54.2.14.56.3 1.11.48.68.23 1.14.53 1.36.86.23.34.34.72.34 1.12 0 .59-.17 1.02-.5 1.29h.01Z",
    paths: null
  },
  investment: {
    pathDefinition: "M18.722 9c0-3.72-3.03-6.75-6.752-6.75-3.721 0-6.752 3.03-6.752 6.75 0 3.47 2.63 6.33 6.002 6.71V21c0 .41.34.75.75.75s.75-.34.75-.75v-5.29A6.758 6.758 0 0 0 18.722 9ZM6.718 9c0-2.89 2.361-5.25 5.252-5.25A5.263 5.263 0 0 1 17.222 9c0 2.89-2.361 5.25-5.252 5.25A5.263 5.263 0 0 1 6.718 9Zm5.842 3.62v-.31c.44-.08.83-.26 1.17-.54.34-.28.51-.71.51-1.31 0-.41-.11-.79-.34-1.14-.23-.35-.69-.64-1.38-.87-.54-.18-.91-.34-1.1-.48-.19-.14-.29-.31-.29-.52 0-.18.07-.33.22-.43.15-.11.34-.16.58-.16.28 0 .5.07.68.21.18.14.31.33.38.57.09.59 1.31.32 1.07-.44-.12-.39-.31-.71-.56-.96-.26-.24-.56-.39-.91-.43v-.4c-.06-.55-1.16-.55-1.18 0v.4c-.5.12-.86.34-1.1.66-.24.32-.36.67-.36 1.05 0 .47.14.85.43 1.14.29.29.76.56 1.42.78.46.16.78.31.98.45.2.14.29.33.29.56 0 .27-.08.46-.25.59-.17.12-.42.19-.74.19-.3 0-.56-.09-.78-.28-.22-.18-.37-.48-.48-.89-.26-.59-1.27-.3-1.1.44.11.5.32.91.63 1.2.31.3.65.49 1.04.57v.34c.05.55 1.15.55 1.18 0l-.01.01Zm-9.333 3.23c.07-.35.38-.6.74-.6 2.171 0 3.782.61 4.772 1.82 1.41 1.72.98 3.97.96 4.07a.75.75 0 0 1-.74.6c-2.17 0-3.781-.61-4.772-1.82-1.41-1.72-.98-3.97-.96-4.07Zm1.42.92c0 .59.12 1.49.71 2.21.601.72 1.581 1.14 2.922 1.24 0-.59-.12-1.5-.71-2.21-.6-.72-1.581-1.14-2.921-1.24Zm15.386-1.52c.36 0 .67.25.74.6.02.09.45 2.35-.96 4.07-.99 1.21-2.601 1.82-4.772 1.82a.75.75 0 0 1-.74-.6c-.02-.09-.45-2.35.96-4.07.99-1.21 2.601-1.82 4.772-1.82Zm-4.312 4.97c1.34-.1 2.321-.52 2.921-1.24.6-.72.71-1.62.71-2.21-1.34.1-2.32.52-2.92 1.24-.6.72-.71 1.62-.71 2.21Z",
    paths: null
  },
  "left-double": {
    pathDefinition: "m12.275 6.029-5.968 5.97 5.968 5.97c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-6.498-6.5a.755.755 0 0 1 0-1.06l6.498-6.5c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06Zm7.008 0-5.968 5.97 5.968 5.97c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-6.498-6.5a.755.755 0 0 1 0-1.06l6.498-6.5c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06Z",
    paths: null
  },
  left: {
    pathDefinition: "M15.005 19.25c-.19 0-.38-.07-.53-.22l-6.505-6.5a.754.754 0 0 1 0-1.06l6.504-6.5c.29-.29.77-.29 1.06 0 .291.29.291.77 0 1.06L9.562 12l5.974 5.97c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z",
    paths: null
  },
  less: {
    pathDefinition: "M19 12.75H5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h14c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    paths: null
  },
  "light-mode": {
    pathDefinition: "M12 16.75c-2.62 0-4.75-2.13-4.75-4.75S9.38 7.25 12 7.25s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75Zm0-8c-1.79 0-3.25 1.46-3.25 3.25s1.46 3.25 3.25 3.25 3.25-1.46 3.25-3.25S13.79 8.75 12 8.75Zm0 12c-.41 0-.75-.34-.75-.75v-1c0-.41.34-.75.75-.75s.75.34.75.75v1c0 .41-.34.75-.75.75Zm0-15c-.41 0-.75-.34-.75-.75V4c0-.41.34-.75.75-.75s.75.34.75.75v1c0 .41-.34.75-.75.75Zm-7 7H4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.41 0 .75.34.75.75s-.34.75-.75.75Zm2-5c-.19 0-.38-.07-.53-.22l-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Zm13 5h-1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.41 0 .75.34.75.75s-.34.75-.75.75Zm-3-5c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1-1c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1 1c-.15.15-.34.22-.53.22Zm-11 11c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1-1c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1 1c-.15.15-.34.22-.53.22Zm12 0c-.19 0-.38-.07-.53-.22l-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z",
    paths: null
  },
  link: {
    pathDefinition: "M12.886 4.238a4.767 4.767 0 0 1 6.725 0 4.765 4.765 0 0 1 0 6.724l-1.41 1.411a.757.757 0 0 1-1.062 0 .755.755 0 0 1 0-1.06l1.412-1.411a3.255 3.255 0 0 0 0-4.604 3.265 3.265 0 0 0-4.604 0L11.114 8.13c-.61.62-.95 1.431-.95 2.302 0 .87.34 1.691.95 2.301.29.29.29.771 0 1.061-.15.15-.34.22-.53.22s-.38-.07-.53-.22a4.714 4.714 0 0 1-1.392-3.362c0-1.271.49-2.462 1.391-3.362l2.833-2.832Zm0 6.724a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0a4.712 4.712 0 0 1 1.392 3.362c0 1.27-.49 2.462-1.391 3.362l-2.833 2.832a4.728 4.728 0 0 1-3.363 1.391 4.727 4.727 0 0 1-3.362-1.39 4.765 4.765 0 0 1 0-6.726l1.41-1.41a.757.757 0 0 1 1.062 0c.29.29.29.77 0 1.06L5.45 13.794a3.255 3.255 0 0 0 0 4.603 3.265 3.265 0 0 0 4.603 0l2.833-2.831a3.261 3.261 0 0 0 0-4.604Z",
    paths: null
  },
  loans: {
    pathDefinition: "M19.75 5.253H22c.41 0 .75.34.75.75 0 .411-.34.752-.75.752h-2.25v2.252c0 .41-.34.75-.75.75s-.75-.34-.75-.75V6.755H16c-.41 0-.75-.34-.75-.751 0-.41.34-.751.75-.751h2.25V3.001c0-.41.34-.751.75-.751s.75.34.75.75v2.253ZM7.08 6.694c1.91 0 3.63-.78 5.23-1.511l.235-.108c.249-.113.494-.226.745-.333a.76.76 0 0 0 .39-.99.76.76 0 0 0-.99-.39c-.34.15-.67.3-1 .45-2.74 1.25-5.11 2.322-8.25.07a.761.761 0 0 0-1.05.17c-.24.34-.16.8.17 1.05 1.63 1.162 3.12 1.582 4.52 1.582v.01ZM21 12.26c-.41 0-.75.34-.75.75v5.667c-3.306-1.725-6.066-.472-8.528.646l-.032.014-.03.014c-2.638 1.196-4.922 2.23-7.91.276V9.347c3.31 1.722 6.08.47 8.56-.66.33-.15.66-.3.99-.441.38-.16.55-.61.39-.991a.751.751 0 0 0-.99-.39c-.34.15-.68.3-1.01.45-2.74 1.251-5.1 2.322-8.25.07a.756.756 0 0 0-.78-.06.76.76 0 0 0-.41.67v12.013c0 .24.12.47.31.61C4.19 21.78 5.68 22.2 7.08 22.2c1.91 0 3.63-.78 5.23-1.511l.017-.008c2.733-1.238 5.1-2.31 8.233-.063.23.16.53.18.78.06a.76.76 0 0 0 .41-.67V13c0-.41-.34-.751-.75-.751v.01ZM9.31 13.912A2.699 2.699 0 0 0 12 16.604c1.48 0 2.69-1.21 2.69-2.692A2.699 2.699 0 0 0 12 11.219a2.699 2.699 0 0 0-2.69 2.693Zm3.88 0c0 .66-.53 1.19-1.19 1.19-.66 0-1.19-.53-1.19-1.19 0-.661.53-1.192 1.19-1.192.66 0 1.19.531 1.19 1.192Z",
    paths: null
  },
  "log-out": {
    pathDefinition: "M8 20.25h3c.41 0 .75.34.75.75s-.34.75-.75.75H8c-2.62 0-4.75-2.13-4.75-4.75V7c0-2.62 2.13-4.75 4.75-4.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H8C6.21 3.75 4.75 5.21 4.75 7v10c0 1.79 1.46 3.25 3.25 3.25Zm12.53-8.78c.07.07.12.15.16.24v.01c.08.18.08.39 0 .57-.04.09-.09.17-.16.24l-4 4c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2.72-2.72H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.19l-2.72-2.72a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l4 4Z",
    paths: null
  },
  "loyalty-color-sm": {
    pathDefinition: "M7.38 2.775 5.909 5.579l-3.024.646a.698.698 0 0 0-.38 1.139l2.012 2.318-.486 3.11a.697.697 0 0 0 1 .733L8 12.04l2.971 1.485a.697.697 0 0 0 1-.732l-.487-3.111 2.012-2.318a.698.698 0 0 0-.38-1.14l-3.024-.645L8.62 2.775a.694.694 0 0 0-1.233 0h-.006Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("rect", {
        width: "16",
        height: "16",
        rx: "8",
        fill: "#FFF4E9"
      }), /* @__PURE__ */ t("path", {
        d: "M7.38 2.775 5.909 5.579l-3.024.646a.698.698 0 0 0-.38 1.139l2.012 2.318-.486 3.11a.697.697 0 0 0 1 .733L8 12.04l2.971 1.485a.697.697 0 0 0 1-.732l-.487-3.111 2.012-2.318a.698.698 0 0 0-.38-1.14l-3.024-.645L8.62 2.775a.694.694 0 0 0-1.233 0h-.006Z",
        fill: "#FD9426"
      })]
    })
  },
  "loyalty-color": {
    pathDefinition: "M11.07 4.162 8.864 8.368l-4.537.97a1.047 1.047 0 0 0-.57 1.708l3.018 3.477-.73 4.666c-.13.839.74 1.479 1.5 1.099L12 18.06l4.457 2.228c.759.38 1.628-.26 1.498-1.1l-.729-4.665 3.018-3.477c.52-.6.21-1.539-.57-1.709l-4.536-.969-2.209-4.206a1.041 1.041 0 0 0-1.848 0h-.01Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "#FFF4E9"
      }), /* @__PURE__ */ t("path", {
        d: "M11.07 4.162 8.864 8.368l-4.537.97a1.047 1.047 0 0 0-.57 1.708l3.018 3.477-.73 4.666c-.13.839.74 1.479 1.5 1.099L12 18.06l4.457 2.228c.759.38 1.628-.26 1.498-1.1l-.729-4.665 3.018-3.477c.52-.6.21-1.539-.57-1.709l-4.536-.969-2.209-4.206a1.041 1.041 0 0 0-1.848 0h-.01Z",
        fill: "#FD9426"
      })]
    })
  },
  loyalty: {
    pathDefinition: "M16.716 20.8c-.27 0-.53-.06-.78-.19l-3.926-1.961-3.927 1.96a1.753 1.753 0 0 1-2.518-1.83l.65-4.133-2.658-3.071a1.73 1.73 0 0 1-.34-1.701c.2-.59.68-1.03 1.29-1.16l3.996-.851L10.45 4.14a1.745 1.745 0 0 1 3.098-.001l1.948 3.723 3.997.85c.61.13 1.099.56 1.289 1.16.2.591.07 1.232-.34 1.702l-2.658 3.072.65 4.132c.1.65-.17 1.3-.7 1.68-.31.22-.67.341-1.029.341h.01Zm-4.706-3.742c.12 0 .23.03.34.08l4.256 2.131c.12.06.21.01.26-.02.05-.03.12-.11.1-.24l-.7-4.473c-.03-.22.03-.44.17-.61l2.888-3.332c.08-.09.06-.19.05-.24-.01-.05-.06-.14-.19-.17l-4.336-.92a.79.79 0 0 1-.51-.38L12.23 4.85c-.12-.23-.32-.23-.44 0L9.682 8.883c-.1.2-.29.34-.51.38l-4.336.921c-.12.03-.17.11-.19.17-.02.06-.03.15.05.24l2.888 3.332c.14.17.21.39.17.61l-.7 4.473c-.02.13.05.21.1.24s.14.08.26.02l4.256-2.131c.11-.05.22-.08.34-.08Z",
    paths: null
  },
  mail: {
    pathDefinition: "M21.75 7.84v-.99c0-1.52-1.23-2.75-2.75-2.75H5c-1.52 0-2.75 1.23-2.75 2.75v10c0 1.52 1.23 2.75 2.75 2.75h14c1.52 0 2.75-1.23 2.75-2.75V7.84ZM5 5.6h14c.69 0 1.25.56 1.25 1.25v.51L12 11.03 3.75 7.36v-.51c0-.69.56-1.25 1.25-1.25Zm14 12.5H5c-.69 0-1.25-.56-1.25-1.25V9l7.95 3.53a.765.765 0 0 0 .6 0L20.25 9v7.85c0 .69-.56 1.25-1.25 1.25Z",
    paths: null
  },
  maps: {
    pathDefinition: "m13.27 2.627 7.95 7.95c.7.7.7 1.84 0 2.54l-7.95 7.95c-.35.35-.81.53-1.27.53-.46 0-.92-.18-1.27-.53l-7.95-7.95c-.7-.7-.7-1.84 0-2.54l7.95-7.95c.7-.7 1.84-.7 2.54 0Zm-1.06 17.38 7.95-7.95a.29.29 0 0 0 0-.42l-7.95-7.95a.288.288 0 0 0-.42 0l-7.95 7.95a.29.29 0 0 0 0 .42l7.95 7.95c.12.12.3.12.42 0Zm4.32-8.69c.07.07.12.15.16.24v.01c.08.18.08.39 0 .57-.04.09-.09.17-.16.24l-2 2c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.72-.72h-3.44v2.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75h4.19l-.72-.72a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2Z",
    paths: null
  },
  market: {
    pathDefinition: "m19.146 13.616 2.243-6.003a1.748 1.748 0 0 0-1.635-2.361H7.234s-.06.01-.09.02L7.046 3.88a1.754 1.754 0 0 0-1.745-1.63H3.248A.754.754 0 0 0 2.5 3c0 .41.339.75.748.75H5.31c.13 0 .24.1.25.23l.796 11.217a2.753 2.753 0 0 0 2.732 2.55h10.107c.409 0 .747-.34.747-.75s-.338-.75-.747-.75H9.089a1.26 1.26 0 0 1-1.246-1.16l-.02-.34h9.688c.718 0 1.376-.46 1.635-1.131ZM7.255 6.742h12.499c.11 0 .18.07.21.11.03.04.07.12.03.23l-2.244 6.004c-.04.1-.129.16-.229.16H7.713l-.458-6.504ZM8.73 21.75c.688 0 1.246-.56 1.246-1.25 0-.691-.558-1.251-1.246-1.251s-1.246.56-1.246 1.25c0 .691.558 1.251 1.246 1.251Zm7.974 0c.688 0 1.246-.56 1.246-1.25 0-.691-.558-1.251-1.246-1.251s-1.246.56-1.246 1.25c0 .691.558 1.251 1.246 1.251Z",
    paths: null
  },
  marketing: {
    pathDefinition: "M15.09 4.71c.08.03.16.04.24.04.31 0 .6-.2.71-.51l.67-2a.745.745 0 0 0-.47-.95c-.4-.13-.82.08-.95.47l-.67 2c-.14.39.08.82.47.95Zm5.29 9.55c-.19 0-.38-.07-.53-.22l-.28-.28-5.75 3.442.03.028.71.71c.52.52.81 1.21.81 1.94s-.29 1.42-.81 1.94-1.21.81-1.94.81h-.01c-.73 0-1.42-.29-1.94-.81l-1.41-1.41a.74.74 0 0 1-.198-.36l-1.846 1.106.314.314c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-3.926-3.926a.738.738 0 0 1-.152-.152l-.922-.922a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.276.276 6.76-12.99-.316-.316a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.682.682a.714.714 0 0 1 .05.05l9.121 9.121a.73.73 0 0 1 .097.097l.66.66c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22l-.01-.01Zm-9.702-9.393 7.796 7.797L6.12 20.06l-2.206-2.206 6.764-12.987ZM10.32 19.35a.744.744 0 0 0-.034-.032l2.307-1.382a.74.74 0 0 0 .197.354l.71.71a1.234 1.234 0 0 1 0 1.76c-.48.47-1.3.47-1.77 0l-1.41-1.41ZM20 9.42a.75.75 0 0 1-.24-1.46l2-.67a.749.749 0 1 1 .48 1.42l-2 .67c-.08.03-.16.04-.24.04Zm-2.53-2.89c.15.15.34.22.53.22s.38-.07.53-.22l2-2c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2 2c-.29.29-.29.77 0 1.06Z",
    paths: null
  },
  "medical-center": {
    pathDefinition: "M13 21.75h-2c-1.52 0-2.75-1.23-2.75-2.75v-3.25H5c-1.52 0-2.75-1.23-2.75-2.75v-2c0-1.52 1.23-2.75 2.75-2.75h3.25V5c0-1.52 1.23-2.75 2.75-2.75h2c1.52 0 2.75 1.23 2.75 2.75v3.25H19c1.52 0 2.75 1.23 2.75 2.75v2c0 1.52-1.23 2.75-2.75 2.75h-3.25V19c0 1.52-1.23 2.75-2.75 2.75Zm-8-12c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h4c.41 0 .75.34.75.75v4c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-4c0-.41.34-.75.75-.75h4c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25h-4c-.41 0-.75-.34-.75-.75V5c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v4c0 .41-.34.75-.75.75H5Z",
    paths: null
  },
  menu: {
    pathDefinition: "M5 6.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5c-.41 0-.75.34-.75.75s.34.75.75.75Zm14 4.5H5c-.41 0-.75.34-.75.75s.34.75.75.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm0 6H5c-.41 0-.75.34-.75.75s.34.75.75.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
    paths: null
  },
  mobile: {
    pathDefinition: "M8 2.1h8c1.52 0 2.75 1.23 2.75 2.75v14c0 1.52-1.23 2.75-2.75 2.75H8c-1.52 0-2.75-1.23-2.75-2.75v-14C5.25 3.33 6.48 2.1 8 2.1Zm8 18c.69 0 1.25-.56 1.25-1.25v-14c0-.69-.56-1.25-1.25-1.25H8c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h8Zm-3.25-2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9 14.1h6c.41 0 .75.34.75.75s-.34.75-.75.75H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75Z",
    paths: null
  },
  "money-circle": {
    pathDefinition: "M2.25 12c0 5.38 4.37 9.75 9.75 9.75s9.75-4.37 9.75-9.75S17.38 2.25 12 2.25 2.25 6.62 2.25 12Zm1.5 0c0-4.55 3.7-8.25 8.25-8.25s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25-8.25-3.7-8.25-8.25Zm7.51 5.39c.03.33.41.48.75.48l-.01-.03c.34 0 .71-.15.73-.47v-.59l.12-.02c.64-.12 1.21-.38 1.69-.77.47-.38.71-1 .71-1.84 0-.59-.16-1.13-.49-1.62-.33-.48-1-.91-1.99-1.25-.84-.28-1.39-.52-1.69-.74-.33-.24-.5-.54-.5-.91 0-.32.13-.58.39-.77.24-.17.56-.26.95-.26.44 0 .82.12 1.11.35.29.23.5.54.62.95.05.32.4.35.51.35.28 0 .58-.13.73-.34.13-.17.15-.37.08-.6-.18-.57-.45-1.03-.81-1.37-.36-.34-.79-.55-1.28-.61l-.13-.02V6.6c-.04-.33-.43-.48-.76-.48s-.7.15-.71.47v.72l-.12.03c-.7.17-1.23.48-1.56.93-.34.45-.51.95-.51 1.48 0 .67.2 1.19.6 1.61.41.42 1.11.81 2.07 1.14.71.24 1.21.47 1.51.7.32.24.49.57.49.96 0 .45-.15.79-.44 1-.28.21-.7.31-1.19.31s-.91-.15-1.26-.45c-.34-.29-.6-.77-.75-1.39-.1-.25-.32-.39-.6-.39-.24 0-.48.11-.63.29-.14.18-.19.41-.13.66.16.73.46 1.31.9 1.73.43.43.93.7 1.48.82l.12.03v.62Z",
    paths: null
  },
  "more-cash": {
    pathDefinition: "M7.08 18.63c-1.4 0-2.89-.42-4.52-1.58a.74.74 0 0 1-.31-.61v-12c0-.28.16-.54.41-.67.25-.13.55-.11.78.06 3.14 2.243 5.495 1.177 8.223-.058l.027-.012c2.76-1.26 5.9-2.68 9.75.07.2.14.31.37.31.61v12c0 .28-.16.54-.41.67-.25.13-.55.11-.78-.06-3.14-2.243-5.495-1.177-8.223.058l-.027.012c-1.6.73-3.32 1.51-5.23 1.51Zm-3.33-2.58c3 1.96 5.29.92 7.94-.29l.01-.004c2.467-1.12 5.234-2.374 8.55-.656V4.84c-2.99-1.96-5.29-.92-7.94.29l-.032.014C9.816 6.261 7.056 7.513 3.75 5.79v10.26Zm3.33 6.14c-1.4 0-2.89-.42-4.52-1.58a.742.742 0 0 1-.17-1.05c.24-.34.71-.42 1.05-.17 3.14 2.243 5.495 1.177 8.223-.058l.027-.012c2.76-1.26 5.9-2.68 9.75.07.34.24.42.71.17 1.05-.25.34-.71.42-1.05.17-3.14-2.243-5.495-1.177-8.223.058l-.027.012c-1.6.73-3.32 1.51-5.23 1.51Zm2.17-11.75c0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75S13.52 7.69 12 7.69s-2.75 1.23-2.75 2.75Zm1.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
    paths: null
  },
  "more-fill": {
    pathDefinition: "M9 3.5H5A1.5 1.5 0 0 0 3.5 5v4A1.5 1.5 0 0 0 5 10.5h4A1.5 1.5 0 0 0 10.5 9V5A1.5 1.5 0 0 0 9 3.5Zm10 0h-4A1.5 1.5 0 0 0 13.5 5v4a1.5 1.5 0 0 0 1.5 1.5h4A1.5 1.5 0 0 0 20.5 9V5A1.5 1.5 0 0 0 19 3.5Zm0 10h-4a1.5 1.5 0 0 0-1.5 1.5v4a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5Zm-10 0H5A1.5 1.5 0 0 0 3.5 15v4A1.5 1.5 0 0 0 5 20.5h4a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 9 13.5Z",
    paths: null
  },
  "more-options": {
    pathDefinition: "M5 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm14 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm-7 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
    paths: null
  },
  more: {
    pathDefinition: "M9 10.75H5c-.96 0-1.75-.79-1.75-1.75V5c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75v4c0 .96-.79 1.75-1.75 1.75Zm-4-6c-.14 0-.25.11-.25.25v4c0 .14.11.25.25.25h4c.14 0 .25-.11.25-.25V5c0-.14-.11-.25-.25-.25H5Zm14 6h-4c-.96 0-1.75-.79-1.75-1.75V5c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75v4c0 .96-.79 1.75-1.75 1.75Zm-4-6c-.14 0-.25.11-.25.25v4c0 .14.11.25.25.25h4c.14 0 .25-.11.25-.25V5c0-.14-.11-.25-.25-.25h-4Zm4 16h-4c-.96 0-1.75-.79-1.75-1.75v-4c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75v4c0 .96-.79 1.75-1.75 1.75Zm-4-6c-.14 0-.25.11-.25.25v4c0 .14.11.25.25.25h4c.14 0 .25-.11.25-.25v-4c0-.14-.11-.25-.25-.25h-4Zm-6 6H5c-.96 0-1.75-.79-1.75-1.75v-4c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75v4c0 .96-.79 1.75-1.75 1.75Zm-4-6c-.14 0-.25.11-.25.25v4c0 .14.11.25.25.25h4c.14 0 .25-.11.25-.25v-4c0-.14-.11-.25-.25-.25H5Z",
    paths: null
  },
  mpos: {
    pathDefinition: "M7 2.1h10c2.62 0 4.75 2.13 4.75 4.75v10c0 2.62-2.13 4.75-4.75 4.75H7c-2.62 0-4.75-2.13-4.75-4.75v-10C2.25 4.23 4.38 2.1 7 2.1Zm10 18c1.79 0 3.25-1.46 3.25-3.25v-10c0-1.79-1.46-3.25-3.25-3.25H7c-1.79 0-3.25 1.46-3.25 3.25v10c0 1.79 1.46 3.25 3.25 3.25h10Zm-8-3.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    paths: null
  },
  "no-label": {
    pathDefinition: "m15.89 2.91 3.48 4.35c.24.31.38.69.38 1.09V20c0 .96-.79 1.75-1.75 1.75H6c-.96 0-1.75-.79-1.75-1.75V8.35c0-.39.13-.78.38-1.09l3.48-4.35c.34-.42.83-.66 1.37-.66h5.04c.54 0 1.04.24 1.37.66ZM18 20.25c.14 0 .25-.11.25-.25h-.02V8.35c0-.06-.05-.16-.05-.16L14.7 3.84c-.04-.06-.11-.09-.19-.09H9.47c-.07 0-.14.03-.19.09L5.8 8.19c-.03.05-.05.1-.05.16V20c0 .14.11.25.25.25h12ZM13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm.47 4.47c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L13.06 14l1.47 1.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L12 15.06l-1.47 1.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L10.94 14l-1.47-1.47a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 12.94l1.47-1.47Z",
    paths: null
  },
  notepad: {
    pathDefinition: "M19.53 6.11a.75.75 0 0 0-.531-.22H6.823c-.59 0-1.071-.48-1.071-1.07 0-.59.48-1.07 1.071-1.07H18.98c.41 0 .751-.34.751-.75s-.34-.75-.751-.75H6.823A2.57 2.57 0 0 0 4.25 4.82V19a2.75 2.75 0 0 0 2.754 2.75h11.975a.75.75 0 0 0 .751-.75l.02-14.35c0-.2-.08-.39-.22-.53v-.01ZM9.737 7.39h4.506v5.4c-1.232-.38-2.043.16-2.674.58-.62.41-1 .66-1.832.2V7.39Zm8.491 12.85H7.004c-.691 0-1.252-.56-1.252-1.25V7.15c.33.15.69.23 1.071.23h1.412v6.6c0 .25.12.49.33.62.782.52 1.432.71 1.983.71.791 0 1.382-.39 1.852-.71.701-.46 1.082-.72 2.173 0 .23.15.531.17.771.04s.4-.38.4-.66V7.39h2.504l-.02 12.85Z",
    paths: null
  },
  "notification-alt": {
    pathDefinition: "M18.637 17.5H4.857c-1.39 0-2.61-.99-2.82-2.29-.22-1.35.56-2.64 1.85-3.07.05-.02.11-.11.11-.22V9.76c0-4.36 3.4-7.76 7.75-7.76s7.75 3.4 7.75 7.75v2.16c0 .11.06.21.11.22 1.29.43 2.07 1.72 1.85 3.07-.21 1.31-1.42 2.29-2.82 2.29v.01Zm-6.89-14c-3.5 0-6.25 2.75-6.25 6.25v2.16c0 .76-.46 1.43-1.14 1.65-.5.17-.96.7-.84 1.4.1.59.67 1.03 1.34 1.03h13.79c.67 0 1.24-.44 1.34-1.03.11-.7-.34-1.24-.84-1.4-.68-.22-1.14-.89-1.14-1.65V9.75c0-3.56-2.69-6.25-6.25-6.25h-.01Zm.266 18c-1.09 0-2.12-.47-2.83-1.29a.748.748 0 0 1 .08-1.06c.31-.27.79-.24 1.06.08.86.99 2.54.99 3.4 0 .27-.31.75-.35 1.06-.08.31.27.35.75.08 1.06-.71.82-1.75 1.29-2.83 1.29h-.02Z",
    paths: null
  },
  notification: {
    pathDefinition: "M13.847 19.55c-.338.46-1.033.7-2.017.7s-1.67-.24-2.017-.7a.742.742 0 0 0-1.043-.15.754.754 0 0 0-.15 1.05c.438.59 1.362 1.3 3.2 1.3s2.762-.71 3.2-1.3a.754.754 0 0 0-.15-1.05.742.742 0 0 0-1.043.15h.02Zm5.683-8.794v-.76c0-2.11-.834-4.091-2.335-5.562a7.654 7.654 0 0 0-5.594-2.18c-4.113.12-7.461 3.73-7.461 8.042v.55c-1.093 1.12-1.65 2.251-1.64 3.371 0 1.32.795 2.101.884 2.181.01.01.03.02.04.04 1.282 1.03 2.524 1.38 3.726 1.38 1.45 0 2.842-.52 4.133-1.01 2.037-.77 3.806-1.43 5.674-.34 1.043.6 2.226.68 3.16.21.774-.39 1.34-1.4 1.38-2.46.03-.77-.188-2.211-1.967-3.462Zm-.09 4.572c-.486.25-1.142.19-1.748-.17-2.484-1.44-4.849-.54-6.935.24-2.275.85-4.233 1.59-6.379-.12-.08-.08-.407-.48-.397-1.11 0-.75.496-1.601 1.41-2.471a.744.744 0 0 0 .229-.54v-.871c0-3.511 2.703-6.442 6.021-6.542 1.7-.06 3.299.57 4.511 1.76a6.246 6.246 0 0 1 1.888 4.492v1.16c0 .26.139.5.358.64 1.093.67 1.649 1.491 1.61 2.351-.03.64-.378 1.09-.567 1.18Z",
    paths: null
  },
  outcome: {
    pathDefinition: "M18.689 5.72a.782.782 0 0 0-.41-.41.718.718 0 0 0-.29-.06h-7.99c-.41 0-.75.34-.75.75s.34.749.75.749h6.19L5.469 17.47c-.29.29-.29.77 0 1.06.15.15.34.219.53.219s.38-.07.53-.22l10.72-10.712v6.186c0 .41.34.749.75.749s.75-.34.75-.75V6.01c0-.1-.02-.19-.06-.29Z",
    paths: null
  },
  password: {
    pathDefinition: "M16.75 8.35c0 .12-.03.22-.08.32 1.75.32 3.08 1.84 3.08 3.68v8c0 .41-.34.75-.75.75H5c-.41 0-.75-.34-.75-.75v-8c0-1.83 1.33-3.36 3.08-3.68a.722.722 0 0 1-.08-.32v-1C7.25 4.73 9.38 2.6 12 2.6s4.75 2.13 4.75 4.75v1ZM12 4.1c-1.79 0-3.25 1.46-3.25 3.25v1c0 .09-.02.17-.05.25h6.6a.696.696 0 0 1-.05-.25v-1c0-1.79-1.46-3.25-3.25-3.25Zm-6.25 8.25v7.25h12.5v-7.25c0-1.24-1.01-2.25-2.25-2.25H8c-1.24 0-2.25 1.01-2.25 2.25Zm5.5 1c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2Z",
    paths: null
  },
  "payment-fill": {
    pathDefinition: "M21.35 4.594c-3.752-2.677-6.692-1.343-9.53-.05-2.338 1.063-4.535 2.065-7.183.842a1.484 1.484 0 0 0-1.445.1A1.507 1.507 0 0 0 2.5 6.75v12.673c0 .521.27 1.003.712 1.283.442.281.993.301 1.465.07l1.906-.952c.2-.1.431-.06.582.1l.913.933c.29.3.682.45 1.073.45.29 0 .582-.08.833-.25l1.765-1.173c.17-.11.391-.11.552 0l1.765 1.173a1.494 1.494 0 0 0 1.906-.2l.913-.933c.15-.16.391-.19.582-.1l1.906.952a1.494 1.494 0 0 0 1.465-.07c.451-.28.712-.752.712-1.283V5.005c0-.16-.08-.31-.21-.41h.01Zm-9.32 11.19H7.014a.758.758 0 0 1-.752-.753c0-.41.34-.752.752-.752h5.016c.411 0 .752.341.752.752a.758.758 0 0 1-.752.752Zm5.016-4.011H7.014a.758.758 0 0 1-.752-.752c0-.411.34-.752.752-.752h10.032c.411 0 .752.34.752.752a.758.758 0 0 1-.752.752Z",
    paths: null
  },
  payment: {
    pathDefinition: "M7.893 21.034c.339.34.787.52 1.245.521h-.005.01-.005c.339 0 .667-.091.966-.29l1.76-1.174c.09-.06.2-.06.28 0l1.762 1.173c.7.472 1.63.372 2.22-.23l.911-.933c.08-.08.19-.1.29-.05l1.901.953c.54.27 1.181.24 1.701-.08.52-.322.83-.883.83-1.495V5.007a.742.742 0 0 0-.31-.612c-3.851-2.758-6.993-1.334-9.754-.07l-.013.005c-2.267 1.031-4.415 2.008-6.941.837A1.743 1.743 0 0 0 2.26 6.752v12.677c0 .612.31 1.174.83 1.494.52.321 1.15.351 1.701.08l1.901-.952c.1-.05.21-.03.29.05l.91.933Zm.16-1.986a1.733 1.733 0 0 0-1.25-.532v-.01c-.261 0-.531.07-.781.19l-1.901.954c-.1.06-.19.02-.24-.01-.05-.02-.12-.09-.12-.211V6.752c0-.11.06-.17.11-.2a.253.253 0 0 1 .25-.02c3.14 1.458 5.814.248 8.18-.822l.024-.011c2.651-1.214 4.953-2.257 7.944-.291v14.031c0 .12-.08.18-.12.21-.04.03-.13.06-.24.01l-1.901-.952c-.68-.341-1.5-.21-2.031.34l-.91.934c-.09.08-.22.1-.32.03l-1.762-1.174a1.752 1.752 0 0 0-1.94 0l-1.762 1.174c-.1.07-.24.05-.32-.03l-.91-.933Zm-1.05-7.271h10.004c.41 0 .75-.341.75-.753a.757.757 0 0 0-.75-.752H7.002c-.41 0-.75.341-.75.752 0 .412.34.753.75.753Zm0 4.011h5.002c.41 0 .75-.34.75-.752a.757.757 0 0 0-.75-.752H7.002c-.41 0-.75.34-.75.752 0 .411.34.752.75.752Z",
    paths: null
  },
  phone: {
    pathDefinition: "M6.836 2.11h2.657V2.1a2.747 2.747 0 0 1 2.747 2.75v2c0 1.52-1.229 2.75-2.747 2.75h-.74c-.34.82-.34 3.68 0 4.5h.74a2.747 2.747 0 0 1 2.747 2.75v2c0 1.52-1.229 2.75-2.747 2.75H6.836a2.785 2.785 0 0 1-2.588-1.8c-1.997-5.27-1.997-10.62 0-15.89a2.785 2.785 0 0 1 2.588-1.8Zm2.657 6a1.25 1.25 0 0 0 1.248-1.25V4.85c0-.69-.559-1.25-1.248-1.25H6.836c-.51 0-.99.34-1.18.84-1.867 4.92-1.867 9.91 0 14.83.19.5.66.84 1.18.84h2.657a1.25 1.25 0 0 0 1.248-1.25v-2c0-.69-.559-1.25-1.248-1.25h-1c-.998 0-1.498-1.26-1.498-3.75 0-.84.08-1.63.21-2.23.22-1.01.66-1.52 1.289-1.52h.999Zm7.382-2.68a.74.74 0 0 1 1.039-.19l.02.01c1.947 1.37 3.316 4.24 3.316 6.99 0 1.98-.69 4.65-2.228 6.16-.14.14-.32.21-.52.21a.754.754 0 0 1-.538-.23c-.29-.3-.29-.77.01-1.06 1.038-1.02 1.768-3.12 1.768-5.09 0-2.22-1.15-4.69-2.678-5.76a.742.742 0 0 1-.19-1.04Zm-3.097 3.18c.14-.39.57-.6.959-.46 1.448.52 2.497 2.07 2.497 3.71 0 1.64-1.049 3.2-2.497 3.71-.08.03-.17.04-.25.04a.75.75 0 0 1-.709-.5c-.13-.39.07-.82.46-.96.859-.3 1.498-1.29 1.498-2.29s-.64-1.99-1.498-2.29a.755.755 0 0 1-.46-.96Z",
    paths: null
  },
  "pin-recover": {
    pathDefinition: "M19.996 6.48c-.36-1.04-1.321-1.71-2.392-1.66-1.19.05-2.131.72-2.532 1.78-.15.39.05.82.44.96.39.15.821-.05.961-.44.11-.29.4-.77 1.191-.81.39 0 .76.24.9.65.19.55-.1 1.16-.78 1.63-.78.55-1.2 1.33-1.18 2.21v1.06c.02.41.35.74.76.74.41 0 .75-.35.74-.76v-1.06c-.02-.38.16-.69.53-.96 1.472-1.04 1.682-2.41 1.362-3.34Zm-14.87.37a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501Zm6.254 0a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501ZM5.126 13.1a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501Zm6.254 0a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501Zm-6.254 6.25a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501Zm6.254 0a1.25 1.25 0 1 0 0-2.502 1.25 1.25 0 0 0 0 2.501Zm6.254 0a1.25 1.25 0 1 0 .001-2.502 1.25 1.25 0 0 0-.001 2.501Z",
    paths: null
  },
  pin: {
    pathDefinition: "M12.712 2.28c2.374.22 4.437 1.65 5.508 3.83a7.246 7.246 0 0 1-.39 7.13l-5.198 8.16a.74.74 0 0 1-.631.35c-.25 0-.49-.13-.631-.35l-5.198-8.16c-1.382-2.15-1.522-4.82-.38-7.13 1.08-2.19 3.134-3.62 5.508-3.83.47-.04.951-.04 1.412 0Zm-.701 17.33 4.567-7.17c1.082-1.71 1.192-3.83.29-5.67-.851-1.73-2.413-2.82-4.286-2.99-.19-.03-.38-.03-.571-.03-.19 0-.38.01-.571.03-1.873.17-3.435 1.26-4.287 2.99-.911 1.84-.8 3.96.29 5.67l4.568 7.17ZM9.257 9a2.75 2.75 0 0 1 2.754-2.75 2.75 2.75 0 1 1 0 5.5A2.75 2.75 0 0 1 9.257 9Zm1.502 0a1.251 1.251 0 0 0 2.504 0 1.251 1.251 0 0 0-2.504 0Z",
    paths: null
  },
  plus: {
    pathDefinition: "M19 11.25h-6.25V5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6.25H5c-.41 0-.75.34-.75.75s.34.75.75.75h6.25V19c0 .41.34.75.75.75s.75-.34.75-.75v-6.25H19c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
    paths: null
  },
  products: {
    pathDefinition: "M19 6.6h-3.3c.03-.08.05-.16.05-.25 0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75 0 .09.02.17.05.25H5c-1.52 0-2.75 1.23-2.75 2.75v9c0 1.52 1.23 2.75 2.75 2.75h14c1.52 0 2.75-1.23 2.75-2.75v-9c0-1.52-1.23-2.75-2.75-2.75Zm-9.25-.25c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25c0 .09.02.17.05.25H9.7c.03-.08.05-.16.05-.25ZM5 8.1h14c.69 0 1.25.56 1.25 1.25v2.25h-7.5v-.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.25h-7.5V9.35c0-.69.56-1.25 1.25-1.25Zm14 11.5H5c-.69 0-1.25-.56-1.25-1.25V13.1h7.5v.25c0 .41.34.75.75.75s.75-.34.75-.75v-.25h7.5v5.25c0 .69-.56 1.25-1.25 1.25Z",
    paths: null
  },
  qr: {
    pathDefinition: "M9 3.25H5c-.96 0-1.75.79-1.75 1.75v4c0 .96.79 1.75 1.75 1.75h4c.96 0 1.75-.79 1.75-1.75V5c0-.96-.79-1.75-1.75-1.75ZM9.25 9c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25V5c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v4ZM19 3.25h-4c-.96 0-1.75.79-1.75 1.75v4c0 .96.79 1.75 1.75 1.75h4c.96 0 1.75-.79 1.75-1.75V5c0-.96-.79-1.75-1.75-1.75ZM19.25 9c0 .14-.11.25-.25.25h-4c-.14 0-.25-.11-.25-.25V5c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v4ZM9 13.25H5c-.96 0-1.75.79-1.75 1.75v4c0 .96.79 1.75 1.75 1.75h4c.96 0 1.75-.79 1.75-1.75v-4c0-.96-.79-1.75-1.75-1.75ZM9.25 19c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25v-4c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v4ZM15 13.25h-1a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm0 5h-1a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm2.5-2.5h-1a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm2.5-2.5h-1a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Zm0 5h-1a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75Z",
    paths: null
  },
  recharge: {
    pathDefinition: "M20.25 12c0-.41.34-.75.75-.75s.75.34.75.75c0 5.38-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12 6.62 2.25 12 2.25c.41 0 .75.34.75.75s-.34.75-.75.75c-4.55 0-8.25 3.7-8.25 8.25s3.7 8.25 8.25 8.25 8.25-3.7 8.25-8.25Zm-3-5.25h-2.32c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.32V3c0-.41.34-.75.75-.75s.75.34.75.75v2.25H21c.41 0 .75.34.75.75s-.34.75-.75.75h-2.25v2.26c0 .41-.34.75-.75.75s-.75-.34-.75-.75V6.75Zm-5.23.04c.31 0 .66.15.7.46l-.001.578.06.022c.43.05.82.24 1.14.54.33.31.57.72.72 1.22.07.22.04.4-.07.56-.14.19-.41.32-.67.32-.1 0-.43-.02-.48-.33-.11-.35-.29-.62-.54-.82-.25-.2-.58-.3-.96-.3-.33 0-.61.08-.82.23-.22.15-.33.37-.33.65 0 .31.14.57.42.77.27.19.75.4 1.48.65.89.3 1.48.68 1.77 1.11.29.43.44.92.44 1.44 0 .75-.21 1.31-.63 1.65-.43.35-.94.58-1.5.69l-.08.02v.49c-.01.31-.36.45-.67.45-.31 0-.66-.14-.69-.45v-.52l-.08-.02a2.71 2.71 0 0 1-1.319-.73c-.39-.38-.66-.9-.8-1.54-.05-.24-.01-.45.12-.61.13-.17.36-.27.58-.27.26 0 .46.13.56.36.14.55.36.97.66 1.22.3.26.65.39 1.09.39.44 0 .79-.09 1.03-.26.25-.18.38-.47.38-.85 0-.33-.14-.61-.42-.82-.27-.21-.7-.41-1.32-.62-.85-.3-1.46-.63-1.83-1.01-.35-.37-.53-.85-.53-1.44 0-.47.15-.92.45-1.32.3-.4.77-.68 1.4-.83l.08-.02v-.61c.01-.31.35-.45.66-.45Z",
    paths: null
  },
  repeat: {
    pathDefinition: "M21 11.255c-.41 0-.75.34-.75.75 0 4.552-3.7 8.254-8.25 8.254-2.48 0-4.83-1.14-6.39-3.061h2.22c.41 0 .75-.34.75-.75s-.34-.751-.75-.751H3.99c-.41 0-.75.34-.75.75v3.842c0 .41.34.75.75.75s.75-.34.75-.75V18.5A9.772 9.772 0 0 0 12 21.75c5.38 0 9.75-4.372 9.75-9.755 0-.41-.34-.75-.75-.75v.01Zm-17.25.75c0-4.552 3.7-8.254 8.25-8.254 2.48 0 4.8 1.12 6.36 3.011h-2.21c-.41 0-.75.34-.75.75s.34.751.75.751h3.84c.41 0 .75-.34.75-.75V3.67c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.81A9.747 9.747 0 0 0 12 2.25c-5.38 0-9.75 4.372-9.75 9.755 0 .41.34.75.75.75s.75-.34.75-.75Z",
    paths: null
  },
  "right-double": {
    pathDefinition: "m5.777 4.97 6.498 6.5c.29.29.29.77 0 1.06l-6.498 6.5c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.755.755 0 0 1 0-1.06L10.685 12 4.717 6.03a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0Zm7.008 0 6.498 6.5c.29.29.29.77 0 1.06l-6.498 6.5c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.755.755 0 0 1 0-1.06L17.693 12l-5.968-5.97a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0Z",
    paths: null
  },
  right: {
    pathDefinition: "M8.5 19.258c-.19 0-.38-.07-.53-.22a.755.755 0 0 1 0-1.061l5.974-5.974L7.97 6.03a.755.755 0 0 1 0-1.061c.29-.29.77-.29 1.06 0l6.505 6.504c.29.29.29.77 0 1.06L9.03 19.039c-.15.15-.34.22-.53.22Z",
    paths: null
  },
  "sale-fill": {
    pathDefinition: "m19.39 7.744-4-5.052A.491.491 0 0 0 15 2.5H9c-.15 0-.3.07-.39.192l-4 5.052a.519.519 0 0 0-.11.313v12.276a.5.5 0 0 0 .19.394C5.85 21.667 6.97 22 8.05 22c1.47 0 2.86-.626 4.16-1.202 2.26-1.02 4.22-1.9 6.48-.071.15.121.35.141.53.06.17-.08.28-.262.28-.454V8.057a.519.519 0 0 0-.11-.313ZM8 11.088c0-.556.45-1.01 1-1.01s1 .454 1 1.01-.45 1.01-1 1.01-1-.454-1-1.01Zm1.53 5.587a.738.738 0 0 1-.53.223.737.737 0 0 1-.53-.223.768.768 0 0 1 0-1.07l6-6.063a.749.749 0 0 1 1.06 0c.29.293.29.778 0 1.071l-6 6.062ZM15 16.14c-.55 0-1-.455-1-1.01 0-.556.45-1.01 1-1.01s1 .454 1 1.01c0 .555-.45 1.01-1 1.01Z",
    paths: null
  },
  sale: {
    pathDefinition: "m15.59 2.53 4 5h-.01c.1.13.16.3.16.47v12.15a.744.744 0 0 1-1.21.59c-2.148-1.708-4.036-.872-6.223.097l-.007.003c-1.32.59-2.75 1.22-4.26 1.22-1.12 0-2.29-.35-3.51-1.32a.759.759 0 0 1-.28-.59V8c0-.17.05-.34.16-.47l4-5c.15-.18.36-.28.59-.28h6c.23 0 .45.1.59.28Zm-3.856 16.915c1.961-.866 4.14-1.828 6.516-.665V8.26l-3.61-4.51H9.36L5.75 8.26v11.51c2.03 1.43 3.86.62 5.95-.31l.034-.015ZM8.47 15.47c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l6-6c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-6 6ZM9 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    paths: null
  },
  savings: {
    pathDefinition: "M15.129 4.75c6.216 0 6.696 5.55 6.696 7.25 0 3.07-1.381 5.08-3.944 5.87v2.63c0 .41-.34.75-.75.75s-.751-.34-.751-.75v-2.33c-.4.04-.811.08-1.251.08h-4.255v2.25c0 .41-.34.75-.75.75s-.751-.34-.751-.75v-2.31c-1.011-.13-2.783-.55-3.844-1.94H3.007a.748.748 0 0 1-.751-.74l-.08-4c-.01-.2.07-.4.21-.54a.79.79 0 0 1 .54-.22h1.482c.22-1.97 1.301-3.69 2.963-4.69V3.5c0-.41.34-.75.75-.75 2.583 0 3.894 1.31 4.415 2h2.593Zm-5.005 12h5.005c3.493 0 5.195-1.55 5.195-4.75 0-2.15-.681-5.75-5.196-5.75h-3.002a.77.77 0 0 1-.671-.42l-.003-.005c-.059-.101-.732-1.261-2.58-1.525v2.2c0 .28-.17.54-.42.67-1.592.8-2.583 2.46-2.583 4.33 0 .41-.34.75-.75.75H3.697l.05 2.5H5.93c.26 0 .51.14.64.37.961 1.6 3.554 1.63 3.554 1.63Zm0-6.25a1 1 0 1 1-2.001 0 1 1 0 0 1 2 0Zm3.003-2.75h3.002c.41 0 .751.34.751.75s-.34.75-.75.75h-3.003c-.41 0-.751-.34-.751-.75s.34-.75.75-.75Z",
    paths: null
  },
  "scan-barcode": {
    pathDefinition: "M3 7.75c-.41 0-.75-.34-.75-.75V5c0-.96.79-1.75 1.75-1.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H4c-.14 0-.25.11-.25.25v2c0 .41-.34.75-.75.75Zm3 13H4c-.96 0-1.75-.79-1.75-1.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .14.11.25.25.25h2c.41 0 .75.34.75.75s-.34.75-.75.75Zm14 0h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.14 0 .25-.11.25-.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .96-.79 1.75-1.75 1.75Zm1-13c-.41 0-.75-.34-.75-.75V5c0-.14-.11-.25-.25-.25h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.96 0 1.75.79 1.75 1.75v2c0 .41-.34.75-.75.75Zm-12 8c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75Zm-3 0c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75Zm6 2c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v9c0 .41-.34.75-.75.75Zm3 0c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v9c0 .41-.34.75-.75.75Zm3-1c-.41 0-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v8c0 .41-.34.75-.75.75Z",
    paths: null
  },
  search: {
    pathDefinition: "m20.53 19.47-3.55-3.55A7.73 7.73 0 0 0 18.75 11c0-4.27-3.48-7.75-7.75-7.75S3.25 6.73 3.25 11s3.48 7.75 7.75 7.75c1.87 0 3.58-.66 4.92-1.77l3.55 3.55c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06ZM4.75 11c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25-2.8 6.25-6.25 6.25-6.25-2.8-6.25-6.25Z",
    paths: null
  },
  "security-settings": {
    pathDefinition: "M16.758 8.422c0 .12-.03.22-.08.32h-.01c1.751.32 3.082 1.839 3.082 3.678v6.996a.743.743 0 0 1-1.21.59c-2.15-1.707-4.04-.872-6.228.096l-.007.004c-1.32.59-2.752 1.219-4.263 1.219-1.12 0-2.291-.35-3.512-1.32a.758.758 0 0 1-.28-.589V12.42c0-1.83 1.33-3.358 3.082-3.678a.72.72 0 0 1-.08-.32v-1a4.755 4.755 0 0 1 4.753-4.747 4.755 4.755 0 0 1 4.753 4.747v1Zm-4.753-4.248a3.256 3.256 0 0 0-3.252 3.248v1c0 .09-.02.17-.05.25h6.604a.696.696 0 0 1-.05-.25v-1a3.256 3.256 0 0 0-3.252-3.248Zm-.266 14.538c1.962-.866 4.142-1.828 6.52-.665V12.41c0-1.24-1.01-2.249-2.251-2.249H8.002a2.253 2.253 0 0 0-2.251 2.249v6.626c2.031 1.43 3.862.62 5.954-.31l.034-.014Zm-.485-5.293c0-.41.34-.75.751-.75.41 0 .75.34.75.75v2c0 .409-.34.749-.75.749s-.75-.34-.75-.75V13.42Z",
    paths: null
  },
  security: {
    pathDefinition: "M12 21.598c-.09 0-.19-.02-.28-.05-5.78-2.32-8.47-6.99-8.47-14.7 0-.41.34-.75.75-.75 1.79 0 5.63-1.94 7.47-3.78.29-.29.77-.29 1.06 0 1.84 1.84 5.68 3.78 7.47 3.78.41 0 .75.34.75.75 0 7.71-2.69 12.38-8.47 14.7-.09.04-.18.05-.28.05ZM4.76 7.528c.14 6.57 2.4 10.46 7.24 12.5 4.85-2.05 7.1-5.93 7.24-12.5-2.11-.33-5.24-1.91-7.24-3.66-2 1.75-5.13 3.33-7.24 3.66Z",
    paths: null
  },
  "service-recharge": {
    pathDefinition: "M21.712 4.555c-.004-.016-.009-.033-.012-.05a.503.503 0 0 0-.05-.13.834.834 0 0 0-.08-.12.524.524 0 0 0-.1-.11.051.051 0 0 1-.02-.02.048.048 0 0 0-.02-.02c-3.85-2.752-6.98-1.33-9.75-.07l-.013.006c-2.265 1.028-4.412 2.003-6.937.834a1.738 1.738 0 0 0-2.48 1.58v12.649c0 .61.31 1.17.83 1.49.52.32 1.16.35 1.7.08l1.9-.95c.1-.05.21-.03.29.05l.91.93c.34.35.79.52 1.25.52.34 0 .67-.1.97-.29l1.76-1.17c.34-.23.44-.7.21-1.04a.753.753 0 0 0-1.04-.21l-1.76 1.17c-.1.07-.24.05-.32-.03l-.91-.93a1.732 1.732 0 0 0-2.03-.34l-1.9.95c-.11.06-.2.02-.24-.01-.04-.03-.12-.09-.12-.21V6.456c0-.11.06-.17.11-.2a.25.25 0 0 1 .25-.02c3.155 1.459 5.83.244 8.188-.825l.012-.005c2.65-1.201 4.95-2.242 7.94-.28v7.634c0 .41.34.75.75.75s.75-.34.75-.75V4.715s-.01-.04-.01-.06h-.01c0-.033-.009-.066-.018-.1Zm-.722 12.417h-2.25v-2.25c0-.411-.34-.751-.75-.751s-.75.34-.75.75v2.251h-2.26c-.41 0-.75.34-.75.75 0 .411.34.751.75.751h2.26v2.252c0 .41.34.75.75.75s.75-.34.75-.75v-2.252h2.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm-4-5.503h-10c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75Zm-10 2.502h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75Z",
    paths: null
  },
  settings: {
    pathDefinition: "m19.253 13.011 1.05.61h.02a1.753 1.753 0 0 1 .642 2.393l-1.002 1.732a1.759 1.759 0 0 1-2.392.64l-1.061-.61a7.31 7.31 0 0 1-1.752 1.011v1.211a1.76 1.76 0 0 1-1.752 1.752h-2.002a1.76 1.76 0 0 1-1.752-1.752v-1.211a7.122 7.122 0 0 1-1.751-1.011l-1.061.61a1.76 1.76 0 0 1-2.393-.64l-1-1.732a1.75 1.75 0 0 1 .64-2.392l1.05-.611c-.05-.34-.07-.67-.07-1.011 0-.34.02-.67.07-1.011l-1.05-.61a1.716 1.716 0 0 1-.821-1.062c-.13-.45-.06-.92.17-1.331l1.001-1.732a1.759 1.759 0 0 1 2.393-.64l1.06.61a7.373 7.373 0 0 1 1.752-1.011V4.002a1.76 1.76 0 0 1 1.752-1.752h2.002c.961 0 1.752.79 1.752 1.752v1.211c.63.25 1.211.59 1.752 1.011l1.061-.61a1.75 1.75 0 0 1 2.392.64l1.002 1.732a1.75 1.75 0 0 1-.65 2.392l-1.052.611c.05.34.07.68.07 1.011 0 .33-.02.67-.07 1.011Zm-.61 3.984 1-1.732v-.02c.07-.12.03-.27-.09-.34l-1.512-.87a.76.76 0 0 1-.36-.812c.09-.42.13-.83.13-1.241 0-.41-.04-.83-.13-1.241a.754.754 0 0 1 .36-.811l1.512-.871a.23.23 0 0 0 .12-.15c.01-.04.01-.11-.03-.19l-1-1.732a.21.21 0 0 0-.151-.12c-.006 0-.012 0-.02-.002a.257.257 0 0 0-.17.032l-1.512.87a.74.74 0 0 1-.88-.09 5.783 5.783 0 0 0-2.143-1.24.733.733 0 0 1-.52-.711V3.982c0-.14-.11-.25-.25-.25h-2.003c-.14 0-.25.11-.25.25v1.742c0 .32-.21.61-.52.71a5.78 5.78 0 0 0-2.143 1.242.77.77 0 0 1-.88.09l-1.512-.871a.268.268 0 0 0-.19-.02c-.05.02-.11.05-.15.12L4.346 8.727a.239.239 0 0 0-.031.163l.001.027c.01.03.04.11.12.15l1.512.87c.28.161.43.491.36.812-.09.41-.13.83-.13 1.241 0 .41.04.82.13 1.241.07.32-.08.65-.36.811l-1.511.871c-.12.07-.16.22-.09.34l1 1.732c.07.12.22.16.34.09l1.512-.87a.746.746 0 0 1 .881.1c.63.57 1.352.99 2.143 1.24.31.09.52.381.52.711v1.742c0 .14.11.25.25.25h2.002c.14 0 .25-.11.25-.25v-1.742c0-.32.21-.61.521-.71a5.776 5.776 0 0 0 2.142-1.242c.24-.21.6-.25.881-.09l1.512.871c.12.07.27.03.34-.09ZM8.24 12a3.755 3.755 0 0 1 3.754-3.754A3.755 3.755 0 0 1 15.75 12a3.755 3.755 0 0 1-3.754 3.754A3.755 3.755 0 0 1 8.241 12Zm1.502 0a2.256 2.256 0 0 0 2.252 2.252A2.256 2.256 0 0 0 14.248 12a2.256 2.256 0 0 0-2.253-2.252A2.256 2.256 0 0 0 9.743 12Z",
    paths: null
  },
  share: {
    pathDefinition: "M18 14.248c-1.19 0-2.25.57-2.93 1.438L9.61 12.96c.08-.31.14-.63.14-.969 0-.34-.06-.66-.14-.969l5.46-2.727c.69.869 1.74 1.438 2.93 1.438a3.75 3.75 0 0 0 3.75-3.746 3.75 3.75 0 0 0-7.5 0c0 .34.06.66.14.97L8.93 9.681C8.24 8.813 7.19 8.244 6 8.244a3.75 3.75 0 0 0-3.75 3.746A3.75 3.75 0 0 0 6 15.736c1.19 0 2.25-.57 2.93-1.438l5.46 2.727c-.08.31-.14.63-.14.969a3.75 3.75 0 0 0 7.5 0A3.75 3.75 0 0 0 18 14.248Zm0-10.49c1.24 0 2.25 1.01 2.25 2.248A2.252 2.252 0 0 1 18 8.254a2.252 2.252 0 0 1-2.25-2.248A2.252 2.252 0 0 1 18 3.758ZM6 14.248A2.252 2.252 0 0 1 3.75 12 2.252 2.252 0 0 1 6 9.752c1.24 0 2.25 1.01 2.25 2.248A2.252 2.252 0 0 1 6 14.248Zm12 5.993a2.252 2.252 0 0 1-2.25-2.247A2.252 2.252 0 0 1 18 15.746c1.24 0 2.25 1.01 2.25 2.248A2.252 2.252 0 0 1 18 20.24Z",
    paths: null
  },
  shipping: {
    pathDefinition: "m21.63 11.08-1.7-2.55a1.754 1.754 0 0 0-1.462-.78h-2.711V6.5a2.75 2.75 0 0 0-2.752-2.75H5.002A2.75 2.75 0 0 0 2.25 6.5v8c0 1.27.87 2.33 2.041 2.64-.02.12-.04.23-.04.36a2.75 2.75 0 0 0 2.751 2.75 2.75 2.75 0 0 0 2.752-2.75c0-.09-.02-.17-.03-.25h4.552c0 .08-.03.16-.03.25a2.75 2.75 0 0 0 2.752 2.75 2.75 2.75 0 0 0 2.751-2.75c0-.09-.02-.17-.03-.25h1.28c.41 0 .751-.34.751-.75v-5c0-.15-.04-.29-.13-.42h.01ZM7.002 18.75a1.25 1.25 0 1 1 0-2.502 1.25 1.25 0 0 1 0 2.502Zm10.006 0a1.25 1.25 0 1 1 0-2.502 1.25 1.25 0 0 1 0 2.502Zm3.251-3h-1.15c-.5-.61-1.261-1-2.101-1-.84 0-1.601.39-2.101 1H9.113c-.5-.61-1.261-1-2.102-1-.84 0-1.58.39-2.09.98-.651-.05-1.161-.57-1.161-1.23v-8c0-.69.56-1.25 1.25-1.25h7.994c.69 0 1.251.56 1.251 1.25v6c0 .41.34.75.75.75s.75-.34.75-.75V9.25h2.712c.08 0 .16.04.21.11l1.581 2.37v4.02Z",
    paths: null
  },
  "shopping-bag": {
    pathDefinition: "M15.25 10c0 .41.34.75.75.75s.75-.34.75-.75V8.75h1.6l1.77 11.5H3.87l1.77-11.5h1.61V10c0 .41.34.75.75.75s.75-.34.75-.75V8.75h6.5V10Zm1.5-2.75V7c0-2.62-2.13-4.75-4.75-4.75S7.25 4.38 7.25 7v.25H5c-.37 0-.68.27-.74.64l-2 13c-.04.21.03.44.17.6.14.16.35.26.57.26h18c.22 0 .43-.1.57-.26.14-.16.2-.38.17-.6l-2-13a.752.752 0 0 0-.74-.64h-2.25Zm-8 0h6.5V7c0-1.79-1.46-3.25-3.25-3.25S8.75 5.21 8.75 7v.25Z",
    paths: null
  },
  "show-password": {
    pathDefinition: "M21.77 12v.14c0 .05-.02.09-.04.13-.02.05-.04.1-.07.14-.01.01-.02.03-.02.04-.253.341-.505.71-.769 1.093l-.183.267-.009.012c-1.812 2.648-4.057 5.928-8.659 5.928-4.61 0-6.864-3.29-8.668-5.94-.32-.48-.641-.94-.952-1.36-.02-.01-.02-.03-.02-.04a.61.61 0 0 1-.07-.14.328.328 0 0 0-.02-.062c-.01-.024-.02-.046-.02-.068v-.28c0-.05.02-.09.04-.13.02-.05.04-.1.07-.14.01-.01.02-.03.02-.04a38.5 38.5 0 0 0 .769-1.093l.183-.267.009-.012C5.173 7.53 7.418 4.25 12.02 4.25c4.61 0 6.864 3.29 8.668 5.94.32.48.641.94.952 1.36.02.01.02.03.02.04.03.04.05.09.07.14.004.022.013.043.02.062.01.024.02.046.02.068V12Zm-17.175.96c1.693 2.48 3.617 5.29 7.425 5.29 3.813 0 5.727-2.803 7.419-5.28l.006-.01.21-.3c.156-.225.309-.445.462-.66-.153-.215-.306-.435-.463-.66-.069-.1-.138-.2-.209-.3l-.006-.01c-1.692-2.477-3.606-5.28-7.419-5.28-3.813 0-5.727 2.803-7.419 5.28l-.006.01-.21.3c-.156.225-.309.445-.462.66.153.215.306.435.463.66.069.1.138.2.209.3ZM8.262 12c0-2.07 1.684-3.75 3.758-3.75A3.755 3.755 0 0 1 15.778 12c0 2.07-1.684 3.75-3.758 3.75A3.755 3.755 0 0 1 8.262 12Zm1.503 0a2.256 2.256 0 0 0 4.51 0 2.256 2.256 0 0 0-4.51 0Z",
    paths: null
  },
  "standby-circle-fill-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm2 7.75H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    paths: null
  },
  "standby-circle-fill": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm3 10.5H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    paths: null
  },
  "standby-circle-sm": {
    pathDefinition: "M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm1.5 0c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5S11.03 2.5 8 2.5A5.51 5.51 0 0 0 2.5 8Zm2.75 0c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H6c-.41 0-.75-.34-.75-.75Z",
    paths: null
  },
  "standby-circle": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm0 18c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("path", {
        d: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm0 18c-4.55 0-8.25-3.7-8.25-8.25S7.45 3.75 12 3.75s8.25 3.7 8.25 8.25-3.7 8.25-8.25 8.25Z",
        fill: "#313643"
      }), /* @__PURE__ */ t("path", {
        d: "M16 11.25H8c-.41 0-.75.34-.75.75s.34.75.75.75h8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
        fill: "#313643"
      })]
    })
  },
  "stocks-investment": {
    pathDefinition: "M21.73 5.498a3.255 3.255 0 0 0-3.248-3.248 3.255 3.255 0 0 0-3.249 3.248c0 1.27.74 2.37 1.81 2.899l-1.38 3.868c-.06 0-.12-.02-.18-.02-.66 0-1.27.2-1.779.54a.734.734 0 0 0-.14-.26l-1.849-2.25c.33-.509.53-1.119.53-1.768 0-1.79-1.46-3.249-3.248-3.249a3.255 3.255 0 0 0-3.249 3.249c0 1.1.55 2.069 1.4 2.658l-1.47 4.108c-.06 0-.12-.02-.18-.02a3.255 3.255 0 0 0-3.248 3.249 3.255 3.255 0 0 0 3.248 3.248c1.79 0 3.249-1.46 3.249-3.248 0-1.2-.66-2.24-1.63-2.799l1.43-3.988c.15.02.3.05.46.05.6 0 1.149-.17 1.629-.45l1.789 2.18c.1.12.23.19.37.23a3.22 3.22 0 0 0-.54 1.788c0 1.79 1.46 3.249 3.248 3.249 1.79 0 3.248-1.46 3.248-3.249 0-1.2-.66-2.239-1.629-2.798l1.41-3.948a3.255 3.255 0 0 0 3.218-3.249l-.02-.02ZM5.488 20.241c-.96 0-1.749-.79-1.749-1.75 0-.959.79-1.748 1.75-1.748.959 0 1.748.79 1.748 1.749 0 .96-.79 1.749-1.749 1.749Zm3.499-9.995c-.96 0-1.75-.79-1.75-1.75 0-.959.79-1.748 1.75-1.748.959 0 1.749.79 1.749 1.749 0 .96-.79 1.749-1.75 1.749Zm6.496 6.996c-.96 0-1.749-.79-1.749-1.749 0-.96.79-1.749 1.75-1.749.959 0 1.748.79 1.748 1.75 0 .959-.79 1.748-1.749 1.748ZM18.482 3.75c.96 0 1.749.79 1.749 1.75 0 .959-.79 1.748-1.75 1.748-.959 0-1.748-.79-1.748-1.749 0-.96.79-1.749 1.749-1.749Z",
    paths: null
  },
  "stores-fill": {
    pathDefinition: "M3.41 10.376c3.168 2.26 5.527 1.19 8.265-.06 2.759-1.249 5.887-2.668 9.725.06l-.68-4.727A2.514 2.514 0 0 0 18.252 3.5H5.718c-1.239 0-2.298.92-2.468 2.149l-.6 4.218.76.51Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("path", {
        d: "M3.41 10.376c3.168 2.26 5.527 1.19 8.265-.06 2.759-1.249 5.887-2.668 9.725.06l-.68-4.727A2.514 2.514 0 0 0 18.252 3.5H5.718c-1.239 0-2.298.92-2.468 2.149l-.6 4.218.76.51Z",
        fill: "#313643"
      }), /* @__PURE__ */ t("path", {
        d: "M12.295 11.676c-2.539 1.149-5.377 2.438-8.805.52v7.795c0 .83.67 1.5 1.499 1.5h3.998c.28 0 .5-.22.5-.5v-2.999c0-.69.28-1.339.779-1.809.5-.48 1.17-.71 1.859-.68 1.3.07 2.369 1.26 2.369 2.67V21c0 .28.22.5.5.5h3.997c.83 0 1.5-.67 1.5-1.5v-8.435c-3.129-2.18-5.478-1.12-8.186.11h-.01Z",
        fill: "#313643"
      })]
    })
  },
  "stores-generic": {
    pathDefinition: "M15 11.02c.979.809 1.987 1.219 2.995 1.22h-.005.01-.005c.42 0 .84-.071 1.255-.211v7.965c0 .14-.11.25-.25.25h-3.25v-2.08c0-2.1-1.56-3.82-3.55-3.92-1.04-.05-2.03.31-2.78 1.03-.74.71-1.17 1.7-1.17 2.72v2.25H5c-.14 0-.25-.11-.25-.25v-7.959c1.421.477 2.871.137 4.25-1.015 1.95 1.63 4.05 1.63 6 0Zm-11.75.197a7.587 7.587 0 0 1-.78-.687.764.764 0 0 1-.21-.66l.75-4.28c.19-1.32 1.36-2.34 2.72-2.34h12.53c1.36 0 2.53 1.01 2.72 2.36l.75 4.26c.04.24-.04.49-.21.66-.254.254-.511.48-.77.678v8.786c0 .96-.79 1.75-1.75 1.75h-4c-.41 0-.75-.34-.75-.75v-2.83c0-1.27-.96-2.36-2.13-2.42a2.21 2.21 0 0 0-1.67.62c-.45.43-.7 1.01-.7 1.63v3c0 .41-.34.75-.75.75H5c-.96 0-1.75-.79-1.75-1.75v-8.777ZM15.53 9.47a.742.742 0 0 0-.53-.22l-.01-.01c-.19 0-.38.07-.53.22-1.71 1.71-3.23 1.71-4.94 0a.754.754 0 0 0-1.06 0c-1.62 1.61-3.07 1.7-4.66.26l.69-3.91c.09-.61.62-1.07 1.24-1.07h12.54c.62 0 1.15.46 1.24 1.1l.68 3.89c-1.59 1.44-3.04 1.35-4.66-.26Z",
    paths: null
  },
  stores: {
    pathDefinition: "M20.983 5.61a2.754 2.754 0 0 0-2.72-2.36H5.73a2.754 2.754 0 0 0-2.72 2.36l-.749 5.28c-.04.28.08.55.31.72.23.17.46.31.69.45V20c0 .96.79 1.75 1.749 1.75h3.998c.41 0 .75-.34.75-.75v-3c0-.62.25-1.2.7-1.63.45-.43 1.04-.65 1.67-.62 1.169.06 2.128 1.15 2.128 2.42V21c0 .41.34.75.75.75h3.998c.96 0 1.75-.79 1.75-1.75v-8.29c.21.07.44.05.64-.06.26-.16.4-.45.35-.75l-.75-5.28-.01-.01Zm-16.484.21c.09-.61.62-1.07 1.24-1.07h12.525c.62 0 1.15.46 1.24 1.07l.53 3.73c-3.22-1.56-5.919-.33-8.348.77-2.629 1.19-4.918 2.24-7.877.33l.69-4.82v-.01ZM19.243 20c0 .14-.11.25-.25.25h-3.248v-2.08c0-2.09-1.56-3.81-3.549-3.92a3.65 3.65 0 0 0-2.779 1.03c-.74.71-1.17 1.7-1.17 2.72v2.25H5c-.14 0-.25-.11-.25-.25v-7.22c.81.29 1.59.41 2.33.41 1.908 0 3.628-.78 5.227-1.51 2.35-1.07 4.428-2.01 6.967-.83 0 .05-.03.09-.03.14V20Z",
    paths: null
  },
  "subtract-circle": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12Zm3.5 0c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.41 0-.75-.34-.75-.75Z",
    paths: null
  },
  "tax-calculator": {
    pathDefinition: "M19 2.974H5c-.96 0-1.75.79-1.75 1.75v4c0 .96.79 1.75 1.75 1.75h14c.96 0 1.75-.79 1.75-1.75v-4c0-.96-.79-1.75-1.75-1.75Zm.25 5.75c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25v-4c0-.14.11-.25.25-.25h14c.14 0 .25.11.25.25v4Zm-.5 6.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-6.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-6.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 5.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm13.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-6.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    paths: null
  },
  theme: {
    pathDefinition: "M12 21.74c-5.38 0-9.75-4.368-9.75-9.745C2.25 6.618 6.62 2.25 12 2.25c1.417 0 2.777.301 4.054.885a.74.74 0 0 1 .474 1.06.743.743 0 0 1-.643.423 7.478 7.478 0 0 0-4.724 3 4.753 4.753 0 0 1 6.59 4.377 4.753 4.753 0 0 1-6.59 4.377 7.478 7.478 0 0 0 4.777 3.01.75.75 0 0 1 .662.879.733.733 0 0 1-.492.578A9.66 9.66 0 0 1 12 21.75v-.01Zm-2.233-9.408A3.257 3.257 0 0 0 13 15.243c1.79 0 3.25-1.459 3.25-3.248 0-1.79-1.46-3.248-3.25-3.248a3.257 3.257 0 0 0-3.233 2.911 7.676 7.676 0 0 0 0 .674ZM12 3.759c.46 0 .916.037 1.364.11a8.972 8.972 0 0 0-5.124 8.126 8.98 8.98 0 0 0 5.127 8.134A8.338 8.338 0 0 1 12 20.24c-4.55 0-8.25-3.698-8.25-8.246S7.45 3.749 12 3.759Zm6 3.988c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1-.999c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1 1c-.15.15-.34.22-.53.22Zm1.25 4.248c0 .41.34.75.75.75h1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1c-.41 0-.75.34-.75.75ZM19 18.741c-.19 0-.38-.07-.53-.22l-1-.999a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z",
    paths: null
  },
  time: {
    pathDefinition: "M18 20.6H6a.756.756 0 0 1-.75-.751v-1c0-1.972.78-3.653 2.24-4.874l.46-.38c.7-.58 1.36-1.12 1.97-1.73-.61-.641-1.27-1.181-1.97-1.762l-.46-.38C6.02 8.503 5.25 6.81 5.25 4.85v-1c0-.41.34-.75.75-.75h12c.41 0 .75.34.75.75v1c0 1.971-.78 3.652-2.24 4.873l-.46.38c-.7.58-1.36 1.12-1.97 1.731v.03c.61.61 1.27 1.16 1.97 1.731l.46.38c1.47 1.221 2.24 2.912 2.24 4.873v1c0 .41-.34.751-.75.751ZM6.75 19.097h10.5v-.25c0-1.53-.57-2.781-1.7-3.722l-.46-.38c-.7-.57-1.42-1.17-2.08-1.831a1.528 1.528 0 0 1 0-2.151c.66-.66 1.38-1.261 2.08-1.832l.46-.38c1.13-.94 1.7-2.191 1.7-3.722v-.25H6.75v.25c0 1.531.57 2.782 1.7 3.722l.46.38c.7.57 1.42 1.171 2.08 1.832.59.59.59 1.56 0 2.15-.66.661-1.38 1.261-2.08 1.832l-.46.38c-1.13.94-1.7 2.191-1.7 3.722v.25Z",
    paths: null
  },
  "transfer-fill": {
    pathDefinition: "M21.703 16.284a.997.997 0 0 0-1.41 0l-1.29 1.289V8.04a3.997 3.997 0 0 0-4-3.997c-2.21 0-4 1.789-4 3.997v7.993c0 1.1-.9 1.998-2 1.998s-2-.899-2-1.998V6.412l1.29 1.29c.2.199.45.289.71.289.26 0 .51-.1.71-.29a.994.994 0 0 0 0-1.409l-3-2.997a1 1 0 0 0-1.42 0l-3 2.997a.996.996 0 1 0 1.41 1.409l1.29-1.289v9.612a3.997 3.997 0 0 0 4 3.997c2.21 0 4-1.789 4-3.997V8.041c0-1.1.9-1.999 2-1.999s2 .9 2 1.999v9.542l-1.29-1.29a.996.996 0 1 0-1.41 1.41l3 2.997c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22l3-2.997a.994.994 0 0 0 0-1.41l-.01-.01Z",
    paths: null
  },
  transfer: {
    pathDefinition: "M5.47 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L6 5.06 3.53 7.53a.75.75 0 0 1-1.06-1.06l3-3Zm9 13a.75.75 0 0 1 1.06 0L18 18.94l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.47 3.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L6 5.06 3.53 7.53a.75.75 0 0 1-1.06-1.06l3-3Zm9 13a.75.75 0 0 1 1.06 0L18 18.94l2.47-2.47a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06Z",
        fill: "#313643"
      }), /* @__PURE__ */ t("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 3.25a.75.75 0 0 1 .75.75v12.04A2.246 2.246 0 0 0 9 18.29a2.246 2.246 0 0 0 2.25-2.25v-8A3.746 3.746 0 0 1 15 4.29a3.746 3.746 0 0 1 3.75 3.75V20a.75.75 0 0 1-1.5 0V8.04A2.246 2.246 0 0 0 15 5.79a2.246 2.246 0 0 0-2.25 2.25v8A3.746 3.746 0 0 1 9 19.79a3.746 3.746 0 0 1-3.75-3.75V4A.75.75 0 0 1 6 3.25Z",
        fill: "#313643"
      })]
    })
  },
  transport: {
    pathDefinition: "M6 2.25h12c1.52 0 2.75 1.23 2.75 2.75v12c0 .96-.79 1.75-1.75 1.75h-1.3c.03.08.05.16.05.25v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1c0-.09.02-.17.05-.25H7.7c.03.08.05.16.05.25v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1c0-.09.02-.17.05-.25H5c-.96 0-1.75-.79-1.75-1.75V5c0-1.52 1.23-2.75 2.75-2.75Zm12 1.5H6c-.69 0-1.25.56-1.25 1.25v6.25h14.5V5c0-.69-.56-1.25-1.25-1.25ZM5 17.25h14c.14 0 .25-.11.25-.25v-4.25H4.75V17c0 .14.11.25.25.25Zm2-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm10 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-7-1.5h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75Z",
    paths: null
  },
  travel: {
    pathDefinition: "M11.542 17.933c-2.74 1.249-5.098 2.318-8.247.07a.762.762 0 0 0-1.05.17.76.76 0 0 0 .17 1.049C4.045 20.38 5.534 20.8 6.934 20.8c1.909 0 3.628-.78 5.228-1.508 2.739-1.239 5.108-2.318 8.247-.07.34.24.81.16 1.05-.17s.16-.8-.17-1.049c-3.849-2.747-6.978-1.328-9.747-.07Zm-6.448-2.018a2.75 2.75 0 0 0 3.02.27l11.875-6.393c2.16-1.388 2.69-3.496 1.94-4.734-.63-1.05-2.23-1.649-4.819-.19l-2.709 1.558-7.487-1.938a.9.9 0 0 0-.4 0l-2.88.86a.743.743 0 0 0-.53.599c-.05.28.07.569.31.729l4.82 3.426-1.58 1.169-3.46-.53a.76.76 0 0 0-.42.06c-.559.25-.939.77-1.009 1.379-.08.609.16 1.198.64 1.578l2.69 2.148v.01Zm-1.82-3.635 3.46.529c.2.03.4-.02.56-.14l2.669-1.978a.73.73 0 0 0 .3-.609.73.73 0 0 0-.32-.6L5.534 6.357l1.2-.36 7.577 1.958c.19.05.39.02.56-.08l2.98-1.708c1.549-.869 2.518-.799 2.798-.34.31.52-.03 1.779-1.42 2.668L7.404 14.877c-.44.24-.98.19-1.37-.12l-2.688-2.148c-.1-.08-.1-.17-.09-.23 0-.02.01-.06.03-.09l-.01-.01Z",
    paths: null
  },
  trophy: {
    pathDefinition: "M21 5.6h-3.25V4.35c0-.41-.34-.75-.75-.75H7c-.41 0-.75.34-.75.75V5.6H3c-.41 0-.75.34-.75.75v2.002c0 2.602 2.1 4.723 4.7 4.743a5.739 5.739 0 0 0 4.3 2.952v2.551H8c-.41 0-.75.34-.75.75s.34.751.75.751h8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.25v-2.552a5.739 5.739 0 0 0 4.3-2.952c2.59-.03 4.7-2.141 4.7-4.743V6.351c0-.41-.34-.75-.75-.75ZM3.75 8.352v-1.25h2.5v3.251c0 .41.04.8.12 1.19a3.254 3.254 0 0 1-2.62-3.191ZM12 14.606a4.26 4.26 0 0 1-4.25-4.253V5.1h8.5v5.253A4.26 4.26 0 0 1 12 14.606Zm8.25-6.254a3.262 3.262 0 0 1-2.62 3.192c.08-.38.12-.78.12-1.19V7.1h2.5v1.251Z",
    paths: null
  },
  tutorials: {
    pathDefinition: "M3.317 12.69a.766.766 0 0 1 .113-.18l6-7c.2-.24.53-.32.83-.21.29.11.49.39.49.7v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.97l-2.76 3.22h.01a4.24 4.24 0 0 1 3.12 1.37A2.747 2.747 0 0 1 12 11.25c1.017 0 1.904.55 2.38 1.37a4.24 4.24 0 0 1 3.12-1.37h.01l-2.76-3.22V9c0 .41-.34.75-.75.75s-.75-.34-.75-.75V6c0-.31.2-.59.49-.7.3-.11.63-.02.83.21l6 7a.69.69 0 0 1 .117.184A4.232 4.232 0 0 1 21.75 15.5a4.26 4.26 0 0 1-4.25 4.25 4.26 4.26 0 0 1-4.235-4.604.735.735 0 0 1-.015-.146v-1a1.25 1.25 0 0 0-2.5 0v1c0 .05-.005.099-.015.146A4.26 4.26 0 0 1 6.5 19.75a4.26 4.26 0 0 1-4.25-4.25c0-1.075.403-2.06 1.067-2.81Zm3.183.06c-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75 2.75-1.23 2.75-2.75-1.23-2.75-2.75-2.75Zm11 0c-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75 2.75-1.23 2.75-2.75-1.23-2.75-2.75-2.75Z",
    paths: null
  },
  up: {
    pathDefinition: "M18.5 16c-.19 0-.38-.07-.53-.22L12 9.81l-5.97 5.97c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l6.5-6.5c.29-.29.77-.29 1.06 0l6.5 6.5c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z",
    paths: null
  },
  user: {
    pathDefinition: "M6.746 7.497c0 2.889 2.355 5.248 5.24 5.248 2.885 0 5.241-2.36 5.241-5.248 0-2.888-2.356-5.247-5.24-5.247-2.886 0-5.241 2.359-5.241 5.247Zm1.497 0a3.747 3.747 0 0 1 3.743-3.748 3.747 3.747 0 0 1 3.744 3.748 3.747 3.747 0 0 1-3.744 3.748 3.747 3.747 0 0 1-3.743-3.748Zm9.17 10.81c-.828-1.207-2.424-2.564-5.417-2.564-4.333 0-5.745 2.851-6.132 3.965 1.973 1.306 3.766.52 5.813-.397l.016-.007c1.737-.771 3.657-1.623 5.72-.997ZM4.324 19.664c.264-.954 1.82-5.42 7.682-5.42 6.317 0 7.625 5.192 7.721 5.575l.006.022a.744.744 0 0 1-.577.877.73.73 0 0 1-.651-.137c-2.136-1.71-4.033-.88-6.22.1-1.317.59-2.744 1.219-4.252 1.219-1.118 0-2.286-.35-3.503-1.32a.753.753 0 0 1-.206-.916Z",
    paths: null
  },
  wallet: {
    pathDefinition: "M17 3.25H7C4.38 3.25 2.25 5.38 2.25 8v8c0 2.62 2.13 4.75 4.75 4.75h10c2.62 0 4.75-2.13 4.75-4.75V8c0-2.62-2.13-4.75-4.75-4.75Zm0 12a1.25 1.25 0 0 1 0-2.5h3.25v2.5H17ZM7 4.75h10c1.54 0 2.84 1.09 3.16 2.53-.05-.01-.11-.03-.16-.03H4c-.06 0-.11.02-.16.03A3.247 3.247 0 0 1 7 4.75Zm10 14.5H7c-1.79 0-3.25-1.46-3.25-3.25V8.7c.08.03.16.05.25.05h16c.09 0 .17-.02.25-.05v2.55H17c-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75h3.15a3.247 3.247 0 0 1-3.15 2.5Z",
    paths: null
  },
  "warning-circle-fill-sm": {
    pathDefinition: "M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7Zm0 11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75S8.41 12 8 12Zm.75-3c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.89c0-.41.34-.75.75-.75s.75.34.75.75V9Z",
    paths: null
  },
  "warning-circle-fill": {
    pathDefinition: "M12 2.25c-5.38 0-9.75 4.37-9.75 9.75s4.37 9.75 9.75 9.75 9.75-4.37 9.75-9.75S17.38 2.25 12 2.25Zm0 14.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75Zm.75-3.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.41.34-.75.75-.75s.75.34.75.75v5Z",
    paths: null
  },
  "warning-circle-sm": {
    pathDefinition: "M1 8c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7-7-3.13-7-7Zm1.5 0c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5S11.03 2.5 8 2.5A5.51 5.51 0 0 0 2.5 8Zm4.75-3.11c0-.41.34-.75.75-.75s.75.34.75.75V9c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.89Zm1.5 6.36a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    paths: null
  },
  "warning-circle": {
    pathDefinition: "M2.25 12c0-5.38 4.37-9.75 9.75-9.75s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75S2.25 17.38 2.25 12Zm1.5 0c0 4.55 3.7 8.25 8.25 8.25s8.25-3.7 8.25-8.25-3.7-8.25-8.25-8.25S3.75 7.45 3.75 12Zm7.5-4c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8Zm1.5 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    paths: null
  }
}, D0 = {
  atm: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm5.005-1.435h17.99c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1h-3v5a1 1 0 0 1-.55.89c-.34.17-.75.14-1.05-.09-1.5-1.13-2.48-.65-3.95.09-.91.46-1.95.98-3.15.98-.87 0-1.84-.28-2.89-1.07-.25-.19-.4-.49-.4-.8v-5h-3c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Zm8.55 14.11c1.23-.62 2.69-1.34 4.45-.77v-7.34h-1.18c.11.31.18.65.18 1 0 1.65-1.35 3-3 3s-3-1.35-3-3c0-.35.07-.69.18-1h-1.18v8.47c1.29.77 2.21.31 3.55-.36Zm.45-6.11c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm6 0h2v-6h-16v6h2v-3c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm5.005-1.435h17.99c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1h-3v5a1 1 0 0 1-.55.89c-.34.17-.75.14-1.05-.09-1.5-1.13-2.48-.65-3.95.09-.91.46-1.95.98-3.15.98-.87 0-1.84-.28-2.89-1.07-.25-.19-.4-.49-.4-.8v-5h-3c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Zm8.55 14.11c1.23-.62 2.69-1.34 4.45-.77v-7.34h-1.18c.11.31.18.65.18 1 0 1.65-1.35 3-3 3s-3-1.35-3-3c0-.35.07-.69.18-1h-1.18v8.47c1.29.77 2.21.31 3.55-.36Zm.45-6.11c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm6 0h2v-6h-16v6h2v-3c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  baby: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15.4 5.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3ZM16 21.6c1.5 0 2.8-.7 3.5-1.8.1-.3.1-.6-.2-.7-.2-.1-.6 0-.7.2-.5.8-1.6 1.3-2.7 1.3s-2.1-.5-2.6-1.3c-.2-.2-.5-.2-.7-.1-.2.2-.2.5-.1.7.7 1 2 1.7 3.5 1.7Zm-2.7-7c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3Zm3.2-5.5c3.3.2 6 2.4 7.1 5.4 1.3 0 2.3.9 2.3 2.2 0 1.3-1 2.3-2.3 2.3-.9 3.4-3.9 6-7.6 6-3.7 0-6.6-2.6-7.6-6-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1-3 3.8-5.2 7.1-5.4 0-1.5-1-1.6-1-1.6-.3 0-.5-.2-.5-.5s.2-.5.5-.5c.4 0 1.1.2 1.5.9.7-.8 1.7-1.2 2.3-1.3.3 0 .5.1.6.5.1.3-.1.5-.4.6-.1 0-2 .4-2 2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15.4 5.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3ZM16 21.6c1.5 0 2.8-.7 3.5-1.8.1-.3.1-.6-.2-.7-.2-.1-.6 0-.7.2-.5.8-1.6 1.3-2.7 1.3s-2.1-.5-2.6-1.3c-.2-.2-.5-.2-.7-.1-.2.2-.2.5-.1.7.7 1 2 1.7 3.5 1.7Zm-2.7-7c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3Zm3.2-5.5c3.3.2 6 2.4 7.1 5.4 1.3 0 2.3.9 2.3 2.2 0 1.3-1 2.3-2.3 2.3-.9 3.4-3.9 6-7.6 6-3.7 0-6.6-2.6-7.6-6-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3 1-3 3.8-5.2 7.1-5.4 0-1.5-1-1.6-1-1.6-.3 0-.5-.2-.5-.5s.2-.5.5-.5c.4 0 1.1.2 1.5.9.7-.8 1.7-1.2 2.3-1.3.3 0 .5.1.6.5.1.3-.1.5-.4.6-.1 0-2 .4-2 2Z",
          fill: "#C68ED7"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  backwards: {
    pathDefinition: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10ZM8.08 16.92l6 6c.25.25.59.38.92.38a1.298 1.298 0 0 0 .92-2.22l-3.78-3.78H23c.72 0 1.3-.58 1.3-1.3 0-.72-.58-1.3-1.3-1.3H12.14l3.78-3.78c.51-.51.51-1.33 0-1.84s-1.33-.51-1.84 0l-6 6c-.51.51-.51 1.327-.003 1.837",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10ZM8.08 16.92l6 6c.25.25.59.38.92.38a1.298 1.298 0 0 0 .92-2.22l-3.78-3.78H23c.72 0 1.3-.58 1.3-1.3 0-.72-.58-1.3-1.3-1.3H12.14l3.78-3.78c.51-.51.51-1.33 0-1.84s-1.33-.51-1.84 0l-6 6c-.51.51-.51 1.327-.003 1.837",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("rect", {
            width: "32",
            height: "32",
            rx: "10",
            fill: "#fff"
          })
        })
      })]
    })
  },
  beauty: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm8.8 6s2.8 1.6 5.1 1.6 4.8-1.6 4.8-1.6-2.2-1.8-4.8-1.8c-2.6 0-5.1 1.8-5.1 1.8Zm5.51-6.212C16.551 9.462 16.897 9 18 9c1.7 0 7.6 6.1 7.7 6.7 0 .5-4.7 7.3-9.8 7.3-5.1 0-9.9-6-9.9-6.8 0-.9 5.1-7.2 7.3-7.2 1.445 0 1.855.475 2.136.8.146.17.258.3.464.3.176 0 .277-.136.41-.312Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm8.8 6s2.8 1.6 5.1 1.6 4.8-1.6 4.8-1.6-2.2-1.8-4.8-1.8c-2.6 0-5.1 1.8-5.1 1.8Zm5.51-6.212C16.551 9.462 16.897 9 18 9c1.7 0 7.6 6.1 7.7 6.7 0 .5-4.7 7.3-9.8 7.3-5.1 0-9.9-6-9.9-6.8 0-.9 5.1-7.2 7.3-7.2 1.445 0 1.855.475 2.136.8.146.17.258.3.464.3.176 0 .277-.136.41-.312Z",
          fill: "#FF68D1"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  car: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.6 6.3c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4ZM9.3 13c-.1.2 0 .5.3.5h12.1c.3 0 .4-.3.3-.5l-2.6-3.2c-.2-.3-.4-.4-.7-.4h-5.9c-.3 0-.5.2-.7.4L9.3 13Zm4.1 6.4h4.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-4.8c-.5 0-.9.4-.9.9s.4.9.9.9Zm-5-3.1c0 .8.6 1.4 1.4 1.4.8 0 1.5-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4Zm11-8.3c.7 0 1.2.3 1.7 1l3 4.1c.2.4.4.9.4 1.4v7.3c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7V21H10.4v.8c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7v-7.3c0-.5.2-1 .4-1.4L10.5 9c.4-.6.9-1 1.6-1h7.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.6 6.3c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4ZM9.3 13c-.1.2 0 .5.3.5h12.1c.3 0 .4-.3.3-.5l-2.6-3.2c-.2-.3-.4-.4-.7-.4h-5.9c-.3 0-.5.2-.7.4L9.3 13Zm4.1 6.4h4.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-4.8c-.5 0-.9.4-.9.9s.4.9.9.9Zm-5-3.1c0 .8.6 1.4 1.4 1.4.8 0 1.5-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4Zm11-8.3c.7 0 1.2.3 1.7 1l3 4.1c.2.4.4.9.4 1.4v7.3c0 .9-.7 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7V21H10.4v.8c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7v-7.3c0-.5.2-1 .4-1.4L10.5 9c.4-.6.9-1 1.6-1h7.3Z",
          fill: "#FF756C"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "cash-out": {
    pathDefinition: "M10 32C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10H10Zm0-30c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm16 6.245c0-.32-.16-.63-.42-.81-3.968-2.828-7.166-1.381-9.995-.102l-.005.002-.017.008c-2.663 1.207-4.96 2.248-7.983.092a.997.997 0 0 0-1.58.81v11.95c0 .32.16.63.42.81 1.13.81 2.24 1.3 3.4 1.51.06.01.12.02.18.02v.66c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3v-3.31c.77.17 1.56.52 2.42 1.13a.997.997 0 0 0 1.58-.81V8.245Zm-13 15.95c-.55 0-1-.45-1-1v-8c0-.29.13-.57.35-.76.23-.19.52-.28.82-.22.46.08.83.55.83 1.09v4.89c0 .05.011.096.023.14a.78.78 0 0 1 .017.08c-.05.2-.05.42.04.63.22.51.8.74 1.32.52.34-.15.68-.3 1.02-.46 1.24-.56 2.4-1.08 3.59-1.27v3.36c0 .55-.45 1-1 1H13Zm3-5.1v-3.8c0-1.52-1.08-2.83-2.5-3.07a2.998 2.998 0 0 0-3.5 2.96v5.32c-.66-.15-1.32-.42-2-.85v-9.67c3.25 1.51 5.97.28 8.41-.83 2.54-1.16 4.76-2.17 7.59-.38v9.68c-3.07-1.43-5.67-.4-8 .65v-.01Zm.13-7.14c.28-.47.89-.64 1.37-.36a3.006 3.006 0 0 1 1.1 4.1c-.19.32-.52.5-.87.5a1.002 1.002 0 0 1-.87-1.5c.08-.15.13-.32.13-.5 0-.36-.19-.69-.5-.87-.47-.28-.64-.89-.36-1.37Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10H10Zm0-30c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm16 6.245c0-.32-.16-.63-.42-.81-3.968-2.828-7.166-1.381-9.995-.102l-.005.002-.017.008c-2.663 1.207-4.96 2.248-7.983.092a.997.997 0 0 0-1.58.81v11.95c0 .32.16.63.42.81 1.13.81 2.24 1.3 3.4 1.51.06.01.12.02.18.02v.66c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3v-3.31c.77.17 1.56.52 2.42 1.13a.997.997 0 0 0 1.58-.81V8.245Zm-13 15.95c-.55 0-1-.45-1-1v-8c0-.29.13-.57.35-.76.23-.19.52-.28.82-.22.46.08.83.55.83 1.09v4.89c0 .05.011.096.023.14a.78.78 0 0 1 .017.08c-.05.2-.05.42.04.63.22.51.8.74 1.32.52.34-.15.68-.3 1.02-.46 1.24-.56 2.4-1.08 3.59-1.27v3.36c0 .55-.45 1-1 1H13Zm3-5.1v-3.8c0-1.52-1.08-2.83-2.5-3.07a2.998 2.998 0 0 0-3.5 2.96v5.32c-.66-.15-1.32-.42-2-.85v-9.67c3.25 1.51 5.97.28 8.41-.83 2.54-1.16 4.76-2.17 7.59-.38v9.68c-3.07-1.43-5.67-.4-8 .65v-.01Zm.13-7.14c.28-.47.89-.64 1.37-.36a3.006 3.006 0 0 1 1.1 4.1c-.19.32-.52.5-.87.5a1.002 1.002 0 0 1-.87-1.5c.08-.15.13-.32.13-.5 0-.36-.19-.69-.5-.87-.47-.28-.64-.89-.36-1.37Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  cedears: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.2 5.5c-.1.3-.1.7 0 1l.6 1.1c.3.8.3 1.7 0 2.5s-1 1.5-1.8 1.8l-1.1.4c-.3.1-.6.4-.7.7l-.4 1.1c-.4.8-1 1.5-1.8 1.8-.4.1-.8.2-1.2.2-.4 0-.9-.1-1.3-.3l-1-.5c-.3-.1-.7-.1-1 0l-1 .5c-.8.3-1.7.3-2.5 0-.9-.3-1.5-1-1.8-1.8l-.4-1.1c-.1-.3-.4-.6-.7-.7L8 21.8c-.8-.3-1.5-1-1.8-1.8-.4-.8-.4-1.7 0-2.5l.5-1c.1-.3.1-.7 0-1l-.5-1c-.3-.8-.3-1.7 0-2.5s1-1.5 1.8-1.8l1.1-.4c.3-.1.6-.3.7-.7l.3-1.1c.4-.8 1-1.5 1.8-1.8.8-.4 1.7-.4 2.5 0l1 .5c.3.1.7.1 1 0l1-.5c.8-.3 1.7-.3 2.5 0s1.5 1 1.8 1.8l.4 1.1c.1.3.4.6.7.7l1.1.4c.8.4 1.5 1 1.8 1.8.4.8.4 1.7 0 2.5l-.5 1Zm-1.3 2.9-.5-1c-.4-.9-.4-1.8.1-2.6l.5-1c.1-.3.1-.6 0-.9-.2-.4-.4-.6-.7-.7l-1.1-.4c-.9-.4-1.6-1-1.9-1.9l-.4-1.1c-.1-.3-.3-.6-.6-.7-.3-.1-.7-.1-1 .1l-1 .5c-.8.4-1.8.4-2.6 0l-1-.5c-.3-.2-.7-.2-.9-.1-.4.2-.6.4-.7.7l-.4 1.1c-.3.9-.9 1.6-1.8 1.9l-1.1.4c-.3.2-.6.4-.7.7-.1.3-.1.6 0 .9l.5 1c.4.8.4 1.8 0 2.6l-.5 1c-.1.3-.1.6 0 1 .2.3.4.5.7.6l1 .3c.9.3 1.6.9 1.9 1.8l.4 1.1c.2.3.4.6.7.7.3.1.6.1.9 0l1-.5c.4-.2.9-.3 1.3-.3s.9.1 1.3.3l1 .5c.3.1.6.1.9 0 .3-.2.5-.4.6-.7l.4-1.1c.4-.8 1-1.5 1.9-1.8l1.1-.4c.3-.1.6-.3.7-.6.1-.3.1-.6 0-.9Zm-8.5-3.8c.2.2.6.4 1.3.6.344.115.644.244.9.354.415.179.715.308.9.246.3.5.4 1 .4 1.5 0 .8-.3 1.3-.7 1.7-.4.4-.9.6-1.4.7v.3c0 .4-.4.6-.8.6-.3 0-.8-.2-.8-.6v-.3c-.5-.1-.9-.3-1.3-.7-.4-.3-.7-.9-.8-1.5-.1-.2-.1-.5.1-.7.2-.2.4-.3.7-.3.3 0 .6.2.7.5.2.5.4.9.6 1.1.2.2.5.3.9.3s.7-.1.9-.2c.2-.1.3-.3.3-.6 0-.2-.1-.4-.3-.6-.2-.1-.6-.3-1.2-.5-.8-.3-1.4-.6-1.8-1-.4-.4-.6-.9-.6-1.5 0-.5.2-1 .5-1.4.3-.4.7-.6 1.3-.8v-.4c0-.4.4-.6.8-.6s.8.2.9.6v.4c.4.1.8.3 1.1.6.3.3.6.7.7 1.2.1.3 0 .6-.1.7-.2.3-.5.4-.8.4-.3 0-.6-.2-.6-.5s-.2-.5-.4-.7c-.2-.1-.5-.2-.8-.2-.3 0-.5.1-.7.2-.1.1-.2.3-.2.5 0 .3.1.5.3.6Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.2 5.5c-.1.3-.1.7 0 1l.6 1.1c.3.8.3 1.7 0 2.5s-1 1.5-1.8 1.8l-1.1.4c-.3.1-.6.4-.7.7l-.4 1.1c-.4.8-1 1.5-1.8 1.8-.4.1-.8.2-1.2.2-.4 0-.9-.1-1.3-.3l-1-.5c-.3-.1-.7-.1-1 0l-1 .5c-.8.3-1.7.3-2.5 0-.9-.3-1.5-1-1.8-1.8l-.4-1.1c-.1-.3-.4-.6-.7-.7L8 21.8c-.8-.3-1.5-1-1.8-1.8-.4-.8-.4-1.7 0-2.5l.5-1c.1-.3.1-.7 0-1l-.5-1c-.3-.8-.3-1.7 0-2.5s1-1.5 1.8-1.8l1.1-.4c.3-.1.6-.3.7-.7l.3-1.1c.4-.8 1-1.5 1.8-1.8.8-.4 1.7-.4 2.5 0l1 .5c.3.1.7.1 1 0l1-.5c.8-.3 1.7-.3 2.5 0s1.5 1 1.8 1.8l.4 1.1c.1.3.4.6.7.7l1.1.4c.8.4 1.5 1 1.8 1.8.4.8.4 1.7 0 2.5l-.5 1Zm-1.3 2.9-.5-1c-.4-.9-.4-1.8.1-2.6l.5-1c.1-.3.1-.6 0-.9-.2-.4-.4-.6-.7-.7l-1.1-.4c-.9-.4-1.6-1-1.9-1.9l-.4-1.1c-.1-.3-.3-.6-.6-.7-.3-.1-.7-.1-1 .1l-1 .5c-.8.4-1.8.4-2.6 0l-1-.5c-.3-.2-.7-.2-.9-.1-.4.2-.6.4-.7.7l-.4 1.1c-.3.9-.9 1.6-1.8 1.9l-1.1.4c-.3.2-.6.4-.7.7-.1.3-.1.6 0 .9l.5 1c.4.8.4 1.8 0 2.6l-.5 1c-.1.3-.1.6 0 1 .2.3.4.5.7.6l1 .3c.9.3 1.6.9 1.9 1.8l.4 1.1c.2.3.4.6.7.7.3.1.6.1.9 0l1-.5c.4-.2.9-.3 1.3-.3s.9.1 1.3.3l1 .5c.3.1.6.1.9 0 .3-.2.5-.4.6-.7l.4-1.1c.4-.8 1-1.5 1.9-1.8l1.1-.4c.3-.1.6-.3.7-.6.1-.3.1-.6 0-.9Zm-8.5-3.8c.2.2.6.4 1.3.6.344.115.644.244.9.354.415.179.715.308.9.246.3.5.4 1 .4 1.5 0 .8-.3 1.3-.7 1.7-.4.4-.9.6-1.4.7v.3c0 .4-.4.6-.8.6-.3 0-.8-.2-.8-.6v-.3c-.5-.1-.9-.3-1.3-.7-.4-.3-.7-.9-.8-1.5-.1-.2-.1-.5.1-.7.2-.2.4-.3.7-.3.3 0 .6.2.7.5.2.5.4.9.6 1.1.2.2.5.3.9.3s.7-.1.9-.2c.2-.1.3-.3.3-.6 0-.2-.1-.4-.3-.6-.2-.1-.6-.3-1.2-.5-.8-.3-1.4-.6-1.8-1-.4-.4-.6-.9-.6-1.5 0-.5.2-1 .5-1.4.3-.4.7-.6 1.3-.8v-.4c0-.4.4-.6.8-.6s.8.2.9.6v.4c.4.1.8.3 1.1.6.3.3.6.7.7 1.2.1.3 0 .6-.1.7-.2.3-.5.4-.8.4-.3 0-.6-.2-.6-.5s-.2-.5-.4-.7c-.2-.1-.5-.2-.8-.2-.3 0-.5.1-.7.2-.1.1-.2.3-.2.5 0 .3.1.5.3.6Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  check: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10.9 11.1c.3.3.7.4 1.1.4.4 0 .8-.1.9-.4l9-9c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0l-7.9 7.9L11 15c-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1l4 4Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10.9 11.1c.3.3.7.4 1.1.4.4 0 .8-.1.9-.4l9-9c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0l-7.9 7.9L11 15c-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1l4 4Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  crypto: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.5-3.9 8 4c.3.2.5.5.5.9v10c0 .4-.2.7-.5.9l-8 4c-.2.1-.3.1-.5.1s-.3 0-.4-.1l-8-4c-.4-.2-.6-.5-.6-.9V11c0-.4.2-.7.6-.9l8-4c.3-.1.6-.1.9 0ZM9 20.4l7 3.5 7-3.5v-8.8l-7-3.5-7 3.5v8.8Zm2.5-6.5c0-.4.2-.7.5-.9l3.5-1.9c.3-.1.6-.1.9 0l3 1.6c.5.3.6.9.4 1.4-.2.5-.8.7-1.3.4L16 13.2l-2.6 1.3v3.1l2.6 1.3 2.6-1.3c.4-.3 1-.1 1.3.4.3.4.1 1-.4 1.3l-3 1.6c-.2.1-.3.1-.5.1h-.4L12 19.1c-.3-.2-.5-.5-.5-.9v-4.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.5-3.9 8 4c.3.2.5.5.5.9v10c0 .4-.2.7-.5.9l-8 4c-.2.1-.3.1-.5.1s-.3 0-.4-.1l-8-4c-.4-.2-.6-.5-.6-.9V11c0-.4.2-.7.6-.9l8-4c.3-.1.6-.1.9 0ZM9 20.4l7 3.5 7-3.5v-8.8l-7-3.5-7 3.5v8.8Zm2.5-6.5c0-.4.2-.7.5-.9l3.5-1.9c.3-.1.6-.1.9 0l3 1.6c.5.3.6.9.4 1.4-.2.5-.8.7-1.3.4L16 13.2l-2.6 1.3v3.1l2.6 1.3 2.6-1.3c.4-.3 1-.1 1.3.4.3.4.1 1-.4 1.3l-3 1.6c-.2.1-.3.1-.5.1h-.4L12 19.1c-.3-.2-.5-.5-.5-.9v-4.3Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  decrease: {
    pathDefinition: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm6 15.3c-.33 0-.67-.13-.92-.38l-6.5-6.5c-.51-.51-.51-1.33 0-1.84s1.33-.51 1.84 0L16 14.16l5.58-5.58c.51-.51 1.33-.51 1.84 0s.51 1.33 0 1.84l-6.5 6.5c-.25.25-.59.38-.92.38Zm-.92 6.63c.25.25.59.38.92.38.33 0 .67-.13.92-.38l6.5-6.5c.51-.51.51-1.33 0-1.84s-1.33-.51-1.84 0L16 21.17l-5.58-5.58c-.51-.51-1.33-.51-1.84 0s-.51 1.33 0 1.84l6.5 6.5Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm6 15.3c-.33 0-.67-.13-.92-.38l-6.5-6.5c-.51-.51-.51-1.33 0-1.84s1.33-.51 1.84 0L16 14.16l5.58-5.58c.51-.51 1.33-.51 1.84 0s.51 1.33 0 1.84l-6.5 6.5c-.25.25-.59.38-.92.38Zm-.92 6.63c.25.25.59.38.92.38.33 0 .67-.13.92-.38l6.5-6.5c.51-.51.51-1.33 0-1.84s-1.33-.51-1.84 0L16 21.17l-5.58-5.58c-.51-.51-1.33-.51-1.84 0s-.51 1.33 0 1.84l6.5 6.5Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("rect", {
            width: "32",
            height: "32",
            rx: "10",
            fill: "#fff"
          })
        })
      })]
    })
  },
  "dollar-mep-in": {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.585-.472c2.829-1.279 6.027-2.726 9.995.103h-.01c.26.18.42.49.42.81v11.99c0 .38-.21.72-.54.89-.34.16-.74.14-1.04-.08-3.023-2.156-5.32-1.115-7.983.092l-.017.008c-1.62.74-3.38 1.54-5.33 1.54-1.43 0-2.98-.43-4.66-1.63a.995.995 0 0 1-.42-.81v-12a.997.997 0 0 1 1.58-.81c3.023 2.155 5.32 1.114 7.983-.093l.017-.007.005-.003Zm.039 11.987c2.43-1.096 5.14-2.317 8.376-.814v-9.72c-2.83-1.78-5.05-.78-7.59.38-2.44 1.11-5.16 2.34-8.41.83v9.72c2.83 1.79 5.05.78 7.59-.38l.034-.015Zm-.264-6.204c.19.13.55.29 1.08.47h-.01c.71.24 1.19.55 1.43.91s.36.76.36 1.19c0 .63-.19 1.1-.55 1.39-.33.27-.71.45-1.13.54v.24c-.03.35-.37.51-.69.51-.32 0-.67-.15-.7-.51v-.26c-.37-.1-.71-.29-1.01-.58-.32-.31-.54-.73-.65-1.25-.05-.23 0-.45.13-.61.14-.17.36-.27.58-.27.26 0 .48.14.59.39.09.39.24.67.44.84.2.17.43.25.71.25.3 0 .53-.06.68-.17.14-.1.21-.27.21-.5a.58.58 0 0 0-.25-.48c-.18-.14-.5-.29-.95-.44-.68-.23-1.17-.51-1.46-.81-.3-.31-.45-.72-.45-1.21 0-.4.13-.77.38-1.11.24-.32.6-.55 1.08-.68v-.33c.02-.35.36-.51.68-.51.32 0 .67.15.71.51v.31c.34.06.63.21.88.45.27.26.47.59.59 1 .09.27 0 .47-.08.58-.14.19-.39.31-.65.31-.29 0-.5-.16-.53-.39-.07-.22-.19-.39-.35-.52-.16-.13-.37-.19-.62-.19a.89.89 0 0 0-.52.14c-.12.08-.18.2-.18.35 0 .18.08.32.25.44Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.585-.472c2.829-1.279 6.027-2.726 9.995.103h-.01c.26.18.42.49.42.81v11.99c0 .38-.21.72-.54.89-.34.16-.74.14-1.04-.08-3.023-2.156-5.32-1.115-7.983.092l-.017.008c-1.62.74-3.38 1.54-5.33 1.54-1.43 0-2.98-.43-4.66-1.63a.995.995 0 0 1-.42-.81v-12a.997.997 0 0 1 1.58-.81c3.023 2.155 5.32 1.114 7.983-.093l.017-.007.005-.003Zm.039 11.987c2.43-1.096 5.14-2.317 8.376-.814v-9.72c-2.83-1.78-5.05-.78-7.59.38-2.44 1.11-5.16 2.34-8.41.83v9.72c2.83 1.79 5.05.78 7.59-.38l.034-.015Zm-.264-6.204c.19.13.55.29 1.08.47h-.01c.71.24 1.19.55 1.43.91s.36.76.36 1.19c0 .63-.19 1.1-.55 1.39-.33.27-.71.45-1.13.54v.24c-.03.35-.37.51-.69.51-.32 0-.67-.15-.7-.51v-.26c-.37-.1-.71-.29-1.01-.58-.32-.31-.54-.73-.65-1.25-.05-.23 0-.45.13-.61.14-.17.36-.27.58-.27.26 0 .48.14.59.39.09.39.24.67.44.84.2.17.43.25.71.25.3 0 .53-.06.68-.17.14-.1.21-.27.21-.5a.58.58 0 0 0-.25-.48c-.18-.14-.5-.29-.95-.44-.68-.23-1.17-.51-1.46-.81-.3-.31-.45-.72-.45-1.21 0-.4.13-.77.38-1.11.24-.32.6-.55 1.08-.68v-.33c.02-.35.36-.51.68-.51.32 0 .67.15.71.51v.31c.34.06.63.21.88.45.27.26.47.59.59 1 .09.27 0 .47-.08.58-.14.19-.39.31-.65.31-.29 0-.5-.16-.53-.39-.07-.22-.19-.39-.35-.52-.16-.13-.37-.19-.62-.19a.89.89 0 0 0-.52.14c-.12.08-.18.2-.18.35 0 .18.08.32.25.44Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "dollar-mep": {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.6-.9c2.8-1.3 6-2.7 10 .1.2.2.4.5.3.8v12c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.154-5.202-1.145-7.83.024l-.17.076-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8V10c0-.4.1-.7.5-.9.4-.2.8-.1 1.1.1 2.937 2.154 5.202 1.145 7.83-.024l.17-.076Zm0 12c2.4-1.1 5.2-2.3 8.4-.8v-9.7c-2.8-1.8-5.1-.8-7.6.4-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4Zm.421-5.943c.118.043.245.09.379.143.7.3 1.2.6 1.2 1.1.3.4.4.8.4 1.2 0 .6-.1 1.1-.5 1.4-.3.2-.7.4-1.1.5v.2c0 .3-.4.5-.7.5-.3 0-.7-.1-.7-.5v-.3c-.4-.1-.7-.3-1-.6-.4-.3-.6-.7-.7-1.2-.1-.2 0-.4.1-.6.2-.2.4-.3.6-.3.3 0 .5.2.6.4.1.3.2.6.4.8.2.1.4.2.7.2.3 0 .5-.1.7-.2.1-.1.2-.3.2-.5s0-.4-.2-.5c-.1-.1-.5-.3-.9-.4-.7-.2-1.2-.5-1.5-.8-.3-.3-.4-.7-.4-1.2 0-.4.2-.8.4-1.1.3-.3.6-.6 1.1-.7v-.3c0-.3.4-.5.7-.5.3 0 .7.1.7.5v.3c.4 0 .7.2.9.4.3.3.5.6.6 1 .1.3 0 .5-.1.6-.1.2-.3.3-.6.3s-.5-.2-.5-.4c-.1-.2-.3-.4-.4-.5-.1-.1-.4-.2-.6-.2-.2 0-.4 0-.5.1-.1.1-.2.2-.2.4 0 .1 0 .3.2.4.146.146.4.24.721.357Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.6-.9c2.8-1.3 6-2.7 10 .1.2.2.4.5.3.8v12c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.154-5.202-1.145-7.83.024l-.17.076-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8V10c0-.4.1-.7.5-.9.4-.2.8-.1 1.1.1 2.937 2.154 5.202 1.145 7.83-.024l.17-.076Zm0 12c2.4-1.1 5.2-2.3 8.4-.8v-9.7c-2.8-1.8-5.1-.8-7.6.4-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4Zm.421-5.943c.118.043.245.09.379.143.7.3 1.2.6 1.2 1.1.3.4.4.8.4 1.2 0 .6-.1 1.1-.5 1.4-.3.2-.7.4-1.1.5v.2c0 .3-.4.5-.7.5-.3 0-.7-.1-.7-.5v-.3c-.4-.1-.7-.3-1-.6-.4-.3-.6-.7-.7-1.2-.1-.2 0-.4.1-.6.2-.2.4-.3.6-.3.3 0 .5.2.6.4.1.3.2.6.4.8.2.1.4.2.7.2.3 0 .5-.1.7-.2.1-.1.2-.3.2-.5s0-.4-.2-.5c-.1-.1-.5-.3-.9-.4-.7-.2-1.2-.5-1.5-.8-.3-.3-.4-.7-.4-1.2 0-.4.2-.8.4-1.1.3-.3.6-.6 1.1-.7v-.3c0-.3.4-.5.7-.5.3 0 .7.1.7.5v.3c.4 0 .7.2.9.4.3.3.5.6.6 1 .1.3 0 .5-.1.6-.1.2-.3.3-.6.3s-.5-.2-.5-.4c-.1-.2-.3-.4-.4-.5-.1-.1-.4-.2-.6-.2-.2 0-.4 0-.5.1-.1.1-.2.2-.2.4 0 .1 0 .3.2.4.146.146.4.24.721.357Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "due-primary": {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.005-3.22c0-.55-.45-1-1-1s-1 .45-1 1h-3c0-.55-.45-1-1-1s-1 .45-1 1h-3c0-.55-.45-1-1-1s-1 .45-1 1c-2.2 0-4 1.79-4 4v13c0 .32.16.63.42.81 1.68 1.2 3.23 1.63 4.66 1.63 1.95 0 3.71-.8 5.33-1.54l.017-.008c2.663-1.207 4.96-2.247 7.983-.092a.997.997 0 0 0 1.58-.81V10.78c0-2.21-1.79-4-4-4h.01Zm-12 2v.44c0 .55.45 1 1 1s1-.45 1-1v-.44h3v.44c0 .55.45 1 1 1s1-.45 1-1v-.44h3v.44c0 .55.45 1 1 1s1-.45 1-1v-.44c1.1 0 2 .9 2 2v1h-16v-1c0-1.1.9-2 2-2Zm5.59 14.09c-2.54 1.16-4.76 2.16-7.59.38v-9.47h16v8.25c-3.24-1.5-5.937-.285-8.366.81l-.044.02v.01Zm-1.79-3.85c-.24-.36-.72-.67-1.42-.91-.53-.18-.89-.34-1.07-.47-.17-.12-.25-.26-.25-.44 0-.15.06-.26.18-.35.13-.09.3-.14.52-.14.25 0 .46.06.62.19.16.13.28.3.34.52.03.23.24.39.53.39.26 0 .51-.12.65-.31a.62.62 0 0 0 .08-.58c-.12-.41-.32-.74-.59-1-.25-.24-.54-.38-.87-.44v-.31c-.04-.35-.39-.51-.7-.51-.31 0-.66.16-.67.51v.32c-.48.13-.84.36-1.08.68-.25.34-.38.71-.38 1.1 0 .49.15.9.45 1.21.29.3.78.57 1.45.81.45.15.76.3.95.44.17.13.25.29.25.48 0 .23-.07.4-.21.5-.15.11-.38.17-.67.17-.28 0-.51-.08-.71-.25-.2-.17-.35-.45-.44-.84a.627.627 0 0 0-.59-.39c-.22 0-.44.1-.57.27-.13.16-.18.38-.13.61.11.52.33.94.65 1.25.3.29.63.48 1 .58v.26c.03.35.38.51.69.51.31 0 .66-.16.68-.51v-.24c.42-.09.8-.27 1.13-.54.36-.29.54-.76.54-1.38 0-.43-.12-.83-.36-1.19Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.005-3.22c0-.55-.45-1-1-1s-1 .45-1 1h-3c0-.55-.45-1-1-1s-1 .45-1 1h-3c0-.55-.45-1-1-1s-1 .45-1 1c-2.2 0-4 1.79-4 4v13c0 .32.16.63.42.81 1.68 1.2 3.23 1.63 4.66 1.63 1.95 0 3.71-.8 5.33-1.54l.017-.008c2.663-1.207 4.96-2.247 7.983-.092a.997.997 0 0 0 1.58-.81V10.78c0-2.21-1.79-4-4-4h.01Zm-12 2v.44c0 .55.45 1 1 1s1-.45 1-1v-.44h3v.44c0 .55.45 1 1 1s1-.45 1-1v-.44h3v.44c0 .55.45 1 1 1s1-.45 1-1v-.44c1.1 0 2 .9 2 2v1h-16v-1c0-1.1.9-2 2-2Zm5.59 14.09c-2.54 1.16-4.76 2.16-7.59.38v-9.47h16v8.25c-3.24-1.5-5.937-.285-8.366.81l-.044.02v.01Zm-1.79-3.85c-.24-.36-.72-.67-1.42-.91-.53-.18-.89-.34-1.07-.47-.17-.12-.25-.26-.25-.44 0-.15.06-.26.18-.35.13-.09.3-.14.52-.14.25 0 .46.06.62.19.16.13.28.3.34.52.03.23.24.39.53.39.26 0 .51-.12.65-.31a.62.62 0 0 0 .08-.58c-.12-.41-.32-.74-.59-1-.25-.24-.54-.38-.87-.44v-.31c-.04-.35-.39-.51-.7-.51-.31 0-.66.16-.67.51v.32c-.48.13-.84.36-1.08.68-.25.34-.38.71-.38 1.1 0 .49.15.9.45 1.21.29.3.78.57 1.45.81.45.15.76.3.95.44.17.13.25.29.25.48 0 .23-.07.4-.21.5-.15.11-.38.17-.67.17-.28 0-.51-.08-.71-.25-.2-.17-.35-.45-.44-.84a.627.627 0 0 0-.59-.39c-.22 0-.44.1-.57.27-.13.16-.18.38-.13.61.11.52.33.94.65 1.25.3.29.63.48 1 .58v.26c.03.35.38.51.69.51.31 0 .66-.16.68-.51v-.24c.42-.09.8-.27 1.13-.54.36-.29.54-.76.54-1.38 0-.43-.12-.83-.36-1.19Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  education: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.9 6.8c.1-.2.1-.5 0-.8l-.3-.8v-2.7c.3-.5.1-1.3-.6-1.5l-9-2.9c-.2-.1-.5-.1-.8-.1l-8.6 2.9c-.9.3-.9 1.5 0 1.9l8.6 3.2c.2.1.5.1.8 0l8.5-3v2.1l-.4.8c-.1.3-.1.6 0 .9l.4.9c.1.2.3.3.5.3s.4-.1.5-.3l.4-.9Zm-3.8-1-5.9 2.1c-.2 0-.4 0-.6.1l-6.1-2.3c-.5-.2-1 .1-1 .6v4.4c0 .4.3.8.7.9l6.1 2.3c.3.1.5.1.8 0l6.3-2.3c.4-.1.7-.5.7-.9v-4.3c0-.4-.5-.8-1-.6Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.9 6.8c.1-.2.1-.5 0-.8l-.3-.8v-2.7c.3-.5.1-1.3-.6-1.5l-9-2.9c-.2-.1-.5-.1-.8-.1l-8.6 2.9c-.9.3-.9 1.5 0 1.9l8.6 3.2c.2.1.5.1.8 0l8.5-3v2.1l-.4.8c-.1.3-.1.6 0 .9l.4.9c.1.2.3.3.5.3s.4-.1.5-.3l.4-.9Zm-3.8-1-5.9 2.1c-.2 0-.4 0-.6.1l-6.1-2.3c-.5-.2-1 .1-1 .6v4.4c0 .4.3.8.7.9l6.1 2.3c.3.1.5.1.8 0l6.3-2.3c.4-.1.7-.5.7-.9v-4.3c0-.4-.5-.8-1-.6Z",
          fill: "#02BDFA"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  electricity: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.2-1.5v5.3c0 .3.2.5.4.5h4c.4 0 .6.4.4.7l-5.3 8.8c-.3.4-.9.3-.9-.2v-5.4c0-.3-.2-.5-.5-.5h-3.8c-.4 0-.6-.4-.4-.7l5.2-8.7c.3-.4.9-.3.9.2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.2-1.5v5.3c0 .3.2.5.4.5h4c.4 0 .6.4.4.7l-5.3 8.8c-.3.4-.9.3-.9-.2v-5.4c0-.3-.2-.5-.5-.5h-3.8c-.4 0-.6-.4-.4-.7l5.2-8.7c.3-.4.9-.3.9.2Z",
          fill: "#FFA800"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  entertainment: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.9 7.5 4-6.4c.2-.5.1-1.1-.4-1.4-.3-.2-.8-.2-1.1.1-.5.5-1.4.6-2.1.2-.7-.4-1-1.2-.9-1.9.1-.4-.1-.8-.5-1-.5-.2-1.1-.1-1.4.4l-1.8 2.9 4.2 7.1Zm-5 7.3c.3-.2.6-.6.5-1-.1-.8.2-1.7 1-2 .7-.4 1.7-.3 2.3.2.4.3.8.3 1.2.1.5-.3.7-.9.4-1.4l-7.2-12c-.3-.5-.9-.7-1.4-.4h-.1c-.3.2-.6.6-.5 1 .1.8-.2 1.7-1 2.1-.7.5-1.7.3-2.3-.2-.4-.3-.8-.3-1.2-.1h-.1c-.5.3-.7.9-.4 1.4l7.2 12c.3.5.9.7 1.4.4l.2-.1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.9 7.5 4-6.4c.2-.5.1-1.1-.4-1.4-.3-.2-.8-.2-1.1.1-.5.5-1.4.6-2.1.2-.7-.4-1-1.2-.9-1.9.1-.4-.1-.8-.5-1-.5-.2-1.1-.1-1.4.4l-1.8 2.9 4.2 7.1Zm-5 7.3c.3-.2.6-.6.5-1-.1-.8.2-1.7 1-2 .7-.4 1.7-.3 2.3.2.4.3.8.3 1.2.1.5-.3.7-.9.4-1.4l-7.2-12c-.3-.5-.9-.7-1.4-.4h-.1c-.3.2-.6.6-.5 1 .1.8-.2 1.7-1 2.1-.7.5-1.7.3-2.3-.2-.4-.3-.8-.3-1.2-.1h-.1c-.5.3-.7.9-.4 1.4l7.2 12c.3.5.9.7 1.4.4l.2-.1Z",
          fill: "#8E73FD"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  fci: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.9 4.8 1.2 4c.6 2.6-.2 4.1-.9 4.9-1.1 1.4-3 2.2-5.2 2.2h-4c-2.2 0-4.1-.8-5.2-2.2-.8-.9-1.5-2.5-1-5L9 14.6c.4-1.4 1.4-3.6 4.5-4.4l-1.4-2.8c-.2-.4-.1-.9.2-1.1.3-.3.8-.3 1.2-.1 1 .6 1.2.5 1.9 0l.12-.075c.799-.507 1.982-1.257 3.98.075.4.3.5.9.3 1.3l-1.4 2.8c3.1.8 4.1 3.1 4.5 4.5Zm-6.3-6.9c-.5.3-1 .6-1.7.7l.7 1.4h.8l1.3-2.5c-.33-.083-.525.04-.865.254-.07.045-.148.094-.235.146ZM18 24c1.6 0 2.9-.5 3.6-1.4.7-.8.9-1.9.6-3.2l-1.2-4c-.5-2.2-2.2-3.3-5-3.3s-4.4 1-5 3.2l-1.2 4.1c-.3 1.3-.1 2.4.6 3.2.7.9 2 1.4 3.6 1.4h4Zm-1.779-6.643c.118.043.245.09.379.143.7.2 1.2.5 1.3 1.1.3.4.4.8.4 1.2 0 .6-.2 1.1-.6 1.4-.3.2-.7.4-1.1.5v.2c0 .3-.4.5-.7.5-.3 0-.7-.1-.7-.5v-.3c-.4-.1-.7-.3-1-.6-.3-.3-.5-.7-.6-1.2-.1-.2 0-.4.1-.6.2-.2.4-.3.6-.3.3 0 .5.2.6.4 0 .4.2.7.4.8.2.1.4.2.7.2.3 0 .6-.1.7-.2.1-.1.2-.3.2-.5s0-.4-.2-.5c-.1-.1-.5-.3-.9-.4-.7-.2-1.2-.5-1.5-.8-.2-.3-.4-.7-.4-1.2 0-.4.2-.8.4-1.1.3-.3.6-.6 1.1-.7v-.3c0-.3.4-.5.7-.5.3 0 .7.1.7.5v.3c.4.1.7.3.9.5.3.3.5.6.6 1 .1.3 0 .5-.1.6-.2.2-.4.3-.7.3-.3 0-.5-.2-.5-.4-.1-.2-.3-.4-.4-.5-.1-.1-.4-.2-.6-.2-.2 0-.4 0-.5.1-.1 0-.2.2-.2.3 0 .1 0 .3.2.4.146.146.4.24.721.357Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.9 4.8 1.2 4c.6 2.6-.2 4.1-.9 4.9-1.1 1.4-3 2.2-5.2 2.2h-4c-2.2 0-4.1-.8-5.2-2.2-.8-.9-1.5-2.5-1-5L9 14.6c.4-1.4 1.4-3.6 4.5-4.4l-1.4-2.8c-.2-.4-.1-.9.2-1.1.3-.3.8-.3 1.2-.1 1 .6 1.2.5 1.9 0l.12-.075c.799-.507 1.982-1.257 3.98.075.4.3.5.9.3 1.3l-1.4 2.8c3.1.8 4.1 3.1 4.5 4.5Zm-6.3-6.9c-.5.3-1 .6-1.7.7l.7 1.4h.8l1.3-2.5c-.33-.083-.525.04-.865.254-.07.045-.148.094-.235.146ZM18 24c1.6 0 2.9-.5 3.6-1.4.7-.8.9-1.9.6-3.2l-1.2-4c-.5-2.2-2.2-3.3-5-3.3s-4.4 1-5 3.2l-1.2 4.1c-.3 1.3-.1 2.4.6 3.2.7.9 2 1.4 3.6 1.4h4Zm-1.779-6.643c.118.043.245.09.379.143.7.2 1.2.5 1.3 1.1.3.4.4.8.4 1.2 0 .6-.2 1.1-.6 1.4-.3.2-.7.4-1.1.5v.2c0 .3-.4.5-.7.5-.3 0-.7-.1-.7-.5v-.3c-.4-.1-.7-.3-1-.6-.3-.3-.5-.7-.6-1.2-.1-.2 0-.4.1-.6.2-.2.4-.3.6-.3.3 0 .5.2.6.4 0 .4.2.7.4.8.2.1.4.2.7.2.3 0 .6-.1.7-.2.1-.1.2-.3.2-.5s0-.4-.2-.5c-.1-.1-.5-.3-.9-.4-.7-.2-1.2-.5-1.5-.8-.2-.3-.4-.7-.4-1.2 0-.4.2-.8.4-1.1.3-.3.6-.6 1.1-.7v-.3c0-.3.4-.5.7-.5.3 0 .7.1.7.5v.3c.4.1.7.3.9.5.3.3.5.6.6 1 .1.3 0 .5-.1.6-.2.2-.4.3-.7.3-.3 0-.5-.2-.5-.4-.1-.2-.3-.4-.4-.5-.1-.1-.4-.2-.6-.2-.2 0-.4 0-.5.1-.1 0-.2.2-.2.3 0 .1 0 .3.2.4.146.146.4.24.721.357Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "finance-primary": {
    pathDefinition: "M32 22c0 5.5-4.5 10-10 10H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm14 11.9H8c-.43 0-.81-.28-.95-.68-.14-.41 0-.86.35-1.12l8-6a.99.99 0 0 1 1.2 0l8 6c.34.26.49.71.35 1.12a1 1 0 0 1-.95.68Zm-13-2h10l-5-3.75-5 3.75Zm-1 7c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v3Zm11 1c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1Zm-13 2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1Zm18 3c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1Zm-11-6c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M32 22c0 5.5-4.5 10-10 10H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm14 11.9H8c-.43 0-.81-.28-.95-.68-.14-.41 0-.86.35-1.12l8-6a.99.99 0 0 1 1.2 0l8 6c.34.26.49.71.35 1.12a1 1 0 0 1-.95.68Zm-13-2h10l-5-3.75-5 3.75Zm-1 7c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v3Zm11 1c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1Zm-13 2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1Zm18 3c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1Zm-11-6c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v3Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  finance: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17.8 12.4h-2.6v-6.6h2.6v6.6Zm-4.9 0h-2.4v-6.6h2.4v6.6Zm1.1-12-5.7 2.8v.2h11.4v-.2L16 10.4Zm8.1 4.2c0 .7-.6 1.2-1.2 1.2h-.8v6.6h.9c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2H9.2c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h1v-6.6h-1c-.7 0-1.2-.6-1.2-1.2v-2.2c0-.4.3-.8.7-1l6.9-3.3c.3-.2.7-.2 1 0l6.9 3.4c.4.2.6.6.6 1v2.1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17.8 12.4h-2.6v-6.6h2.6v6.6Zm-4.9 0h-2.4v-6.6h2.4v6.6Zm1.1-12-5.7 2.8v.2h11.4v-.2L16 10.4Zm8.1 4.2c0 .7-.6 1.2-1.2 1.2h-.8v6.6h.9c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2H9.2c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h1v-6.6h-1c-.7 0-1.2-.6-1.2-1.2v-2.2c0-.4.3-.8.7-1l6.9-3.3c.3-.2.7-.2 1 0l6.9 3.4c.4.2.6.6.6 1v2.1Z",
          fill: "#53C866"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  forward: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15 13.3a1.298 1.298 0 0 1-.92-2.22l3.78-3.78H9c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3h10.86l-3.78-3.78c-.51-.51-.51-1.33 0-1.84s1.33-.51 1.84 0l6 6c.506.506.51 1.317.012 1.828l-.014.014-5.998 5.998c-.25.25-.59.38-.92.38Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15 13.3a1.298 1.298 0 0 1-.92-2.22l3.78-3.78H9c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3h10.86l-3.78-3.78c-.51-.51-.51-1.33 0-1.84s1.33-.51 1.84 0l6 6c.506.506.51 1.317.012 1.828l-.014.014-5.998 5.998c-.25.25-.59.38-.92.38Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("rect", {
            width: "32",
            height: "32",
            rx: "10",
            fill: "#fff"
          })
        })
      })]
    })
  },
  games: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14 .02c-.782 0-1.284-.217-1.826-.451C13.543 9.296 12.858 9 11.615 9 7.435 9 7 17.942 7 19.877 7 21.813 8.296 23 9.363 23c1.56 0 2.241-.888 2.955-1.817.786-1.023 1.61-2.096 3.682-2.096s2.896 1.073 3.682 2.096c.714.93 1.396 1.817 2.955 1.817C23.703 23 25 21.813 25 19.877 25 17.942 24.566 9 20.384 9c-1.243 0-1.928.296-2.56.569-.54.234-1.043.45-1.824.45Zm-1.791 5.773H12.79v1.416a.79.79 0 1 1-1.582 0v-1.416H9.79a.791.791 0 0 1 0-1.583h1.418v-1.419a.791.791 0 0 1 1.582 0v1.42h1.418a.79.79 0 1 1 0 1.582ZM20 14a1 1 0 1 1 .001-1.999A1 1 0 0 1 20 14Zm-3 1a1 1 0 1 0 1.998 0A1 1 0 0 0 17 15Zm4 0a1 1 0 1 0 1.998 0A1 1 0 0 0 21 15Zm-2 2a1 1 0 1 0 1.998 0A1 1 0 0 0 19 17Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14 .02c-.782 0-1.284-.217-1.826-.451C13.543 9.296 12.858 9 11.615 9 7.435 9 7 17.942 7 19.877 7 21.813 8.296 23 9.363 23c1.56 0 2.241-.888 2.955-1.817.786-1.023 1.61-2.096 3.682-2.096s2.896 1.073 3.682 2.096c.714.93 1.396 1.817 2.955 1.817C23.703 23 25 21.813 25 19.877 25 17.942 24.566 9 20.384 9c-1.243 0-1.928.296-2.56.569-.54.234-1.043.45-1.824.45Zm-1.791 5.773H12.79v1.416a.79.79 0 1 1-1.582 0v-1.416H9.79a.791.791 0 0 1 0-1.583h1.418v-1.419a.791.791 0 0 1 1.582 0v1.42h1.418a.79.79 0 1 1 0 1.582ZM20 14a1 1 0 1 1 .001-1.999A1 1 0 0 1 20 14Zm-3 1a1 1 0 1 0 1.998 0A1 1 0 0 0 17 15Zm4 0a1 1 0 1 0 1.998 0A1 1 0 0 0 21 15Zm-2 2a1 1 0 1 0 1.998 0A1 1 0 0 0 19 17Z",
          fill: "#8E73FD"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  gaming: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm11.1-1.8L11.9 7C9.7 8 8 9.9 7 12.2l1.2 1.2c.8-2.4 2.6-4.3 4.9-5.2Zm7-1.2-1.2 1.2c2.3.9 4.1 2.7 4.9 5.2l1.2-1.2C24 9.9 22.3 8 20.1 7ZM8.3 18.9l-1.2 1.2c1 2.2 2.8 4 5.1 4.9l1.2-1.2c-2.3-.8-4.1-2.6-5.1-4.9ZM19.7 25l-1.2-1.2c2.4-.8 4.2-2.6 5.1-4.9l1.2 1.2C23.7 22.3 22 24 19.7 25Zm-1.1-7c-1 0-1.3-.8-1.3-.8s-.4.3-.6 1.3c0 1.1 2.2.9 2.2.9v.9h-6v-.9s2.2.2 2.2-.9c0-1-.4-1.3-.4-1.3s-.1.8-1.2.8c-1 0-1.8-.8-1.8-1.8 0-2.3 4.3-4.6 4.3-4.6s4.3 2.3 4.3 4.6c0 1-.7 1.8-1.7 1.8Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm11.1-1.8L11.9 7C9.7 8 8 9.9 7 12.2l1.2 1.2c.8-2.4 2.6-4.3 4.9-5.2Zm7-1.2-1.2 1.2c2.3.9 4.1 2.7 4.9 5.2l1.2-1.2C24 9.9 22.3 8 20.1 7ZM8.3 18.9l-1.2 1.2c1 2.2 2.8 4 5.1 4.9l1.2-1.2c-2.3-.8-4.1-2.6-5.1-4.9ZM19.7 25l-1.2-1.2c2.4-.8 4.2-2.6 5.1-4.9l1.2 1.2C23.7 22.3 22 24 19.7 25Zm-1.1-7c-1 0-1.3-.8-1.3-.8s-.4.3-.6 1.3c0 1.1 2.2.9 2.2.9v.9h-6v-.9s2.2.2 2.2-.9c0-1-.4-1.3-.4-1.3s-.1.8-1.2.8c-1 0-1.8-.8-1.8-1.8 0-2.3 4.3-4.6 4.3-4.6s4.3 2.3 4.3 4.6c0 1-.7 1.8-1.7 1.8Z",
          fill: "#00C17A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  gas: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm6 9c0 2.6 1.8 4.7 3.2 5.9.5.3 1.1-.1 1-.7a87.974 87.974 0 0 0-.089-.293c-.284-.936-.611-2.013-.611-3.007 0-1.2.5-2.4.9-3.3.2-.5.8-.5 1 0 .3.9.9 1.4 1.6 1.4.9 0 1.8-.5 1.8-1.9 0-1.038-.319-1.693-.6-2.272a9.9 9.9 0 0 1-.2-.428c-.3-.6.4-1.1.9-.7 1.2 1.2 2.7 3.2 2.7 5.8 0 1.7-.4 3.1-.9 4.1-.2.6.4 1.1.9.7 1.6-1.4 3.4-3.6 3.4-6.6 0-3.6-6.1-8.8-8.3-10.6-.3-.2-.8-.1-.9.3-.367 1.303-1.396 2.805-2.488 4.398C9.722 14.117 8 16.628 8 19Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm6 9c0 2.6 1.8 4.7 3.2 5.9.5.3 1.1-.1 1-.7a87.974 87.974 0 0 0-.089-.293c-.284-.936-.611-2.013-.611-3.007 0-1.2.5-2.4.9-3.3.2-.5.8-.5 1 0 .3.9.9 1.4 1.6 1.4.9 0 1.8-.5 1.8-1.9 0-1.038-.319-1.693-.6-2.272a9.9 9.9 0 0 1-.2-.428c-.3-.6.4-1.1.9-.7 1.2 1.2 2.7 3.2 2.7 5.8 0 1.7-.4 3.1-.9 4.1-.2.6.4 1.1.9.7 1.6-1.4 3.4-3.6 3.4-6.6 0-3.6-6.1-8.8-8.3-10.6-.3-.2-.8-.1-.9.3-.367 1.303-1.396 2.805-2.488 4.398C9.722 14.117 8 16.628 8 19Z",
          fill: "#FF8933"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  government: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.9 12.7h-2.3v-6.6h2.3v6.6Zm4.9 0h-2.5v-6.6h2.5v6.6Zm2.4 0h.9c.6 0 1.1.5 1.2 1.1 0 .7-.6 1.2-1.2 1.2H9.2c-.7 0-1.2-.5-1.2-1 0-.7.6-1.2 1.2-1.2h1v-6.6H9.1c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h5V8.9c0-.5.4-.9.9-.9h2.7c.3 0 .5.2.4.4v.5h2.7c.2 0 .4.3.2.5l-.9 1c-.1.1-.1.2 0 .3l.8 1.1c.2.2 0 .4-.2.4h-2.3c-.1 0-.2-.1-.2-.2v-.9h-1.7v2.6h6.6c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2h-.9v6.6Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.9 12.7h-2.3v-6.6h2.3v6.6Zm4.9 0h-2.5v-6.6h2.5v6.6Zm2.4 0h.9c.6 0 1.1.5 1.2 1.1 0 .7-.6 1.2-1.2 1.2H9.2c-.7 0-1.2-.5-1.2-1 0-.7.6-1.2 1.2-1.2h1v-6.6H9.1c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h5V8.9c0-.5.4-.9.9-.9h2.7c.3 0 .5.2.4.4v.5h2.7c.2 0 .4.3.2.5l-.9 1c-.1.1-.1.2 0 .3l.8 1.1c.2.2 0 .4-.2.4h-2.3c-.1 0-.2-.1-.2-.2v-.9h-1.7v2.6h6.6c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2h-.9v6.6Z",
          fill: "#C1B298"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  health: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm16 4h5.1c.5 0 .9.4.9.9v2.2c0 .5-.4.9-.9.9H18v5.1c0 .5-.4.9-.9.9h-2.2c-.5 0-.9-.4-.9-.9V18H8.9c-.5 0-.9-.4-.9-.9v-2.2c0-.5.4-.9.9-.9H14V8.9c0-.5.4-.9.9-.9h2.2c.5 0 .9.4.9.9V14Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm16 4h5.1c.5 0 .9.4.9.9v2.2c0 .5-.4.9-.9.9H18v5.1c0 .5-.4.9-.9.9h-2.2c-.5 0-.9-.4-.9-.9V18H8.9c-.5 0-.9-.4-.9-.9v-2.2c0-.5.4-.9.9-.9H14V8.9c0-.5.4-.9.9-.9h2.2c.5 0 .9.4.9.9V14Z",
          fill: "#FF6E5B"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  income: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm19.4-1.2c.5-.5 1.3-.5 1.8 0s.5 1.4 0 1.9L12.9 21h4.9c.7 0 1.3.5 1.3 1.2s-.6 1.3-1.3 1.3h-8c-.7 0-1.3-.6-1.3-1.3v-8c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v4.9L21.4 8.8Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm19.4-1.2c.5-.5 1.3-.5 1.8 0s.5 1.4 0 1.9L12.9 21h4.9c.7 0 1.3.5 1.3 1.2s-.6 1.3-1.3 1.3h-8c-.7 0-1.3-.6-1.3-1.3v-8c0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3v4.9L21.4 8.8Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  increase: {
    pathDefinition: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm12.5 21.8c-.33 0-.67-.13-.92-.38L16 17.84l-5.58 5.58c-.51.51-1.33.51-1.84 0s-.51-1.33 0-1.84l6.5-6.5c.51-.51 1.33-.51 1.84 0l6.5 6.5a1.298 1.298 0 0 1-.92 2.22Zm-.92-7.39c.25.25.59.38.92.38a1.298 1.298 0 0 0 .92-2.22l-6.5-6.5c-.51-.51-1.33-.51-1.84 0l-6.5 6.5c-.51.51-.51 1.33 0 1.84s1.33.51 1.84 0L16 10.83l5.58 5.58Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm12.5 21.8c-.33 0-.67-.13-.92-.38L16 17.84l-5.58 5.58c-.51.51-1.33.51-1.84 0s-.51-1.33 0-1.84l6.5-6.5c.51-.51 1.33-.51 1.84 0l6.5 6.5a1.298 1.298 0 0 1-.92 2.22Zm-.92-7.39c.25.25.59.38.92.38a1.298 1.298 0 0 0 .92-2.22l-6.5-6.5c-.51-.51-1.33-.51-1.84 0l-6.5 6.5c-.51.51-.51 1.33 0 1.84s1.33.51 1.84 0L16 10.83l5.58 5.58Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("rect", {
            width: "32",
            height: "32",
            rx: "10",
            fill: "#fff"
          })
        })
      })]
    })
  },
  "international-money": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18 2.2c-.4.2-.6.7-.5 1.1l1.4 2.2c.2.4.1 1.1-.4 1.4-.041 0-.1.017-.169.037A1.18 1.18 0 0 1 20 17c-.4 0-.7-.2-.9-.5l-1.4-2.4c0-.05-.025-.075-.05-.1-.025-.025-.05-.05-.05-.1-.5-1.4.2-2.9 1.5-3.6l1.5-.8c-1.4-.9-3-1.5-4.7-1.5-1.4 0-2.7.3-3.9 1l1.3 4.7c.5.9.3 2-.6 2.6l-1.3.8 4.3 1.6c.9.4 1.3 1.4 1.1 2.3l-.8 3c.6 0 1.2 0 1.8-.2.5-.1 1.1.3 1.2.8.1.5-.3 1.1-.8 1.2-.7.1-1.4.2-2.2.2-5.5 0-10-4.5-10-10S10.5 6 16 6c4.2 0 8 2.7 9.4 6.7.2.5-.1 1.1-.6 1.3-.5.2-1.1-.1-1.3-.6-.3-.8-.7-1.6-1.3-2.3L20 12.2Zm-8.3 2.4c-.1 0-.2-.1-.2-.2l-1.2-4C8.9 11.9 8 13.9 8 16.1c0 3.7 2.5 6.8 6 7.7l.9-3.3-4.2-1.6c-.7-.4-1.2-1-1.2-1.7s.3-1.4.9-1.8l1.3-.8Zm12.2 5.7c.8.3 1.4.7 1.7 1.1.3.4.4.9.3 1.4 0 .7-.2 1.3-.6 1.6-.5.4-.9.6-1.5.7v.4c-.1.7-1.4.7-1.5 0v-.4c-.5-.1-.9-.3-1.3-.7-.4-.4-.7-.9-.8-1.5-.2-1 1.1-1.3 1.4-.6.1.5.3.9.6 1.1.3.2.6.3 1 .3s.7-.1.9-.2c.2-.1.3-.4.3-.7 0-.3-.2-.5-.4-.7-.2-.2-.6-.4-1.2-.6-.9-.3-1.4-.6-1.8-1-.3-.3-.5-.8-.5-1.4 0-.5.2-.9.5-1.3s.8-.7 1.4-.8v-.5c0-.7 1.4-.7 1.5 0v.5c.4 0 .8.2 1.1.5.3.3.5.7.7 1.2.3 1-1.2 1.3-1.3.6-.1-.3-.3-.5-.5-.7-.2-.2-.5-.3-.8-.3-.3 0-.5.1-.7.2-.2.1-.3.3-.3.5 0 .3.1.5.4.7.3.2.7.4 1.4.6Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18 2.2c-.4.2-.6.7-.5 1.1l1.4 2.2c.2.4.1 1.1-.4 1.4-.041 0-.1.017-.169.037A1.18 1.18 0 0 1 20 17c-.4 0-.7-.2-.9-.5l-1.4-2.4c0-.05-.025-.075-.05-.1-.025-.025-.05-.05-.05-.1-.5-1.4.2-2.9 1.5-3.6l1.5-.8c-1.4-.9-3-1.5-4.7-1.5-1.4 0-2.7.3-3.9 1l1.3 4.7c.5.9.3 2-.6 2.6l-1.3.8 4.3 1.6c.9.4 1.3 1.4 1.1 2.3l-.8 3c.6 0 1.2 0 1.8-.2.5-.1 1.1.3 1.2.8.1.5-.3 1.1-.8 1.2-.7.1-1.4.2-2.2.2-5.5 0-10-4.5-10-10S10.5 6 16 6c4.2 0 8 2.7 9.4 6.7.2.5-.1 1.1-.6 1.3-.5.2-1.1-.1-1.3-.6-.3-.8-.7-1.6-1.3-2.3L20 12.2Zm-8.3 2.4c-.1 0-.2-.1-.2-.2l-1.2-4C8.9 11.9 8 13.9 8 16.1c0 3.7 2.5 6.8 6 7.7l.9-3.3-4.2-1.6c-.7-.4-1.2-1-1.2-1.7s.3-1.4.9-1.8l1.3-.8Zm12.2 5.7c.8.3 1.4.7 1.7 1.1.3.4.4.9.3 1.4 0 .7-.2 1.3-.6 1.6-.5.4-.9.6-1.5.7v.4c-.1.7-1.4.7-1.5 0v-.4c-.5-.1-.9-.3-1.3-.7-.4-.4-.7-.9-.8-1.5-.2-1 1.1-1.3 1.4-.6.1.5.3.9.6 1.1.3.2.6.3 1 .3s.7-.1.9-.2c.2-.1.3-.4.3-.7 0-.3-.2-.5-.4-.7-.2-.2-.6-.4-1.2-.6-.9-.3-1.4-.6-1.8-1-.3-.3-.5-.8-.5-1.4 0-.5.2-.9.5-1.3s.8-.7 1.4-.8v-.5c0-.7 1.4-.7 1.5 0v.5c.4 0 .8.2 1.1.5.3.3.5.7.7 1.2.3 1-1.2 1.3-1.3.6-.1-.3-.3-.5-.5-.7-.2-.2-.5-.3-.8-.3-.3 0-.5.1-.7.2-.2.1-.3.3-.3.5 0 .3.1.5.4.7.3.2.7.4 1.4.6Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  internet: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21.6 3.9c-.4 0-.8-.2-1-.5l-.02-.02c-.247-.263-2.527-2.68-6.48-2.68-4.2 0-6.7 2.7-6.7 2.7-.5.6-1.4.7-1.9.2-.6-.5-.6-1.4-.1-1.9.1-.2 3.2-3.7 8.7-3.7 5.4 0 8.5 3.5 8.6 3.7.5.6.4 1.4-.2 1.9-.2.2-.5.3-.9.3Zm-5.8 8.4c0 1-.8 1.7-1.7 1.7-1 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7.9-.1 1.7.7 1.7 1.7Zm2.3-3.8c-.3 0-.7-.2-1-.5-.018 0-.067-.04-.146-.105A4.435 4.435 0 0 0 16 16.8c-1.9 0-3.1 1.2-3.1 1.3-.5.6-1.4.6-1.9.1s-.6-1.3-.1-1.9l.017-.017c.216-.225 2.093-2.183 5.183-2.183 3.056 0 4.835 1.915 5.076 2.175l.024.025c.4.5.4 1.4-.2 1.9-.3.2-.6.3-.9.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21.6 3.9c-.4 0-.8-.2-1-.5l-.02-.02c-.247-.263-2.527-2.68-6.48-2.68-4.2 0-6.7 2.7-6.7 2.7-.5.6-1.4.7-1.9.2-.6-.5-.6-1.4-.1-1.9.1-.2 3.2-3.7 8.7-3.7 5.4 0 8.5 3.5 8.6 3.7.5.6.4 1.4-.2 1.9-.2.2-.5.3-.9.3Zm-5.8 8.4c0 1-.8 1.7-1.7 1.7-1 0-1.7-.8-1.7-1.7 0-1 .8-1.7 1.7-1.7.9-.1 1.7.7 1.7 1.7Zm2.3-3.8c-.3 0-.7-.2-1-.5-.018 0-.067-.04-.146-.105A4.435 4.435 0 0 0 16 16.8c-1.9 0-3.1 1.2-3.1 1.3-.5.6-1.4.6-1.9.1s-.6-1.3-.1-1.9l.017-.017c.216-.225 2.093-2.183 5.183-2.183 3.056 0 4.835 1.915 5.076 2.175l.024.025c.4.5.4 1.4-.2 1.9-.3.2-.6.3-.9.3Z",
          fill: "#20A2F8"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  investment: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15 9.928c3.345-.487 6-3.376 6-6.928 0-3.9-3.1-7-7-7s-7 3.1-7 7a6.95 6.95 0 0 0 6 6.93V25c0 .5.4 1 1 1 .5 0 1-.5 1-1v-5.072ZM11 13c0-2.8 2.2-5 5-5 2.7 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5Zm7 .3c-.2-.4-.7-.7-1.4-.9-.134-.054-.26-.1-.379-.143-.321-.118-.575-.21-.721-.357-.2-.1-.3-.3-.3-.4 0-.1.1-.3.2-.3.1-.1.3-.1.5-.1.3 0 .5.1.6.2.2.1.3.3.4.5 0 .2.2.4.5.4s.5-.1.7-.3c.1-.1.2-.3.1-.6-.1-.4-.3-.7-.6-1-.052-.034-.1-.069-.147-.102-.227-.16-.422-.298-.753-.298v-.5c0-.4-.4-.5-.7-.5-.3 0-.7.2-.7.5v.3c-.5.1-.8.4-1.1.7-.3.3-.4.7-.4 1.1 0 .5.2.9.5 1.2.3.3.8.6 1.5.8.41.082.685.231.881.337.043.024.083.045.119.063.2.1.3.3.3.5s-.1.4-.2.5c-.2.1-.4.2-.7.2-.3 0-.5-.1-.7-.2-.2-.2-.4-.5-.4-.8-.1-.2-.3-.4-.6-.4-.2 0-.4.1-.6.3-.1.2-.2.4-.1.6.1.5.3.9.7 1.2.3.3.6.5 1 .6v.3c0 .4.4.5.7.5.3 0 .7-.2.7-.5v-.2c.4-.1.8-.3 1.1-.5.4-.3.6-.8.6-1.4-.137-.273-.232-.505-.314-.705-.098-.239-.177-.432-.286-.595ZM13 26c-2.3 0-3.9-.6-5-1.9-1.376-1.651-1.069-3.808-1.009-4.23A.7.7 0 0 0 7 19.8c.1-.5.5-.8 1-.8 2.3 0 3.9.6 5 1.9 1.376 1.651 1.069 3.808 1.009 4.23a.7.7 0 0 0-.009.07c-.1.5-.5.8-1 .8Zm-4.1-5c0 .5.2 1.2.6 1.8.5.6 1.3 1 2.5 1.1 0-.5-.2-1.2-.6-1.8-.5-.6-1.4-.9-2.5-1.1Zm9.1 4.2c.1.5.5.8 1 .8 2.3 0 4-.6 5-1.9 1.376-1.651 1.069-3.808 1.009-4.23A.7.7 0 0 1 25 19.8c-.1-.5-.5-.8-1-.8-2.3 0-4 .6-5 1.9-1.376 1.651-1.069 3.808-1.009 4.23a.7.7 0 0 1 .009.07Zm2.6-3.1c.5-.6 1.4-1 2.5-1.1 0 .6-.2 1.3-.6 1.9-.5.6-1.4 1-2.5 1.1 0-.6.2-1.3.6-1.9Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm15 9.928c3.345-.487 6-3.376 6-6.928 0-3.9-3.1-7-7-7s-7 3.1-7 7a6.95 6.95 0 0 0 6 6.93V25c0 .5.4 1 1 1 .5 0 1-.5 1-1v-5.072ZM11 13c0-2.8 2.2-5 5-5 2.7 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5Zm7 .3c-.2-.4-.7-.7-1.4-.9-.134-.054-.26-.1-.379-.143-.321-.118-.575-.21-.721-.357-.2-.1-.3-.3-.3-.4 0-.1.1-.3.2-.3.1-.1.3-.1.5-.1.3 0 .5.1.6.2.2.1.3.3.4.5 0 .2.2.4.5.4s.5-.1.7-.3c.1-.1.2-.3.1-.6-.1-.4-.3-.7-.6-1-.052-.034-.1-.069-.147-.102-.227-.16-.422-.298-.753-.298v-.5c0-.4-.4-.5-.7-.5-.3 0-.7.2-.7.5v.3c-.5.1-.8.4-1.1.7-.3.3-.4.7-.4 1.1 0 .5.2.9.5 1.2.3.3.8.6 1.5.8.41.082.685.231.881.337.043.024.083.045.119.063.2.1.3.3.3.5s-.1.4-.2.5c-.2.1-.4.2-.7.2-.3 0-.5-.1-.7-.2-.2-.2-.4-.5-.4-.8-.1-.2-.3-.4-.6-.4-.2 0-.4.1-.6.3-.1.2-.2.4-.1.6.1.5.3.9.7 1.2.3.3.6.5 1 .6v.3c0 .4.4.5.7.5.3 0 .7-.2.7-.5v-.2c.4-.1.8-.3 1.1-.5.4-.3.6-.8.6-1.4-.137-.273-.232-.505-.314-.705-.098-.239-.177-.432-.286-.595ZM13 26c-2.3 0-3.9-.6-5-1.9-1.376-1.651-1.069-3.808-1.009-4.23A.7.7 0 0 0 7 19.8c.1-.5.5-.8 1-.8 2.3 0 3.9.6 5 1.9 1.376 1.651 1.069 3.808 1.009 4.23a.7.7 0 0 0-.009.07c-.1.5-.5.8-1 .8Zm-4.1-5c0 .5.2 1.2.6 1.8.5.6 1.3 1 2.5 1.1 0-.5-.2-1.2-.6-1.8-.5-.6-1.4-.9-2.5-1.1Zm9.1 4.2c.1.5.5.8 1 .8 2.3 0 4-.6 5-1.9 1.376-1.651 1.069-3.808 1.009-4.23A.7.7 0 0 1 25 19.8c-.1-.5-.5-.8-1-.8-2.3 0-4 .6-5 1.9-1.376 1.651-1.069 3.808-1.009 4.23a.7.7 0 0 1 .009.07Zm2.6-3.1c.5-.6 1.4-1 2.5-1.1 0 .6-.2 1.3-.6 1.9-.5.6-1.4 1-2.5 1.1 0-.6.2-1.3.6-1.9Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  less: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21 4.6H9c-.775 0-1.4.625-1.4 1.4 0 .775.625 1.4 1.4 1.4h14c.775 0 1.4-.625 1.4-1.4 0-.775-.625-1.4-1.4-1.4Z",
    paths: null
  },
  living: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm9 4v-2.9c0-.7.3-1.1 1-1.1h8c.6 0 1 .5 1 1.1V14H11Zm11 6c1.1 0 2-.4 2-1.6V16c0-.133.089-.267.178-.4.044-.067.089-.133.122-.2.3-.2.6-.5.6-1.3s-.1-2.1-1.5-2.1c-1.3 0-1.4 1.1-1.4 2.1V16s0-1-1-1H11c-1 0-1 1-1 1v-2c0-.9-.1-2-1.5-2S7 13.2 7 14c0 .5.3.9.6 1.3.054.08.107.154.157.221.136.186.243.333.243.479v2.4c0 1.2.9 1.6 2 1.6h12Zm-10 1v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h2Zm9 0v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm9 4v-2.9c0-.7.3-1.1 1-1.1h8c.6 0 1 .5 1 1.1V14H11Zm11 6c1.1 0 2-.4 2-1.6V16c0-.133.089-.267.178-.4.044-.067.089-.133.122-.2.3-.2.6-.5.6-1.3s-.1-2.1-1.5-2.1c-1.3 0-1.4 1.1-1.4 2.1V16s0-1-1-1H11c-1 0-1 1-1 1v-2c0-.9-.1-2-1.5-2S7 13.2 7 14c0 .5.3.9.6 1.3.054.08.107.154.157.221.136.186.243.333.243.479v2.4c0 1.2.9 1.6 2 1.6h12Zm-10 1v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h2Zm9 0v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h2Z",
          fill: "#68DCAA"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "loans-primary": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm22-1h2c.5 0 1 .5 1 1 0 .6-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2h-2c-.5 0-1-.4-1-1s.5-1 1-1h2V7c0-.6.5-1 1-1s1 .4 1 1v2Zm-7.67.53c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.5-4.7-1.7-.4-.3-.5-.9-.2-1.4.3-.4.9-.5 1.4 0 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.15-.1.325-.175.5-.25.175-.075.35-.15.5-.25.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3-.238.06-.44.154-.629.243a3.53 3.53 0 0 1-.371.157l-.07.03ZM24 17c0-.6.5-1 1-1s1 .5.9 1.1v7c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.153-5.202-1.145-7.83.024L16.4 25l-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8v-12c0-.4.2-.8.6-.9.3-.1.7-.1 1 .1 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.3-.2.7-.4 1-.5.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3a6.93 6.93 0 0 0-.5.2 6.91 6.91 0 0 1-.5.2c-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4 2.4-1.1 5.2-2.3 8.4-.8V17Zm-10.9.9c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9Zm3.8 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm22-1h2c.5 0 1 .5 1 1 0 .6-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2h-2c-.5 0-1-.4-1-1s.5-1 1-1h2V7c0-.6.5-1 1-1s1 .4 1 1v2Zm-7.67.53c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.5-4.7-1.7-.4-.3-.5-.9-.2-1.4.3-.4.9-.5 1.4 0 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.15-.1.325-.175.5-.25.175-.075.35-.15.5-.25.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3-.238.06-.44.154-.629.243a3.53 3.53 0 0 1-.371.157l-.07.03ZM24 17c0-.6.5-1 1-1s1 .5.9 1.1v7c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.153-5.202-1.145-7.83.024L16.4 25l-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8v-12c0-.4.2-.8.6-.9.3-.1.7-.1 1 .1 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.3-.2.7-.4 1-.5.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3a6.93 6.93 0 0 0-.5.2 6.91 6.91 0 0 1-.5.2c-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4 2.4-1.1 5.2-2.3 8.4-.8V17Zm-10.9.9c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9Zm3.8 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  loans: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm22-1h2c.5 0 1 .5 1 1 0 .6-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2h-2c-.5 0-1-.4-1-1s.5-1 1-1h2V7c0-.6.5-1 1-1s1 .4 1 1v2Zm-7.67.53c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.5-4.7-1.7-.4-.3-.5-.9-.2-1.4.3-.4.9-.5 1.4 0 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.15-.1.325-.175.5-.25.175-.075.35-.15.5-.25.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3-.238.06-.44.154-.629.243a3.53 3.53 0 0 1-.371.157l-.07.03ZM24 17c0-.6.5-1 1-1s1 .5.9 1.1v7c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.153-5.202-1.145-7.83.024L16.4 25l-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8v-12c0-.4.2-.8.6-.9.3-.1.7-.1 1 .1 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.3-.2.7-.4 1-.5.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3a6.93 6.93 0 0 0-.5.2 6.91 6.91 0 0 1-.5.2c-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4 2.4-1.1 5.2-2.3 8.4-.8V17Zm-10.9.9c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9Zm3.8 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm22-1h2c.5 0 1 .5 1 1 0 .6-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2h-2c-.5 0-1-.4-1-1s.5-1 1-1h2V7c0-.6.5-1 1-1s1 .4 1 1v2Zm-7.67.53c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.5-4.7-1.7-.4-.3-.5-.9-.2-1.4.3-.4.9-.5 1.4 0 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.15-.1.325-.175.5-.25.175-.075.35-.15.5-.25.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3-.238.06-.44.154-.629.243a3.53 3.53 0 0 1-.371.157l-.07.03ZM24 17c0-.6.5-1 1-1s1 .5.9 1.1v7c0 .4-.2.7-.5.9-.3.1-.7.1-1-.1-2.937-2.153-5.202-1.145-7.83.024L16.4 25l-.07.03c-1.582.693-3.358 1.47-5.23 1.47-1.5 0-3-.4-4.7-1.6-.2-.2-.4-.5-.4-.8v-12c0-.4.2-.8.6-.9.3-.1.7-.1 1 .1 2.937 2.153 5.202 1.145 7.83-.024l.17-.076c.3-.2.7-.4 1-.5.5-.2 1.1 0 1.3.5.2.5 0 1.1-.5 1.3a6.93 6.93 0 0 0-.5.2 6.91 6.91 0 0 1-.5.2c-2.4 1.1-5.2 2.3-8.4.8v9.7c2.8 1.8 5.1.8 7.6-.4 2.4-1.1 5.2-2.3 8.4-.8V17Zm-10.9.9c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9Zm3.8 0c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "loyalty-experience-pts": {
    pathDefinition: "M10 32C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10H10Zm0-30c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm15 8h-3V9c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1v1H7c-.55 0-1 .45-1 1v2c0 2.69 2.14 4.87 4.8 4.98.88 1.53 2.4 2.63 4.2 2.93V23h-3c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-2.09c1.8-.3 3.32-1.4 4.2-2.93 2.66-.11 4.8-2.29 4.8-4.98v-2c0-.55-.45-1-1-1ZM8 13v-1h2v3c0 .28.03.56.07.84C8.87 15.44 8 14.33 8 13Zm8 6c-2.21 0-4-1.79-4-4v-5h8v5c0 2.21-1.79 4-4 4Zm8-6c0 1.33-.87 2.44-2.07 2.84.04-.27.07-.55.07-.84v-3h2v1Zm-5.69-.39c.19.04.35.18.41.37l.01.01c.06.19.02.4-.11.55l-.81.95.2 1.28c.03.21-.06.42-.23.54-.17.12-.39.14-.58.04l-1.2-.6-1.2.6c-.08.04-.17.06-.25.06-.12 0-.23-.04-.33-.11a.545.545 0 0 1-.23-.54l.2-1.28-.81-.95a.577.577 0 0 1-.11-.55.55.55 0 0 1 .41-.37l1.22-.26.6-1.15c.2-.37.8-.37.99 0l.6 1.15 1.22.26Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10H10Zm0-30c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm15 8h-3V9c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1v1H7c-.55 0-1 .45-1 1v2c0 2.69 2.14 4.87 4.8 4.98.88 1.53 2.4 2.63 4.2 2.93V23h-3c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-2.09c1.8-.3 3.32-1.4 4.2-2.93 2.66-.11 4.8-2.29 4.8-4.98v-2c0-.55-.45-1-1-1ZM8 13v-1h2v3c0 .28.03.56.07.84C8.87 15.44 8 14.33 8 13Zm8 6c-2.21 0-4-1.79-4-4v-5h8v5c0 2.21-1.79 4-4 4Zm8-6c0 1.33-.87 2.44-2.07 2.84.04-.27.07-.55.07-.84v-3h2v1Zm-5.69-.39c.19.04.35.18.41.37l.01.01c.06.19.02.4-.11.55l-.81.95.2 1.28c.03.21-.06.42-.23.54-.17.12-.39.14-.58.04l-1.2-.6-1.2.6c-.08.04-.17.06-.25.06-.12 0-.23-.04-.33-.11a.545.545 0 0 1-.23-.54l.2-1.28-.81-.95a.577.577 0 0 1-.11-.55.55.55 0 0 1 .41-.37l1.22-.26.6-1.15c.2-.37.8-.37.99 0l.6 1.15 1.22.26Z",
          fill: "#FF7391"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "loyalty-experience": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20 0h3c.55 0 1 .45 1 1v2c0 2.69-2.14 4.87-4.8 4.98a5.982 5.982 0 0 1-4.2 2.93V23h3c.55 0 1 .45 1 1s-.45 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h3v-2.09c-1.8-.3-3.32-1.4-4.2-2.93C8.14 17.87 6 15.69 6 13v-2c0-.55.45-1 1-1h3V9c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1ZM8 12v1c0 1.33.87 2.44 2.07 2.84-.04-.28-.07-.56-.07-.84v-3H8Zm4 3c0 2.21 1.79 4 4 4s4-1.79 4-4v-5h-8v5Zm9.93.84c1.2-.4 2.07-1.51 2.07-2.84v-1h-2v3c0 .29-.03.57-.07.84Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20 0h3c.55 0 1 .45 1 1v2c0 2.69-2.14 4.87-4.8 4.98a5.982 5.982 0 0 1-4.2 2.93V23h3c.55 0 1 .45 1 1s-.45 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h3v-2.09c-1.8-.3-3.32-1.4-4.2-2.93C8.14 17.87 6 15.69 6 13v-2c0-.55.45-1 1-1h3V9c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1ZM8 12v1c0 1.33.87 2.44 2.07 2.84-.04-.28-.07-.56-.07-.84v-3H8Zm4 3c0 2.21 1.79 4 4 4s4-1.79 4-4v-5h-8v5Zm9.93.84c1.2-.4 2.07-1.51 2.07-2.84v-1h-2v3c0 .29-.03.57-.07.84Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  loyalty: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17.8 15c.3.1.6.2.9.2.4 0 .8-.1 1.3-.4.6-.4.9-1.2.8-1.9l-.6-4 2.6-3c.5-.5.7-1.2.4-1.9-.3-.7-.8-1.2-1.5-1.3l-3.9-.8-1.9-3.6c-.4-.7-1-1.1-1.8-1.1s-1.5.4-1.8 1.1l-1.9 3.6-3.9.8c-.7.1-1.2.6-1.5 1.3-.3.7-.1 1.4.3 1.9l2.6 3-.6 4c-.1.7.2 1.5.8 1.9.6.5 1.4.5 2.1.2l3.8-1.9 3.8 1.9Zm-3.3-3.9c-.2-.1-.4-.1-.5-.1-.2 0-.3 0-.4.2l-4.3 2.1.7-4.5c.1-.3 0-.6-.2-.8l-2.9-3.3 4.3-.9c.3-.1.6-.2.7-.5l2.1-4 2.1 4c.2.3.4.4.7.5l4.3.9-2.9 3.3c-.2.2-.2.5-.2.8l.8 4.4-4.3-2.1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17.8 15c.3.1.6.2.9.2.4 0 .8-.1 1.3-.4.6-.4.9-1.2.8-1.9l-.6-4 2.6-3c.5-.5.7-1.2.4-1.9-.3-.7-.8-1.2-1.5-1.3l-3.9-.8-1.9-3.6c-.4-.7-1-1.1-1.8-1.1s-1.5.4-1.8 1.1l-1.9 3.6-3.9.8c-.7.1-1.2.6-1.5 1.3-.3.7-.1 1.4.3 1.9l2.6 3-.6 4c-.1.7.2 1.5.8 1.9.6.5 1.4.5 2.1.2l3.8-1.9 3.8 1.9Zm-3.3-3.9c-.2-.1-.4-.1-.5-.1-.2 0-.3 0-.4.2l-4.3 2.1.7-4.5c.1-.3 0-.6-.2-.8l-2.9-3.3 4.3-.9c.3-.1.6-.2.7-.5l2.1-4 2.1 4c.2.3.4.4.7.5l4.3.9-2.9 3.3c-.2.2-.2.5-.2.8l.8 4.4-4.3-2.1Z",
          fill: "#FD9426"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  mobile: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10-3c-1.1 0-2 .9-2 2v9h12V9c0-1.1-.9-2-2-2h-8Zm-2 16v-4h12v4c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2Zm6 0c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10-3c-1.1 0-2 .9-2 2v9h12V9c0-1.1-.9-2-2-2h-8Zm-2 16v-4h12v4c0 1.1-.9 2-2 2h-8c-1.1 0-2-.9-2-2Zm6 0c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1Z",
          fill: "#4CC7E9"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  mortage: {
    pathDefinition: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm15.545 11.165-9-6c-.34-.22-.77-.22-1.11 0l-8.99 6c-.46.31-.58.93-.28 1.39.31.46.92.58 1.39.28l.45-.3v9.46c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-9.46l.45.3c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39h-.01Zm-3.55 9.83h-12v-9.8l6-4 6 4v9.8Zm-5.42-7.03c.71.24 1.19.55 1.43.91h-.01c.24.36.36.76.36 1.19 0 .63-.19 1.1-.55 1.39-.33.27-.71.45-1.13.54v.24c-.03.35-.37.51-.69.51-.32 0-.67-.15-.7-.51v-.26c-.37-.1-.71-.29-1.01-.58-.32-.31-.54-.73-.65-1.25-.05-.23 0-.45.13-.61.14-.17.36-.27.58-.27.26 0 .48.14.59.39.09.39.24.67.44.84.2.17.43.25.71.25.3 0 .53-.06.68-.17.14-.1.21-.27.21-.5a.58.58 0 0 0-.25-.48c-.18-.14-.5-.29-.95-.44-.68-.23-1.17-.51-1.46-.81-.3-.31-.45-.72-.45-1.21 0-.4.13-.77.38-1.11.24-.32.6-.55 1.08-.68v-.33c.02-.35.36-.51.68-.51.32 0 .67.15.71.51v.31c.34.06.63.21.88.45.27.26.47.59.59 1 .09.27 0 .47-.08.58-.14.19-.39.31-.65.31-.29 0-.5-.16-.53-.39-.07-.22-.19-.39-.35-.52-.16-.13-.37-.19-.62-.19a.89.89 0 0 0-.52.14c-.12.08-.18.2-.18.35 0 .18.08.32.25.44.19.13.55.29 1.08.47Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 32H10C4.5 32 0 27.5 0 22V10C0 4.5 4.5 0 10 0h12c5.5 0 10 4.5 10 10v12c0 5.5-4.5 10-10 10ZM10 2c-4.4 0-8 3.6-8 8v12c0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8V10c0-4.4-3.6-8-8-8H10Zm15.545 11.165-9-6c-.34-.22-.77-.22-1.11 0l-8.99 6c-.46.31-.58.93-.28 1.39.31.46.92.58 1.39.28l.45-.3v9.46c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-9.46l.45.3c.17.11.36.17.55.17.32 0 .64-.16.83-.45.31-.46.18-1.08-.28-1.39h-.01Zm-3.55 9.83h-12v-9.8l6-4 6 4v9.8Zm-5.42-7.03c.71.24 1.19.55 1.43.91h-.01c.24.36.36.76.36 1.19 0 .63-.19 1.1-.55 1.39-.33.27-.71.45-1.13.54v.24c-.03.35-.37.51-.69.51-.32 0-.67-.15-.7-.51v-.26c-.37-.1-.71-.29-1.01-.58-.32-.31-.54-.73-.65-1.25-.05-.23 0-.45.13-.61.14-.17.36-.27.58-.27.26 0 .48.14.59.39.09.39.24.67.44.84.2.17.43.25.71.25.3 0 .53-.06.68-.17.14-.1.21-.27.21-.5a.58.58 0 0 0-.25-.48c-.18-.14-.5-.29-.95-.44-.68-.23-1.17-.51-1.46-.81-.3-.31-.45-.72-.45-1.21 0-.4.13-.77.38-1.11.24-.32.6-.55 1.08-.68v-.33c.02-.35.36-.51.68-.51.32 0 .67.15.71.51v.31c.34.06.63.21.88.45.27.26.47.59.59 1 .09.27 0 .47-.08.58-.14.19-.39.31-.65.31-.29 0-.5-.16-.53-.39-.07-.22-.19-.39-.35-.52-.16-.13-.37-.19-.62-.19a.89.89 0 0 0-.52.14c-.12.08-.18.2-.18.35 0 .18.08.32.25.44.19.13.55.29 1.08.47Z",
          fill: "#C68ED7"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "no-category": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17 11.5c.3-.3.3-.7 0-1l-2-2 2-2c.3-.3.3-.7 0-1-.3-.3-.7-.3-1 0l-2 2-2-2c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l2 2-2 2c-.3.3-.3.7 0 1 .054.027.1.054.143.078.118.068.21.122.357.122.2 0 .4-.1.5-.2l2-2 2 2c.054.027.1.054.143.078.118.068.21.122.357.122.2 0 .4-.1.5-.2ZM17 11c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1Zm1.6-4c1 0 1.9.6 2.3 1.5l1.9 4 .051.198c.08.308.149.57.149.902v10.2c0 .7-.6 1.3-1.3 1.3H10.3c-.7 0-1.3-.6-1.3-1.3V13.6c0-.3.1-.7.3-1l1.8-4.1c.4-.9 1.3-1.5 2.3-1.5h5.2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17 11.5c.3-.3.3-.7 0-1l-2-2 2-2c.3-.3.3-.7 0-1-.3-.3-.7-.3-1 0l-2 2-2-2c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l2 2-2 2c-.3.3-.3.7 0 1 .054.027.1.054.143.078.118.068.21.122.357.122.2 0 .4-.1.5-.2l2-2 2 2c.054.027.1.054.143.078.118.068.21.122.357.122.2 0 .4-.1.5-.2ZM17 11c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1Zm1.6-4c1 0 1.9.6 2.3 1.5l1.9 4 .051.198c.08.308.149.57.149.902v10.2c0 .7-.6 1.3-1.3 1.3H10.3c-.7 0-1.3-.6-1.3-1.3V13.6c0-.3.1-.7.3-1l1.8-4.1c.4-.9 1.3-1.5 2.3-1.5h5.2Z",
          fill: "#929191"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  outcome: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.2-1.6h8c.8 0 1.3.6 1.3 1.3v8c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-4.9L10.6 23.1c-.2.3-.6.4-.9.4-.3 0-.7-.2-.9-.4-.5-.5-.5-1.3 0-1.8L19.1 11h-4.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.2-1.6h8c.8 0 1.3.6 1.3 1.3v8c0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3v-4.9L10.6 23.1c-.2.3-.6.4-.9.4-.3 0-.7-.2-.9-.4-.5-.5-.5-1.3 0-1.8L19.1 11h-4.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "payment-service": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.6-1.8c-4-2.8-7.2-1.4-10-.1-2.3 1.1-4.3 2-6.8.8-.6-.3-1.3-.2-1.9.2-.6.4-.9 1-.9 1.6v12.6c0 .7.3 1.3.9 1.7.6.4 1.3.4 1.9.1l1.9-1 .9.9c.4.4.9.6 1.4.6.4 0 .8-.1 1.1-.3l1.8-1.2 1.8 1.2c.8.5 1.9.4 2.5-.3l.9-.9 1.9 1c.6.3 1.3.3 1.9-.1.6-.4 1-1 1-1.7V9c.1-.3 0-.6-.3-.8ZM24 23.4l-1.9-.9c-.8-.4-1.7-.2-2.3.4l-.9.9-1.8-1.2c-.7-.5-1.5-.5-2.2 0l-1.8 1.2-.9-.9c-.4-.4-.9-.6-1.4-.6-.3 0-.6.1-.9.2l-1.9.9V10.8c3.3 1.5 6 .3 8.4-.8 2.5-1.2 4.8-2.2 7.6-.4v13.8ZM11 14c-.6 0-1 .4-1 1s.4 1 1 1h10c.5 0 1-.4 1-1s-.5-1-1-1H11Zm0 4h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.6-1.8c-4-2.8-7.2-1.4-10-.1-2.3 1.1-4.3 2-6.8.8-.6-.3-1.3-.2-1.9.2-.6.4-.9 1-.9 1.6v12.6c0 .7.3 1.3.9 1.7.6.4 1.3.4 1.9.1l1.9-1 .9.9c.4.4.9.6 1.4.6.4 0 .8-.1 1.1-.3l1.8-1.2 1.8 1.2c.8.5 1.9.4 2.5-.3l.9-.9 1.9 1c.6.3 1.3.3 1.9-.1.6-.4 1-1 1-1.7V9c.1-.3 0-.6-.3-.8ZM24 23.4l-1.9-.9c-.8-.4-1.7-.2-2.3.4l-.9.9-1.8-1.2c-.7-.5-1.5-.5-2.2 0l-1.8 1.2-.9-.9c-.4-.4-.9-.6-1.4-.6-.3 0-.6.1-.9.2l-1.9.9V10.8c3.3 1.5 6 .3 8.4-.8 2.5-1.2 4.8-2.2 7.6-.4v13.8ZM11 14c-.6 0-1 .4-1 1s.4 1 1 1h10c.5 0 1-.4 1-1s-.5-1-1-1H11Zm0 4h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
          fill: "#85CC47"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  payment: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.6-1.8c-4-2.8-7.2-1.4-10-.1-2.3 1.1-4.3 2-6.8.8-.6-.3-1.3-.2-1.9.2-.6.4-.9 1-.9 1.6v12.6c0 .7.3 1.3.9 1.7.6.4 1.3.4 1.9.1l1.9-1 .9.9c.4.4.9.6 1.4.6.4 0 .8-.1 1.1-.3l1.8-1.2 1.8 1.2c.8.5 1.9.4 2.5-.3l.9-.9 1.9 1c.6.3 1.3.3 1.9-.1.6-.4 1-1 1-1.7V9c.1-.3 0-.6-.3-.8ZM24 23.4l-1.9-.9c-.8-.4-1.7-.2-2.3.4l-.9.9-1.8-1.2c-.7-.5-1.5-.5-2.2 0l-1.8 1.2-.9-.9c-.4-.4-.9-.6-1.4-.6-.3 0-.6.1-.9.2l-1.9.9V10.8c3.3 1.5 6 .3 8.4-.8 2.5-1.2 4.8-2.2 7.6-.4v13.8ZM11 14c-.6 0-1 .4-1 1s.4 1 1 1h10c.5 0 1-.4 1-1s-.5-1-1-1H11Zm0 4h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23.6-1.8c-4-2.8-7.2-1.4-10-.1-2.3 1.1-4.3 2-6.8.8-.6-.3-1.3-.2-1.9.2-.6.4-.9 1-.9 1.6v12.6c0 .7.3 1.3.9 1.7.6.4 1.3.4 1.9.1l1.9-1 .9.9c.4.4.9.6 1.4.6.4 0 .8-.1 1.1-.3l1.8-1.2 1.8 1.2c.8.5 1.9.4 2.5-.3l.9-.9 1.9 1c.6.3 1.3.3 1.9-.1.6-.4 1-1 1-1.7V9c.1-.3 0-.6-.3-.8ZM24 23.4l-1.9-.9c-.8-.4-1.7-.2-2.3.4l-.9.9-1.8-1.2c-.7-.5-1.5-.5-2.2 0l-1.8 1.2-.9-.9c-.4-.4-.9-.6-1.4-.6-.3 0-.6.1-.9.2l-1.9.9V10.8c3.3 1.5 6 .3 8.4-.8 2.5-1.2 4.8-2.2 7.6-.4v13.8ZM11 14c-.6 0-1 .4-1 1s.4 1 1 1h10c.5 0 1-.4 1-1s-.5-1-1-1H11Zm0 4h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  pet: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13 1c0 1.7-1.1 3-2.5 3S10 12.7 10 11s1.1-3 2.5-3S15 9.3 15 11Zm-5 4.5c0 1.4-.9 2.5-2 2.5s-2-1.1-2-2.5.9-2.5 2-2.5 2 1.1 2 2.5Zm4.11 8.14c.613-.178 1.17-.34 1.89-.34.8 0 1.4.2 2 .4.137.027.282.063.433.099.397.096.832.201 1.267.201 1.3 0 2.3-.7 2.3-2.3 0-1.7-1.5-5.7-6-5.7s-6 4.3-6 5.7c0 1.4 1 2.3 2.2 2.3.6 0 1.1-.1 1.7-.3l.21-.06ZM24 18c1.1 0 2-1.1 2-2.5s-.9-2.5-2-2.5-2 1.1-2 2.5.9 2.5 2 2.5Zm-2-7c0 1.7-1.1 3-2.5 3S17 12.7 17 11s1.1-3 2.5-3S22 9.3 22 11Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13 1c0 1.7-1.1 3-2.5 3S10 12.7 10 11s1.1-3 2.5-3S15 9.3 15 11Zm-5 4.5c0 1.4-.9 2.5-2 2.5s-2-1.1-2-2.5.9-2.5 2-2.5 2 1.1 2 2.5Zm4.11 8.14c.613-.178 1.17-.34 1.89-.34.8 0 1.4.2 2 .4.137.027.282.063.433.099.397.096.832.201 1.267.201 1.3 0 2.3-.7 2.3-2.3 0-1.7-1.5-5.7-6-5.7s-6 4.3-6 5.7c0 1.4 1 2.3 2.2 2.3.6 0 1.1-.1 1.7-.3l.21-.06ZM24 18c1.1 0 2-1.1 2-2.5s-.9-2.5-2-2.5-2 1.1-2 2.5.9 2.5 2 2.5Zm-2-7c0 1.7-1.1 3-2.5 3S17 12.7 17 11s1.1-3 2.5-3S22 9.3 22 11Z",
          fill: "#F59776"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  plus: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21 4.6h-5.6V9c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v5.6H9c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h5.6V23c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-5.6H23c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21 4.6h-5.6V9c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v5.6H9c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h5.6V23c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-5.6H23c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  qr: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7-3h4c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2Zm0 2v4h4V9H9Zm10-2h4c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2Zm0 2v4h4V9h-4Zm-6 8H9c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2Zm-4 6v-4h4v4H9Zm9-6h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1Zm1 5h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1Zm1.5-2.5h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1ZM24 17h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1Zm-1 5h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7-3h4c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2Zm0 2v4h4V9H9Zm10-2h4c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2Zm0 2v4h4V9h-4Zm-6 8H9c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2Zm-4 6v-4h4v4H9Zm9-6h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1Zm1 5h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1Zm1.5-2.5h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1ZM24 17h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1Zm-1 5h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  recharge: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23 5c-.5 0-1 .4-1 1 0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c.5 0 1-.4 1-1s-.5-1-1-1C10.5 6 6 10.5 6 16s4.5 10 10 10 10-4.5 10-10c0-.6-.5-1-1-1Zm-9 6.4c.4 0 .9-.2.9-.6v-.3c.6-.1 1.1-.4 1.5-.7.5-.4.7-1 .7-1.8 0-.6-.2-1.1-.5-1.5-.3-.5-.9-.9-1.9-1.2-.7-.2-1.2-.4-1.4-.6-.2-.2-.3-.4-.3-.6 0-.2.1-.4.2-.5.2-.1.4-.2.7-.2.3 0 .6.1.8.3.2.2.4.4.5.7 0 .3.3.5.7.5.3 0 .7-.2.8-.4.1-.1.2-.4.1-.7-.2-.5-.4-1-.8-1.3-.3-.3-.7-.5-1.2-.6v-.4c0-.4-.5-.7-.9-.7s-.8.2-.9.6v.4c-.6.2-1.1.5-1.4.9-.3.4-.5.9-.5 1.4 0 .6.2 1.2.6 1.6.4.4 1 .8 1.9 1.1.6.2 1 .4 1.3.6.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.1-.5.2-.9.2s-.7-.1-1-.3c-.3-.2-.5-.6-.6-1.1-.1-.3-.4-.5-.8-.5-.3 0-.6.1-.7.3-.1.2-.2.4-.2.8.1.7.4 1.2.8 1.6.335.335.74.53 1.098.702l.202.098v.4c.4.2.8.4 1.2.4ZM21 11h-2.1c-.5 0-1-.4-1-1s.4-1 1-1H21V7c0-.6.5-1 1-1s1 .4 1 1v2h2c.5 0 1 .4 1 1s-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm23 5c-.5 0-1 .4-1 1 0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c.5 0 1-.4 1-1s-.5-1-1-1C10.5 6 6 10.5 6 16s4.5 10 10 10 10-4.5 10-10c0-.6-.5-1-1-1Zm-9 6.4c.4 0 .9-.2.9-.6v-.3c.6-.1 1.1-.4 1.5-.7.5-.4.7-1 .7-1.8 0-.6-.2-1.1-.5-1.5-.3-.5-.9-.9-1.9-1.2-.7-.2-1.2-.4-1.4-.6-.2-.2-.3-.4-.3-.6 0-.2.1-.4.2-.5.2-.1.4-.2.7-.2.3 0 .6.1.8.3.2.2.4.4.5.7 0 .3.3.5.7.5.3 0 .7-.2.8-.4.1-.1.2-.4.1-.7-.2-.5-.4-1-.8-1.3-.3-.3-.7-.5-1.2-.6v-.4c0-.4-.5-.7-.9-.7s-.8.2-.9.6v.4c-.6.2-1.1.5-1.4.9-.3.4-.5.9-.5 1.4 0 .6.2 1.2.6 1.6.4.4 1 .8 1.9 1.1.6.2 1 .4 1.3.6.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.1-.5.2-.9.2s-.7-.1-1-.3c-.3-.2-.5-.6-.6-1.1-.1-.3-.4-.5-.8-.5-.3 0-.6.1-.7.3-.1.2-.2.4-.2.8.1.7.4 1.2.8 1.6.335.335.74.53 1.098.702l.202.098v.4c.4.2.8.4 1.2.4ZM21 11h-2.1c-.5 0-1-.4-1-1s.4-1 1-1H21V7c0-.6.5-1 1-1s1 .4 1 1v2h2c.5 0 1 .4 1 1s-.5 1-1 1h-2v2c0 .6-.5 1-1 1s-1-.4-1-1v-2Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  restaurant: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm11.9 6.1V23c0 .5-.5 1-1.1 1-.6 0-1.1-.4-1.1-1v-6.9c-1.6-.5-2.7-1.9-2.7-3.6V8.8c0-.4.4-.8.9-.8.4 0 .8.4.8.8V12c0 .4.3.7.7.7.4 0 .7-.3.7-.7V8.7c0-.4.3-.7.7-.7.5 0 .8.3.8.7v3.4c0 .4.3.7.7.7.4 0 .7-.3.7-.7V8.8c0-.4.3-.8.8-.8.4 0 .8.3.8.8v3.7c0 1.7-1.1 3.1-2.7 3.6Zm8 7.9c.7 0 1.1-.4 1.1-1V8.9c0-.5-.4-.9-1-.9h-1.3c-1.6 0-2.2 1.1-2.2 2.2V17c0 1 1 1.9 2.3 1.9V23c0 .5.4 1 1.1 1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm11.9 6.1V23c0 .5-.5 1-1.1 1-.6 0-1.1-.4-1.1-1v-6.9c-1.6-.5-2.7-1.9-2.7-3.6V8.8c0-.4.4-.8.9-.8.4 0 .8.4.8.8V12c0 .4.3.7.7.7.4 0 .7-.3.7-.7V8.7c0-.4.3-.7.7-.7.5 0 .8.3.8.7v3.4c0 .4.3.7.7.7.4 0 .7-.3.7-.7V8.8c0-.4.3-.8.8-.8.4 0 .8.3.8.8v3.7c0 1.7-1.1 3.1-2.7 3.6Zm8 7.9c.7 0 1.1-.4 1.1-1V8.9c0-.5-.4-.9-1-.9h-1.3c-1.6 0-2.2 1.1-2.2 2.2V17c0 1 1 1.9 2.3 1.9V23c0 .5.4 1 1.1 1Z",
          fill: "#FF5267"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  security: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14 5.8v6.8c1-.6 3.5-2.7 4.7-6.8H16Zm-4.8-.1H16V9c-.119.086-.25.183-.39.288-1.163.864-3.037 2.255-4.91 2.612 0 1.4.2 2.7.5 3.8Zm5.4-8.5c.9.9 3.7 3.1 5.6 3.1.4 0 .8.4.8.8 0 9.6-6.3 13.2-6.6 13.3-.1.1-.3.1-.4.1-.05 0-.1-.025-.15-.05-.05-.025-.1-.05-.15-.05a1.255 1.255 0 0 0-.022-.01C15.223 24.174 9.1 21.272 9.1 11.1c0-.4.3-.8.8-.8 1.9 0 4.7-2.2 5.6-3.1.3-.3.8-.3 1.1 0Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14 5.8v6.8c1-.6 3.5-2.7 4.7-6.8H16Zm-4.8-.1H16V9c-.119.086-.25.183-.39.288-1.163.864-3.037 2.255-4.91 2.612 0 1.4.2 2.7.5 3.8Zm5.4-8.5c.9.9 3.7 3.1 5.6 3.1.4 0 .8.4.8.8 0 9.6-6.3 13.2-6.6 13.3-.1.1-.3.1-.4.1-.05 0-.1-.025-.15-.05-.05-.025-.1-.05-.15-.05a1.255 1.255 0 0 0-.022-.01C15.223 24.174 9.1 21.272 9.1 11.1c0-.4.3-.8.8-.8 1.9 0 4.7-2.2 5.6-3.1.3-.3.8-.3 1.1 0Z",
          fill: "#1F8BEF"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "service-recharge": {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm24-1.3V17c0 .6-.5 1-1 1-.6 0-1-.4-1-1V9.6c-2.78-1.787-4.968-.814-7.642.374L16.3 10c-2.4 1.1-5.1 2.3-8.4.8v12.5l1.9-1c.8-.4 1.7-.2 2.3.4l.9.9 1.8-1.2c.5-.3 1.1-.2 1.4.3.3.5.2 1.1-.3 1.4l-1.8 1.2c-.3.2-.7.3-1.1.3-.5 0-1-.2-1.4-.6l-.9-.9-1.9 1c-.6.3-1.3.3-1.9-.1-.6-.4-.9-1-.9-1.7V10.7c0-.6.3-1.2.9-1.6.6-.4 1.3-.5 2-.3 2.371 1.138 4.293.297 6.447-.646L15.7 8c2.8-1.3 6-2.7 10 .1v.1c0 .05.025.075.05.1.025.025.05.05.05.1 0 0 .1 0 .1.1.058.058.082.082.092.111A.268.268 0 0 1 26 8.7ZM22 18c.5 0 1 .5 1 1v2h2c.5 0 1 .5 1 1s-.5 1-1 1h-2v2c0 .5-.5 1-1 1s-1-.5-1-1v-2h-2c-.5 0-1-.5-1-1s.5-1 1-1h2v-2c0-.5.5-1 1-1Zm-11-2h10c.5 0 1-.4 1-1s-.5-1-1-1H11c-.6 0-1 .4-1 1s.4 1 1 1Zm0 2h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm24-1.3V17c0 .6-.5 1-1 1-.6 0-1-.4-1-1V9.6c-2.78-1.787-4.968-.814-7.642.374L16.3 10c-2.4 1.1-5.1 2.3-8.4.8v12.5l1.9-1c.8-.4 1.7-.2 2.3.4l.9.9 1.8-1.2c.5-.3 1.1-.2 1.4.3.3.5.2 1.1-.3 1.4l-1.8 1.2c-.3.2-.7.3-1.1.3-.5 0-1-.2-1.4-.6l-.9-.9-1.9 1c-.6.3-1.3.3-1.9-.1-.6-.4-.9-1-.9-1.7V10.7c0-.6.3-1.2.9-1.6.6-.4 1.3-.5 2-.3 2.371 1.138 4.293.297 6.447-.646L15.7 8c2.8-1.3 6-2.7 10 .1v.1c0 .05.025.075.05.1.025.025.05.05.05.1 0 0 .1 0 .1.1.058.058.082.082.092.111A.268.268 0 0 1 26 8.7ZM22 18c.5 0 1 .5 1 1v2h2c.5 0 1 .5 1 1s-.5 1-1 1h-2v2c0 .5-.5 1-1 1s-1-.5-1-1v-2h-2c-.5 0-1-.5-1-1s.5-1 1-1h2v-2c0-.5.5-1 1-1Zm-11-2h10c.5 0 1-.4 1-1s-.5-1-1-1H11c-.6 0-1 .4-1 1s.4 1 1 1Zm0 2h5c.5 0 1 .5 1 1s-.5 1-1 1h-5c-.6 0-1-.5-1-1s.4-1 1-1Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  shopping: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.7 1.8C20.7 9.2 18.6 7 16 7s-4.7 2.2-4.7 4.9h-1.1c-1.2 0-2.2 1-2.2 2.3v8.5c0 1.3 1 2.3 2.2 2.2h11.6c1.2 0 2.2-1 2.2-2.3v-8.5c0-1.3-1-2.3-2.2-2.3h-1.1Zm-8 0c0-1.9 1.5-3.4 3.3-3.4 1.8 0 3.3 1.5 3.4 3.4h-6.7ZM12 16c0-.4.3-.7.7-.7h6.6c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-6.6c-.4 0-.7-.3-.7-.7Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm18.7 1.8C20.7 9.2 18.6 7 16 7s-4.7 2.2-4.7 4.9h-1.1c-1.2 0-2.2 1-2.2 2.3v8.5c0 1.3 1 2.3 2.2 2.2h11.6c1.2 0 2.2-1 2.2-2.3v-8.5c0-1.3-1-2.3-2.2-2.3h-1.1Zm-8 0c0-1.9 1.5-3.4 3.3-3.4 1.8 0 3.3 1.5 3.4 3.4h-6.7ZM12 16c0-.4.3-.7.7-.7h6.6c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-6.6c-.4 0-.7-.3-.7-.7Z",
          fill: "#F281EB"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  sport: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.8-2.1c0 1.1.9 2 1.9 2 1 0 1.8-.9 1.9-2 0-1.1-.9-2-1.9-2-1.1 0-1.9.9-1.9 2Zm-5.2 7.3c-.4.5-1.2.6-1.7.1s-.6-1.3 0-1.6l2.1-2.6c.3-.4.7-.5 1.2-.4l4.5 1.1c.076.038.138.062.191.082A.525.525 0 0 1 18.1 12l3.2 1.8 1.4-1.9c.4-.5 1.2-.6 1.7-.2.5.4.6 1.2.2 1.8l-2.1 2.7c-.4.5-1.1.6-1.6.3l-3.2-1.8-1.7 2.4 3.9 2c.7.4.9 1.2.5 1.9l-2.8 4.6c-.4.6-1.1.8-1.7.4-.6-.4-.8-1.2-.4-1.8l2-3.4-2.9-1.5-.1-.1-1.2 1.7c-.2.3-.6.5-1 .5H8.2c-.6 0-1.2-.6-1.2-1.3 0-.7.5-1.3 1.2-1.3h3.5l3.5-5.1-2-.5-1.6 2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm14.8-2.1c0 1.1.9 2 1.9 2 1 0 1.8-.9 1.9-2 0-1.1-.9-2-1.9-2-1.1 0-1.9.9-1.9 2Zm-5.2 7.3c-.4.5-1.2.6-1.7.1s-.6-1.3 0-1.6l2.1-2.6c.3-.4.7-.5 1.2-.4l4.5 1.1c.076.038.138.062.191.082A.525.525 0 0 1 18.1 12l3.2 1.8 1.4-1.9c.4-.5 1.2-.6 1.7-.2.5.4.6 1.2.2 1.8l-2.1 2.7c-.4.5-1.1.6-1.6.3l-3.2-1.8-1.7 2.4 3.9 2c.7.4.9 1.2.5 1.9l-2.8 4.6c-.4.6-1.1.8-1.7.4-.6-.4-.8-1.2-.4-1.8l2-3.4-2.9-1.5-.1-.1-1.2 1.7c-.2.3-.6.5-1 .5H8.2c-.6 0-1.2-.6-1.2-1.3 0-.7.5-1.3 1.2-1.3h3.5l3.5-5.1-2-.5-1.6 2Z",
          fill: "#36C5AC"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  stoks: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.5-4C24.4 6 26 7.6 26 9.5s-1.4 3.4-3.2 3.5l-1.3 3.6c1 .6 1.6 1.7 1.6 2.9 0 1.9-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5c0-.6.1-1.2.4-1.7l-.2-.2-1.7-2c-.5.3-1 .4-1.6.4h-.3l-1.3 3.6c1 .6 1.6 1.7 1.6 2.9 0 1.9-1.6 3.5-3.5 3.5S6 24.4 6 22.5 7.6 19 9.5 19l1.4-3.8c-.9-.6-1.4-1.6-1.4-2.7C9.5 10.6 11.1 9 13 9s3.5 1.6 3.5 3.5c0 .6-.2 1.2-.5 1.7l1.8 2.1v.1c.5-.2 1.1-.4 1.7-.4l1.3-3.5c-1.1-.6-1.8-1.7-1.8-3C19 7.6 20.6 6 22.5 6ZM8 22.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5Zm3.5-10c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S13.8 11 13 11s-1.5.7-1.5 1.5Zm6.5 7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5Zm6-10c0-.8-.7-1.5-1.5-1.5S21 8.7 21 9.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm20.5-4C24.4 6 26 7.6 26 9.5s-1.4 3.4-3.2 3.5l-1.3 3.6c1 .6 1.6 1.7 1.6 2.9 0 1.9-1.6 3.5-3.5 3.5s-3.5-1.6-3.5-3.5c0-.6.1-1.2.4-1.7l-.2-.2-1.7-2c-.5.3-1 .4-1.6.4h-.3l-1.3 3.6c1 .6 1.6 1.7 1.6 2.9 0 1.9-1.6 3.5-3.5 3.5S6 24.4 6 22.5 7.6 19 9.5 19l1.4-3.8c-.9-.6-1.4-1.6-1.4-2.7C9.5 10.6 11.1 9 13 9s3.5 1.6 3.5 3.5c0 .6-.2 1.2-.5 1.7l1.8 2.1v.1c.5-.2 1.1-.4 1.7-.4l1.3-3.5c-1.1-.6-1.8-1.7-1.8-3C19 7.6 20.6 6 22.5 6ZM8 22.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5Zm3.5-10c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S13.8 11 13 11s-1.5.7-1.5 1.5Zm6.5 7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5Zm6-10c0-.8-.7-1.5-1.5-1.5S21 8.7 21 9.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  "stores-in": {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7.7-3h12.6c1.5 0 2.7 1.1 2.9 2.6l.8 5.3c0 .4-.2.8-.5 1-.1.1-.3.1-.5.1v8c0 1.1-.9 2-2 2h-4c-.5 0-1-.5-1-1v-2.8c0-1.2-.9-2.2-1.9-2.2-.6-.1-1.1.1-1.5.5-.4.4-.6.9-.6 1.5v3c0 .5-.4 1-1 1H9c-1.1 0-2-.9-2-2v-7.8l-.6-.3c-.3-.3-.4-.6-.4-1l.8-5.3C7 8.1 8.3 7 9.7 7Zm0 2c-.4 0-.9.4-.9.9l-.7 4.7c2.77 1.682 4.953.721 7.42-.365l.08-.035c2.3-1.1 5-2.3 8.1-1l-.5-3.3c-.1-.5-.5-.9-1-.9H9.7ZM20 22.2V24h3v-9c-2.4-1-4.4-.1-6.6.9l-.273.12c-1.52.668-3.14 1.38-5.027 1.38-.7 0-1.4-.1-2.1-.3V24h3v-2c0-1.1.4-2.2 1.2-2.9.8-.8 1.9-1.1 3-1.1 2.1.2 3.8 2 3.8 4.2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7.7-3h12.6c1.5 0 2.7 1.1 2.9 2.6l.8 5.3c0 .4-.2.8-.5 1-.1.1-.3.1-.5.1v8c0 1.1-.9 2-2 2h-4c-.5 0-1-.5-1-1v-2.8c0-1.2-.9-2.2-1.9-2.2-.6-.1-1.1.1-1.5.5-.4.4-.6.9-.6 1.5v3c0 .5-.4 1-1 1H9c-1.1 0-2-.9-2-2v-7.8l-.6-.3c-.3-.3-.4-.6-.4-1l.8-5.3C7 8.1 8.3 7 9.7 7Zm0 2c-.4 0-.9.4-.9.9l-.7 4.7c2.77 1.682 4.953.721 7.42-.365l.08-.035c2.3-1.1 5-2.3 8.1-1l-.5-3.3c-.1-.5-.5-.9-1-.9H9.7ZM20 22.2V24h3v-9c-2.4-1-4.4-.1-6.6.9l-.273.12c-1.52.668-3.14 1.38-5.027 1.38-.7 0-1.4-.1-2.1-.3V24h3v-2c0-1.1.4-2.2 1.2-2.9.8-.8 1.9-1.1 3-1.1 2.1.2 3.8 2 3.8 4.2Z",
          fill: "#1C8367"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  stores: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7.7-3h12.6c1.5 0 2.7 1.1 2.9 2.6l.8 5.3c0 .4-.2.8-.5 1-.1.1-.3.1-.5.1v8c0 1.1-.9 2-2 2h-4c-.5 0-1-.5-1-1v-2.8c0-1.2-.9-2.2-1.9-2.2-.6-.1-1.1.1-1.5.5-.4.4-.6.9-.6 1.5v3c0 .5-.4 1-1 1H9c-1.1 0-2-.9-2-2v-7.8l-.6-.3c-.3-.3-.4-.6-.4-1l.8-5.3C7 8.1 8.3 7 9.7 7Zm0 2c-.4 0-.9.4-.9.9l-.7 4.7c2.77 1.682 4.953.721 7.42-.365l.08-.035c2.3-1.1 5-2.3 8.1-1l-.5-3.3c-.1-.5-.5-.9-1-.9H9.7ZM20 22.2V24h3v-9c-2.4-1-4.4-.1-6.6.9l-.273.12c-1.52.668-3.14 1.38-5.027 1.38-.7 0-1.4-.1-2.1-.3V24h3v-2c0-1.1.4-2.2 1.2-2.9.8-.8 1.9-1.1 3-1.1 2.1.2 3.8 2 3.8 4.2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm7.7-3h12.6c1.5 0 2.7 1.1 2.9 2.6l.8 5.3c0 .4-.2.8-.5 1-.1.1-.3.1-.5.1v8c0 1.1-.9 2-2 2h-4c-.5 0-1-.5-1-1v-2.8c0-1.2-.9-2.2-1.9-2.2-.6-.1-1.1.1-1.5.5-.4.4-.6.9-.6 1.5v3c0 .5-.4 1-1 1H9c-1.1 0-2-.9-2-2v-7.8l-.6-.3c-.3-.3-.4-.6-.4-1l.8-5.3C7 8.1 8.3 7 9.7 7Zm0 2c-.4 0-.9.4-.9.9l-.7 4.7c2.77 1.682 4.953.721 7.42-.365l.08-.035c2.3-1.1 5-2.3 8.1-1l-.5-3.3c-.1-.5-.5-.9-1-.9H9.7ZM20 22.2V24h3v-9c-2.4-1-4.4-.1-6.6.9l-.273.12c-1.52.668-3.14 1.38-5.027 1.38-.7 0-1.4-.1-2.1-.3V24h3v-2c0-1.1.4-2.2 1.2-2.9.8-.8 1.9-1.1 3-1.1 2.1.2 3.8 2 3.8 4.2Z",
          fill: "#022A9A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  supermarket: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21.6-.3c.8 0 1.5.3 2 .9.4.6.6 1.3.3 2.1l-.9 3c-.3 1.2-1.4 2-2.7 2h-10l.2.8c0 .3.3.5.6.5H23c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-9.9c-1 0-1.8-.7-1.9-1.6L9.1 8.9c0-.4-.3-.6-.6-.6H6.7c-.4 0-.7-.3-.7-.6 0-.4.3-.7.7-.7h1.8c1 0 1.8.7 1.9 1.6l.2 1.1h13ZM13.5 24.9c.8 0 1.4-.6 1.4-1.3-.1-.7-.7-1.3-1.4-1.3-.8 0-1.4.6-1.4 1.3 0 .7.6 1.3 1.4 1.3Zm6.7-1.3c0-.7.6-1.3 1.4-1.3.8 0 1.4.6 1.4 1.3 0 .7-.6 1.3-1.4 1.3-.8 0-1.4-.6-1.4-1.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm21.6-.3c.8 0 1.5.3 2 .9.4.6.6 1.3.3 2.1l-.9 3c-.3 1.2-1.4 2-2.7 2h-10l.2.8c0 .3.3.5.6.5H23c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-9.9c-1 0-1.8-.7-1.9-1.6L9.1 8.9c0-.4-.3-.6-.6-.6H6.7c-.4 0-.7-.3-.7-.6 0-.4.3-.7.7-.7h1.8c1 0 1.8.7 1.9 1.6l.2 1.1h13ZM13.5 24.9c.8 0 1.4-.6 1.4-1.3-.1-.7-.7-1.3-1.4-1.3-.8 0-1.4.6-1.4 1.3 0 .7.6 1.3 1.4 1.3Zm6.7-1.3c0-.7.6-1.3 1.4-1.3.8 0 1.4.6 1.4 1.3 0 .7-.6 1.3-1.4 1.3-.8 0-1.4-.6-1.4-1.3Z",
          fill: "#FF5935"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  time: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm8 15h12c.5 0 1-.5 1-.9v-1c0-2.1-.8-3.8-2.3-5.1l-.5-.4-1.8-1.5c.6-.6 1.2-1.1 1.8-1.6l.5-.4c1.5-1.3 2.3-3 2.3-5.1V8c0-.6-.5-1-1-1H10c-.6 0-1 .4-1 1v1c0 2.1.8 3.8 2.3 5l.5.4c.6.6 1.2 1.1 1.8 1.6l-1.8 1.5-.5.4C9.8 19.2 9 21 9 23v1c0 .5.4 1 1 1Zm11-2H11c0-1.5.5-2.6 1.6-3.6l.5-.4c.7-.6 1.4-1.2 2.1-1.9.3-.3.5-.8.5-1.2 0-.4-.2-.9-.5-1.2l-2.1-1.8-.5-.4c-1.1-.9-1.6-2-1.6-3.5h10c0 1.4-.5 2.6-1.6 3.6l-.4.4c-.7.5-1.4 1.1-2.1 1.8-.3.3-.5.8-.5 1.2 0 .4.2.9.5 1.2.7.7 1.4 1.3 2.1 1.9l.4.4c1.1.9 1.6 2 1.6 3.5Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm8 15h12c.5 0 1-.5 1-.9v-1c0-2.1-.8-3.8-2.3-5.1l-.5-.4-1.8-1.5c.6-.6 1.2-1.1 1.8-1.6l.5-.4c1.5-1.3 2.3-3 2.3-5.1V8c0-.6-.5-1-1-1H10c-.6 0-1 .4-1 1v1c0 2.1.8 3.8 2.3 5l.5.4c.6.6 1.2 1.1 1.8 1.6l-1.8 1.5-.5.4C9.8 19.2 9 21 9 23v1c0 .5.4 1 1 1Zm11-2H11c0-1.5.5-2.6 1.6-3.6l.5-.4c.7-.6 1.4-1.2 2.1-1.9.3-.3.5-.8.5-1.2 0-.4-.2-.9-.5-1.2l-2.1-1.8-.5-.4c-1.1-.9-1.6-2-1.6-3.5h10c0 1.4-.5 2.6-1.6 3.6l-.4.4c-.7.5-1.4 1.1-2.1 1.8-.3.3-.5.8-.5 1.2 0 .4.2.9.5 1.2.7.7 1.4 1.3 2.1 1.9l.4.4c1.1.9 1.6 2 1.6 3.5Z",
          fill: "#606882"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  transportation: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17 10h-6v-2h6v2Zm-9-1c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1Zm11 1c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1ZM11.1 9c-.6 0-1.1.5-1.1 1.1v4.8c0 .6.5 1.1 1.1 1.1h9.8c.6 0 1.1-.5 1.1-1.1v-4.8c0-.6-.5-1.1-1.1-1.1h-9.8ZM8 9.3C8 8 9.1 7 10.3 7h11.4C22.9 7 24 8 24 9.3v11.3c0 1.3-1 2.3-2.3 2.3H21v1.2c0 .5-.6 1-1.3 1-.7 0-1.4-.4-1.4-1v-1.3h-5V24c0 .5-.6 1-1.3 1-.8 0-1.4-.4-1.4-1v-1.3h-.3c-1.2 0-2.3-1-2.3-2.3V9.3Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm17 10h-6v-2h6v2Zm-9-1c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1Zm11 1c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1ZM11.1 9c-.6 0-1.1.5-1.1 1.1v4.8c0 .6.5 1.1 1.1 1.1h9.8c.6 0 1.1-.5 1.1-1.1v-4.8c0-.6-.5-1.1-1.1-1.1h-9.8ZM8 9.3C8 8 9.1 7 10.3 7h11.4C22.9 7 24 8 24 9.3v11.3c0 1.3-1 2.3-2.3 2.3H21v1.2c0 .5-.6 1-1.3 1-.7 0-1.4-.4-1.4-1v-1.3h-5V24c0 .5-.6 1-1.3 1-.8 0-1.4-.4-1.4-1v-1.3h-.3c-1.2 0-2.3-1-2.3-2.3V9.3Z",
          fill: "#55B3E0"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  travel: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm9.8 13.3c.3.4.7.7 1.2.7.1 0 .2-.025.3-.05.1-.025.2-.05.3-.05.4-.2.7-.7.7-1.2l-.1-2.3 1.8-2 2.1 5.1c.3.5 1.2.7 1.6.2l.7-.7c.4-.4.7-1.1.6-1.7l-.6-6.2s2.8-2.9 2.9-3c1-1.3.7-2.7-.2-3.5-1-1-2.7-.7-3.6.4l-2.6 2.7-6.2-.6c-.6-.1-1.2.2-1.7.6l-.7.6c-.2.2-.3.5-.3.8 0 .3.2.6.5.7l5.1 1.7-1.9 2.3-2.4-.1c-.5 0-1 .3-1.2.7-.2.3-.2.7-.1 1 .1.4.3.6.6.8l2.1 1.1 1.1 2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm9.8 13.3c.3.4.7.7 1.2.7.1 0 .2-.025.3-.05.1-.025.2-.05.3-.05.4-.2.7-.7.7-1.2l-.1-2.3 1.8-2 2.1 5.1c.3.5 1.2.7 1.6.2l.7-.7c.4-.4.7-1.1.6-1.7l-.6-6.2s2.8-2.9 2.9-3c1-1.3.7-2.7-.2-3.5-1-1-2.7-.7-3.6.4l-2.6 2.7-6.2-.6c-.6-.1-1.2.2-1.7.6l-.7.6c-.2.2-.3.5-.3.8 0 .3.2.6.5.7l5.1 1.7-1.9 2.3-2.4-.1c-.5 0-1 .3-1.2.7-.2.3-.2.7-.1 1 .1.4.3.6.6.8l2.1 1.1 1.1 2Z",
          fill: "#448AEC"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  tv: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.2 5.8L18 14c.2-.1.2-.5 0-.7l-2.8-1.7c-.2-.1-.6.1-.6.4v3.5c0 .3.3.5.6.3ZM8 8.9c0-.5.4-.9.9-.9h14.2c.5 0 .9.4.8.9v9.6c0 .5-.4.9-.9.9h-6v2.2h3.1c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2h-8.5c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h3.1v-2.2H8.9c-.5 0-.9-.4-.9-.9V8.9Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm13.2 5.8L18 14c.2-.1.2-.5 0-.7l-2.8-1.7c-.2-.1-.6.1-.6.4v3.5c0 .3.3.5.6.3ZM8 8.9c0-.5.4-.9.9-.9h14.2c.5 0 .9.4.8.9v9.6c0 .5-.4.9-.9.9h-6v2.2h3.1c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2h-8.5c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2h3.1v-2.2H8.9c-.5 0-.9-.4-.9-.9V8.9Z",
          fill: "#717FFF"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  warning: {
    pathDefinition: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.5-1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V9Zm3 14.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 22c0 5.5 4.5 10 10 10h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12Zm2-12c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm12.5-1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V9Zm3 14.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5Z",
          fill: "#E3131A"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  },
  water: {
    pathDefinition: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10.3 9.5c-.3.3.7 3 3.9 3s4.3-2.7 3.9-3c-.104-.104-.245-.027-.509.117-.497.272-1.433.783-3.391.783-1.863 0-2.762-.501-3.271-.786-.312-.173-.477-.266-.629-.114ZM10 18.2C10 13.3 16.2 7 16.2 7s6.2 7.1 6.2 11.2c0 3.8-3 6.1-6.2 6.2-3 .1-6.2-2.5-6.2-6.2Z",
    paths: /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t("g", {
        clipPath: "url(#undefineda)",
        children: /* @__PURE__ */ t("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 32h12c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H10C4.5 0 0 4.5 0 10v12c0 5.5 4.5 10 10 10ZM2 10c0-4.4 3.6-8 8-8h12c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H10c-4.4 0-8-3.6-8-8V10Zm10.3 9.5c-.3.3.7 3 3.9 3s4.3-2.7 3.9-3c-.104-.104-.245-.027-.509.117-.497.272-1.433.783-3.391.783-1.863 0-2.762-.501-3.271-.786-.312-.173-.477-.266-.629-.114ZM10 18.2C10 13.3 16.2 7 16.2 7s6.2 7.1 6.2 11.2c0 3.8-3 6.1-6.2 6.2-3 .1-6.2-2.5-6.2-6.2Z",
          fill: "#34DCDA"
        })
      }), /* @__PURE__ */ t("defs", {
        children: /* @__PURE__ */ t("clipPath", {
          id: "undefineda",
          children: /* @__PURE__ */ t("path", {
            fill: "#fff",
            d: "M0 0h32v32H0z"
          })
        })
      })]
    })
  }
}, V2 = D.forwardRef((e, a) => {
  const {
    ariaHidden: i = !0,
    children: r,
    color: n,
    focusable: c = !1,
    size: s,
    viewBox: o,
    name: l = "loyalty",
    label: d,
    ...v
  } = e, [u, f] = D.useState(l), h = (b) => s === "sm" && Object.keys(Z0).includes(`${b}-sm`) && s === "sm" ? `${b}-sm` : b, $ = (b) => Object.keys(Z0).includes(`${b}-sm`) && s === "sm" ? "0 0 16 16" : "0 0 24 24";
  return u5(() => {
    f(h(l));
  }, [l, u, s]), /* @__PURE__ */ t(T1, {
    ...v,
    className: l,
    "aria-hidden": i,
    "aria-label": d,
    focusable: c,
    size: s,
    viewBox: $(l),
    color: n,
    ref: a,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(A, {
      children: Z0[h(l)].paths ? Z0[h(l)].paths : /* @__PURE__ */ t("path", {
        d: Z0[h(l)].pathDefinition
      })
    })
  });
}), _1 = V2;
V2.displayName = "Icon";
const w2 = b1.forwardRef((e, a) => {
  var u, f;
  const {
    ariaHidden: i = !0,
    label: r,
    children: n,
    focusable: c = !1,
    viewBox: s = "0 0 32 32",
    name: o,
    ...l
  } = e, [d, v] = b1.useState("no-category");
  return u5(() => {
    o && Object.keys(D0).includes(o) && v(o);
  }, [o]), /* @__PURE__ */ t(Pt, {
    ...l,
    "aria-label": r,
    "aria-hidden": i,
    focusable: c,
    viewBox: s,
    ref: a,
    children: /* @__PURE__ */ t(A, {
      children: (u = D0[d]) != null && u.paths ? (f = D0[d]) == null ? void 0 : f.paths : /* @__PURE__ */ t("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: D0[d].pathDefinition
      })
    })
  });
});
w2.displayName = "IconCategory";
const g5 = f2({
  all: "unset",
  alignItems: "center",
  appearance: "none",
  cursor: "pointer",
  borderColor: "transparent",
  borderRadius: "$lg",
  borderStyle: "solid",
  borderWidth: "$medium",
  display: "inline-flex",
  justifyContent: "center",
  lineHeight: "$normal",
  position: "relative",
  transition: "$default",
  userSelect: "none",
  whiteSpace: "nowrap",
  gap: "$4",
  boxSizing: "border-box",
  fontFamily: "$primary",
  outline: "0.25rem transparent solid",
  "& span, & svg": {
    zIndex: 1
  },
  variants: {
    variant: {
      primary: {
        backgroundColor: "$primary-default",
        color: "$neutral-white",
        "&:hover": {
          backgroundColor: "$primary-dark"
        },
        "&:active": {
          backgroundColor: "$primary-darker"
        },
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: "0.25rem solid $primary-light"
        },
        "&:disabled": {
          color: "$neutral-middle",
          backgroundColor: "$neutral-light"
        },
        "&.is-inverted": {
          backgroundColor: "$neutral-white",
          color: "$primary-default",
          "&:hover": {
            backgroundColor: "$primary-lighter",
            color: "$primary-dark"
          },
          "&:active": {
            backgroundColor: "$primary-dark",
            color: "$neutral-white"
          },
          "&:focus": {
            outline: "none"
          },
          "&:focus-visible": {
            outline: "0.25rem solid $primary-light"
          },
          "&:disabled": {
            color: "$primary-darker",
            backgroundColor: "$primary-dark"
          }
        }
      },
      secondary: {
        backgroundColor: "$bg-light",
        borderColor: "$primary-default",
        color: "$primary-default",
        "&:hover": {
          borderColor: "$primary-dark",
          color: "$primary-dark",
          backgroundColor: "$primary-lighter"
        },
        "&:active": {
          borderColor: "$primary-darker",
          color: "$primary-darker",
          backgroundColor: "$primary-light"
        },
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: "0.25rem solid $primary-light"
        },
        "&:disabled": {
          color: "$neutral-middle",
          borderColor: "$neutral-light"
        },
        "&.is-inverted": {
          backgroundColor: "transparent",
          color: "$neutral-white",
          borderColor: "$neutral-white",
          "&:hover": {
            backgroundColor: "$primary-lighter",
            color: "$primary-dark",
            borderColor: "$primary-dark"
          },
          "&:active": {
            backgroundColor: "$primary-dark",
            color: "$neutral-white",
            borderColor: "$neutral-white"
          },
          "&:focus": {
            outline: "none"
          },
          "&:focus-visible": {
            outline: "0.25rem solid $primary-light"
          },
          "&:disabled": {
            color: "$primary-dark",
            borderColor: "$primary-dark",
            backgroundColor: "transparent"
          }
        }
      },
      text: {
        backgroundColor: "transparent",
        color: "$primary-default",
        "&:hover": {
          color: "$primary-dark",
          borderColor: "$primary-dark"
        },
        "&:active": {
          color: "$primary-darker",
          borderColor: "$primary-darker",
          backgroundColor: "$primary-lighter"
        },
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: "0.25rem solid $primary-light"
        },
        "&:disabled": {
          color: "$neutral-middle"
        },
        "&.is-inverted": {
          backgroundColor: "transparent",
          color: "$neutral-white",
          "&:hover": {
            color: "$neutral-white",
            borderColor: "$neutral-white"
          },
          "&:active": {
            color: "$primary-darker",
            borderColor: "$primary-darker"
          },
          "&:focus": {
            outline: "none"
          },
          "&:focus-visible": {
            outline: "0.25rem solid $primary-light"
          },
          "&:disabled": {
            color: "$primary-dark"
          }
        }
      }
    },
    size: {
      sm: {
        ...q.button.md.regular,
        padding: "$none calc($16 - $borderWidths$medium)",
        minHeight: "$32"
      },
      md: {
        ...q.button.lg.regular,
        padding: "$none $12",
        minWidth: s1(320),
        minHeight: "$48",
        "& span": {
          paddingTop: 1
        }
      }
    },
    isDisabled: {
      true: {
        pointerEvents: "none"
      },
      false: {}
    },
    isInverted: {
      true: {},
      false: {}
    },
    isLoading: {
      true: {
        pointerEvents: "none"
      }
    },
    isLoaded: {
      true: {
        pointerEvents: "none"
      }
    },
    isBlock: {
      true: {
        width: "100%",
        minWidth: 0
      }
    }
  },
  compoundVariants: [
    {
      variant: "link",
      size: "md",
      css: {
        padding: "0"
      }
    },
    {
      variant: "link",
      size: "sm",
      css: {
        padding: "0"
      }
    }
  ],
  defaultVariants: {
    variant: "primary",
    size: "md",
    isInverted: !1
  }
}), La = O("a", g5, {
  cursor: "pointer"
});
O("span", g5, {});
const Ta = O("button", g5, {}), Ea = O("span", {
  position: "absolute",
  height: "100%",
  top: 0,
  margin: "0 auto",
  borderRadius: "$lg",
  backgroundColor: "$primary-dark",
  transition: "all 1s ease-in-out",
  zIndex: "0 !important",
  opacity: 0,
  variants: {
    isComplete: {
      true: {
        pointerEvents: "none"
      }
    }
  }
}), Fa = D.forwardRef((e, a) => {
  const {
    icon: i,
    children: r,
    isDisabled: n,
    as: c = "button",
    isInverted: s = !1,
    isLoading: o,
    isLoaded: l,
    onLoaded: d,
    variant: v,
    size: u,
    ...f
  } = e, [h, $] = D.useState(30), [b, x] = D.useState(!1), Z = c !== "button" ? "button" : e.role, S = c !== "button" ? null : e.type || "button";
  let P, z;
  return c === "a" ? (P = La, z = a) : (P = Ta, z = a), w1(() => {
    if (v !== "primary" && u !== "md")
      return;
    o || ($(30), x(!1)), h >= 100 && (d && d(), x(!0)), l && ($(100), x(!0));
    const L = h > 50 ? 500 : 5;
    if (o && !b && !l) {
      const F = setTimeout(() => {
        $(h + 1);
      }, L);
      return () => clearTimeout(F);
    }
  }, [l, o, h, v, u, b]), /* @__PURE__ */ t(P, {
    "aria-disabled": n,
    disabled: n,
    isDisabled: n,
    type: S,
    role: Z,
    ref: z,
    size: u,
    isLoading: o,
    className: s ? "is-inverted" : "",
    variant: v,
    ...f,
    children: /* @__PURE__ */ V(A, {
      children: [i && /* @__PURE__ */ t(_1, {
        name: i,
        label: ""
      }), /* @__PURE__ */ t("span", {
        children: r
      }), /* @__PURE__ */ t(Ea, {
        isComplete: l,
        style: {
          width: `${h.toString()}%`,
          opacity: h < 31 ? 0 : h * 0.01
        }
      })]
    })
  });
});
Fa.displayName = "Button";
const b5 = O(N1, {
  ...q.body.sm.regular,
  "& svg": {
    marginTop: s1(-2)
  },
  defaultVariants: {
    spacing: "4",
    justify: "center",
    align: "center"
  }
}), k2 = O(N1, {
  width: "$32",
  height: s1(32)
}), O0 = O("div", {
  position: "relative",
  overflow: "hidden",
  img: {
    width: "100%",
    height: "100%"
  },
  variants: {
    orientation: {
      vertical: {
        height: s1(70),
        marginBottom: -24,
        img: {
          objectFit: "cover"
        }
      },
      horizontal: {
        maxWidth: s1(158),
        maxHeight: s1(40),
        borderRadius: "$sm",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
        img: {
          objectFit: "contain"
        }
      },
      banner: {
        width: s1(140),
        maxHeight: s1(124),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        img: {
          objectFit: "contain"
        }
      }
    }
  }
}), r5 = O("div", {
  width: s1(40),
  height: s1(40),
  mx: "auto",
  position: "relative",
  zIndex: 1
}), Na = O("div", {
  display: "flex",
  borderRadius: "$md",
  boxShadow: "$sm",
  backgroundColor: "$bg-light",
  transition: "$default",
  cursor: "pointer",
  width: "100%",
  outline: "1px solid $neutral-lighter",
  outlineOffset: "-1px",
  overflow: "hidden",
  "&:hover": {
    boxShadow: "$md",
    backgroundColor: "$bg-hover"
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "$bg-press"
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    outline: "0.25rem $focus solid"
  },
  variants: {
    isDisabled: {
      true: {
        outline: "none",
        pointerEvents: "none",
        boxShadow: "none",
        border: "1px solid $neutral-light",
        transition: "$default",
        "&:focus-visible": {
          outline: "none"
        },
        [`& ${X1}, & ${J1}, & ${b5} , & ${P1}, & ${T1}`]: {
          color: "$neutral-middle"
        },
        [`& ${O0}`]: {
          opacity: 0.5
        }
      },
      false: {}
    },
    isLoading: {
      true: {
        transition: "$default",
        pointerEvents: "none",
        boxShadow: "none"
      },
      false: {}
    },
    variant: {
      horizontal: {
        minWidth: s1(320)
      },
      vertical: {
        minWidth: s1(153)
      }
    }
  }
}), W0 = D.forwardRef((e, a) => {
  const {
    isDisabled: i,
    children: r,
    ...n
  } = e, c = Y1();
  return /* @__PURE__ */ t(Na, {
    role: "button",
    "aria-describedby": `texts-${c}`,
    "aria-disabled": i,
    isDisabled: i,
    tabIndex: 0,
    ref: a,
    ...n,
    children: r
  });
});
W0.displayName = "CardContainer";
const Oa = D.forwardRef((e, a) => {
  const {
    title: i,
    description: r,
    image: n,
    isLoading: c = !1,
    isDisabled: s,
    score: o,
    hasScore: l = !0,
    hasStock: d = !0,
    className: v,
    ...u
  } = e, f = Y1(), h = () => /* @__PURE__ */ t(A, {
    children: /* @__PURE__ */ t(j1, {
      width: "100%",
      children: /* @__PURE__ */ V(f1, {
        spacing: 16,
        align: "center",
        children: [/* @__PURE__ */ t(v1, {
          width: 140,
          height: 124
        }), /* @__PURE__ */ V(f1, {
          direction: "column",
          spacing: 4,
          children: [/* @__PURE__ */ t(v1, {
            width: 100,
            css: {
              minHeight: 17
            }
          }), /* @__PURE__ */ t(v1, {
            width: 137,
            css: {
              minHeight: 17
            }
          }), /* @__PURE__ */ t(v1, {
            width: 56,
            css: {
              minHeight: 17,
              mt: 4
            }
          })]
        })]
      })
    })
  });
  return /* @__PURE__ */ t(W0, {
    ...u,
    ref: a,
    isDisabled: s,
    className: `${v} card-banner`,
    variant: "horizontal",
    isLoading: c,
    children: /* @__PURE__ */ t(f1, {
      spacing: 16,
      css: {
        height: s1(124),
        w: 100
      },
      align: "center",
      className: "card-banner__content",
      children: c ? h() : /* @__PURE__ */ V(A, {
        children: [/* @__PURE__ */ t(O0, {
          orientation: "banner",
          className: "card-banner__image",
          children: n
        }), /* @__PURE__ */ V(f1, {
          direction: "column",
          className: "card-banner__inner",
          spacing: "8",
          css: {
            minWidth: 0,
            flex: 1
          },
          children: [/* @__PURE__ */ V(f1, {
            direction: "column",
            spacing: 0,
            id: `texts-${f}}`,
            className: "card-banner__texts",
            children: [i && /* @__PURE__ */ t(B0, {
              size: "xs",
              as: "h3",
              className: "card-banner__title",
              children: /* @__PURE__ */ t(F1, {
                children: i
              })
            }), r && /* @__PURE__ */ t(j0, {
              size: "sm",
              className: "card-banner__description",
              children: /* @__PURE__ */ t(F1, {
                lines: 3,
                children: r
              })
            })]
          }), l && o ? /* @__PURE__ */ t(b5, {
            justify: "start",
            css: {
              color: d ? "$text-dark" : "$text-default"
            },
            className: "card-vertical__score",
            children: d ? /* @__PURE__ */ V(A, {
              children: [/* @__PURE__ */ t(_1, {
                name: "loyalty-color",
                size: "sm",
                css: {
                  opacity: s ? 0.5 : 1
                }
              }), o]
            }) : "Sin stock"
          }) : null]
        })]
      })
    })
  });
});
Oa.displayName = "CardBanner";
const Wa = [
  "feedback-default",
  "feedback-error",
  "feedback-success",
  "large-activar-biometria-huella-dactilar",
  "large-activar-notificaciones-recordatorios",
  "large-all-in-one",
  "large-aviso-atencion",
  "large-benefits",
  "large-billetera-rendimientos",
  "large-bis-installment",
  "large-caja-ahorro-default",
  "large-card-freeze",
  "large-cash-in-mx",
  "large-challenge-1",
  "large-challenge-2",
  "large-challenge-3",
  "large-cobro-pospro",
  "large-compras-consumo-alt",
  "large-compras-consumo",
  "large-congelar-tarjeta",
  "large-contrato-documentacion-encuesta",
  "large-credit-card-horizontal",
  "large-credit-card-shop",
  "large-credit-card",
  "large-crypto-1",
  "large-crypto-2",
  "large-crypto-3",
  "large-cuenta-bancaria",
  "large-debit-mx-benefits",
  "large-debit-mx-free",
  "large-debit-mx-instant",
  "large-documentacion-usuario",
  "large-documento-y-selfie",
  "large-dollar-mep",
  "large-dollar-send",
  "large-domicilio-en-servicio-factura",
  "large-dorso-documento",
  "large-easy-payment",
  "large-easy-safe",
  "large-error-actualizacion",
  "large-error-conexion",
  "large-error-cuenta-bancaria-cbu",
  "large-error-cuenta-congelada",
  "large-error-fotografia-domicilio",
  "large-error-fotografia-selfie",
  "large-error-generico",
  "large-error-informacion",
  "large-error-limite-diario",
  "large-error-limite-mensual",
  "large-error-monto-limite-diario",
  "large-error-monto-limite-mensual",
  "large-error-o-baja-caja-ahorro",
  "large-error-servicio-desactivado",
  "large-error-time-out",
  "large-error-ubicacion",
  "large-exito-caja-ahorro",
  "large-exito-correo-enviado",
  "large-exito-fotografia-selfie-documento",
  "large-exito-fotografia-selfie",
  "large-exito-generico",
  "large-exito-intermedio-solicitud-tarjeta-credito",
  "large-exito-link",
  "large-exito-solicitud-tarjeta-cred",
  "large-fci-1",
  "large-fci-2",
  "large-fci-3-alt",
  "large-fci-3",
  "large-fotografia-usuario",
  "large-frente-documento",
  "large-generica-ubicacion",
  "large-how-to",
  "large-installment",
  "large-instant",
  "large-inversiones",
  "large-loyalty-experiencia-ganada",
  "large-loyalty-gifts",
  "large-loyalty-mobile",
  "large-loyalty-prices",
  "large-loyalty-puntos-beneficios",
  "large-loyalty-puntos-experiencia-ganadas",
  "large-loyalty-puntos-ganados",
  "large-loyalty-trophy",
  "large-loyalty",
  "large-on-your-phone",
  "large-onboarding-suma-puntos",
  "large-posnet",
  "large-pospro-devoluciones",
  "large-prestamos",
  "large-procesando-documentacion",
  "large-profile-conservative",
  "large-profile-moderate",
  "large-profile-risky",
  "large-promo",
  "large-receipts",
  "large-resale",
  "large-selfie-persona-usuaria",
  "large-shop-online",
  "large-stock-easy",
  "large-stock-investment",
  "large-tacho-de-basura",
  "large-tarjeta-credito-fisica",
  "large-tarjeta-credito-ofrecimiento",
  "large-tarjeta-credito-scoring-insuficiente",
  "large-tienda-uala-bis",
  "large-tienda-virtual-alt",
  "large-tienda-virtual",
  "large-transparency",
  "large-velocimetro-acelerar",
  "large-what-are-stocks",
  "large-wifi",
  "medium-24hs",
  "medium-404-error",
  "medium-48hs",
  "medium-address",
  "medium-apple-pay",
  "medium-authorization",
  "medium-back-documentation",
  "medium-biometry-photo",
  "medium-card-delivery",
  "medium-card-error",
  "medium-card-freeze",
  "medium-card",
  "medium-celebrate-success",
  "medium-connection-error",
  "medium-credit-card-delivery",
  "medium-credit-card",
  "medium-data-analysis",
  "medium-data-analysis2",
  "medium-datafono",
  "medium-discard",
  "medium-document-back-error",
  "medium-document-front-error",
  "medium-heart-error",
  "medium-information-success",
  "medium-investment-profile-data",
  "medium-investment-profile",
  "medium-link-success",
  "medium-loans",
  "medium-location-access-error",
  "medium-location-access",
  "medium-loyalty-level-1",
  "medium-loyalty-level-2",
  "medium-loyalty-level-3",
  "medium-loyalty-level-4",
  "medium-loyalty-level-5",
  "medium-loyalty-level-6",
  "medium-loyalty-trophy",
  "medium-mail-sent-success",
  "medium-mail-sent",
  "medium-mpos-free",
  "medium-mpos",
  "medium-nip-creation",
  "medium-ok-success",
  "medium-onboarding",
  "medium-password-accent",
  "medium-password-success",
  "medium-password",
  "medium-photo-analysis",
  "medium-photo-documents",
  "medium-pin-datafono",
  "medium-pospro-wifi",
  "medium-selfie-error",
  "medium-service-error",
  "medium-stop-error",
  "medium-tea-time",
  "medium-time-out-error",
  "medium-transparency",
  "medium-update-app",
  "medium-upgrade-account",
  "medium-wait",
  "medium-welcome",
  "small-battery",
  "small-beneficios-cash-back",
  "small-bicycle",
  "small-bluetooth",
  "small-calificar",
  "small-card",
  "small-cash-in",
  "small-cobros-uala-bis",
  "small-credit-card",
  "small-cuotificaciones",
  "small-datos-biometricos",
  "small-dni-frame",
  "small-document-back-error",
  "small-document-error",
  "small-escanear-qr",
  "small-gaming",
  "small-healthcare",
  "small-home",
  "small-informacion",
  "small-intereses-remunerada",
  "small-inversiones",
  "small-light",
  "small-logros-desafios-loyalty",
  "small-loyalty",
  "small-mobile",
  "small-movements-empty",
  "small-mpos",
  "small-no-accessories-error",
  "small-no-flash-error",
  "small-no-focus-error",
  "small-pago-servicios",
  "small-payment",
  "small-phone-uala",
  "small-photo-error",
  "small-posnet-chip",
  "small-posnet-contactless",
  "small-posnet-magnetic",
  "small-prestamos",
  "small-promos-descuentos",
  "small-recarga-servicios",
  "small-remesas",
  "small-seguros",
  "small-selfie-error",
  "small-silhouette",
  "small-tarjeta-cred",
  "small-tarjeta-prepaga",
  "small-upgrade-cuenta",
  "small-user-check",
  "small-user"
], ja = O("div", {
  variants: {
    isDisabled: {
      true: {
        opacity: 0.5
      },
      false: {}
    }
  },
  defaultVariants: {
    isDisabled: !1
  }
}), D2 = D.forwardRef((e, a) => {
  const {
    children: i,
    label: r,
    name: n,
    isDisabled: c,
    className: s,
    ...o
  } = e, [l, d] = D.useState(80), [v, u] = D.useState("small-battery"), f = ($) => $.startsWith("large") ? 240 : $.startsWith("medium") ? 184 : 80;
  D.useEffect(() => {
    if (!n)
      throw new Error("El nombre de la ilustraci\xF3n es requerido");
    if (Wa.indexOf(n) === -1)
      throw new Error(`La ilustraci\xF3n ${n} no existe, verifica el nombre`);
    d(f(n)), u(n);
  }, [n, l]);
  const h = o2(() => C2(/* @__PURE__ */ Object.assign({ "../illustrations/feedback-default.tsx": () => import("./feedback-default.6ca5e558.mjs"), "../illustrations/feedback-error.tsx": () => import("./feedback-error.f38240e4.mjs"), "../illustrations/feedback-success.tsx": () => import("./feedback-success.59408ad7.mjs"), "../illustrations/large-activar-biometria-huella-dactilar.tsx": () => import("./large-activar-biometria-huella-dactilar.93900fce.mjs"), "../illustrations/large-activar-notificaciones-recordatorios.tsx": () => import("./large-activar-notificaciones-recordatorios.1704e490.mjs"), "../illustrations/large-all-in-one.tsx": () => import("./large-all-in-one.a6c52eb0.mjs"), "../illustrations/large-aviso-atencion.tsx": () => import("./large-aviso-atencion.431cb8d1.mjs"), "../illustrations/large-benefits.tsx": () => import("./large-benefits.ca2abe5b.mjs"), "../illustrations/large-billetera-rendimientos.tsx": () => import("./large-billetera-rendimientos.16b799f5.mjs"), "../illustrations/large-bis-installment.tsx": () => import("./large-bis-installment.fac98547.mjs"), "../illustrations/large-caja-ahorro-default.tsx": () => import("./large-caja-ahorro-default.83aee704.mjs"), "../illustrations/large-card-freeze.tsx": () => import("./large-card-freeze.bea9d06a.mjs"), "../illustrations/large-cash-in-mx.tsx": () => import("./large-cash-in-mx.c4ed6262.mjs"), "../illustrations/large-challenge-1.tsx": () => import("./large-challenge-1.83e45486.mjs"), "../illustrations/large-challenge-2.tsx": () => import("./large-challenge-2.8b27acea.mjs"), "../illustrations/large-challenge-3.tsx": () => import("./large-challenge-3.accec467.mjs"), "../illustrations/large-cobro-pospro.tsx": () => import("./large-cobro-pospro.bb94070a.mjs"), "../illustrations/large-compras-consumo-alt.tsx": () => import("./large-compras-consumo-alt.28bbfcad.mjs"), "../illustrations/large-compras-consumo.tsx": () => import("./large-compras-consumo.2883c678.mjs"), "../illustrations/large-congelar-tarjeta.tsx": () => import("./large-congelar-tarjeta.afe4213a.mjs"), "../illustrations/large-contrato-documentacion-encuesta.tsx": () => import("./large-contrato-documentacion-encuesta.98cfdc9c.mjs"), "../illustrations/large-credit-card-horizontal.tsx": () => import("./large-credit-card-horizontal.1a5f6b2b.mjs"), "../illustrations/large-credit-card-shop.tsx": () => import("./large-credit-card-shop.5805dcb3.mjs"), "../illustrations/large-credit-card.tsx": () => import("./large-credit-card.a262ad1e.mjs"), "../illustrations/large-crypto-1.tsx": () => import("./large-crypto-1.4994d067.mjs"), "../illustrations/large-crypto-2.tsx": () => import("./large-crypto-2.2a1cf986.mjs"), "../illustrations/large-crypto-3.tsx": () => import("./large-crypto-3.59daa0c6.mjs"), "../illustrations/large-cuenta-bancaria.tsx": () => import("./large-cuenta-bancaria.18a227ae.mjs"), "../illustrations/large-debit-mx-benefits.tsx": () => import("./large-debit-mx-benefits.81966241.mjs"), "../illustrations/large-debit-mx-free.tsx": () => import("./large-debit-mx-free.a451e34b.mjs"), "../illustrations/large-debit-mx-instant.tsx": () => import("./large-debit-mx-instant.55790103.mjs"), "../illustrations/large-documentacion-usuario.tsx": () => import("./large-documentacion-usuario.db4bf638.mjs"), "../illustrations/large-documento-y-selfie.tsx": () => import("./large-documento-y-selfie.0cdf0631.mjs"), "../illustrations/large-dollar-mep.tsx": () => import("./large-dollar-mep.b1488d24.mjs"), "../illustrations/large-dollar-send.tsx": () => import("./large-dollar-send.c38e21e7.mjs"), "../illustrations/large-domicilio-en-servicio-factura.tsx": () => import("./large-domicilio-en-servicio-factura.93fd1981.mjs"), "../illustrations/large-dorso-documento.tsx": () => import("./large-dorso-documento.19b08e3c.mjs"), "../illustrations/large-easy-payment.tsx": () => import("./large-easy-payment.ce4f1298.mjs"), "../illustrations/large-easy-safe.tsx": () => import("./large-easy-safe.0864d795.mjs"), "../illustrations/large-error-actualizacion.tsx": () => import("./large-error-actualizacion.86e0d7e9.mjs"), "../illustrations/large-error-conexion.tsx": () => import("./large-error-conexion.52d91e55.mjs"), "../illustrations/large-error-cuenta-bancaria-cbu.tsx": () => import("./large-error-cuenta-bancaria-cbu.81843544.mjs"), "../illustrations/large-error-cuenta-congelada.tsx": () => import("./large-error-cuenta-congelada.76092e4e.mjs"), "../illustrations/large-error-fotografia-domicilio.tsx": () => import("./large-error-fotografia-domicilio.adc0e339.mjs"), "../illustrations/large-error-fotografia-selfie.tsx": () => import("./large-error-fotografia-selfie.6b901a44.mjs"), "../illustrations/large-error-generico.tsx": () => import("./large-error-generico.23fdb4e3.mjs"), "../illustrations/large-error-informacion.tsx": () => import("./large-error-informacion.819b6fc1.mjs"), "../illustrations/large-error-limite-diario.tsx": () => import("./large-error-limite-diario.d9a41ba6.mjs"), "../illustrations/large-error-limite-mensual.tsx": () => import("./large-error-limite-mensual.45bf7a73.mjs"), "../illustrations/large-error-monto-limite-diario.tsx": () => import("./large-error-monto-limite-diario.cc226e0d.mjs"), "../illustrations/large-error-monto-limite-mensual.tsx": () => import("./large-error-monto-limite-mensual.4f129451.mjs"), "../illustrations/large-error-o-baja-caja-ahorro.tsx": () => import("./large-error-o-baja-caja-ahorro.cc561d68.mjs"), "../illustrations/large-error-servicio-desactivado.tsx": () => import("./large-error-servicio-desactivado.758da081.mjs"), "../illustrations/large-error-time-out.tsx": () => import("./large-error-time-out.10caa9b7.mjs"), "../illustrations/large-error-ubicacion.tsx": () => import("./large-error-ubicacion.b121df62.mjs"), "../illustrations/large-exito-caja-ahorro.tsx": () => import("./large-exito-caja-ahorro.92cb2099.mjs"), "../illustrations/large-exito-correo-enviado.tsx": () => import("./large-exito-correo-enviado.ddd29713.mjs"), "../illustrations/large-exito-fotografia-selfie-documento.tsx": () => import("./large-exito-fotografia-selfie-documento.9a7deb77.mjs"), "../illustrations/large-exito-fotografia-selfie.tsx": () => import("./large-exito-fotografia-selfie.6afb51d0.mjs"), "../illustrations/large-exito-generico.tsx": () => import("./large-exito-generico.a1a551c5.mjs"), "../illustrations/large-exito-intermedio-solicitud-tarjeta-credito.tsx": () => import("./large-exito-intermedio-solicitud-tarjeta-credito.1f99da53.mjs"), "../illustrations/large-exito-link.tsx": () => import("./large-exito-link.b8142b2f.mjs"), "../illustrations/large-exito-solicitud-tarjeta-cred.tsx": () => import("./large-exito-solicitud-tarjeta-cred.a6c05fda.mjs"), "../illustrations/large-fci-1.tsx": () => import("./large-fci-1.d330261c.mjs"), "../illustrations/large-fci-2.tsx": () => import("./large-fci-2.f64cdaf6.mjs"), "../illustrations/large-fci-3-alt.tsx": () => import("./large-fci-3-alt.a4149d49.mjs"), "../illustrations/large-fci-3.tsx": () => import("./large-fci-3.a01493b1.mjs"), "../illustrations/large-fotografia-usuario.tsx": () => import("./large-fotografia-usuario.545c0e41.mjs"), "../illustrations/large-frente-documento.tsx": () => import("./large-frente-documento.fd5f133e.mjs"), "../illustrations/large-generica-ubicacion.tsx": () => import("./large-generica-ubicacion.95930855.mjs"), "../illustrations/large-how-to.tsx": () => import("./large-how-to.d8cb8d41.mjs"), "../illustrations/large-installment.tsx": () => import("./large-installment.da1fe526.mjs"), "../illustrations/large-instant.tsx": () => import("./large-instant.fdb20d14.mjs"), "../illustrations/large-inversiones.tsx": () => import("./large-inversiones.dfd481eb.mjs"), "../illustrations/large-loyalty-experiencia-ganada.tsx": () => import("./large-loyalty-experiencia-ganada.7c7a6c60.mjs"), "../illustrations/large-loyalty-gifts.tsx": () => import("./large-loyalty-gifts.1bbe6ffc.mjs"), "../illustrations/large-loyalty-mobile.tsx": () => import("./large-loyalty-mobile.5012e3d8.mjs"), "../illustrations/large-loyalty-prices.tsx": () => import("./large-loyalty-prices.4a6a24a2.mjs"), "../illustrations/large-loyalty-puntos-beneficios.tsx": () => import("./large-loyalty-puntos-beneficios.f711baef.mjs"), "../illustrations/large-loyalty-puntos-experiencia-ganadas.tsx": () => import("./large-loyalty-puntos-experiencia-ganadas.5b048005.mjs"), "../illustrations/large-loyalty-puntos-ganados.tsx": () => import("./large-loyalty-puntos-ganados.fbb29f9a.mjs"), "../illustrations/large-loyalty-trophy.tsx": () => import("./large-loyalty-trophy.2ebb574d.mjs"), "../illustrations/large-loyalty.tsx": () => import("./large-loyalty.87afbdac.mjs"), "../illustrations/large-on-your-phone.tsx": () => import("./large-on-your-phone.06c938f9.mjs"), "../illustrations/large-onboarding-suma-puntos.tsx": () => import("./large-onboarding-suma-puntos.8489a10a.mjs"), "../illustrations/large-posnet.tsx": () => import("./large-posnet.14cd857e.mjs"), "../illustrations/large-pospro-devoluciones.tsx": () => import("./large-pospro-devoluciones.892f2e8a.mjs"), "../illustrations/large-prestamos.tsx": () => import("./large-prestamos.532ea569.mjs"), "../illustrations/large-procesando-documentacion.tsx": () => import("./large-procesando-documentacion.3832157e.mjs"), "../illustrations/large-profile-conservative.tsx": () => import("./large-profile-conservative.cd51a513.mjs"), "../illustrations/large-profile-moderate.tsx": () => import("./large-profile-moderate.69c71439.mjs"), "../illustrations/large-profile-risky.tsx": () => import("./large-profile-risky.6908d9cd.mjs"), "../illustrations/large-promo.tsx": () => import("./large-promo.e95ce836.mjs"), "../illustrations/large-receipts.tsx": () => import("./large-receipts.3e3ccf81.mjs"), "../illustrations/large-resale.tsx": () => import("./large-resale.67b28b01.mjs"), "../illustrations/large-selfie-persona-usuaria.tsx": () => import("./large-selfie-persona-usuaria.d4a3f688.mjs"), "../illustrations/large-shop-online.tsx": () => import("./large-shop-online.800c3650.mjs"), "../illustrations/large-stock-easy.tsx": () => import("./large-stock-easy.58847060.mjs"), "../illustrations/large-stock-investment.tsx": () => import("./large-stock-investment.4c1b7f8f.mjs"), "../illustrations/large-tacho-de-basura.tsx": () => import("./large-tacho-de-basura.b59c8c1e.mjs"), "../illustrations/large-tarjeta-credito-fisica.tsx": () => import("./large-tarjeta-credito-fisica.1bb8a593.mjs"), "../illustrations/large-tarjeta-credito-ofrecimiento.tsx": () => import("./large-tarjeta-credito-ofrecimiento.53d6b735.mjs"), "../illustrations/large-tarjeta-credito-scoring-insuficiente.tsx": () => import("./large-tarjeta-credito-scoring-insuficiente.5d3af098.mjs"), "../illustrations/large-tienda-uala-bis.tsx": () => import("./large-tienda-uala-bis.e1747038.mjs"), "../illustrations/large-tienda-virtual-alt.tsx": () => import("./large-tienda-virtual-alt.f9011282.mjs"), "../illustrations/large-tienda-virtual.tsx": () => import("./large-tienda-virtual.5c397c49.mjs"), "../illustrations/large-transparency.tsx": () => import("./large-transparency.c05be83c.mjs"), "../illustrations/large-velocimetro-acelerar.tsx": () => import("./large-velocimetro-acelerar.9d525aa4.mjs"), "../illustrations/large-what-are-stocks.tsx": () => import("./large-what-are-stocks.ffc2579e.mjs"), "../illustrations/large-wifi.tsx": () => import("./large-wifi.f73eb501.mjs"), "../illustrations/medium-24hs.tsx": () => import("./medium-24hs.21bc100d.mjs"), "../illustrations/medium-404-error.tsx": () => import("./medium-404-error.14f6ed4a.mjs"), "../illustrations/medium-48hs.tsx": () => import("./medium-48hs.9d706df8.mjs"), "../illustrations/medium-address.tsx": () => import("./medium-address.ae206ed1.mjs"), "../illustrations/medium-apple-pay.tsx": () => import("./medium-apple-pay.b1d10d6e.mjs"), "../illustrations/medium-authorization.tsx": () => import("./medium-authorization.162595ed.mjs"), "../illustrations/medium-back-documentation.tsx": () => import("./medium-back-documentation.9f37e267.mjs"), "../illustrations/medium-biometry-photo.tsx": () => import("./medium-biometry-photo.3aea51ef.mjs"), "../illustrations/medium-card-delivery.tsx": () => import("./medium-card-delivery.277d4cbd.mjs"), "../illustrations/medium-card-error.tsx": () => import("./medium-card-error.4b4a09d9.mjs"), "../illustrations/medium-card-freeze.tsx": () => import("./medium-card-freeze.64c45749.mjs"), "../illustrations/medium-card.tsx": () => import("./medium-card.e35bca52.mjs"), "../illustrations/medium-celebrate-success.tsx": () => import("./medium-celebrate-success.000827a3.mjs"), "../illustrations/medium-connection-error.tsx": () => import("./medium-connection-error.b2145361.mjs"), "../illustrations/medium-credit-card-delivery.tsx": () => import("./medium-credit-card-delivery.ba43d4b2.mjs"), "../illustrations/medium-credit-card.tsx": () => import("./medium-credit-card.f3a756b5.mjs"), "../illustrations/medium-data-analysis.tsx": () => import("./medium-data-analysis.043dee54.mjs"), "../illustrations/medium-data-analysis2.tsx": () => import("./medium-data-analysis2.a5ae0851.mjs"), "../illustrations/medium-datafono.tsx": () => import("./medium-datafono.37d8d88c.mjs"), "../illustrations/medium-discard.tsx": () => import("./medium-discard.7145b773.mjs"), "../illustrations/medium-document-back-error.tsx": () => import("./medium-document-back-error.aa421796.mjs"), "../illustrations/medium-document-front-error.tsx": () => import("./medium-document-front-error.32971c57.mjs"), "../illustrations/medium-heart-error.tsx": () => import("./medium-heart-error.78557283.mjs"), "../illustrations/medium-information-success.tsx": () => import("./medium-information-success.db59d62f.mjs"), "../illustrations/medium-investment-profile-data.tsx": () => import("./medium-investment-profile-data.c31de395.mjs"), "../illustrations/medium-investment-profile.tsx": () => import("./medium-investment-profile.0c559db9.mjs"), "../illustrations/medium-link-success.tsx": () => import("./medium-link-success.d82aca41.mjs"), "../illustrations/medium-loans.tsx": () => import("./medium-loans.1de9dd12.mjs"), "../illustrations/medium-location-access-error.tsx": () => import("./medium-location-access-error.a19760d0.mjs"), "../illustrations/medium-location-access.tsx": () => import("./medium-location-access.a65c2ab4.mjs"), "../illustrations/medium-loyalty-level-1.tsx": () => import("./medium-loyalty-level-1.88bce6c6.mjs"), "../illustrations/medium-loyalty-level-2.tsx": () => import("./medium-loyalty-level-2.28dbda20.mjs"), "../illustrations/medium-loyalty-level-3.tsx": () => import("./medium-loyalty-level-3.aeefcbe2.mjs"), "../illustrations/medium-loyalty-level-4.tsx": () => import("./medium-loyalty-level-4.39396dfd.mjs"), "../illustrations/medium-loyalty-level-5.tsx": () => import("./medium-loyalty-level-5.88604e8f.mjs"), "../illustrations/medium-loyalty-level-6.tsx": () => import("./medium-loyalty-level-6.28722cb1.mjs"), "../illustrations/medium-loyalty-trophy.tsx": () => import("./medium-loyalty-trophy.8eeff3bd.mjs"), "../illustrations/medium-mail-sent-success.tsx": () => import("./medium-mail-sent-success.bb69adf0.mjs"), "../illustrations/medium-mail-sent.tsx": () => import("./medium-mail-sent.2b4f03cb.mjs"), "../illustrations/medium-mpos-free.tsx": () => import("./medium-mpos-free.ceb30779.mjs"), "../illustrations/medium-mpos.tsx": () => import("./medium-mpos.cf97bffc.mjs"), "../illustrations/medium-nip-creation.tsx": () => import("./medium-nip-creation.2716b620.mjs"), "../illustrations/medium-ok-success.tsx": () => import("./medium-ok-success.5cdda2b4.mjs"), "../illustrations/medium-onboarding.tsx": () => import("./medium-onboarding.7ade6ad6.mjs"), "../illustrations/medium-password-accent.tsx": () => import("./medium-password-accent.59e8101a.mjs"), "../illustrations/medium-password-success.tsx": () => import("./medium-password-success.b045cac1.mjs"), "../illustrations/medium-password.tsx": () => import("./medium-password.2b278143.mjs"), "../illustrations/medium-photo-analysis.tsx": () => import("./medium-photo-analysis.2677cbed.mjs"), "../illustrations/medium-photo-documents.tsx": () => import("./medium-photo-documents.2ebd0dda.mjs"), "../illustrations/medium-pin-datafono.tsx": () => import("./medium-pin-datafono.baaeb128.mjs"), "../illustrations/medium-pospro-wifi.tsx": () => import("./medium-pospro-wifi.18ca6966.mjs"), "../illustrations/medium-selfie-error.tsx": () => import("./medium-selfie-error.bece324b.mjs"), "../illustrations/medium-service-error.tsx": () => import("./medium-service-error.0290bdc3.mjs"), "../illustrations/medium-stop-error.tsx": () => import("./medium-stop-error.98b75aab.mjs"), "../illustrations/medium-tea-time.tsx": () => import("./medium-tea-time.0341a0f3.mjs"), "../illustrations/medium-time-out-error.tsx": () => import("./medium-time-out-error.8cda2bb6.mjs"), "../illustrations/medium-transparency.tsx": () => import("./medium-transparency.2dadc9fb.mjs"), "../illustrations/medium-update-app.tsx": () => import("./medium-update-app.fd392c61.mjs"), "../illustrations/medium-upgrade-account.tsx": () => import("./medium-upgrade-account.d4c472c1.mjs"), "../illustrations/medium-wait.tsx": () => import("./medium-wait.6fc38329.mjs"), "../illustrations/medium-welcome.tsx": () => import("./medium-welcome.43d9cca7.mjs"), "../illustrations/small-battery.tsx": () => import("./small-battery.be027103.mjs"), "../illustrations/small-beneficios-cash-back.tsx": () => import("./small-beneficios-cash-back.ae942621.mjs"), "../illustrations/small-bicycle.tsx": () => import("./small-bicycle.547bc7e6.mjs"), "../illustrations/small-bluetooth.tsx": () => import("./small-bluetooth.ef657d27.mjs"), "../illustrations/small-calificar.tsx": () => import("./small-calificar.5ff0e2aa.mjs"), "../illustrations/small-card.tsx": () => import("./small-card.2b2e41f5.mjs"), "../illustrations/small-cash-in.tsx": () => import("./small-cash-in.451577d9.mjs"), "../illustrations/small-cobros-uala-bis.tsx": () => import("./small-cobros-uala-bis.19c8e948.mjs"), "../illustrations/small-credit-card.tsx": () => import("./small-credit-card.7a268485.mjs"), "../illustrations/small-cuotificaciones.tsx": () => import("./small-cuotificaciones.bcd7f444.mjs"), "../illustrations/small-datos-biometricos.tsx": () => import("./small-datos-biometricos.bc54ac90.mjs"), "../illustrations/small-dni-frame.tsx": () => import("./small-dni-frame.f8c2bae8.mjs"), "../illustrations/small-document-back-error.tsx": () => import("./small-document-back-error.609bede4.mjs"), "../illustrations/small-document-error.tsx": () => import("./small-document-error.f5be1f6b.mjs"), "../illustrations/small-escanear-qr.tsx": () => import("./small-escanear-qr.09f76b36.mjs"), "../illustrations/small-gaming.tsx": () => import("./small-gaming.1bc3775b.mjs"), "../illustrations/small-healthcare.tsx": () => import("./small-healthcare.fd5358b4.mjs"), "../illustrations/small-home.tsx": () => import("./small-home.fb3c085c.mjs"), "../illustrations/small-informacion.tsx": () => import("./small-informacion.d6a89e55.mjs"), "../illustrations/small-intereses-remunerada.tsx": () => import("./small-intereses-remunerada.43fd7361.mjs"), "../illustrations/small-inversiones.tsx": () => import("./small-inversiones.763b96b3.mjs"), "../illustrations/small-light.tsx": () => import("./small-light.c3b93902.mjs"), "../illustrations/small-logros-desafios-loyalty.tsx": () => import("./small-logros-desafios-loyalty.466ee7b4.mjs"), "../illustrations/small-loyalty.tsx": () => import("./small-loyalty.67ae040f.mjs"), "../illustrations/small-mobile.tsx": () => import("./small-mobile.7f07e5f3.mjs"), "../illustrations/small-movements-empty.tsx": () => import("./small-movements-empty.922dcd2f.mjs"), "../illustrations/small-mpos.tsx": () => import("./small-mpos.ef975e6c.mjs"), "../illustrations/small-no-accessories-error.tsx": () => import("./small-no-accessories-error.9ed0f1ea.mjs"), "../illustrations/small-no-flash-error.tsx": () => import("./small-no-flash-error.7a2cdd31.mjs"), "../illustrations/small-no-focus-error.tsx": () => import("./small-no-focus-error.c9c8fcab.mjs"), "../illustrations/small-pago-servicios.tsx": () => import("./small-pago-servicios.183d76c1.mjs"), "../illustrations/small-payment.tsx": () => import("./small-payment.3e7028d4.mjs"), "../illustrations/small-phone-uala.tsx": () => import("./small-phone-uala.d4919b58.mjs"), "../illustrations/small-photo-error.tsx": () => import("./small-photo-error.b8307189.mjs"), "../illustrations/small-posnet-chip.tsx": () => import("./small-posnet-chip.e5509813.mjs"), "../illustrations/small-posnet-contactless.tsx": () => import("./small-posnet-contactless.43357a22.mjs"), "../illustrations/small-posnet-magnetic.tsx": () => import("./small-posnet-magnetic.486397ab.mjs"), "../illustrations/small-prestamos.tsx": () => import("./small-prestamos.9cecf2e5.mjs"), "../illustrations/small-promos-descuentos.tsx": () => import("./small-promos-descuentos.cdfeba64.mjs"), "../illustrations/small-recarga-servicios.tsx": () => import("./small-recarga-servicios.2c8d5958.mjs"), "../illustrations/small-remesas.tsx": () => import("./small-remesas.980e2dcf.mjs"), "../illustrations/small-seguros.tsx": () => import("./small-seguros.a072b6fa.mjs"), "../illustrations/small-selfie-error.tsx": () => import("./small-selfie-error.25743442.mjs"), "../illustrations/small-silhouette.tsx": () => import("./small-silhouette.392cba92.mjs"), "../illustrations/small-tarjeta-cred.tsx": () => import("./small-tarjeta-cred.d6e6cd4a.mjs"), "../illustrations/small-tarjeta-prepaga.tsx": () => import("./small-tarjeta-prepaga.a86ae18f.mjs"), "../illustrations/small-upgrade-cuenta.tsx": () => import("./small-upgrade-cuenta.69d671a2.mjs"), "../illustrations/small-user-check.tsx": () => import("./small-user-check.618d96b9.mjs"), "../illustrations/small-user.tsx": () => import("./small-user.d35ae359.mjs") }), `../illustrations/${v}.tsx`));
  return /* @__PURE__ */ t(ja, {
    ref: a,
    ...o,
    isDisabled: c,
    className: `${s} ${n}`,
    children: /* @__PURE__ */ t(s2, {
      fallback: /* @__PURE__ */ t(j1, {
        children: /* @__PURE__ */ t(v1, {
          isCircle: !0,
          width: l,
          height: l
        })
      }),
      children: /* @__PURE__ */ t(h, {
        "aria-label": r
      })
    })
  });
});
D2.displayName = "Illustration";
const R2 = D.forwardRef((e, a) => {
  const {
    as: i = "div",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(N1, {
    ...n,
    as: i,
    ref: a,
    children: r
  });
}), f1 = R2;
R2.displayName = "Stack";
const A2 = D.forwardRef((e, a) => {
  const {
    as: i = "p",
    size: r = "lg",
    children: n,
    ...c
  } = e;
  return /* @__PURE__ */ t(J1, {
    as: i,
    size: r,
    ...c,
    ref: a,
    children: n
  });
}), j0 = A2;
A2.displayName = "Text";
const _2 = D.forwardRef((e, a) => {
  const {
    as: i = "h2",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(X1, {
    ...n,
    as: i,
    ref: a,
    children: r
  });
}), B0 = _2;
_2.displayName = "Title";
const Ba = O("span", {
  maxWidth: "100%",
  minWidth: 0
}), Ya = O("span", {
  overflow: "hidden",
  textOverflow: "ellipsis",
  variants: {
    hasMultiLine: {
      true: {
        "-webkit-box-orient": "vertical",
        display: "-webkit-box"
      },
      false: {
        whiteSpace: "nowrap",
        display: "block"
      }
    }
  },
  defaultVariants: {
    hasMultiLine: !1
  }
}), P2 = D.forwardRef((e, a) => {
  const {
    children: i,
    lines: r = 1,
    ...n
  } = e;
  return /* @__PURE__ */ t(Ba, {
    children: /* @__PURE__ */ t(Ya, {
      ...n,
      ref: a,
      hasMultiLine: r > 1,
      css: r > 1 ? {
        "-webkit-line-clamp": r,
        maxHeight: s1(20 * r)
      } : void 0,
      children: i
    })
  });
}), F1 = P2;
P2.displayName = "Truncated";
const Ga = D.forwardRef((e, a) => {
  const {
    title: i,
    description: r,
    icon: n,
    illustration: c,
    tag: s,
    image: o,
    isLoading: l = !1,
    isDisabled: d,
    className: v,
    ...u
  } = e, f = Y1(), h = () => {
    if (!!s)
      return D.cloneElement(s, {
        size: "md",
        variant: d ? "default" : s.props.variant,
        className: "card-horizontal__tag",
        css: {
          minWidth: 0,
          display: "inline-table"
        }
      });
  }, $ = () => /* @__PURE__ */ t(j1, {
    width: "100%",
    className: "skeleton",
    children: /* @__PURE__ */ V(A, {
      children: [n && /* @__PURE__ */ V(f1, {
        spacing: 16,
        align: "center",
        children: [/* @__PURE__ */ t(v1, {
          width: 32,
          height: 32,
          css: {
            minWidth: 0
          }
        }), /* @__PURE__ */ V(f1, {
          direction: "column",
          spacing: 4,
          css: {
            width: "calc(100% - 16px - 32px)"
          },
          children: [/* @__PURE__ */ t(v1, {
            width: "50%",
            css: {
              minHeight: 17
            }
          }), /* @__PURE__ */ t(v1, {
            width: "75%",
            css: {
              minHeight: 17
            }
          })]
        })]
      }), o && /* @__PURE__ */ t(v1, {
        width: 167,
        height: 40,
        css: {
          margin: "0 auto"
        }
      }), c && /* @__PURE__ */ V(f1, {
        spacing: 16,
        align: "center",
        children: [/* @__PURE__ */ t(v1, {
          width: 80,
          height: 80,
          isCircle: !0
        }), /* @__PURE__ */ V(f1, {
          direction: "column",
          spacing: 4,
          css: {
            width: "calc(100% - 16px - 80px)"
          },
          children: [/* @__PURE__ */ t(v1, {
            width: "50%",
            css: {
              minHeight: 17
            }
          }), /* @__PURE__ */ t(v1, {
            width: "75%",
            css: {
              minHeight: 17
            }
          })]
        })]
      })]
    })
  });
  return /* @__PURE__ */ t(W0, {
    ...u,
    isDisabled: d,
    ref: a,
    className: `${v} card-horizontal`,
    variant: "horizontal",
    isLoading: l,
    children: /* @__PURE__ */ t(f1, {
      spacing: 16,
      justify: "space-between",
      css: {
        p: "$16",
        w: 100,
        minWidth: 0
      },
      align: "center",
      className: "card-horizontal__inner",
      children: l ? $() : /* @__PURE__ */ V(A, {
        children: [o ? /* @__PURE__ */ t(O0, {
          orientation: "horizontal",
          className: "card-horizontal__image-container",
          children: o
        }) : null, o ? null : /* @__PURE__ */ V(f1, {
          spacing: 16,
          align: "center",
          css: {
            minWidth: 0
          },
          className: "card-horizontal__left",
          children: [c ? /* @__PURE__ */ t(D2, {
            isDisabled: d,
            name: c,
            css: {
              display: "flex"
            },
            className: "card-horizontal__illustration"
          }) : null, n ? /* @__PURE__ */ t(k2, {
            align: "center",
            justify: "center",
            css: {
              minWidth: 32
            },
            className: "card-horizontal__icon-container",
            children: /* @__PURE__ */ t(_1, {
              name: n,
              size: "lg",
              color: "primary",
              className: "card-horizontal__icon"
            })
          }) : null, /* @__PURE__ */ V(f1, {
            direction: "column",
            spacing: 0,
            id: `texts-${f}}`,
            className: "card-horizontal__texts",
            css: {
              minWidth: 0
            },
            children: [i && /* @__PURE__ */ t(B0, {
              as: "h3",
              size: "xs",
              className: "card-horizontal__title",
              children: /* @__PURE__ */ t(F1, {
                lines: 1,
                children: i
              })
            }), r && /* @__PURE__ */ t(j0, {
              size: "md",
              className: "card-horizontal__description",
              children: /* @__PURE__ */ t(F1, {
                lines: c ? 3 : 1,
                children: r
              })
            })]
          })]
        }), !c && !o ? /* @__PURE__ */ V(f1, {
          spacing: 16,
          align: "center",
          className: "card-horizontal__right",
          children: [s ? h() : null, c ? null : /* @__PURE__ */ t(_1, {
            name: "right",
            size: "md",
            color: "primary",
            css: {
              width: 24
            },
            className: "card-horizontal__chevron"
          })]
        }) : null]
      })
    })
  });
});
Ga.displayName = "CardHorizontal";
const Ua = D.forwardRef((e, a) => {
  const {
    title: i,
    description: r,
    icon: n,
    avatar: c,
    image: s,
    amount: o,
    score: l,
    isDisabled: d,
    isLoading: v = !1,
    hasScore: u = !0,
    hasStock: f = !0,
    ...h
  } = e, $ = u && l !== void 0, b = () => /* @__PURE__ */ V(B1, {
    className: "skeleton",
    children: [(n || c) && !s && /* @__PURE__ */ t(j1, {
      children: /* @__PURE__ */ V(f1, {
        direction: "column",
        spacing: 8,
        align: "center",
        justify: "center",
        css: {
          p: "$16"
        },
        children: [/* @__PURE__ */ t(v1, {
          width: c ? 40 : 32,
          height: c ? 40 : 32,
          isCircle: !!c,
          css: {
            minWidth: 0
          }
        }), /* @__PURE__ */ V(f1, {
          direction: "column",
          spacing: 4,
          justify: "center",
          align: "center",
          children: [/* @__PURE__ */ t(v1, {
            width: 80,
            css: {
              minHeight: 17
            }
          }), /* @__PURE__ */ t(v1, {
            width: 120,
            css: {
              minHeight: 17
            }
          })]
        })]
      })
    }), s && /* @__PURE__ */ V(A, {
      children: [/* @__PURE__ */ t(j1, {
        css: {
          marginBottom: -24,
          w: 100
        },
        children: /* @__PURE__ */ t(v1, {
          width: "100%",
          height: "70px"
        })
      }), /* @__PURE__ */ t(j1, {
        children: /* @__PURE__ */ V(f1, {
          direction: "column",
          spacing: 0,
          align: "center",
          css: {
            pb: "$16"
          },
          children: [/* @__PURE__ */ t(r5, {
            children: /* @__PURE__ */ t(v1, {
              width: 40,
              height: 40,
              isCircle: !0
            })
          }), /* @__PURE__ */ V(f1, {
            direction: "column",
            spacing: 8,
            align: "center",
            css: {
              px: "$16",
              py: s ? "$8" : "$16"
            },
            children: [/* @__PURE__ */ t(v1, {
              width: 80,
              css: {
                minHeight: 17
              }
            }), /* @__PURE__ */ t(v1, {
              width: 120,
              css: {
                minHeight: 17
              }
            }), /* @__PURE__ */ t(oe, {
              y: 20
            })]
          }), /* @__PURE__ */ t(f1, {
            children: /* @__PURE__ */ t(v1, {
              width: 80,
              css: {
                minHeight: 17,
                mt: 2
              }
            })
          })]
        })
      })]
    }), o && !n && !c && /* @__PURE__ */ t(j1, {
      children: /* @__PURE__ */ V(f1, {
        direction: "column",
        spacing: 4,
        justify: "center",
        align: "center",
        children: [/* @__PURE__ */ t(v1, {
          width: 80,
          css: {
            minHeight: 17
          }
        }), /* @__PURE__ */ t(v1, {
          width: 120,
          css: {
            minHeight: 22
          }
        })]
      })
    })]
  }), x = () => {
    if (!!c)
      return D.cloneElement(c, {
        size: "sm",
        isDisabled: d,
        className: "card-vertical__avatar"
      });
  };
  return /* @__PURE__ */ t(W0, {
    ...h,
    ref: a,
    className: `card-vertical ${h.className || ""}`,
    variant: "vertical",
    isLoading: v,
    isDisabled: d,
    children: /* @__PURE__ */ t(f1, {
      align: "center",
      direction: "column",
      justify: "center",
      spacing: 0,
      css: {
        w: 100,
        minHeight: s1(90)
      },
      className: "card-vertical__container",
      children: v ? b() : /* @__PURE__ */ V(A, {
        children: [s && /* @__PURE__ */ V(f1, {
          direction: "column",
          css: {
            w: 100
          },
          spacing: 0,
          className: "card-vertical__image-container",
          children: [/* @__PURE__ */ t(O0, {
            orientation: "vertical",
            className: "card-vertical__image",
            children: s
          }), c ? /* @__PURE__ */ t(r5, {
            className: "card-vertical__avatar-container",
            children: x()
          }) : null]
        }), /* @__PURE__ */ V(f1, {
          align: "center",
          spacing: 8,
          direction: "column",
          css: {
            px: "$16",
            py: s ? "$12" : "$16"
          },
          className: "card-vertical__inner",
          children: [n && !s ? /* @__PURE__ */ t(k2, {
            align: "center",
            justify: "center",
            css: {
              minWidth: 32
            },
            children: /* @__PURE__ */ t(_1, {
              name: n,
              size: "lg",
              color: "primary",
              className: "card-vertical__icon"
            })
          }) : null, !n && !s && c ? /* @__PURE__ */ t(r5, {
            className: "card-vertical__avatar",
            children: x()
          }) : null, /* @__PURE__ */ V(f1, {
            direction: "column",
            align: "center",
            justify: "center",
            spacing: s ? 4 : 0,
            className: "card-vertical__texts",
            children: [i && /* @__PURE__ */ t(B0, {
              as: "h3",
              size: "xs",
              align: "center",
              className: "card-vertical__title",
              children: /* @__PURE__ */ t(F1, {
                lines: s ? 1 : 2,
                children: i
              })
            }), o && /* @__PURE__ */ t(F0, {
              value: o,
              size: "sm",
              css: {
                margin: "$8 auto 0",
                color: d ? "$neutral-middle" : "$text-default",
                fontWeight: 500
              },
              className: "card-vertical__amount"
            }), r && !o && /* @__PURE__ */ t(j0, {
              size: "sm",
              align: "center",
              className: "card-vertical__description",
              css: {
                minHeight: s ? s1(51) : 0
              },
              color: d ? "disabled" : "default",
              children: /* @__PURE__ */ t(F1, {
                lines: 2,
                children: r
              })
            })]
          }), $ && l ? /* @__PURE__ */ t(b5, {
            css: {
              color: f ? "$text-dark" : "$text-default"
            },
            className: "card-vertical__score",
            children: f ? /* @__PURE__ */ V(A, {
              children: [/* @__PURE__ */ t(_1, {
                name: "loyalty-color",
                size: "sm",
                css: {
                  opacity: d ? 0.5 : 1
                }
              }), l]
            }) : "Sin stock"
          }) : null]
        })]
      })
    })
  });
});
Ua.displayName = "CardVertical";
function E1(e, a, { checkForDefaultPrevented: i = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), i === !1 || !n.defaultPrevented)
      return a == null ? void 0 : a(n);
  };
}
function Y0({ prop: e, defaultProp: a, onChange: i = () => {
} }) {
  const [r, n] = qa({
    defaultProp: a,
    onChange: i
  }), c = e !== void 0, s = c ? e : r, o = N0(i), l = e0((d) => {
    if (c) {
      const u = typeof d == "function" ? d(e) : d;
      u !== e && o(u);
    } else
      n(d);
  }, [
    c,
    e,
    n,
    o
  ]);
  return [
    s,
    l
  ];
}
function qa({ defaultProp: e, onChange: a }) {
  const i = A1(e), [r] = i, n = y1(r), c = N0(a);
  return w1(() => {
    n.current !== r && (c(r), n.current = r);
  }, [
    r,
    n,
    c
  ]), i;
}
function $5(e) {
  const a = y1({
    value: e,
    previous: e
  });
  return m0(() => (a.current.value !== e && (a.current.previous = a.current.value, a.current.value = e), a.current.previous), [
    e
  ]);
}
function y5(e) {
  const [a, i] = A1(void 0);
  return V0(() => {
    if (e) {
      i({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const c = n[0];
        let s, o;
        if ("borderBoxSize" in c) {
          const l = c.borderBoxSize, d = Array.isArray(l) ? l[0] : l;
          s = d.inlineSize, o = d.blockSize;
        } else
          s = e.offsetWidth, o = e.offsetHeight;
        i({
          width: s,
          height: o
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      i(void 0);
  }, [
    e
  ]), a;
}
function Ka(e, a) {
  return De((i, r) => {
    const n = a[i][r];
    return n != null ? n : i;
  }, e);
}
const Z5 = (e) => {
  const { present: a, children: i } = e, r = Ja(a), n = typeof i == "function" ? i({
    present: r.isPresent
  }) : a0.only(i), c = t0(r.ref, n.ref);
  return typeof i == "function" || r.isPresent ? /* @__PURE__ */ f5(n, {
    ref: c
  }) : null;
};
Z5.displayName = "Presence";
function Ja(e) {
  const [a, i] = A1(), r = y1({}), n = y1(e), c = y1("none"), s = e ? "mounted" : "unmounted", [o, l] = Ka(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return w1(() => {
    const d = R0(r.current);
    c.current = o === "mounted" ? d : "none";
  }, [
    o
  ]), V0(() => {
    const d = r.current, v = n.current;
    if (v !== e) {
      const f = c.current, h = R0(d);
      e ? l("MOUNT") : h === "none" || (d == null ? void 0 : d.display) === "none" ? l("UNMOUNT") : l(v && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [
    e,
    l
  ]), V0(() => {
    if (a) {
      const d = (u) => {
        const h = R0(r.current).includes(u.animationName);
        u.target === a && h && Re(
          () => l("ANIMATION_END")
        );
      }, v = (u) => {
        u.target === a && (c.current = R0(r.current));
      };
      return a.addEventListener("animationstart", v), a.addEventListener("animationcancel", d), a.addEventListener("animationend", d), () => {
        a.removeEventListener("animationstart", v), a.removeEventListener("animationcancel", d), a.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [
    a,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(o),
    ref: e0((d) => {
      d && (r.current = getComputedStyle(d)), i(d);
    }, [])
  };
}
function R0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const z2 = "Checkbox", [Xa, Di] = o0(z2), [Qa, e4] = Xa(z2), t4 = /* @__PURE__ */ C1((e, a) => {
  const { __scopeCheckbox: i, name: r, checked: n, defaultChecked: c, required: s, disabled: o, value: l = "on", onCheckedChange: d, ...v } = e, [u, f] = A1(null), h = t0(
    a,
    (S) => f(S)
  ), $ = y1(!1), b = u ? Boolean(u.closest("form")) : !0, [x = !1, Z] = Y0({
    prop: n,
    defaultProp: c,
    onChange: d
  });
  return /* @__PURE__ */ t1(Qa, {
    scope: i,
    state: x,
    disabled: o
  }, /* @__PURE__ */ t1(z1.button, $1({
    type: "button",
    role: "checkbox",
    "aria-checked": n0(x) ? "mixed" : x,
    "aria-required": s,
    "data-state": I2(x),
    "data-disabled": o ? "" : void 0,
    disabled: o,
    value: l
  }, v, {
    ref: h,
    onKeyDown: E1(e.onKeyDown, (S) => {
      S.key === "Enter" && S.preventDefault();
    }),
    onClick: E1(e.onClick, (S) => {
      Z(
        (P) => n0(P) ? !0 : !P
      ), b && ($.current = S.isPropagationStopped(), $.current || S.stopPropagation());
    })
  })), b && /* @__PURE__ */ t1(i4, {
    control: u,
    bubbles: !$.current,
    name: r,
    value: l,
    checked: x,
    required: s,
    disabled: o,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), a4 = "CheckboxIndicator", r4 = /* @__PURE__ */ C1((e, a) => {
  const { __scopeCheckbox: i, forceMount: r, ...n } = e, c = e4(a4, i);
  return /* @__PURE__ */ t1(Z5, {
    present: r || n0(c.state) || c.state === !0
  }, /* @__PURE__ */ t1(z1.span, $1({
    "data-state": I2(c.state),
    "data-disabled": c.disabled ? "" : void 0
  }, n, {
    ref: a,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), i4 = (e) => {
  const { control: a, checked: i, bubbles: r = !0, ...n } = e, c = y1(null), s = $5(i), o = y5(a);
  return w1(() => {
    const l = c.current, d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== i && u) {
      const f = new Event("click", {
        bubbles: r
      });
      l.indeterminate = n0(i), u.call(l, n0(i) ? !1 : i), l.dispatchEvent(f);
    }
  }, [
    s,
    i,
    r
  ]), /* @__PURE__ */ t1("input", $1({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n0(i) ? !1 : i
  }, n, {
    tabIndex: -1,
    ref: c,
    style: {
      ...e.style,
      ...o,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function n0(e) {
  return e === "indeterminate";
}
function I2(e) {
  return n0(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const n4 = t4, c4 = r4, A0 = O(c4, {
  "& svg": {
    opacity: 0
  }
}), l4 = O(N1, {
  width: "$48",
  height: "$48",
  defaultVariants: {
    spacing: "0",
    align: "center",
    justify: "center"
  }
}), L2 = O(n4, {
  all: "unset",
  backgroundColor: "transparent",
  borderRadius: "$xs",
  border: "1px solid $neutral-middle",
  transition: "$default",
  outline: "0.25rem solid transparent",
  width: "1.375rem",
  height: "1.375rem",
  [`& ${A0} svg`]: {
    fill: "white",
    width: "1.375rem",
    height: "1.375rem"
  },
  "&:hover": {
    borderColor: "$neutral-dark"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$primary-default",
    borderColor: "$primary-default",
    [`& ${A0} svg`]: {
      opacity: 1
    },
    "&:disabled": {
      borderColor: "$neutral-middle",
      backgroundColor: "$neutral-middle",
      [`& ${A0} svg`]: {
        fill: "white"
      }
    }
  },
  "&:focus": {
    outline: "0.25rem solid transparent"
  },
  "&:focus-visible": {
    outline: "0.25rem solid $primary-light"
  },
  "&:disabled": {
    pointerEvents: "none",
    borderColor: "$neutral-light"
  }
}), o4 = D.forwardRef((e, a) => {
  const {
    isDisabled: i,
    isRequired: r,
    isChecked: n,
    isDefaultChecked: c,
    label: s,
    id: o,
    ...l
  } = e, d = `field-${Y1()}`;
  return /* @__PURE__ */ t(l4, {
    children: /* @__PURE__ */ t(L2, {
      ...l,
      disabled: i,
      required: r,
      "aria-label": s,
      checked: n,
      defaultChecked: c,
      id: o || d,
      ref: a,
      children: /* @__PURE__ */ t(A0, {
        children: /* @__PURE__ */ t(_1, {
          name: "check-fill",
          color: "light",
          css: {
            width: 24
          }
        })
      })
    })
  });
});
o4.displayName = "Checkbox";
const s4 = () => {
  const e = [];
  for (let a = 0; a < 13; a++)
    e.push({ gridTemplateColumns: "repeat(" + a + ", 1fr)" });
  return e;
}, d4 = () => {
  const e = [];
  for (let a = 0; a < 13; a++)
    e.push({ gridTemplateRows: "repeat(" + a + ", 1fr)" });
  return e;
}, u4 = O("div", {
  all: "unset",
  display: "grid",
  variants: {
    cols: { ...s4() },
    rows: { ...d4() },
    spacing: {
      0: {
        gap: 0
      },
      4: {
        gap: "$4"
      },
      8: {
        gap: "$8"
      },
      12: {
        gap: "$12"
      },
      16: {
        gap: "$16"
      },
      20: {
        gap: "$20"
      },
      24: {
        gap: "$24"
      },
      32: {
        gap: "$32"
      },
      40: {
        gap: "$40"
      },
      48: {
        gap: "$48"
      }
    }
  },
  defaultVariants: {
    cols: "2",
    rows: "1",
    spacing: "12"
  }
}), f4 = O(B1, {}), h4 = D.forwardRef((e, a) => {
  const {
    as: i = "div",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(u4, {
    ...n,
    as: i,
    ref: a,
    children: e.children
  });
});
h4.displayName = "Grid";
const m4 = D.forwardRef((e, a) => {
  const {
    colSpan: i = 0,
    rowSpan: r = 0,
    css: n,
    ...c
  } = e;
  return /* @__PURE__ */ t(f4, {
    ...c,
    css: {
      ...n,
      ...Et(r, i)
    },
    ref: a,
    children: e.children
  });
});
m4.displayName = "GridItem";
const T2 = O("span", {
  all: "unset",
  ...q.label.sm.regular,
  color: "$neutral-darker",
  display: "flex",
  alignItems: "flex-start",
  lineHeight: "1rem",
  gap: "$4",
  transition: "$default",
  "& svg": {
    flex: "none"
  },
  variants: {
    variant: {
      default: {
        color: "$neutral-dark"
      },
      error: {
        color: "$error-middle"
      },
      disabled: {
        color: "$neutral-middle"
      },
      information: {
        color: "$information-middle"
      },
      success: {
        color: "$success-middle"
      },
      warning: {
        color: "$warning-dark",
        "& svg": {
          color: "$warning-middle"
        }
      }
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), w0 = D.forwardRef((e, a) => {
  const {
    children: i,
    variant: r,
    ...n
  } = e, c = D.useMemo(() => {
    if (r === "error")
      return "denied-circle";
    if (r === "warning")
      return "warning-circle";
    if (r === "success")
      return "check-circle";
    if (r === "information")
      return "info-circle-feedback";
  }, [r]);
  return /* @__PURE__ */ V(T2, {
    ...n,
    variant: r,
    ref: a,
    children: [c && /* @__PURE__ */ t(_1, {
      name: c,
      size: "sm"
    }), i]
  });
});
w0.displayName = "HelpText";
const x5 = f2({
  alignItems: "center",
  appearance: "none",
  backgroundColor: "transparent",
  border: "none",
  borderRadius: "$lg",
  boxSizing: "border-box",
  cursor: "pointer",
  display: "inline-flex",
  fontWeight: "$regular",
  justifyContent: "center",
  lineHeight: "$normal",
  position: "relative",
  transition: "$default",
  userSelect: "none",
  whiteSpace: "nowrap",
  outline: "0.25rem transparent solid",
  width: "$48",
  height: "$48",
  padding: "$8",
  "&:hover": {
    backgroundColor: "$primary-lighter"
  },
  "&:active": {
    backgroundColor: "$primary-light"
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    outline: "0.25rem solid $primary-light"
  },
  variants: {
    isDisabled: {
      true: {
        pointerEvents: "none",
        color: "$neutral-middle"
      },
      false: {}
    },
    variant: {
      default: {
        color: "$primary-default"
      },
      neutral: {
        color: "$neutral-dark"
      }
    },
    isInverted: {
      true: {
        color: "$neutral-lighter",
        "&:hover": {
          backgroundColor: "$primary-lighter",
          color: "$primary-default"
        },
        "&:active": {
          backgroundColor: "$primary-light",
          color: "$primary-default"
        },
        "&:focus": {
          outline: "none"
        },
        "&:focus-visible": {
          outline: "0.25rem solid $primary-light"
        }
      },
      false: {}
    }
  },
  defaultVariants: {
    variant: "default"
  },
  compoundVariants: [
    {
      isInverted: !0,
      isDisabled: !0,
      css: {
        color: "$primary-dark"
      }
    }
  ]
}), p4 = O("a", x5, {});
O("span", x5, {});
const v4 = O("button", x5, {}), g4 = D.forwardRef((e, a) => {
  const {
    children: i,
    isDisabled: r,
    label: n,
    icon: c,
    as: s = "button",
    ...o
  } = e, l = s !== "button" ? "button" : e.role, d = s !== "button" ? null : e.type || "button";
  let v, u;
  return s === "a" ? (v = p4, u = a) : (v = v4, u = a), /* @__PURE__ */ t(v, {
    ...o,
    "aria-disabled": r,
    disabled: r,
    isDisabled: r,
    "aria-label": n,
    type: d,
    role: l,
    ref: u,
    children: c ? /* @__PURE__ */ t(_1, {
      name: c
    }) : i
  });
});
g4.displayName = "IconButton";
const b4 = D.forwardRef((e, a) => /* @__PURE__ */ t(U0, {
  ...e,
  size: "sm",
  ref: a
}));
b4.displayName = "Input";
function E2(e, a) {
  var i = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && a.indexOf(r) < 0 && (i[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      a.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (i[r[n]] = e[r[n]]);
  return i;
}
var k0;
(function(e) {
  e.event = "event", e.props = "prop";
})(k0 || (k0 = {}));
function Q1() {
}
function I0(e) {
  return !!(e || "").match(/\d/);
}
function M0(e) {
  return e == null;
}
function F2(e) {
  return typeof e == "number" && isNaN(e);
}
function N2(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function $4(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function y4(e, a, i) {
  var r = $4(i), n = e.search(/[1-9]/);
  return n = n === -1 ? e.length : n, e.substring(0, n) + e.substring(n, e.length).replace(r, "$1" + a);
}
function Z4(e) {
  var a = y1(e);
  a.current = e;
  var i = y1(function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return a.current.apply(a, r);
  });
  return i.current;
}
function S5(e, a) {
  a === void 0 && (a = !0);
  var i = e[0] === "-", r = i && a;
  e = e.replace("-", "");
  var n = e.split("."), c = n[0], s = n[1] || "";
  return {
    beforeDecimal: c,
    afterDecimal: s,
    hasNegation: i,
    addNegation: r
  };
}
function x4(e) {
  if (!e)
    return e;
  var a = e[0] === "-";
  a && (e = e.substring(1, e.length));
  var i = e.split("."), r = i[0].replace(/^0+/, "") || "0", n = i[1] || "";
  return (a ? "-" : "") + r + (n ? "." + n : "");
}
function O2(e, a, i) {
  for (var r = "", n = i ? "0" : "", c = 0; c <= a - 1; c++)
    r += e[c] || n;
  return r;
}
function t2(e, a) {
  return Array(a + 1).join(e);
}
function W2(e) {
  var a = e + "", i = a[0] === "-" ? "-" : "";
  i && (a = a.substring(1));
  var r = a.split(/[eE]/g), n = r[0], c = r[1];
  if (c = Number(c), !c)
    return i + n;
  n = n.replace(".", "");
  var s = 1 + c, o = n.length;
  return s < 0 ? n = "0." + t2("0", Math.abs(s)) + n : s >= o ? n = n + t2("0", s - o) : n = (n.substring(0, s) || "0") + "." + n.substring(s), i + n;
}
function a2(e, a, i) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || i) && a, n = S5(e), c = n.beforeDecimal, s = n.afterDecimal, o = n.hasNegation, l = parseFloat("0." + (s || "0")), d = s.length <= a ? "0." + s : l.toFixed(a), v = d.split("."), u = c.split("").reverse().reduce(function(b, x, Z) {
    return b.length > Z ? (Number(b[0]) + Number(x)).toString() + b.substring(1, b.length) : x + b;
  }, v[0]), f = O2(v[1] || "", a, i), h = o ? "-" : "", $ = r ? "." : "";
  return "" + h + u + $ + f;
}
function h0(e, a) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var i = e.createTextRange();
      return i.move("character", a), i.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(a, a), !0) : (e.focus(), !1);
  }
}
function S4(e, a) {
  for (var i = 0, r = 0, n = e.length, c = a.length; e[i] === a[i] && i < n; )
    i++;
  for (; e[n - 1 - r] === a[c - 1 - r] && c - r > i && n - r > i; )
    r++;
  return {
    from: {
      start: i,
      end: n - r
    },
    to: {
      start: i,
      end: c - r
    }
  };
}
function M4(e, a, i) {
  return Math.min(Math.max(e, a), i);
}
function r2(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function H4() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function C4(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function V4(e, a, i, r, n, c) {
  var s = n.findIndex(function(S) {
    return S;
  }), o = e.slice(0, s);
  !a && !i.startsWith(o) && (i = o + i, r = r + o.length);
  for (var l = i.length, d = e.length, v = {}, u = new Array(l), f = 0; f < l; f++) {
    u[f] = -1;
    for (var h = 0, $ = d; h < $; h++)
      if (i[f] === e[h] && v[h] !== !0) {
        u[f] = h, v[h] = !0;
        break;
      }
  }
  for (var b = r; b < l && (u[b] === -1 || !c(i[b])); )
    b++;
  var x = b === l || u[b] === -1 ? d : u[b];
  for (b = r - 1; b > 0 && u[b] === -1; )
    b--;
  var Z = b === -1 || u[b] === -1 ? 0 : u[b] + 1;
  return Z > x ? x : r - Z < x - r ? Z : x;
}
function i2(e, a, i, r) {
  var n = e.length;
  if (a = M4(a, 0, n), r === "left") {
    for (; a >= 0 && !i[a]; )
      a--;
    a === -1 && (a = i.indexOf(!0));
  } else {
    for (; a <= n && !i[a]; )
      a++;
    a > n && (a = i.lastIndexOf(!0));
  }
  return a === -1 && (a = n), a;
}
function w4(e) {
  for (var a = Array.from({
    length: e.length + 1
  }).map(function() {
    return !0;
  }), i = 0, r = a.length; i < r; i++)
    a[i] = Boolean(I0(e[i]) || I0(e[i - 1]));
  return a;
}
function j2(e, a, i, r, n, c) {
  c === void 0 && (c = Q1);
  var s = y1(), o = Z4(function(f) {
    var h, $;
    return M0(f) || F2(f) ? ($ = "", h = "") : typeof f == "number" || i ? ($ = typeof f == "number" ? W2(f) : f, h = r($)) : ($ = n(f, void 0), h = f), {
      formattedValue: h,
      numAsString: $
    };
  }), l = A1(function() {
    return o(a);
  }), d = l[0], v = l[1], u = function(f, h) {
    v({
      formattedValue: f.formattedValue,
      numAsString: f.value
    }), c(f, h);
  };
  return m0(function() {
    M0(e) ? s.current = void 0 : (s.current = o(e), v(s.current));
  }, [e, o]), [d, u];
}
function k4(e) {
  return e.replace(/[^0-9]/g, "");
}
function D4(e) {
  return e;
}
function R4(e) {
  var a = e.type;
  a === void 0 && (a = "text");
  var i = e.displayType;
  i === void 0 && (i = "input");
  var r = e.customInput, n = e.renderText, c = e.getInputRef, s = e.format;
  s === void 0 && (s = D4);
  var o = e.removeFormatting;
  o === void 0 && (o = k4);
  var l = e.defaultValue, d = e.valueIsNumericString, v = e.onValueChange, u = e.isAllowed, f = e.onChange;
  f === void 0 && (f = Q1);
  var h = e.onKeyDown;
  h === void 0 && (h = Q1);
  var $ = e.onMouseUp;
  $ === void 0 && ($ = Q1);
  var b = e.onFocus;
  b === void 0 && (b = Q1);
  var x = e.onBlur;
  x === void 0 && (x = Q1);
  var Z = e.value, S = e.getCaretBoundary;
  S === void 0 && (S = w4);
  var P = e.isValidInputCharacter;
  P === void 0 && (P = I0);
  var z = E2(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter"]), L = j2(Z, l, Boolean(d), s, o, v), F = L[0], I = F.formattedValue, U = F.numAsString, T = L[1], M = y1(), Y = function(N, W) {
    M.current = N.formattedValue, T(N, W);
  };
  w1(function() {
    var N = s(U);
    if (M.current === void 0 || N !== M.current) {
      var W = p.current;
      G({
        formattedValue: N,
        numAsString: U,
        input: W,
        setCaretPosition: !0,
        source: k0.props,
        event: void 0
      });
    }
  });
  var Q = A1(!1), H = Q[0], y = Q[1], p = y1(null), C = y1({
    setCaretTimeout: null,
    focusTimeout: null
  });
  w1(function() {
    return y(!0), function() {
      clearTimeout(C.current.setCaretTimeout), clearTimeout(C.current.focusTimeout);
    };
  }, []);
  var g = s, k = function(N, W) {
    var J = parseFloat(W);
    return {
      formattedValue: N,
      value: W,
      floatValue: isNaN(J) ? void 0 : J
    };
  }, w = function(N, W, J) {
    h0(N, W), C.current.setCaretTimeout = setTimeout(function() {
      N.value === J && h0(N, W);
    }, 0);
  }, _ = function(N, W, J) {
    return i2(N, W, S(N), J);
  }, j = function(N, W, J) {
    var a1 = S(W), h1 = V4(W, I, N, J, a1, P);
    return h1 = i2(W, h1, a1), h1;
  }, G = function(N) {
    var W = N.formattedValue;
    W === void 0 && (W = "");
    var J = N.input, a1 = N.setCaretPosition;
    a1 === void 0 && (a1 = !0);
    var h1 = N.source, m1 = N.event, x1 = N.numAsString, S1 = N.caretPos;
    if (J) {
      if (S1 === void 0 && a1) {
        var O1 = N.inputValue || J.value, K1 = r2(J);
        J.value = W, S1 = j(O1, W, K1);
      }
      J.value = W, a1 && S1 !== void 0 && w(J, S1, W);
    }
    W !== I && Y(k(W, x1), {
      event: m1,
      source: h1
    });
  }, K = function(N, W, J) {
    var a1 = S4(I, N), h1 = Object.assign(Object.assign({}, a1), {
      lastValue: I
    }), m1 = o(N, h1), x1 = g(m1);
    if (u && !u(k(x1, m1))) {
      var S1 = W.target, O1 = r2(S1), K1 = j(N, I, O1);
      return w(S1, K1, I), !1;
    }
    return G({
      formattedValue: x1,
      numAsString: m1,
      inputValue: N,
      event: W,
      source: J,
      setCaretPosition: !0,
      input: W.target
    }), !0;
  }, l1 = function(N) {
    var W = N.target, J = W.value, a1 = K(J, N, k0.event);
    a1 && f(N);
  }, n1 = function(N) {
    var W = N.target, J = N.key, a1 = W.selectionStart, h1 = W.selectionEnd, m1 = W.value;
    m1 === void 0 && (m1 = "");
    var x1;
    if (J === "ArrowLeft" || J === "Backspace" ? x1 = Math.max(a1 - 1, 0) : J === "ArrowRight" ? x1 = Math.min(a1 + 1, m1.length) : J === "Delete" && (x1 = a1), x1 === void 0 || a1 !== h1) {
      h(N);
      return;
    }
    var S1 = x1;
    if (J === "ArrowLeft" || J === "ArrowRight") {
      var O1 = J === "ArrowLeft" ? "left" : "right";
      S1 = _(m1, x1, O1);
    } else
      J === "Delete" && !P(m1[x1]) ? S1 = _(m1, x1, "right") : J === "Backspace" && !P(m1[x1]) && (S1 = _(m1, x1, "left"));
    S1 !== x1 && w(W, S1, m1), N.isUnitTestRun && w(W, S1, m1), h(N);
  }, d1 = function(N) {
    var W = N.target, J = W.selectionStart, a1 = W.selectionEnd, h1 = W.value;
    if (h1 === void 0 && (h1 = ""), J === a1) {
      var m1 = _(h1, J);
      m1 !== J && w(W, m1, h1);
    }
    $(N);
  }, Z1 = function(N) {
    N.persist();
    var W = N.target;
    p.current = W, C.current.focusTimeout = setTimeout(function() {
      var J = W.selectionStart, a1 = W.selectionEnd, h1 = W.value;
      h1 === void 0 && (h1 = "");
      var m1 = _(h1, J);
      m1 !== J && !(J === 0 && a1 === h1.length) && w(W, m1, h1), b(N);
    }, 0);
  }, g1 = function(N) {
    p.current = null, clearTimeout(C.current.focusTimeout), clearTimeout(C.current.setCaretTimeout), x(N);
  }, e1 = H && H4() ? "numeric" : void 0, r1 = Object.assign({
    inputMode: e1
  }, z, {
    type: a,
    value: I,
    onChange: l1,
    onKeyDown: n1,
    onMouseUp: d1,
    onFocus: Z1,
    onBlur: g1
  });
  if (i === "text")
    return n ? /* @__PURE__ */ t(A, {
      children: n(I, z) || null
    }) : /* @__PURE__ */ t("span", {
      ...Object.assign({}, z, {
        ref: c
      }),
      children: I
    });
  if (r) {
    var V1 = r;
    return /* @__PURE__ */ t(V1, {
      ...Object.assign({}, r1, {
        ref: c
      })
    });
  }
  return /* @__PURE__ */ t("input", {
    ...Object.assign({}, r1, {
      ref: c
    })
  });
}
function n2(e, a) {
  var i = a.decimalScale, r = a.fixedDecimalScale, n = a.prefix;
  n === void 0 && (n = "");
  var c = a.suffix;
  c === void 0 && (c = "");
  var s = a.allowNegative;
  s === void 0 && (s = !0);
  var o = a.thousandsGroupStyle;
  if (o === void 0 && (o = "thousand"), e === "" || e === "-")
    return e;
  var l = G0(a), d = l.thousandSeparator, v = l.decimalSeparator, u = i !== 0 && e.indexOf(".") !== -1 || i && r, f = S5(e, s), h = f.beforeDecimal, $ = f.afterDecimal, b = f.addNegation;
  return i !== void 0 && ($ = O2($, i, !!r)), d && (h = y4(h, d, o)), n && (h = n + h), c && ($ = $ + c), b && (h = "-" + h), e = h + (u && v || "") + $, e;
}
function G0(e) {
  var a = e.decimalSeparator;
  a === void 0 && (a = ".");
  var i = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return i === !0 && (i = ","), r || (r = [a, "."]), {
    decimalSeparator: a,
    thousandSeparator: i,
    allowedDecimalSeparators: r
  };
}
function A4(e, a) {
  e === void 0 && (e = "");
  var i = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), n = i.test(e), c = r.test(e);
  return e = e.replace(/-/g, ""), n && !c && a && (e = "-" + e), e;
}
function _4(e, a) {
  return new RegExp("(^-)|[0-9]|" + N2(e), a ? "g" : void 0);
}
function P4(e, a, i) {
  a === void 0 && (a = C4(e));
  var r = i.allowNegative;
  r === void 0 && (r = !0);
  var n = i.prefix;
  n === void 0 && (n = "");
  var c = i.suffix;
  c === void 0 && (c = "");
  var s = i.decimalScale, o = a.from, l = a.to, d = l.start, v = l.end, u = G0(i), f = u.allowedDecimalSeparators, h = u.decimalSeparator, $ = e[v] === h;
  if (v - d === 1 && f.indexOf(e[d]) !== -1) {
    var b = s === 0 ? "" : h;
    e = e.substring(0, d) + b + e.substring(d + 1, e.length);
  }
  var x = !1;
  n.startsWith("-") ? x = e.startsWith("--") : c.startsWith("-") && e.length === c.length ? x = !1 : e[0] === "-" && (x = !0), x && (e = e.substring(1), d -= 1, v -= 1);
  var Z = 0;
  e.startsWith(n) ? Z += n.length : d < n.length && (Z = d), e = e.substring(Z), v -= Z;
  var S = e.length, P = e.length - c.length;
  e.endsWith(c) ? S = P : v > e.length - c.length && (S = v), e = e.substring(0, S), e = A4(x ? "-" + e : e, r), e = (e.match(_4(h, !0)) || []).join("");
  var z = e.indexOf(h);
  e = e.replace(new RegExp(N2(h), "g"), function(T, M) {
    return M === z ? "." : "";
  });
  var L = S5(e, r), F = L.beforeDecimal, I = L.afterDecimal, U = L.addNegation;
  return l.end - l.start < o.end - o.start && F === "" && $ && !parseFloat(I) && (e = U ? "-" : ""), e;
}
function z4(e, a) {
  var i = a.prefix;
  i === void 0 && (i = "");
  var r = a.suffix;
  r === void 0 && (r = "");
  var n = Array.from({
    length: e.length + 1
  }).map(function() {
    return !0;
  }), c = e[0] === "-";
  n.fill(!1, 0, i.length + (c ? 1 : 0));
  var s = e.length;
  return n.fill(!1, s - r.length + 1, s + 1), n;
}
function I4(e) {
  var a = G0(e), i = a.thousandSeparator, r = a.decimalSeparator;
  if (i === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + i + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
}
function L4(e) {
  var a = e.decimalSeparator;
  a === void 0 && (a = "."), e.allowedDecimalSeparators, e.thousandsGroupStyle, e.suffix, e.allowNegative;
  var i = e.allowLeadingZeros, r = e.onKeyDown;
  r === void 0 && (r = Q1);
  var n = e.onBlur;
  n === void 0 && (n = Q1);
  var c = e.thousandSeparator, s = e.decimalScale, o = e.fixedDecimalScale, l = e.prefix;
  l === void 0 && (l = "");
  var d = e.defaultValue, v = e.value, u = e.valueIsNumericString, f = e.onValueChange, h = E2(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]);
  I4(e);
  var $ = function(M) {
    return n2(M, e);
  }, b = function(M, Y) {
    return P4(M, Y, e);
  }, x = u;
  M0(v) ? M0(d) || (x = u != null ? u : typeof d == "number") : x = u != null ? u : typeof v == "number";
  var Z = function(M) {
    return M0(M) || F2(M) ? M : (typeof M == "number" && (M = W2(M)), x && typeof s == "number" ? a2(M, s, Boolean(o)) : M);
  }, S = j2(Z(v), Z(d), Boolean(x), $, b, f), P = S[0], z = P.numAsString, L = P.formattedValue, F = S[1], I = function(M) {
    var Y = M.target, Q = M.key, H = Y.selectionStart, y = Y.selectionEnd, p = Y.value;
    if (p === void 0 && (p = ""), H !== y) {
      r(M);
      return;
    }
    Q === "Backspace" && p[0] === "-" && H === l.length + 1 && h0(Y, 1);
    var C = G0(e), g = C.decimalSeparator;
    Q === "Backspace" && p[H - 1] === g && s && o && (h0(Y, H - 1), M.preventDefault());
    var k = c === !0 ? "," : c;
    Q === "Backspace" && p[H - 1] === k && h0(Y, H - 1), Q === "Delete" && p[H] === k && h0(Y, H + 1), r(M);
  }, U = function(M) {
    var Y = z;
    if (Y.match(/\d/g) || (Y = ""), i || (Y = x4(Y)), o && s && (Y = a2(Y, s, o)), Y !== z) {
      var Q = n2(Y, e);
      F({
        formattedValue: Q,
        value: Y,
        floatValue: parseFloat(Y)
      }, {
        event: M,
        source: k0.event
      });
    }
    n(M);
  }, T = function(M) {
    return M === a ? !0 : I0(M);
  };
  return Object.assign(Object.assign({}, h), {
    value: L,
    valueIsNumericString: !1,
    isValidInputCharacter: T,
    onValueChange: F,
    format: $,
    removeFormatting: b,
    getCaretBoundary: function(M) {
      return z4(M, e);
    },
    onKeyDown: I,
    onBlur: U
  });
}
function B2(e) {
  var a = L4(e);
  return /* @__PURE__ */ t(R4, {
    ...Object.assign({}, a)
  });
}
const T4 = D.forwardRef((e, a) => {
  const {
    label: i,
    defaultValue: r,
    currencySymbol: n,
    thousandsSeparator: c,
    decimalsSeparator: s,
    decimalsLimit: o,
    placeholder: l = "0",
    options: d,
    onValueChange: v,
    ...u
  } = e, f = D.useContext(E0), h = D.useMemo(() => {
    const x = () => c ? c === "," ? "." : s || "," : (d == null ? void 0 : d.code) === "ARS" || !(d != null && d.code) || f.code === "ARS" ? "," : ".", Z = () => o ? o <= 0 ? 0 : o || 2 : (d == null ? void 0 : d.decimals) || 2, S = () => s ? s === "." ? "," : c || "." : (d == null ? void 0 : d.code) === "ARS" || !(d != null && d.code) || f.code === "ARS" ? "." : ",", P = `0${Z() > 0 ? x() : ""}${"0".repeat(Z())}`, z = {
      ...d,
      code: (d == null ? void 0 : d.code) || f.code || "ARS",
      symbol: (d == null ? void 0 : d.symbol) || (d == null ? void 0 : d.code) || "$",
      decimals: (d == null ? void 0 : d.decimals) || 2
    };
    return {
      decimalsSeparator: x(),
      decimalsLimit: Z(),
      thousandsSeparator: S(),
      defaultPlaceholder: P,
      options: z
    };
  }, [o, s, c, d]), $ = (x) => {
    v && v(x);
  };
  return /* @__PURE__ */ t(B2, {
    customInput: (x) => /* @__PURE__ */ t(U0, {
      ...x,
      ...u,
      onValueChange: void 0,
      label: i,
      ref: a,
      size: "md",
      align: "right",
      hasPrefix: !0,
      defaultValue: r,
      placeholder: l || h.defaultPlaceholder,
      prefix: n || (d == null ? void 0 : d.symbol)
    }),
    thousandSeparator: h.thousandsSeparator,
    decimalSeparator: h.decimalsSeparator,
    decimalScale: h.decimalsLimit,
    allowedDecimalSeparators: [",", "."],
    onValueChange: $
  });
});
T4.displayName = "InputAmount";
const E4 = /* @__PURE__ */ C1((e, a) => /* @__PURE__ */ t1(z1.label, $1({}, e, {
  ref: a,
  onMouseDown: (i) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, i), !i.defaultPrevented && i.detail > 1 && i.preventDefault();
  }
}))), F4 = E4, Y2 = O(F4, {
  all: "unset",
  color: "$neutral-darker",
  variants: {
    size: {
      sm: {
        ...q.label.sm.regular
      },
      md: {
        ...q.label.md.regular
      },
      lg: {
        ...q.label.lg.regular
      }
    },
    weight: {
      regular: {
        fontWeight: "$regular"
      },
      bold: {
        fontWeight: "$bold"
      }
    },
    variant: {
      default: {
        color: "$neutral-darker"
      },
      error: {
        color: "$error-middle"
      },
      disabled: {
        color: "$neutral-middle"
      },
      primary: {
        color: "$primary-default"
      }
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "sm",
    weight: "regular"
  }
}), G2 = D.forwardRef((e, a) => {
  const {
    as: i = "label",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(Y2, {
    ...n,
    as: i,
    ref: a,
    children: r
  });
});
G2.displayName = "Label";
const N4 = O("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "$default",
  "&:focus-visible": {
    outline: "0.25rem solid $primary-light"
  },
  [`& ${Y2}`]: {
    padding: "0 $8",
    display: "table-cell",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  [`& ${T2}`]: {
    padding: "$8 $8 0"
  }
}), U2 = D.forwardRef((e, a) => {
  const {
    id: i,
    label: r,
    helpText: n,
    errorText: c,
    isInvalid: s,
    isDisabled: o,
    isRequired: l,
    hasPrefix: d,
    variant: v,
    onFocus: u,
    onBlur: f,
    size: h,
    isOutlined: $,
    onValueChange: b,
    css: x,
    ...Z
  } = e, [S, P] = D.useState(!1), z = `field-${Y1()}`, L = i || z, F = (M) => {
    P(!0), u && u(M);
  }, I = (M) => {
    P(!1), f && f(M);
  }, U = (M) => {
    b && b(M);
  }, T = () => o ? "disabled" : s ? "error" : (S, "primary");
  return /* @__PURE__ */ t(N4, {
    onFocus: F,
    css: x,
    children: /* @__PURE__ */ V(A, {
      children: [r && h !== "lg" && /* @__PURE__ */ V(G2, {
        variant: T(),
        className: T(),
        htmlFor: L,
        id: `${L}-label`,
        children: [r, d && /* @__PURE__ */ t(B1, {
          as: "span",
          isVisuallyHidden: !0,
          children: Z.prefix
        })]
      }), /* @__PURE__ */ t(U4, {
        ...Z,
        "aria-describedby": e["aria-describedby"] ? e["aria-describedby"] : s ? void 0 : `${L}-help-text`,
        "aria-errormessage": e["aria-errormessage"] ? e["aria-errormessage"] : s ? `${L}-error-text` : void 0,
        id: L,
        onFocus: F,
        onBlur: I,
        onValueChange: U,
        hasPrefix: d,
        isInvalid: s,
        isDisabled: o,
        isRequired: l,
        isOutlined: $,
        size: h,
        ref: a
      }), (c || n) && s && /* @__PURE__ */ t(w0, {
        variant: "error",
        className: "error",
        role: "alert",
        id: `${L}-error-text`,
        children: c || n
      }), n && !s && /* @__PURE__ */ t(w0, {
        variant: o ? "disabled" : v,
        className: o ? "disabled" : v,
        id: `${L}-help-text`,
        children: n
      })]
    })
  });
}), U0 = U2;
U2.displayName = "InputBase";
function O4({
  values: e,
  onChange: a,
  onComplete: i,
  actionRef: r,
  autoFocus: n = !1,
  defaultValues: c = Array(6).fill(""),
  type: s = "numeric",
  otp: o = !1,
  placeholder: l = "",
  disabled: d = !1,
  mask: v = !1,
  error: u = !1
} = {}) {
  const [f, h] = D.useState(c), [$, b] = D.useState(-1), x = e !== void 0, Z = x ? e : f, S = s === "alphanumeric", P = D.useRef(
    Array(Z.length).fill(null)
  ), z = D.useCallback((p = 0) => {
    var C;
    (C = P.current[p]) == null || C.focus();
  }, []);
  D.useEffect(() => {
    n && z();
  }, [n, z]);
  const L = D.useCallback(() => {
    var p;
    (p = P.current[$]) == null || p.blur();
  }, [$]);
  D.useImperativeHandle(
    r,
    () => ({
      focus: (p = 0) => {
        const C = Z.findIndex((g) => !g);
        z(
          u ? C === -1 ? p : C : p
        );
      },
      blur: L
    }),
    [L, z, Z, u]
  );
  const F = D.useCallback(
    (p) => (C) => {
      P.current[p] = C;
    },
    []
  ), I = D.useCallback(
    (p) => {
      x || h(p), a == null || a(p);
    },
    [x, h, a]
  ), U = D.useCallback(
    (p) => (C) => {
      let { value: g } = C.target;
      if (g = g.trim(), !(S ? /^[a-z\d]*$/i : /^\d*$/).test(g))
        return;
      if (S && (g = g.toUpperCase()), g.length > 2) {
        g.length === Z.length && (I(g.split("")), i == null || i(g));
        return;
      }
      if (g.length === 2) {
        const _ = Z[p];
        if (_ === g[0])
          g = g[1];
        else if (_ === g[1])
          g = g[0];
        else
          return;
      }
      const w = Z.slice();
      if (w[p] = g, I(w), g && (w.includes("") || i == null || i(w.join("")), p !== Z.length - 1))
        if (u) {
          const _ = w.findIndex((j) => !j);
          _ !== -1 && z(_);
        } else
          z(p + 1);
    },
    [S, Z, I, i, z, u]
  ), T = D.useCallback(
    (p) => (C) => {
      C.key === "Backspace" && !Z[p] && p && z(p - 1);
    },
    [Z, z]
  ), M = D.useCallback(
    ({ focus: p = !1 } = {}) => {
      I(Array(Z.length).fill("")), p ? z() : L();
    },
    [I, Z, z, L]
  ), Y = D.useCallback(
    (p) => () => {
      b(p);
    },
    []
  ), Q = D.useCallback(() => {
    b(-1);
  }, []), H = $ !== -1;
  return { fields: Z.map(
    (p, C) => ({
      ref: F(C),
      value: p,
      disabled: d,
      autoComplete: o ? "one-time-code" : "off",
      inputMode: S ? "text" : "numeric",
      type: v ? "password" : "text",
      placeholder: H ? "" : l,
      ...!d && {
        onBlur: Q,
        onFocus: Y(C),
        onChange: U(C),
        onKeyDown: T(C)
      }
    })
  ), clear: M, isFocused: H };
}
const W4 = D.forwardRef((e, a) => {
  const {
    errorText: i,
    helpText: r,
    id: n,
    isDisabled: c,
    isInvalid: s,
    isReadOnly: o,
    isRequired: l,
    label: d,
    onCodeComplete: v,
    onValueChange: u,
    quantity: f = 6,
    variant: h = "default",
    placeholder: $,
    ...b
  } = e, x = `field-${Y1()}`, Z = n || x, [S, P] = D.useState(Array(f).fill("")), [z, L] = D.useState(""), {
    fields: F
  } = O4({
    values: S,
    onChange: (I) => {
      P(I), L(I.join(""));
    }
  });
  return w1(() => {
    v && S.join("").length === f && v(S.join("")), u && u(z);
  }, [S, z]), w1(() => {
    P(Array(f).fill(""));
  }, [f]), /* @__PURE__ */ V(f1, {
    ref: a,
    ...b,
    direction: "column",
    spacing: "16",
    children: [/* @__PURE__ */ V(f1, {
      spacing: "8",
      as: "fieldset",
      children: [/* @__PURE__ */ t(B1, {
        as: "legend",
        isVisuallyHidden: !0,
        children: d
      }), F.map((I, U) => /* @__PURE__ */ t1(U0, {
        ...I,
        "aria-describedby": e["aria-describedby"] ? e["aria-describedby"] : s ? void 0 : `${Z}-help-text`,
        "aria-errormessage": e["aria-errormessage"] ? e["aria-errormessage"] : s ? `${Z}-error-text` : void 0,
        "aria-label": `${d} campo ${U + 1} de ${f}`,
        css: {
          width: "$32",
          height: "$40",
          "& input": {
            minHeight: 40
          }
        },
        "data-index": U,
        id: `${Z}-${U}`,
        isDisabled: c,
        isInvalid: s,
        isOutlined: !0,
        isReadOnly: o,
        isRequired: l,
        key: U,
        maxLength: 1,
        size: "sm",
        type: "tel",
        placeholder: $
      }))]
    }), (i || r) && s && /* @__PURE__ */ t(w0, {
      variant: "error",
      className: "error",
      role: "alert",
      id: `${Z}-error-text`,
      children: i || r
    }), r && !s && /* @__PURE__ */ t(w0, {
      variant: c ? "disabled" : h,
      className: c ? "disabled" : h,
      id: `${Z}-help-text`,
      children: r
    })]
  });
});
W4.displayName = "InputCode";
const j4 = D.forwardRef((e, a) => {
  const {
    label: i,
    defaultValue: r,
    currencySymbol: n,
    thousandsSeparator: c,
    decimalsSeparator: s,
    decimalsLimit: o,
    options: l,
    placeholder: d,
    ...v
  } = e, u = D.useContext(E0), f = D.useMemo(() => {
    const b = () => c ? c === "," ? "." : s || "," : (l == null ? void 0 : l.code) === "ARS" || !(l != null && l.code) || u.code === "ARS" ? "," : ".", x = () => o ? o <= 0 ? 0 : o || 2 : (l == null ? void 0 : l.decimals) || 2, Z = () => s ? s === "." ? "," : c || "." : (l == null ? void 0 : l.code) === "ARS" || !(l != null && l.code) || u.code === "ARS" ? "." : ",", S = `0${x() > 0 ? b() : ""}${"0".repeat(x())}`, P = () => z.code && Object.keys(P0).filter((L) => L === (l == null ? void 0 : l.code)).length > 0 ? P0[z.code].plural : z.symbol || z.code || "pesos", z = {
      ...l,
      code: (l == null ? void 0 : l.code) || u.code || "ARS",
      symbol: (l == null ? void 0 : l.symbol) || (l == null ? void 0 : l.code) || "$",
      decimals: (l == null ? void 0 : l.decimals) || 2
    };
    return {
      decimalsSeparator: b(),
      decimalsLimit: x(),
      thousandsSeparator: Z(),
      defaultPlaceholder: S,
      prefixLabel: P,
      options: z
    };
  }, [o, s, c, l]), h = (b) => /* @__PURE__ */ t(U0, {
    ...b,
    ...v,
    onValueChange: void 0,
    "aria-label": `${i} ${f.prefixLabel()}`,
    ref: a,
    size: "lg",
    hasPrefix: !0,
    defaultValue: r,
    placeholder: d || f.defaultPlaceholder,
    prefix: n || (l == null ? void 0 : l.symbol) || "$"
  }), $ = (b) => {
    v.onValueChange && v.onValueChange(b);
  };
  return /* @__PURE__ */ t(B2, {
    customInput: h,
    thousandSeparator: f.thousandsSeparator,
    decimalSeparator: f.decimalsSeparator,
    decimalScale: f.decimalsLimit,
    allowedDecimalSeparators: [",", "."],
    onValueChange: $
  });
});
j4.displayName = "InputCurrency";
const B4 = O("span", {
  color: "$neutral-dark",
  display: "flex",
  alignItems: "center",
  transition: "$default",
  position: "absolute",
  left: 8,
  zIndex: 1,
  variants: {
    size: {
      sm: {
        ...q.label.md.regular,
        bottom: 12
      },
      md: {
        ...q.number.md.light,
        bottom: 12
      },
      lg: {
        ...q.number.lg.light,
        bottom: 5
      }
    },
    isFocused: {
      true: {
        color: "$primary-default"
      },
      false: {}
    },
    isFilled: {
      true: {
        color: "$neutral-darker"
      },
      false: {}
    },
    isInvalid: {
      true: {
        color: "$error-middle"
      },
      false: {}
    },
    isDisabled: {
      true: {
        color: "$neutral-middle"
      },
      false: {}
    }
  },
  defaultVariants: {
    size: "sm"
  },
  compoundVariants: [
    {
      isFilled: !0,
      isFocused: !0,
      css: {
        color: "$primary-default"
      }
    }
  ]
}), Y4 = O("span", {
  position: "absolute",
  right: 0,
  bottom: 2,
  zIndex: 3
}), L0 = O("input", {
  unset: "all",
  backgroundColor: "transparent",
  border: "none",
  color: "$neutral-darker",
  margin: 0,
  minHeight: 47,
  padding: "0 $8",
  width: "100%",
  zIndex: 2,
  transition: "$default",
  "&::-webkit-outer-spin-button,  &::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  },
  "&[type=number]": {
    "-moz-appearance": "textfield"
  },
  "&:focus": {
    outline: "none"
  },
  "&::placeholder": {
    color: "$neutral-dark"
  },
  "&:disabled": {
    color: "$neutral-middle",
    backgroundColor: "transparent",
    "&::placeholder": {
      color: "$neutral-middle"
    }
  },
  variants: {
    size: {
      sm: {
        ...q.label.md.regular
      },
      md: {
        ...q.number.md.light
      },
      lg: {
        ...q.number.lg.light,
        paddingTop: 2
      }
    },
    align: {
      left: {
        textAlign: "left"
      },
      right: {
        textAlign: "right"
      }
    }
  },
  defaultVariants: {
    size: "sm",
    align: "left"
  }
}), G4 = O("div", {
  color: "$neutral-darker",
  display: "flex",
  alignItems: "center",
  transition: "$default",
  position: "relative",
  variants: {
    hasPrefix: {
      true: {
        [`& ${L0}`]: {
          paddingLeft: 38
        }
      },
      false: {}
    },
    hasSuffix: {
      true: {
        [`& ${L0}`]: {
          paddingRight: 48
        }
      },
      false: {}
    },
    isFocused: {
      true: {
        borderColor: "$primary-default !important",
        "& input": {
          outline: "none "
        }
      }
    },
    isInvalid: {
      true: {
        borderColor: "$error-middle"
      }
    },
    isDisabled: {
      true: {
        borderColor: "$neutral-middle"
      }
    },
    isOutlined: {
      true: {
        border: "$borderWidths$thin solid $neutral-middle",
        borderRadius: "$radii$sm",
        "& input": {
          ...q.number.md.regular,
          textAlign: "center"
        }
      },
      false: {
        borderBottom: "$borderWidths$thin solid $neutral-middle"
      }
    }
  },
  defaultVariants: {
    hasPrefix: !1,
    hasSuffix: !1,
    isFocused: !1,
    isInvalid: !1,
    isDisabled: !1,
    isOutlined: !1
  },
  compoundVariants: [
    {
      isOutlined: !0,
      isDisabled: !0,
      css: {
        color: "$neutral-middle",
        borderColor: "$neutral-light",
        backgroundColor: "$neutral-light"
      }
    }
  ]
}), q2 = D.forwardRef((e, a) => {
  const {
    icon: i,
    action: r,
    autoComplete: n = "off",
    onFocus: c,
    onBlur: s,
    isInvalid: o = void 0,
    isDisabled: l = void 0,
    isReadOnly: d = void 0,
    isRequired: v = void 0,
    placeholder: u = void 0,
    prefix: f,
    hasPrefix: h,
    hasSuffix: $,
    onClick: b,
    size: x,
    value: Z,
    defaultValue: S,
    isOutlined: P,
    onChange: z,
    onValueChange: L,
    ...F
  } = e, [I, U] = D.useState(!1), [T, M] = D.useState(!!S || !!Z), [Y, Q] = D.useState({
    css: {}
  }), H = (j) => {
    U(!0), c && c(j);
  }, y = (j) => {
    U(!1), s && s(j);
  }, p = (j) => {
    z && z(j), L && L(j.target.value);
  }, C = D.useRef(null), [g, {
    width: k
  }] = c5(), [w, {
    width: _
  }] = c5();
  return D.useEffect(() => {
    const j = i ? 0 : 2, G = k + 16 + j, K = _ + 24;
    Q({
      css: {
        [`& ${L0}`]: {
          paddingLeft: i || f ? G : "",
          paddingRight: r ? K + 24 : ""
        }
      }
    });
  }, [r, f, i, x, k, _]), D.useEffect(() => {
    M(!!Z);
  }, [Z]), /* @__PURE__ */ V(G4, {
    ...Y,
    isFocused: I,
    isInvalid: o,
    isDisabled: l,
    hasPrefix: !!i || h,
    hasSuffix: !!r || $,
    isOutlined: P,
    ref: C,
    children: [(i || f) && /* @__PURE__ */ t(B4, {
      size: x,
      isInvalid: !i && o,
      isDisabled: l,
      isFocused: I,
      isFilled: T,
      ref: g,
      id: `${F.id}-prefix`,
      "aria-hidden": "true",
      children: i ? /* @__PURE__ */ t(_1, {
        name: i,
        color: "default"
      }) : f && f
    }), /* @__PURE__ */ t(L0, {
      ...F,
      "aria-disabled": l,
      "aria-invalid": o,
      "aria-readonly": d,
      autoComplete: n,
      defaultValue: S,
      disabled: l,
      onBlur: y,
      onFocus: H,
      onChange: p,
      placeholder: u,
      readOnly: d,
      ref: a,
      required: v,
      size: x,
      value: Z
    }), r && /* @__PURE__ */ t(Y4, {
      ref: w,
      children: D.cloneElement(r, {
        isDisabled: r.props.isDisabled || l
      })
    })]
  });
}), U4 = q2;
q2.displayName = "InputField";
const q4 = D.forwardRef((e, a) => {
  var u;
  const {
    children: i,
    isExternal: r = !1,
    size: n = "md",
    isInline: c = !1,
    isDisabled: s = !1,
    ...o
  } = e, [l, d] = D.useState(!1), v = r !== void 0 ? r : !!((u = o == null ? void 0 : o.href) != null && u.includes("http"));
  return D.useEffect(() => {
    d(v);
  }, [v, r]), /* @__PURE__ */ t(L1, {
    isInline: c,
    isExternal: l,
    isDisabled: s,
    size: n,
    tabIndex: s ? -1 : 0,
    ...o,
    ref: a,
    children: l ? /* @__PURE__ */ V(f1, {
      as: "span",
      spacing: "4",
      align: "center",
      children: [/* @__PURE__ */ t("span", {
        children: i
      }), " ", /* @__PURE__ */ t(_1, {
        name: "external-link",
        size: "sm"
      })]
    }) : i
  });
});
q4.displayName = "Link";
const K4 = (e) => {
  const {
    children: a,
    code: i
  } = e, r = b1.useMemo(() => ({
    code: i || "ARS"
  }), [i]);
  return /* @__PURE__ */ t(E0.Provider, {
    value: r,
    children: a
  });
}, Ri = (e) => {
  const {
    children: a,
    locale: i,
    mode: r,
    resetCSS: n
  } = e;
  return /* @__PURE__ */ t(_t, {
    resetCSS: n,
    mode: r,
    children: /* @__PURE__ */ t(K4, {
      code: i,
      children: a
    })
  });
}, J4 = {
  isDisabledGroup: !1,
  isRequiredGroup: !1,
  isLoadingGroup: !1
}, {
  Provider: X4,
  Consumer: Q4
} = D.createContext(J4);
function er(e) {
  const a = e + "CollectionProvider", [i, r] = o0(a), [n, c] = i(a, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (h) => {
    const { scope: $, children: b } = h, x = b1.useRef(null), Z = b1.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ b1.createElement(n, {
      scope: $,
      itemMap: Z,
      collectionRef: x
    }, b);
  }, o = e + "CollectionSlot", l = /* @__PURE__ */ b1.forwardRef((h, $) => {
    const { scope: b, children: x } = h, Z = c(o, b), S = t0($, Z.collectionRef);
    return /* @__PURE__ */ b1.createElement(z0, {
      ref: S
    }, x);
  }), d = e + "CollectionItemSlot", v = "data-radix-collection-item", u = /* @__PURE__ */ b1.forwardRef((h, $) => {
    const { scope: b, children: x, ...Z } = h, S = b1.useRef(null), P = t0($, S), z = c(d, b);
    return b1.useEffect(() => (z.itemMap.set(S, {
      ref: S,
      ...Z
    }), () => void z.itemMap.delete(S))), /* @__PURE__ */ b1.createElement(z0, {
      [v]: "",
      ref: P
    }, x);
  });
  function f(h) {
    const $ = c(e + "CollectionConsumer", h);
    return b1.useCallback(() => {
      const x = $.collectionRef.current;
      if (!x)
        return [];
      const Z = Array.from(x.querySelectorAll(`[${v}]`));
      return Array.from($.itemMap.values()).sort(
        (z, L) => Z.indexOf(z.ref.current) - Z.indexOf(L.ref.current)
      );
    }, [
      $.collectionRef,
      $.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: l,
      ItemSlot: u
    },
    f,
    r
  ];
}
const tr = D["useId".toString()] || (() => {
});
let ar = 0;
function rr(e) {
  const [a, i] = D.useState(tr());
  return V0(() => {
    e || i(
      (r) => r != null ? r : String(ar++)
    );
  }, [
    e
  ]), e || (a ? `radix-${a}` : "");
}
const ir = /* @__PURE__ */ H0(void 0);
function K2(e) {
  const a = C0(ir);
  return e || a || "ltr";
}
const i5 = "rovingFocusGroup.onEntryFocus", nr = {
  bubbles: !1,
  cancelable: !0
}, M5 = "RovingFocusGroup", [o5, J2, cr] = er(M5), [lr, X2] = o0(M5, [
  cr
]), [or, sr] = lr(M5), dr = /* @__PURE__ */ C1((e, a) => /* @__PURE__ */ t1(o5.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ t1(o5.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ t1(ur, $1({}, e, {
  ref: a
}))))), ur = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRovingFocusGroup: i, orientation: r, loop: n = !1, dir: c, currentTabStopId: s, defaultCurrentTabStopId: o, onCurrentTabStopIdChange: l, onEntryFocus: d, ...v } = e, u = y1(null), f = t0(a, u), h = K2(c), [$ = null, b] = Y0({
    prop: s,
    defaultProp: o,
    onChange: l
  }), [x, Z] = A1(!1), S = N0(d), P = J2(i), z = y1(!1), [L, F] = A1(0);
  return w1(() => {
    const I = u.current;
    if (I)
      return I.addEventListener(i5, S), () => I.removeEventListener(i5, S);
  }, [
    S
  ]), /* @__PURE__ */ t1(or, {
    scope: i,
    orientation: r,
    dir: h,
    loop: n,
    currentTabStopId: $,
    onItemFocus: e0(
      (I) => b(I),
      [
        b
      ]
    ),
    onItemShiftTab: e0(
      () => Z(!0),
      []
    ),
    onFocusableItemAdd: e0(
      () => F(
        (I) => I + 1
      ),
      []
    ),
    onFocusableItemRemove: e0(
      () => F(
        (I) => I - 1
      ),
      []
    )
  }, /* @__PURE__ */ t1(z1.div, $1({
    tabIndex: x || L === 0 ? -1 : 0,
    "data-orientation": r
  }, v, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: E1(e.onMouseDown, () => {
      z.current = !0;
    }),
    onFocus: E1(e.onFocus, (I) => {
      const U = !z.current;
      if (I.target === I.currentTarget && U && !x) {
        const T = new CustomEvent(i5, nr);
        if (I.currentTarget.dispatchEvent(T), !T.defaultPrevented) {
          const M = P().filter(
            (p) => p.focusable
          ), Y = M.find(
            (p) => p.active
          ), Q = M.find(
            (p) => p.id === $
          ), y = [
            Y,
            Q,
            ...M
          ].filter(Boolean).map(
            (p) => p.ref.current
          );
          Q2(y);
        }
      }
      z.current = !1;
    }),
    onBlur: E1(
      e.onBlur,
      () => Z(!1)
    )
  })));
}), fr = "RovingFocusGroupItem", hr = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRovingFocusGroup: i, focusable: r = !0, active: n = !1, ...c } = e, s = rr(), o = sr(fr, i), l = o.currentTabStopId === s, d = J2(i), { onFocusableItemAdd: v, onFocusableItemRemove: u } = o;
  return w1(() => {
    if (r)
      return v(), () => u();
  }, [
    r,
    v,
    u
  ]), /* @__PURE__ */ t1(o5.ItemSlot, {
    scope: i,
    id: s,
    focusable: r,
    active: n
  }, /* @__PURE__ */ t1(z1.span, $1({
    tabIndex: l ? 0 : -1,
    "data-orientation": o.orientation
  }, c, {
    ref: a,
    onMouseDown: E1(e.onMouseDown, (f) => {
      r ? o.onItemFocus(s) : f.preventDefault();
    }),
    onFocus: E1(
      e.onFocus,
      () => o.onItemFocus(s)
    ),
    onKeyDown: E1(e.onKeyDown, (f) => {
      if (f.key === "Tab" && f.shiftKey) {
        o.onItemShiftTab();
        return;
      }
      if (f.target !== f.currentTarget)
        return;
      const h = vr(f, o.orientation, o.dir);
      if (h !== void 0) {
        f.preventDefault();
        let b = d().filter(
          (x) => x.focusable
        ).map(
          (x) => x.ref.current
        );
        if (h === "last")
          b.reverse();
        else if (h === "prev" || h === "next") {
          h === "prev" && b.reverse();
          const x = b.indexOf(f.currentTarget);
          b = o.loop ? gr(b, x + 1) : b.slice(x + 1);
        }
        setTimeout(
          () => Q2(b)
        );
      }
    })
  })));
}), mr = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function pr(e, a) {
  return a !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function vr(e, a, i) {
  const r = pr(e.key, i);
  if (!(a === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(a === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return mr[r];
}
function Q2(e) {
  const a = document.activeElement;
  for (const i of e)
    if (i === a || (i.focus(), document.activeElement !== a))
      return;
}
function gr(e, a) {
  return e.map(
    (i, r) => e[(a + r) % e.length]
  );
}
const br = dr, $r = hr, ee = "Radio", [yr, te] = o0(ee), [Zr, xr] = yr(ee), Sr = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRadio: i, name: r, checked: n = !1, required: c, disabled: s, value: o = "on", onCheck: l, ...d } = e, [v, u] = A1(null), f = t0(
    a,
    (b) => u(b)
  ), h = y1(!1), $ = v ? Boolean(v.closest("form")) : !0;
  return /* @__PURE__ */ t1(Zr, {
    scope: i,
    checked: n,
    disabled: s
  }, /* @__PURE__ */ t1(z1.button, $1({
    type: "button",
    role: "radio",
    "aria-checked": n,
    "data-state": ae(n),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: o
  }, d, {
    ref: f,
    onClick: E1(e.onClick, (b) => {
      n || l == null || l(), $ && (h.current = b.isPropagationStopped(), h.current || b.stopPropagation());
    })
  })), $ && /* @__PURE__ */ t1(Cr, {
    control: v,
    bubbles: !h.current,
    name: r,
    value: o,
    checked: n,
    required: c,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Mr = "RadioIndicator", Hr = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRadio: i, forceMount: r, ...n } = e, c = xr(Mr, i);
  return /* @__PURE__ */ t1(Z5, {
    present: r || c.checked
  }, /* @__PURE__ */ t1(z1.span, $1({
    "data-state": ae(c.checked),
    "data-disabled": c.disabled ? "" : void 0
  }, n, {
    ref: a
  })));
}), Cr = (e) => {
  const { control: a, checked: i, bubbles: r = !0, ...n } = e, c = y1(null), s = $5(i), o = y5(a);
  return w1(() => {
    const l = c.current, d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== i && u) {
      const f = new Event("click", {
        bubbles: r
      });
      u.call(l, i), l.dispatchEvent(f);
    }
  }, [
    s,
    i,
    r
  ]), /* @__PURE__ */ t1("input", $1({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: i
  }, n, {
    tabIndex: -1,
    ref: c,
    style: {
      ...e.style,
      ...o,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function ae(e) {
  return e ? "checked" : "unchecked";
}
const Vr = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], re = "RadioGroup", [wr, Ai] = o0(re, [
  X2,
  te
]), ie = X2(), ne = te(), [kr, Dr] = wr(re), Rr = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRadioGroup: i, name: r, defaultValue: n, value: c, required: s = !1, disabled: o = !1, orientation: l, dir: d, loop: v = !0, onValueChange: u, ...f } = e, h = ie(i), $ = K2(d), [b, x] = Y0({
    prop: c,
    defaultProp: n,
    onChange: u
  });
  return /* @__PURE__ */ t1(kr, {
    scope: i,
    name: r,
    required: s,
    disabled: o,
    value: b,
    onValueChange: x
  }, /* @__PURE__ */ t1(br, $1({
    asChild: !0
  }, h, {
    orientation: l,
    dir: $,
    loop: v
  }), /* @__PURE__ */ t1(z1.div, $1({
    role: "radiogroup",
    "aria-required": s,
    "aria-orientation": l,
    "data-disabled": o ? "" : void 0,
    dir: $
  }, f, {
    ref: a
  }))));
}), Ar = "RadioGroupItem", _r = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRadioGroup: i, disabled: r, ...n } = e, c = Dr(Ar, i), s = c.disabled || r, o = ie(i), l = ne(i), d = y1(null), v = t0(a, d), u = c.value === n.value, f = y1(!1);
  return w1(() => {
    const h = (b) => {
      Vr.includes(b.key) && (f.current = !0);
    }, $ = () => f.current = !1;
    return document.addEventListener("keydown", h), document.addEventListener("keyup", $), () => {
      document.removeEventListener("keydown", h), document.removeEventListener("keyup", $);
    };
  }, []), /* @__PURE__ */ t1($r, $1({
    asChild: !0
  }, o, {
    focusable: !s,
    active: u
  }), /* @__PURE__ */ t1(Sr, $1({
    disabled: s,
    required: c.required,
    checked: u
  }, l, n, {
    name: c.name,
    ref: v,
    onCheck: () => c.onValueChange(n.value),
    onKeyDown: E1((h) => {
      h.key === "Enter" && h.preventDefault();
    }),
    onFocus: E1(n.onFocus, () => {
      var h;
      f.current && ((h = d.current) === null || h === void 0 || h.click());
    })
  })));
}), Pr = /* @__PURE__ */ C1((e, a) => {
  const { __scopeRadioGroup: i, ...r } = e, n = ne(i);
  return /* @__PURE__ */ t1(Hr, $1({}, n, r, {
    ref: a
  }));
}), zr = Rr, Ir = _r, Lr = Pr, Tr = O(Lr, {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  position: "relative",
  "&::after": {
    content: '""',
    display: "block",
    borderRadius: "$full",
    backgroundColor: "$bg-light"
  }
}), Er = O("div", {
  alignItems: "center",
  width: 48,
  height: 48,
  display: "flex",
  justifyContent: "center",
  "& .label": {
    color: "$neutral-darker"
  },
  "&.disabled": {
    "& .description, & .label": {
      color: "$neutral-middle",
      pointerEvents: "none"
    }
  }
}), Fr = O(Ir, {
  all: "unset",
  backgroundColor: "transparent",
  borderRadius: "$full",
  border: "1px solid $neutral-middle",
  transition: "$default",
  outline: "0.25rem solid transparent",
  overflow: "hidden",
  width: 24,
  height: 24,
  ["& span::after"]: {
    width: 12,
    height: 12
  },
  '&[data-state="checked"]': {
    borderColor: "$primary-default",
    backgroundColor: "$primary-default",
    "&:hover": {
      borderColor: "$primary-dark",
      backgroundColor: "$primary-dark"
    }
  },
  "&:hover": {
    borderColor: "$neutral-dark"
  },
  "&:focus": {
    outline: "0.25rem solid transparent"
  },
  "&:focus-visible": {
    outline: "0.25rem solid $primary-light"
  },
  "&:disabled": {
    pointerEvents: "none",
    borderColor: "$neutral-light",
    '&[data-state="checked"]': {
      backgroundColor: "$neutral-light"
    }
  }
}), Nr = O(zr, {}), Or = D.forwardRef((e, a) => {
  const {
    isDisabled: i,
    isRequired: r,
    isLoading: n,
    label: c,
    id: s,
    ...o
  } = e, l = `field-${Y1()}`, d = s || l, v = D.useRef(null);
  return /* @__PURE__ */ t(Q4, {
    children: ({
      isDisabledGroup: u,
      isLoadingGroup: f,
      isRequiredGroup: h
    }) => /* @__PURE__ */ t(Er, {
      className: u || i ? "disabled" : void 0,
      ref: v,
      children: /* @__PURE__ */ t(A, {
        children: /* @__PURE__ */ t(Fr, {
          ...o,
          disabled: i || u || n || f,
          "aria-label": c,
          id: d,
          required: r || h,
          ref: a,
          children: /* @__PURE__ */ t(Tr, {})
        })
      })
    })
  });
});
Or.displayName = "Radio";
const Wr = D.forwardRef((e, a) => {
  const {
    children: i,
    isDisabled: r,
    isLoading: n,
    isRequired: c,
    ...s
  } = e;
  return /* @__PURE__ */ t(Nr, {
    ...s,
    ref: a,
    required: c,
    role: n ? "" : "radiogroup",
    children: /* @__PURE__ */ t(X4, {
      value: {
        isDisabledGroup: r,
        isRequiredGroup: c
      },
      children: i
    })
  });
});
var ce = { exports: {} };
(function(e, a) {
  (function(i, r) {
    e.exports = r();
  })(Dt, function() {
    var i = 1e3, r = 6e4, n = 36e5, c = "millisecond", s = "second", o = "minute", l = "hour", d = "day", v = "week", u = "month", f = "quarter", h = "year", $ = "date", b = "Invalid Date", x = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Z = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(H) {
      var y = ["th", "st", "nd", "rd"], p = H % 100;
      return "[" + H + (y[(p - 20) % 10] || y[p] || y[0]) + "]";
    } }, P = function(H, y, p) {
      var C = String(H);
      return !C || C.length >= y ? H : "" + Array(y + 1 - C.length).join(p) + H;
    }, z = { s: P, z: function(H) {
      var y = -H.utcOffset(), p = Math.abs(y), C = Math.floor(p / 60), g = p % 60;
      return (y <= 0 ? "+" : "-") + P(C, 2, "0") + ":" + P(g, 2, "0");
    }, m: function H(y, p) {
      if (y.date() < p.date())
        return -H(p, y);
      var C = 12 * (p.year() - y.year()) + (p.month() - y.month()), g = y.clone().add(C, u), k = p - g < 0, w = y.clone().add(C + (k ? -1 : 1), u);
      return +(-(C + (p - g) / (k ? g - w : w - g)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: u, y: h, w: v, d, D: $, h: l, m: o, s, ms: c, Q: f }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, L = "en", F = {};
    F[L] = S;
    var I = function(H) {
      return H instanceof Y;
    }, U = function H(y, p, C) {
      var g;
      if (!y)
        return L;
      if (typeof y == "string") {
        var k = y.toLowerCase();
        F[k] && (g = k), p && (F[k] = p, g = k);
        var w = y.split("-");
        if (!g && w.length > 1)
          return H(w[0]);
      } else {
        var _ = y.name;
        F[_] = y, g = _;
      }
      return !C && g && (L = g), g || !C && L;
    }, T = function(H, y) {
      if (I(H))
        return H.clone();
      var p = typeof y == "object" ? y : {};
      return p.date = H, p.args = arguments, new Y(p);
    }, M = z;
    M.l = U, M.i = I, M.w = function(H, y) {
      return T(H, { locale: y.$L, utc: y.$u, x: y.$x, $offset: y.$offset });
    };
    var Y = function() {
      function H(p) {
        this.$L = U(p.locale, null, !0), this.parse(p);
      }
      var y = H.prototype;
      return y.parse = function(p) {
        this.$d = function(C) {
          var g = C.date, k = C.utc;
          if (g === null)
            return new Date(NaN);
          if (M.u(g))
            return new Date();
          if (g instanceof Date)
            return new Date(g);
          if (typeof g == "string" && !/Z$/i.test(g)) {
            var w = g.match(x);
            if (w) {
              var _ = w[2] - 1 || 0, j = (w[7] || "0").substring(0, 3);
              return k ? new Date(Date.UTC(w[1], _, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, j)) : new Date(w[1], _, w[3] || 1, w[4] || 0, w[5] || 0, w[6] || 0, j);
            }
          }
          return new Date(g);
        }(p), this.$x = p.x || {}, this.init();
      }, y.init = function() {
        var p = this.$d;
        this.$y = p.getFullYear(), this.$M = p.getMonth(), this.$D = p.getDate(), this.$W = p.getDay(), this.$H = p.getHours(), this.$m = p.getMinutes(), this.$s = p.getSeconds(), this.$ms = p.getMilliseconds();
      }, y.$utils = function() {
        return M;
      }, y.isValid = function() {
        return this.$d.toString() !== b;
      }, y.isSame = function(p, C) {
        var g = T(p);
        return this.startOf(C) <= g && g <= this.endOf(C);
      }, y.isAfter = function(p, C) {
        return T(p) < this.startOf(C);
      }, y.isBefore = function(p, C) {
        return this.endOf(C) < T(p);
      }, y.$g = function(p, C, g) {
        return M.u(p) ? this[C] : this.set(g, p);
      }, y.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, y.valueOf = function() {
        return this.$d.getTime();
      }, y.startOf = function(p, C) {
        var g = this, k = !!M.u(C) || C, w = M.p(p), _ = function(g1, e1) {
          var r1 = M.w(g.$u ? Date.UTC(g.$y, e1, g1) : new Date(g.$y, e1, g1), g);
          return k ? r1 : r1.endOf(d);
        }, j = function(g1, e1) {
          return M.w(g.toDate()[g1].apply(g.toDate("s"), (k ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e1)), g);
        }, G = this.$W, K = this.$M, l1 = this.$D, n1 = "set" + (this.$u ? "UTC" : "");
        switch (w) {
          case h:
            return k ? _(1, 0) : _(31, 11);
          case u:
            return k ? _(1, K) : _(0, K + 1);
          case v:
            var d1 = this.$locale().weekStart || 0, Z1 = (G < d1 ? G + 7 : G) - d1;
            return _(k ? l1 - Z1 : l1 + (6 - Z1), K);
          case d:
          case $:
            return j(n1 + "Hours", 0);
          case l:
            return j(n1 + "Minutes", 1);
          case o:
            return j(n1 + "Seconds", 2);
          case s:
            return j(n1 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, y.endOf = function(p) {
        return this.startOf(p, !1);
      }, y.$set = function(p, C) {
        var g, k = M.p(p), w = "set" + (this.$u ? "UTC" : ""), _ = (g = {}, g[d] = w + "Date", g[$] = w + "Date", g[u] = w + "Month", g[h] = w + "FullYear", g[l] = w + "Hours", g[o] = w + "Minutes", g[s] = w + "Seconds", g[c] = w + "Milliseconds", g)[k], j = k === d ? this.$D + (C - this.$W) : C;
        if (k === u || k === h) {
          var G = this.clone().set($, 1);
          G.$d[_](j), G.init(), this.$d = G.set($, Math.min(this.$D, G.daysInMonth())).$d;
        } else
          _ && this.$d[_](j);
        return this.init(), this;
      }, y.set = function(p, C) {
        return this.clone().$set(p, C);
      }, y.get = function(p) {
        return this[M.p(p)]();
      }, y.add = function(p, C) {
        var g, k = this;
        p = Number(p);
        var w = M.p(C), _ = function(K) {
          var l1 = T(k);
          return M.w(l1.date(l1.date() + Math.round(K * p)), k);
        };
        if (w === u)
          return this.set(u, this.$M + p);
        if (w === h)
          return this.set(h, this.$y + p);
        if (w === d)
          return _(1);
        if (w === v)
          return _(7);
        var j = (g = {}, g[o] = r, g[l] = n, g[s] = i, g)[w] || 1, G = this.$d.getTime() + p * j;
        return M.w(G, this);
      }, y.subtract = function(p, C) {
        return this.add(-1 * p, C);
      }, y.format = function(p) {
        var C = this, g = this.$locale();
        if (!this.isValid())
          return g.invalidDate || b;
        var k = p || "YYYY-MM-DDTHH:mm:ssZ", w = M.z(this), _ = this.$H, j = this.$m, G = this.$M, K = g.weekdays, l1 = g.months, n1 = function(e1, r1, V1, N) {
          return e1 && (e1[r1] || e1(C, k)) || V1[r1].slice(0, N);
        }, d1 = function(e1) {
          return M.s(_ % 12 || 12, e1, "0");
        }, Z1 = g.meridiem || function(e1, r1, V1) {
          var N = e1 < 12 ? "AM" : "PM";
          return V1 ? N.toLowerCase() : N;
        }, g1 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: G + 1, MM: M.s(G + 1, 2, "0"), MMM: n1(g.monthsShort, G, l1, 3), MMMM: n1(l1, G), D: this.$D, DD: M.s(this.$D, 2, "0"), d: String(this.$W), dd: n1(g.weekdaysMin, this.$W, K, 2), ddd: n1(g.weekdaysShort, this.$W, K, 3), dddd: K[this.$W], H: String(_), HH: M.s(_, 2, "0"), h: d1(1), hh: d1(2), a: Z1(_, j, !0), A: Z1(_, j, !1), m: String(j), mm: M.s(j, 2, "0"), s: String(this.$s), ss: M.s(this.$s, 2, "0"), SSS: M.s(this.$ms, 3, "0"), Z: w };
        return k.replace(Z, function(e1, r1) {
          return r1 || g1[e1] || w.replace(":", "");
        });
      }, y.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, y.diff = function(p, C, g) {
        var k, w = M.p(C), _ = T(p), j = (_.utcOffset() - this.utcOffset()) * r, G = this - _, K = M.m(this, _);
        return K = (k = {}, k[h] = K / 12, k[u] = K, k[f] = K / 3, k[v] = (G - j) / 6048e5, k[d] = (G - j) / 864e5, k[l] = G / n, k[o] = G / r, k[s] = G / i, k)[w] || G, g ? K : M.a(K);
      }, y.daysInMonth = function() {
        return this.endOf(u).$D;
      }, y.$locale = function() {
        return F[this.$L];
      }, y.locale = function(p, C) {
        if (!p)
          return this.$L;
        var g = this.clone(), k = U(p, C, !0);
        return k && (g.$L = k), g;
      }, y.clone = function() {
        return M.w(this.$d, this);
      }, y.toDate = function() {
        return new Date(this.valueOf());
      }, y.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, y.toISOString = function() {
        return this.$d.toISOString();
      }, y.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), Q = Y.prototype;
    return T.prototype = Q, [["$ms", c], ["$s", s], ["$m", o], ["$H", l], ["$W", d], ["$M", u], ["$y", h], ["$D", $]].forEach(function(H) {
      Q[H[1]] = function(y) {
        return this.$g(y, H[0], H[1]);
      };
    }), T.extend = function(H, y) {
      return H.$i || (H(y, Y, T), H.$i = !0), T;
    }, T.locale = U, T.isDayjs = I, T.unix = function(H) {
      return T(1e3 * H);
    }, T.en = F[L], T.Ls = F, T.p = {}, T;
  });
})(ce);
const jr = ce.exports, Br = {
  isDisabledGroup: !1,
  hasDividerGroup: !1,
  isActionableGroup: !1,
  isLoadingGroup: !1,
  amountOptionsGroup: {}
}, s5 = b1.createContext(Br), {
  Provider: Yr,
  Consumer: Gr
} = s5, Ur = (e, a) => {
  if (a === "Checkbox")
    throw new Error(
      "Los checkboxes no pueden estar en rightElement, ingresalo en leftElement"
    );
  if (e === "Switch")
    throw new Error(
      "El componente Switch no pueden estar en leftElement, ingresalo en rightElement"
    );
  if (e === "Button" || e === "IconButton")
    throw new Error(
      "Los buttons no pueden estar en leftElement, ingresalo en rightElement"
    );
}, qr = O(N1, {
  width: 20,
  height: 20,
  fontSize: 12,
  color: "$neutral-dark",
  border: "1px solid $neutral-dark",
  borderRadius: "$full",
  margin: 2,
  defaultVariants: {
    spacing: "0",
    justify: "center",
    align: "center"
  }
}), Kr = O(N1, {
  display: "flex",
  [`& ${T1}`]: {
    fill: "$neutral-dark"
  },
  [`& ${L2}`]: {
    marginTop: 0
  },
  variants: {
    ...v5
  },
  defaultVariants: {
    align: "center",
    direction: "column",
    justify: "start",
    spacing: "0"
  }
}), c0 = O(N1, {
  width: "100%",
  minWidth: 0,
  defaultVariants: {
    direction: "column",
    spacing: "none",
    justify: "center"
  }
}), U1 = O(N1, {
  [`& ${F0}`]: {
    ...q.number.md.regular,
    color: "$neutral-darker"
  },
  variants: {
    ...v5,
    textAlign: {
      left: {
        textAlign: "left"
      },
      right: {
        textAlign: "right",
        flex: "1 1 auto"
      }
    },
    hasTexts: {
      true: {},
      false: {
        padding: "0 !important"
      }
    }
  },
  defaultVariants: {
    textAlign: "right",
    align: "end",
    justify: "center",
    direction: "column",
    spacing: "0"
  }
}), l0 = O("span", {
  all: "unset",
  color: "$neutral-darker",
  display: "table-cell",
  verticalAlign: "middle",
  variants: {
    size: {
      md: {
        ...q.label.md.bold,
        padding: "1px 0"
      },
      lg: {
        ...q.label.lg.bold
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), p0 = O("p", {
  all: "unset",
  ...q.body.md.regular,
  color: "$neutral-dark",
  lineHeight: "20px",
  minHeight: 20
}), d5 = O("span", {
  ...q.label.sm.regular,
  pb: "calc($8 - $borderWidths$thin)",
  color: "$neutral-dark",
  display: "table-cell"
}), W1 = O("div", {
  display: "grid",
  gridTemplateColumns: "1fr max-content",
  gap: "$8",
  padding: "0 $8",
  transition: "$default",
  minHeight: s1(47),
  [`& ${U1}.no-padding`]: {
    padding: 0
  },
  variants: {
    hasDescription: {
      true: {
        [`& ${c0}`]: {
          padding: "$12 0 $8"
        },
        [`& ${U1}`]: {
          padding: "$12 0 $8"
        },
        [`& ${l0}`]: {
          marginBottom: 2
        },
        [`& ${p0}`]: {
          marginTop: -2
        }
      },
      false: {
        [`& ${c0}`]: {
          padding: "$12 0"
        },
        [`& ${U1}`]: {
          padding: "$12 0"
        },
        [`& ${l0}`]: {
          marginBottom: 0
        }
      }
    }
  }
}), Jr = {
  padding: 0,
  borderColor: "transparent !important",
  backgroundColor: "transparent !important",
  outline: "none !important",
  minHeight: s1(48),
  "&:focus-visible": {
    textDecoration: "underline"
  }
}, c2 = O("div", {
  width: "100%",
  display: "flex",
  gap: "$8",
  flex: "0 1 auto",
  minWidth: 0
}), Xr = O(N1, {
  width: s1(24),
  height: s1(48),
  defaultVariants: {
    align: "center",
    justify: "center"
  }
}), q0 = O("li", {
  width: "100%",
  transition: "$default",
  outline: "0.25rem transparent solid",
  listStyle: "none",
  variants: {
    isSelected: {
      true: {
        boxShadow: "none",
        bg: "$primary-lighter",
        [`& ${W1}`]: {
          borderColor: "transparent"
        }
      },
      false: {}
    },
    isActionable: {
      true: {
        borderRadius: "$sm",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "$bg-light",
          boxShadow: "$md",
          [`& ${W1}`]: {
            borderColor: "transparent"
          }
        },
        "&:active": {
          boxShadow: "none",
          bg: "$primary-lighter",
          [`& ${W1}`]: {
            borderColor: "transparent"
          }
        },
        "&:focus": {
          outline: "0.25rem transparent solid",
          [`& ${W1}`]: {
            borderColor: "transparent"
          }
        },
        "&:focus-visible": {
          outline: "0.25rem $primary-light solid",
          [`& ${W1}`]: {
            borderColor: "transparent"
          }
        }
      }
    },
    status: {
      default: {},
      success: {
        [`& ${U1} ${l0}`]: {
          color: "$success-middle"
        }
      },
      error: {
        [`& ${U1} ${l0}`]: {
          color: "$error-middle"
        }
      }
    },
    titleSize: {
      md: {},
      lg: {}
    },
    hasDivider: {
      true: {
        [`& ${W1}`]: {
          borderBottom: "1px solid $neutral-light"
        }
      }
    },
    isDisabled: {
      true: {
        pointerEvents: "none",
        color: "$neutral-middle",
        "& p, & span, & label, & .description, & .date": {
          color: "$neutral-middle"
        },
        "& svg path": {
          fill: "$neutral-light"
        },
        "& svg rect": {
          fill: "$neutral-light"
        }
      }
    }
  },
  defaultVariants: {
    isSelected: !1,
    isDisabled: !1,
    hasDivider: !0,
    titleSize: "sm",
    status: "default"
  }
}), Qr = O(q0, {
  [`& ${W1}`]: {
    minHeight: 64
  },
  [`& ${p0}`]: {
    minHeight: 14,
    lineHeight: "$normal"
  },
  [`& ${l0}`]: {
    padding: 0
  },
  [`& ${d5}`]: {
    height: 18,
    display: "flex",
    alignContent: "flex-end",
    flexWrap: "wrap",
    padding: "0 0 2px"
  },
  [`& ${c0}, & ${U1}`]: {
    padding: "$12 0",
    gap: 4
  }
}), ei = O(q0, {
  [`& ${W1}`]: {
    minHeight: 56
  },
  [`& ${c0}, & ${U1}`]: {
    padding: 0,
    gap: 0,
    marginBottom: -2
  },
  [`& ${c0}`]: {
    justifyContent: "center"
  },
  [`& ${p0}`]: {
    minHeight: 14
  },
  variants: {
    status: {
      default: {},
      success: {
        [`& ${U1} ${P1}`]: {
          color: "$success-middle !important"
        }
      },
      error: {
        [`& ${c0} ${p0}`]: {
          color: "$error-middle !important"
        }
      }
    }
  }
}), le = D.forwardRef((e, a) => {
  const {
    children: i,
    isLoading: r,
    hasDivider: n,
    isDisabled: c,
    isActionable: s,
    titleSize: o,
    status: l,
    hasDescription: d,
    type: v,
    ...u
  } = e, f = ($) => $ === "ul" ? "li" : "div";
  let h = q0;
  return v === "movements" ? h = ei : v === "avatar" && (h = Qr), /* @__PURE__ */ t(Gr, {
    children: ({
      isDisabledGroup: $,
      hasDividerGroup: b,
      isLoadingGroup: x,
      isActionableGroup: Z,
      asGroup: S
    }) => /* @__PURE__ */ t(A, {
      children: x || r ? /* @__PURE__ */ t(j1, {
        css: {
          mb: "$8"
        },
        children: /* @__PURE__ */ V(f1, {
          children: [/* @__PURE__ */ t(v1, {
            height: 40,
            width: 40
          }), /* @__PURE__ */ t(v1, {
            height: 40,
            width: "calc(100%-60px) !important"
          })]
        })
      }) : /* @__PURE__ */ t(h, {
        ...u,
        as: f(S),
        isDisabled: c !== void 0 ? c : $,
        hasDivider: n !== void 0 ? n : b,
        isActionable: s !== void 0 ? s : Z,
        status: !c && !$ ? l : "default",
        titleSize: o,
        ref: a,
        children: /* @__PURE__ */ t(W1, {
          hasDescription: d,
          role: s ? "button" : void 0,
          children: i
        })
      })
    })
  });
});
le.displayName = "RowContainer";
const l2 = (e) => e.includes("hs") ? !0 : jr(e).isValid(), K0 = ({
  amount: e,
  as: a = "li",
  children: i,
  count: r,
  description: n,
  icon: c,
  id: s,
  isActionable: o,
  isDisabled: l,
  isLoading: d,
  label: v,
  leftElement: u,
  rightElement: f,
  detail: h,
  rightTitle: $,
  titleSize: b = "md",
  leftTitle: x,
  title: Z,
  css: S,
  type: P,
  tag: z,
  amountOptions: L,
  status: F,
  ...I
}) => {
  var O1, K1;
  const [U, T] = D.useState(!1), [M, Y] = D.useState({}), [Q, H] = D.useState({}), [y, p] = D.useState({}), [C, g] = D.useState({}), [k, {
    height: w
  }] = c5(), {
    isActionableGroup: _
  } = C0(s5), j = `item-${Y1()}`, G = s || j, K = `container-${Y1()}`, l1 = Z || x, n1 = (O1 = u == null ? void 0 : u.type) == null ? void 0 : O1.displayName, d1 = (K1 = f == null ? void 0 : f.type) == null ? void 0 : K1.displayName, Z1 = c || n1 || r || u, g1 = $ || h || f || o || _, e1 = l1 || n || v, r1 = n1 === "Checkbox" || n1 === "Radio" || d1 === "Switch", V1 = K5(v || ""), N = K5(h || ""), {
    amountOptionsGroup: W
  } = C0(s5), J = () => P && !f ? !0 : !P && !f && !o;
  Ur(n1, d1);
  const a1 = D.useMemo(() => d1 === "Switch" && !(n && l1) || P || n1 === "Radio" && !l1 ? !1 : v && P !== "avatar" || U ? !0 : !l1 && n ? !1 : !!(h && $ || l1 && n), [d1, P, v, n, h, $, U]), h1 = () => {
    if (!!f)
      return d1 === "IconButton" ? D.cloneElement(f, {
        isDisabled: f.props.isDisabled || l,
        css: {
          marginRight: "-$8"
        }
      }) : d1 === "Switch" ? D.cloneElement(f, {
        "aria-labelledby": f.props["aria-labelledby"] || K,
        isDisabled: f.props.isDisabled || l
      }) : d1 === "Button" ? D.cloneElement(f, {
        isDisabled: f.props.isDisabled || l,
        css: Jr
      }) : d1 === "Tag" ? D.cloneElement(f, {
        css: {
          marginTop: a1 ? 10 : 0
        }
      }) : f;
  }, m1 = D.useMemo(() => ({
    code: (L == null ? void 0 : L.code) || (W == null ? void 0 : W.code),
    symbol: (L == null ? void 0 : L.symbol) || (W == null ? void 0 : W.symbol),
    decimals: (L == null ? void 0 : L.decimals) || (W == null ? void 0 : W.decimals),
    value: e || 0,
    isCrypto: (L == null ? void 0 : L.isCrypto) || (W == null ? void 0 : W.isCrypto)
  }), [L, e, W]), x1 = () => {
    if (!!u)
      return n1 === "Checkbox" || n1 === "Radio" ? D.cloneElement(u, {
        "aria-labelledby": u.props["aria-labelledby"] || K,
        id: u.props.id || G,
        isDisabled: u.props.isDisabled || l,
        css: {
          marginLeft: "-$8"
        }
      }) : n1 === "Avatar" ? D.cloneElement(u, {
        "aria-hidden": u.props["aria-hidden"] || !0,
        name: "",
        isDisabled: u.props.isDisabled || l
      }) : u;
  }, S1 = () => {
    if (!!z)
      return D.cloneElement(z, {
        isDisabled: z.props.isDisabled || l,
        size: "sm"
      });
  };
  return D.useLayoutEffect(() => {
    T(w > 21), Y({
      align: a1 && !r1 ? "start" : "center",
      justify: P || !a1 ? "center" : "start",
      css: {
        paddingTop: a1 && !r1 ? 10 : 0
      }
    }), H({
      justify: a1 ? "start" : "center"
    }), p({
      css: {
        justifyContent: a1 ? "start" : "center"
      }
    }), g({
      id: G,
      as: r1 ? "div" : a,
      hasDescription: a1,
      isActionable: f ? !1 : o,
      isDisabled: l,
      isLoading: d,
      tabIndex: o ? 0 : -1,
      type: P,
      css: {
        ...S,
        [`${c2}`]: {
          gap: u && !P ? 0 : ""
        }
      }
    });
  }, [l, d, f, u, o, a1, P]), /* @__PURE__ */ V(le, {
    ...I,
    ...C,
    id: K,
    status: F,
    children: [/* @__PURE__ */ V(c2, {
      children: [Z1 && /* @__PURE__ */ t(Kr, {
        ...M,
        children: /* @__PURE__ */ V(A, {
          children: [!c && !u && r && /* @__PURE__ */ t(qr, {
            children: r
          }), !u && c && /* @__PURE__ */ t(_1, {
            name: c,
            "aria-label": "",
            color: "default",
            className: "left-icon"
          }), u && x1()]
        })
      }), e1 && /* @__PURE__ */ V(c0, {
        ...y,
        children: [v && P !== "avatar" && /* @__PURE__ */ t(d5, {
          as: "span",
          children: /* @__PURE__ */ t(F1, {
            lines: 1,
            children: v
          })
        }), l1 && /* @__PURE__ */ t(l0, {
          as: r1 ? "label" : "span",
          className: "title",
          htmlFor: r1 ? G : void 0,
          size: b,
          children: /* @__PURE__ */ t(F1, {
            lines: 1,
            children: l1
          })
        }), n && /* @__PURE__ */ t(p0, {
          className: "description",
          as: r1 && !l1 ? "label" : "span",
          htmlFor: r1 && !l1 ? G : void 0,
          ref: k,
          children: /* @__PURE__ */ t(F1, {
            lines: !!$ || !!h || !!P ? 1 : 15,
            children: n
          })
        }), P === "avatar" && v && /* @__PURE__ */ V(A, {
          children: [l2(v) && /* @__PURE__ */ t(B1, {
            isVisuallyHidden: !0,
            as: "span",
            children: V1
          }), /* @__PURE__ */ t(d5, {
            as: "span",
            css: {
              color: "$neutral-darker"
            },
            "aria-hidden": !0,
            children: /* @__PURE__ */ t(F1, {
              lines: 1,
              children: v
            })
          })]
        })]
      })]
    }), g1 && /* @__PURE__ */ t(U1, {
      ...Q,
      hasTexts: J(),
      children: /* @__PURE__ */ V(A, {
        children: [J() && /* @__PURE__ */ V(A, {
          children: [$ && /* @__PURE__ */ t(l0, {
            size: b,
            children: $
          }), e !== void 0 && /* @__PURE__ */ t(A, {
            children: F === "error" ? /* @__PURE__ */ t(B1, {
              css: {
                height: 16.5
              }
            }) : /* @__PURE__ */ t(F0, {
              ...m1,
              value: e,
              size: "xs",
              className: "amount",
              prefix: F === "success" ? "+" : void 0
            })
          }), h && /* @__PURE__ */ V(A, {
            children: [l2(h) && /* @__PURE__ */ t(B1, {
              isVisuallyHidden: !0,
              as: "span",
              children: N
            }), /* @__PURE__ */ t(p0, {
              "aria-hidden": !0,
              as: "span",
              className: "detail",
              children: /* @__PURE__ */ t(F1, {
                lines: 1,
                children: h
              })
            })]
          })]
        }), f && !o && !_ && h1(), P === "avatar" && z && S1, (o || _) && !P && /* @__PURE__ */ t(Xr, {
          children: /* @__PURE__ */ t(_1, {
            name: "right",
            color: "default"
          })
        })]
      })
    })]
  });
};
K0.displayName = "RowBase";
const ti = ({
  ...e
}) => /* @__PURE__ */ t(K0, {
  ...e
});
ti.displayName = "Row";
const ai = ({
  amount: e,
  date: a,
  avatar: i,
  rightElement: r,
  tagLabel: n,
  amountOptions: c,
  ...s
}) => /* @__PURE__ */ t(K0, {
  ...s,
  type: "avatar",
  amount: e,
  detail: a || " ",
  leftElement: i,
  rightElement: r,
  isActionable: !r,
  label: n
});
ai.displayName = "RowAvatar";
const ri = ({
  icon: e,
  amount: a,
  date: i,
  rightElement: r,
  ...n
}) => /* @__PURE__ */ t(K0, {
  ...n,
  type: "movements",
  amount: a,
  detail: i || " ",
  leftElement: /* @__PURE__ */ t(w2, {
    name: e,
    "data-icon": e
  }),
  rightElement: r,
  isActionable: !r
});
ri.displayName = "RowMovements";
const ii = O("ul", {
  all: "unset",
  margin: 0,
  padding: 0,
  listStyleType: "none",
  marginBlockStart: 0,
  marginBlockEnd: 0,
  marginInlineStart: 0,
  marginInlineEnd: 0,
  paddingInlineStart: 0,
  [`${q0}:last-child ${W1}`]: {
    borderBottom: "none"
  }
}), ni = D.forwardRef((e, a) => {
  const {
    as: i = "ul",
    children: r,
    isDisabled: n = !1,
    hasDivider: c = !1,
    isActionable: s = !1,
    isLoading: o = !1,
    onValueChange: l,
    defaultValue: d,
    amountOptions: v,
    ...u
  } = e, f = (Z) => {
    l && l(Z);
  }, h = a0.toArray(r), $ = r.displayName === "Row" || r.displayName === "ListItemMovements" || r.displayName === "ListItemAvatar" || h.some((Z) => {
    var S, P;
    return ((P = (S = Z == null ? void 0 : Z.props) == null ? void 0 : S.leftElement) == null ? void 0 : P.type.displayName) === "Radio";
  }), b = r.displayName === "Row" || r.displayName === "ListItemMovements" || r.displayName === "ListItemAvatar" || h.some((Z) => {
    var S, P, z, L, F, I;
    return ((P = (S = Z == null ? void 0 : Z.props) == null ? void 0 : S.leftElement) == null ? void 0 : P.type.displayName) === "Radio" || ((L = (z = Z == null ? void 0 : Z.props) == null ? void 0 : z.leftElement) == null ? void 0 : L.type.displayName) === "Checkbox" || ((I = (F = Z == null ? void 0 : Z.props) == null ? void 0 : F.rightElement) == null ? void 0 : I.type.displayName) === "Switch";
  }), x = $ || o ? "div" : i;
  return /* @__PURE__ */ t(ii, {
    ...u,
    as: x,
    ref: a,
    "aria-labelledby": $ ? void 0 : u["aria-labelledby"],
    "aria-activedescendant": $ ? void 0 : u["aria-activedescendant"],
    role: i === "div" ? "group" : o ? "alert" : void 0,
    "aria-busy": o ? !0 : void 0,
    "aria-disabled": n,
    "aria-live": o ? "polite" : void 0,
    "aria-label": o ? "Cargando elementos" : void 0,
    children: /* @__PURE__ */ t(Yr, {
      value: {
        isDisabledGroup: n,
        hasDividerGroup: b ? !1 : c,
        isActionableGroup: s,
        isLoadingGroup: o,
        asGroup: x,
        amountOptionsGroup: v
      },
      children: $ ? /* @__PURE__ */ t(Wr, {
        "aria-labelledby": u["aria-labelledby"],
        "aria-activedescendant": u["aria-activedescendant"],
        isDisabled: n,
        isLoading: o,
        defaultValue: d,
        onValueChange: f,
        children: r
      }) : r
    })
  });
});
ni.displayName = "RowList";
const ci = O("div", {
  all: "unset",
  lineHeight: 0,
  display: "inline-block",
  variants: {
    x: {
      4: {
        paddingRight: "$4"
      },
      8: {
        paddingRight: "$8"
      },
      12: {
        paddingRight: "$12"
      },
      16: {
        paddingRight: "$16"
      },
      20: {
        paddingRight: "$20"
      },
      24: {
        paddingRight: "$24"
      },
      32: {
        paddingRight: "$32"
      },
      40: {
        paddingRight: "$40"
      },
      48: {
        paddingRight: "$48"
      }
    },
    y: {
      4: {
        paddingBottom: "$4"
      },
      8: {
        paddingBottom: "$8"
      },
      12: {
        paddingBottom: "$12"
      },
      16: {
        paddingBottom: "$16"
      },
      20: {
        paddingBottom: "$20"
      },
      24: {
        paddingBottom: "$24"
      },
      32: {
        paddingBottom: "$32"
      },
      40: {
        paddingBottom: "$40"
      },
      48: {
        paddingBottom: "$48"
      }
    }
  }
}), oe = D.forwardRef((e, a) => {
  const {
    as: i = "span",
    x: r,
    y: n,
    ...c
  } = e;
  return /* @__PURE__ */ t(ci, {
    as: i,
    x: r,
    y: n,
    ...c,
    ref: a
  });
});
oe.displayName = "Spacer";
const se = "Switch", [li, _i] = o0(se), [oi, si] = li(se), di = /* @__PURE__ */ C1((e, a) => {
  const { __scopeSwitch: i, name: r, checked: n, defaultChecked: c, required: s, disabled: o, value: l = "on", onCheckedChange: d, ...v } = e, [u, f] = A1(null), h = t0(
    a,
    (S) => f(S)
  ), $ = y1(!1), b = u ? Boolean(u.closest("form")) : !0, [x = !1, Z] = Y0({
    prop: n,
    defaultProp: c,
    onChange: d
  });
  return /* @__PURE__ */ t1(oi, {
    scope: i,
    checked: x,
    disabled: o
  }, /* @__PURE__ */ t1(z1.button, $1({
    type: "button",
    role: "switch",
    "aria-checked": x,
    "aria-required": s,
    "data-state": de(x),
    "data-disabled": o ? "" : void 0,
    disabled: o,
    value: l
  }, v, {
    ref: h,
    onClick: E1(e.onClick, (S) => {
      Z(
        (P) => !P
      ), b && ($.current = S.isPropagationStopped(), $.current || S.stopPropagation());
    })
  })), b && /* @__PURE__ */ t1(hi, {
    control: u,
    bubbles: !$.current,
    name: r,
    value: l,
    checked: x,
    required: s,
    disabled: o,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), ui = "SwitchThumb", fi = /* @__PURE__ */ C1((e, a) => {
  const { __scopeSwitch: i, ...r } = e, n = si(ui, i);
  return /* @__PURE__ */ t1(z1.span, $1({
    "data-state": de(n.checked),
    "data-disabled": n.disabled ? "" : void 0
  }, r, {
    ref: a
  }));
}), hi = (e) => {
  const { control: a, checked: i, bubbles: r = !0, ...n } = e, c = y1(null), s = $5(i), o = y5(a);
  return w1(() => {
    const l = c.current, d = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== i && u) {
      const f = new Event("click", {
        bubbles: r
      });
      u.call(l, i), l.dispatchEvent(f);
    }
  }, [
    s,
    i,
    r
  ]), /* @__PURE__ */ t1("input", $1({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: i
  }, n, {
    tabIndex: -1,
    ref: c,
    style: {
      ...e.style,
      ...o,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function de(e) {
  return e ? "checked" : "unchecked";
}
const mi = di, pi = fi, vi = O(mi, {
  all: "unset",
  width: s1(44),
  height: s1(24),
  backgroundColor: "$neutral-middle",
  borderRadius: s1(24),
  position: "relative",
  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
  outline: "0.25rem solid transparent",
  transition: "$default",
  "&:hover": {
    backgroundColor: "$neutral-dark"
  },
  "&:focus": {
    outline: "0.25rem solid transparent"
  },
  "&:focus-visible": {
    outline: "0.25rem solid $primary-light"
  },
  "&:disabled": {
    backgroundColor: "$neutral-light",
    "& + label": {
      color: "$neutral-light"
    }
  },
  '&[data-state="checked"]': {
    backgroundColor: "$primary-default",
    "&:hover": {
      backgroundColor: "$primary-dark"
    },
    "&:disabled": {
      backgroundColor: "$primary-light"
    }
  }
}), gi = O(pi, {
  display: "block",
  width: s1(16),
  height: s1(16),
  backgroundColor: "$neutral-white",
  borderRadius: "$full",
  transition: "transform 100ms",
  transform: "translateX(4px)",
  willChange: "transform",
  '&[data-state="checked"]': { transform: "translateX(24px)" }
}), bi = O(N1, {
  height: s1(48),
  defaultVariants: {
    spacing: "2",
    align: "center"
  }
}), $i = D.forwardRef((e, a) => {
  const {
    children: i,
    label: r,
    id: n,
    isDisabled: c,
    onChange: s,
    ...o
  } = e, l = `field-${Y1()}`;
  return /* @__PURE__ */ t(bi, {
    children: /* @__PURE__ */ t(vi, {
      ...o,
      ref: a,
      id: n || l,
      "aria-label": r,
      disabled: c,
      onChange: s,
      children: /* @__PURE__ */ t(gi, {})
    })
  });
});
$i.displayName = "Switch";
const yi = O(B1, {
  all: "unset",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  overflow: "hidden",
  userSelect: "none",
  variants: {
    size: {
      sm: {
        ...q.label.sm.regular,
        padding: "$4 $8",
        borderRadius: "$md"
      },
      md: {
        ...q.label.md.regular,
        padding: "$8",
        borderRadius: "$md"
      }
    },
    variant: {
      success: {
        color: "$success-dark",
        bg: "$success-light"
      },
      error: {
        color: "$error-dark",
        bg: "$error-light"
      },
      information: {
        color: "$text-information",
        bg: "$information-light"
      },
      onGoing: {
        color: "$text-information",
        bg: "$information-light"
      },
      new: {
        color: "$text-accent",
        bg: "$accent-light"
      },
      accent: {
        color: "$text-accent",
        bg: "$accent-light"
      },
      default: {
        color: "$text-dark",
        bg: "$neutral-light"
      },
      pending: {
        color: "$text-dark",
        bg: "$neutral-light"
      }
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
}), Zi = D.forwardRef((e, a) => {
  const {
    as: i = "span",
    children: r,
    ...n
  } = e;
  return /* @__PURE__ */ t(yi, {
    as: i,
    ...n,
    ref: a,
    children: r
  });
});
Zi.displayName = "Tag";
export {
  Lt as A,
  B1 as B,
  Oa as C,
  f1 as D,
  $i as E,
  j0 as F,
  h4 as G,
  w0 as H,
  _1 as I,
  wi as J,
  Vi as K,
  G2 as L,
  Ct as M,
  Mi as N,
  Hi as O,
  h2 as P,
  Ht as Q,
  Or as R,
  j1 as S,
  Zi as T,
  O as U,
  Vt as V,
  Ci as W,
  _t as X,
  q as Y,
  B0 as Z,
  F1 as _,
  t as a,
  F0 as b,
  Da as c,
  Ia as d,
  Fa as e,
  Ga as f,
  Ua as g,
  o4 as h,
  m4 as i,
  V as j,
  w2 as k,
  g4 as l,
  D2 as m,
  b4 as n,
  j4 as o,
  T4 as p,
  W4 as q,
  q4 as r,
  Ri as s,
  Wr as t,
  ti as u,
  ai as v,
  ri as w,
  ni as x,
  v1 as y,
  oe as z
};
